var Backoffice =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var ArgValidator_1 = __webpack_require__(2);
	exports.ArgValidator = ArgValidator_1.ArgValidator;
	exports.ArgValidationError = ArgValidator_1.ArgValidationError;
	exports.ArgValidationErrorTypes = ArgValidator_1.ArgValidationErrorTypes;
	var ArrayUtils_1 = __webpack_require__(4);
	exports.ArrayUtils = ArrayUtils_1.ArrayUtils;
	var StringUtils_1 = __webpack_require__(3);
	exports.StringUtils = StringUtils_1.StringUtils;
	var Utils_1 = __webpack_require__(5);
	exports.Utils = Utils_1.Utils;
	var Logger_1 = __webpack_require__(6);
	exports.Logger = Logger_1.Logger;
	var UriHelper_1 = __webpack_require__(8);
	exports.UriHelper = UriHelper_1.UriHelper;
	var FileUtils_1 = __webpack_require__(9);
	exports.FileUtils = FileUtils_1.FileUtils;
	var DateUtils_1 = __webpack_require__(48);
	exports.DateUtils = DateUtils_1.DateUtils;
	var StatusMessageHelper_1 = __webpack_require__(50);
	var Widgets = __webpack_require__(51);
	exports.Widgets = Widgets;
	var Pages = __webpack_require__(62);
	exports.Pages = Pages;
	var Components = __webpack_require__(159);
	exports.Components = Components;
	$(document).ready(function () {
	    StatusMessageHelper_1.StatusMessageHelper.initValidator();
	    StatusMessageHelper_1.StatusMessageHelper.initSatusMessage();
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var StringUtils_1 = __webpack_require__(3);
	exports.ArgValidationErrorTypes = {
	    Other: 'Other',
	    IsNullOrUndefined: 'IsNullOrUndefined',
	    StringIsNullOrEmpty: 'StringIsNullOrEmpty',
	    NotNumber: 'NotNumber'
	};
	var ArgValidator = (function () {
	    function ArgValidator() {
	    }
	    ArgValidator.ensureIsNotNullOrUndefined = function (obj, argName) {
	        var failure = obj === undefined || obj === null;
	        if (failure) {
	            throw new ArgValidationError(argName, exports.ArgValidationErrorTypes.IsNullOrUndefined, 'Parameter "' + argName + '" could not be null or undefined.');
	        }
	    };
	    ArgValidator.ensureIsNumber = function (obj, argName) {
	        ArgValidator.ensureIsNotNullOrUndefined(obj, argName);
	        var type = typeof obj;
	        var failure = type !== 'number';
	        if (failure) {
	            throw new ArgValidationError(argName, exports.ArgValidationErrorTypes.NotNumber, 'Parameter "' + argName + '" required type is number, actual is: ' + type);
	        }
	    };
	    ArgValidator.ensureStringIsNotNullOrEmpty = function (str, argName) {
	        var failure = StringUtils_1.StringUtils.isNullOrEmpty(str);
	        if (failure) {
	            throw new ArgValidationError(argName, exports.ArgValidationErrorTypes.StringIsNullOrEmpty, 'Parameter "' + argName + '" could not be null or undefined or empty string.');
	        }
	    };
	    return ArgValidator;
	}());
	exports.ArgValidator = ArgValidator;
	var ArgValidationError = (function (_super) {
	    __extends(ArgValidationError, _super);
	    function ArgValidationError(arg, type, message) {
	        _super.call(this, message);
	        this.arg = arg;
	        this.type = type;
	        this.message = message;
	        this.name = 'ArgValidationError';
	    }
	    ArgValidationError.prototype.equalsTo = function (other) {
	        if (other instanceof ArgValidationError) {
	            return this.name === other.name &&
	                this.arg === other.arg &&
	                this.type === other.type;
	        }
	        return false;
	    };
	    return ArgValidationError;
	}(Error));
	exports.ArgValidationError = ArgValidationError;


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ArgValidator_1 = __webpack_require__(2);
	var StringUtils = (function () {
	    function StringUtils() {
	    }
	    StringUtils.parseBoolean = function (s) {
	        switch (s.toUpperCase()) {
	            case 'TRUE':
	                return true;
	            case '1':
	                return true;
	        }
	        return false;
	    };
	    StringUtils.hexColor = function (s) {
	        ArgValidator_1.ArgValidator.ensureStringIsNotNullOrEmpty(s, 's');
	        if (s.substring(0, 1) === '#') {
	            return s;
	        }
	        else {
	            return '#' + s;
	        }
	    };
	    StringUtils.startsWith = function (str, searchString) {
	        return str.indexOf(searchString) === 0;
	    };
	    StringUtils.isNullOrEmpty = function (str) {
	        return str === null || str === undefined || str === '';
	    };
	    StringUtils.equals = function (str1, str2, ignoreCase) {
	        if (ignoreCase === undefined || ignoreCase === null) {
	            ignoreCase = true;
	        }
	        if (ignoreCase) {
	            str1 = this.isNullOrEmpty(str1) ? str1 : str1.toLocaleLowerCase();
	            str2 = this.isNullOrEmpty(str2) ? str2 : str2.toLocaleLowerCase();
	            return str1 === str2;
	        }
	        return str1 === str2;
	    };
	    StringUtils.escapeHtml = function (text) {
	        if (this.isNullOrEmpty(text)) {
	            return "";
	        }
	        return text
	            .replace(/&/g, "&amp;")
	            .replace(/</g, "&lt;")
	            .replace(/>/g, "&gt;")
	            .replace(/"/g, "&quot;")
	            .replace(/'/g, "&#039;");
	    };
	    StringUtils.capitalizeFirstLetter = function (text) {
	        return text.charAt(0).toUpperCase() + text.slice(1);
	    };
	    return StringUtils;
	}());
	exports.StringUtils = StringUtils;


/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	var ArrayUtils = (function () {
	    function ArrayUtils() {
	    }
	    ArrayUtils.numberArray = function (s, delimiter) {
	        if (delimiter === void 0) { delimiter = ';'; }
	        var arr = s.split(delimiter).map(Number);
	        return arr;
	    };
	    ArrayUtils.stringArray = function (s, delimiter) {
	        if (delimiter === void 0) { delimiter = ';'; }
	        var arr = s.split(delimiter);
	        return arr;
	    };
	    ArrayUtils.arraysNumbers = function (s, delimiter, numbersDelimiter) {
	        if (delimiter === void 0) { delimiter = ';'; }
	        if (numbersDelimiter === void 0) { numbersDelimiter = ';'; }
	        var helpArray = s.split(delimiter);
	        var arr = [];
	        if (helpArray != null) {
	            for (var i = 0; i < helpArray.length; i++) {
	                arr.push(this.numberArray(helpArray[i], numbersDelimiter));
	            }
	        }
	        return arr;
	    };
	    ArrayUtils.findIndex = function (array, searchValue) {
	        for (var i = 0; i < array.length; i++) {
	            if (array[i] === searchValue) {
	                return i;
	            }
	        }
	        return -1;
	    };
	    return ArrayUtils;
	}());
	exports.ArrayUtils = ArrayUtils;


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery, $) {"use strict";
	var Logger_1 = __webpack_require__(6);
	var lodash_1 = __webpack_require__(7);
	var Utils = (function () {
	    function Utils() {
	    }
	    Utils.focusControl = function (selector, delayed) {
	        delayed = Utils.valueOrDefault(delayed, true);
	        var ctrl = selector instanceof jQuery ? selector : Utils.getJQueryById(selector);
	        if (delayed) {
	            setTimeout(function () {
	                ctrl.focus();
	            }, 100);
	        }
	        else {
	            ctrl.focus();
	        }
	    };
	    Utils.makeAutosizeEdit = function (selector) {
	        var ctrl = selector instanceof jQuery ? selector : Utils.getJQueryById(selector);
	        if (ctrl && autosize) {
	            autosize(ctrl);
	        }
	    };
	    Utils.getJQueryById = function (id) {
	        if (typeof id !== 'string') {
	            throw new Error('id must be type of string.');
	        }
	        if (!_.startsWith(id, '#')) {
	            id = '#' + id;
	        }
	        return $(id);
	    };
	    Utils.isNullOrUndefined = function (obj) {
	        return obj === undefined || obj === null;
	    };
	    Utils.asNumber = function (value) {
	        var type = typeof value;
	        if (type === 'string') {
	            return Number(value);
	        }
	        else if (type === 'number') {
	            return value;
	        }
	        else if (type === 'boolean') {
	            return value === true ? 1 : 0;
	        }
	        return NaN;
	    };
	    Utils.valueIsIn = function (value, array) {
	        if (lodash_1.isArray(array)) {
	            return lodash_1.findIndex(array, function (item) { return value === item; }) > -1;
	        }
	        return false;
	    };
	    Utils.tryParseNumber = function (value) {
	        var result = Utils.asNumber(value);
	        return {
	            value: result,
	            isValid: !isNaN(result)
	        };
	    };
	    Utils.formatNumber = function (value, fractionDigits) {
	        var number = Utils.asNumber(value);
	        fractionDigits = Utils.valueOrDefault(fractionDigits, 0);
	        return number.toFixed(fractionDigits);
	    };
	    Utils.tryParseJson = function (value, logError) {
	        var result = Utils.parseJson(value, logError);
	        return result.json;
	    };
	    Utils.parseJson = function (value, logError) {
	        var result = {
	            json: undefined,
	            isValid: false
	        };
	        if (typeof value === 'string') {
	            if (value !== undefined && value !== null && value !== '') {
	                try {
	                    result.json = JSON.parse(value);
	                }
	                catch (e) {
	                    logError = Utils.valueOrDefault(logError, true);
	                    if (logError === true) {
	                        Logger_1.Logger.debug('[parseJson] failed for string: ' + value);
	                    }
	                }
	            }
	        }
	        else if (typeof value === 'object') {
	            result.json = value;
	        }
	        result.isValid = !this.isNullOrUndefined(result.json);
	        return result;
	    };
	    Utils.valueOrDefault = function (value, defaultValue) {
	        var result = Utils.isNullOrUndefined(value)
	            ? defaultValue
	            : value;
	        var t = typeof defaultValue;
	        if (t === 'boolean') {
	            result = Utils.asBool(result);
	        }
	        return result;
	    };
	    Utils.getURIQuery = function () {
	        return URI().query(true);
	    };
	    Utils.asBool = function (value) {
	        var t = typeof value;
	        if (t === 'boolean') {
	            return value;
	        }
	        if (t === 'number') {
	            var n = value;
	            return n > 0;
	        }
	        if (t === 'string') {
	            var s = value.toLowerCase();
	            return s === 'true';
	        }
	        return false;
	    };
	    Utils.getErrorMsg = function (error) {
	        if (error instanceof Error) {
	            return error.message;
	        }
	        return error;
	    };
	    Utils.calcPercentage = function (value, total, roundPrecision) {
	        var result = total === 0 ? 0 : (value / total) * 100.00;
	        roundPrecision = this.valueOrDefault(roundPrecision, null);
	        if (!this.isNullOrUndefined(roundPrecision)) {
	            result = lodash_1.round(result, roundPrecision);
	        }
	        return result;
	    };
	    Utils.generateUuid = function (hexNoDelim) {
	        if (hexNoDelim === void 0) { hexNoDelim = null; }
	        hexNoDelim = Utils.valueOrDefault(hexNoDelim, false);
	        var uuid = UUID.generate();
	        if (hexNoDelim) {
	            uuid = uuid.replace(/-/gi, '');
	        }
	        return uuid;
	    };
	    Utils.toggleShow = function (jqElement, show) {
	        if (show) {
	            jqElement.show();
	        }
	        else {
	            jqElement.hide();
	        }
	    };
	    Utils.scrollToTop = function () {
	        window.scrollTo(0, 0);
	    };
	    return Utils;
	}());
	exports.Utils = Utils;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(1)))

/***/ },
/* 6 */
/***/ function(module, exports) {

	"use strict";
	var Logger = (function () {
	    function Logger() {
	    }
	    Logger.debug = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i - 0] = arguments[_i];
	        }
	        Logger.closeGroup();
	        console.log.apply(console, [].slice.call(args, 0));
	    };
	    Logger.error = function (msg, e) {
	        var args = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            args[_i - 2] = arguments[_i];
	        }
	        Logger.closeGroup();
	        console.error(msg, e, [].slice.call(args, 0));
	    };
	    Logger.doSupportGroups = function () {
	        if (Logger.supportGroups === null) {
	            Logger.supportGroups = console.groupEnd !== undefined &&
	                console.groupCollapsed !== undefined &&
	                console.group !== undefined;
	        }
	        return Logger.supportGroups;
	    };
	    Logger.closeGroup = function () {
	        if (Logger.curGroup !== null) {
	            console.groupEnd();
	            Logger.curGroup = null;
	        }
	    };
	    Logger.debugGroup = function (group) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        if (Logger.doSupportGroups()) {
	            if (Logger.curGroup !== group) {
	                console.groupEnd();
	                console.group(Logger.curGroup = group);
	            }
	            console.log.apply(console, [].slice.call(args, 0));
	        }
	        else {
	            Logger.debug("[" + group + "]", args);
	        }
	    };
	    ;
	    Logger.errorGroup = function (group, e) {
	        var args = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            args[_i - 2] = arguments[_i];
	        }
	        if (Logger.doSupportGroups()) {
	            if (Logger.curGroup !== group) {
	                console.groupEnd();
	                console.group(Logger.curGroup = group);
	            }
	            console.error.apply(console, [e].concat([].slice.call(args, 0)));
	        }
	        else {
	            Logger.error("[" + group + "]", e, args);
	        }
	    };
	    ;
	    Logger.curGroup = null;
	    Logger.supportGroups = null;
	    return Logger;
	}());
	exports.Logger = Logger;


/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = _;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var lodash_1 = __webpack_require__(7);
	var Utils_1 = __webpack_require__(5);
	var StringUtils_1 = __webpack_require__(3);
	var UriHelper = (function () {
	    function UriHelper() {
	    }
	    UriHelper.setTimeStamp = function (url, timestamp, timeStampKey) {
	        if (timestamp === void 0) { timestamp = null; }
	        if (timeStampKey === void 0) { timeStampKey = '_t'; }
	        var uri = URI(url);
	        timeStampKey = Utils_1.Utils.valueOrDefault(timeStampKey, '_t');
	        timestamp = Utils_1.Utils.valueOrDefault(timestamp, new Date().toString());
	        uri.setQuery(timeStampKey, timestamp);
	        return uri.toString();
	    };
	    UriHelper.setQueryString = function (url, queryStringObject) {
	        var uri = URI(url);
	        for (var key in queryStringObject) {
	            if (queryStringObject.hasOwnProperty(key)) {
	                uri.setQuery(key, queryStringObject[key]);
	            }
	        }
	        return uri.toString();
	    };
	    UriHelper.getPacketsMode = function (uriObj) {
	        uriObj = Utils_1.Utils.valueOrDefault(uriObj, Utils_1.Utils.getURIQuery());
	        return Utils_1.Utils.valueOrDefault(uriObj['packets'], false);
	    };
	    UriHelper.getPacketSetName = function (uriObj) {
	        uriObj = Utils_1.Utils.valueOrDefault(uriObj, Utils_1.Utils.getURIQuery());
	        return Utils_1.Utils.valueOrDefault(uriObj['packetSet'], null);
	    };
	    UriHelper.updateHashGroupValue = function (name, value) {
	        var groups = this.getHashGroups();
	        var item = lodash_1.find(groups, function (group) { return StringUtils_1.StringUtils.equals(group.name, name, true); });
	        if (Utils_1.Utils.isNullOrUndefined(item)) {
	            item = {
	                name: name,
	                value: value
	            };
	            groups.push(item);
	        }
	        else {
	            item.value = value;
	        }
	        this.updateHash(groups);
	    };
	    UriHelper.updateHash = function (groups) {
	        var fragment = '';
	        for (var i = 0; i < groups.length; i++) {
	            var group = groups[i];
	            fragment += group.name + "=" + group.value;
	            if (i + 1 < groups.length) {
	                fragment += '&';
	            }
	        }
	        var oldhash = location.hash;
	        var hash = URI().fragment(fragment).hash();
	        location.hash = hash;
	        console.log("Update location hash to: \"" + hash + "\" (old: \"" + oldhash + "\")");
	    };
	    UriHelper.getHashGroupValue = function (name, defaultValue) {
	        var groups = this.getHashGroups();
	        if (groups.length > 0) {
	            var item = lodash_1.find(groups, function (group) { return StringUtils_1.StringUtils.equals(group.name, name, true); });
	            return item ? item.value : defaultValue;
	        }
	    };
	    UriHelper.getHashGroups = function () {
	        var result = [];
	        var fragment = URI().fragment();
	        if (fragment) {
	            var groups = fragment.split('&');
	            lodash_1.each(groups, function (group) {
	                var groupVals = group.split('=', 2);
	                var name = groupVals.length > 0 ? groupVals[0] : '';
	                var value = groupVals.length > 1 ? groupVals[1] : '';
	                if (!StringUtils_1.StringUtils.isNullOrEmpty(name)) {
	                    result.push({
	                        name: name,
	                        value: value
	                    });
	                }
	            });
	        }
	        return result;
	    };
	    return UriHelper;
	}());
	exports.UriHelper = UriHelper;
	var isBrowser = typeof window !== 'undefined';
	if (isBrowser) {
	    window['URI'] = URI;
	}


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var Utils_1 = __webpack_require__(5);
	var StringUtils_1 = __webpack_require__(3);
	var Promise = __webpack_require__(10);
	var FileUtils = (function () {
	    function FileUtils() {
	    }
	    FileUtils._readFile = function (file, responseType, throwError) {
	        if (responseType === void 0) { responseType = null; }
	        if (throwError === void 0) { throwError = true; }
	        responseType = Utils_1.Utils.valueOrDefault(responseType, null);
	        throwError = Utils_1.Utils.valueOrDefault(throwError, true);
	        return new Promise(function (resolve, reject) {
	            var xhr = new XMLHttpRequest();
	            xhr.open('GET', file, true);
	            if (!StringUtils_1.StringUtils.isNullOrEmpty(responseType)) {
	                xhr.responseType = responseType;
	            }
	            xhr.onreadystatechange = function () {
	                if (xhr.readyState === 4) {
	                    if (xhr.status === 200 || xhr.status == 0) {
	                        return resolve(xhr);
	                    }
	                    else {
	                        if (throwError) {
	                            return reject(new Error('Could not load file: ' + file));
	                        }
	                        else {
	                            resolve(null);
	                        }
	                    }
	                }
	            };
	            xhr.send(null);
	        });
	    };
	    FileUtils.readLocalFile = function (file, responseType, throwError) {
	        if (responseType === void 0) { responseType = null; }
	        if (throwError === void 0) { throwError = true; }
	        return this._readFile(file, responseType, throwError)
	            .then(function (xhr) {
	            return xhr ? xhr.responseText : '';
	        });
	    };
	    FileUtils.readLocalJsonFile = function (file, throwError) {
	        if (throwError === void 0) { throwError = true; }
	        return FileUtils.readLocalFile(file, null, throwError)
	            .then(function (fileContent) {
	            if (fileContent) {
	                var res = Utils_1.Utils.parseJson(fileContent);
	                if (res.isValid) {
	                    return res.json;
	                }
	                if (throwError) {
	                    return Promise.reject(new Error("File \"" + file + "\" content is not valid JSON object."));
	                }
	            }
	            return null;
	        });
	    };
	    FileUtils.readLocalXmlFile = function (file, throwError) {
	        if (throwError === void 0) { throwError = true; }
	        return this._readFile(file, 'document', throwError)
	            .then(function (xhr) {
	            if (xhr) {
	                return xhr.responseXML;
	            }
	            if (throwError) {
	                return Promise.reject(new Error("File \"" + file + "\" could not be loaded."));
	            }
	            return null;
	        });
	    };
	    FileUtils.jsonPost = function (url, data) {
	        return new Promise(function (resolve, reject) {
	            $.ajax({
	                method: "POST",
	                dataType: 'json',
	                url: url,
	                data: data
	            }).done(function (response) {
	                resolve(response);
	            }).fail(reject);
	        });
	    };
	    return FileUtils;
	}());
	exports.FileUtils = FileUtils;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var old;
	if (typeof Promise !== "undefined") old = Promise;
	function noConflict() {
	    try { if (Promise === bluebird) Promise = old; }
	    catch (e) {}
	    return bluebird;
	}
	var bluebird = __webpack_require__(11)();
	bluebird.noConflict = noConflict;
	module.exports = bluebird;


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	module.exports = function() {
	var makeSelfResolutionError = function () {
	    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var reflectHandler = function() {
	    return new Promise.PromiseInspection(this._target());
	};
	var apiRejection = function(msg) {
	    return Promise.reject(new TypeError(msg));
	};
	function Proxyable() {}
	var UNDEFINED_BINDING = {};
	var util = __webpack_require__(13);
	
	var getDomain;
	if (util.isNode) {
	    getDomain = function() {
	        var ret = process.domain;
	        if (ret === undefined) ret = null;
	        return ret;
	    };
	} else {
	    getDomain = function() {
	        return null;
	    };
	}
	util.notEnumerableProp(Promise, "_getDomain", getDomain);
	
	var es5 = __webpack_require__(14);
	var Async = __webpack_require__(15);
	var async = new Async();
	es5.defineProperty(Promise, "_async", {value: async});
	var errors = __webpack_require__(19);
	var TypeError = Promise.TypeError = errors.TypeError;
	Promise.RangeError = errors.RangeError;
	var CancellationError = Promise.CancellationError = errors.CancellationError;
	Promise.TimeoutError = errors.TimeoutError;
	Promise.OperationalError = errors.OperationalError;
	Promise.RejectionError = errors.OperationalError;
	Promise.AggregateError = errors.AggregateError;
	var INTERNAL = function(){};
	var APPLY = {};
	var NEXT_FILTER = {};
	var tryConvertToPromise = __webpack_require__(20)(Promise, INTERNAL);
	var PromiseArray =
	    __webpack_require__(21)(Promise, INTERNAL,
	                               tryConvertToPromise, apiRejection, Proxyable);
	var Context = __webpack_require__(22)(Promise);
	 /*jshint unused:false*/
	var createContext = Context.create;
	var debug = __webpack_require__(23)(Promise, Context);
	var CapturedTrace = debug.CapturedTrace;
	var PassThroughHandlerContext =
	    __webpack_require__(24)(Promise, tryConvertToPromise, NEXT_FILTER);
	var catchFilter = __webpack_require__(25)(NEXT_FILTER);
	var nodebackForPromise = __webpack_require__(26);
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	function check(self, executor) {
	    if (self == null || self.constructor !== Promise) {
	        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (typeof executor !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(executor));
	    }
	
	}
	
	function Promise(executor) {
	    if (executor !== INTERNAL) {
	        check(this, executor);
	    }
	    this._bitField = 0;
	    this._fulfillmentHandler0 = undefined;
	    this._rejectionHandler0 = undefined;
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._resolveFromExecutor(executor);
	    this._promiseCreated();
	    this._fireEvent("promiseCreated", this);
	}
	
	Promise.prototype.toString = function () {
	    return "[object Promise]";
	};
	
	Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
	    var len = arguments.length;
	    if (len > 1) {
	        var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return apiRejection("Catch statement predicate: " +
	                    "expecting an object but got " + util.classString(item));
	            }
	        }
	        catchInstances.length = j;
	        fn = arguments[i];
	        return this.then(undefined, catchFilter(catchInstances, fn, this));
	    }
	    return this.then(undefined, fn);
	};
	
	Promise.prototype.reflect = function () {
	    return this._then(reflectHandler,
	        reflectHandler, undefined, this, undefined);
	};
	
	Promise.prototype.then = function (didFulfill, didReject) {
	    if (debug.warnings() && arguments.length > 0 &&
	        typeof didFulfill !== "function" &&
	        typeof didReject !== "function") {
	        var msg = ".then() only accepts functions but was passed: " +
	                util.classString(didFulfill);
	        if (arguments.length > 1) {
	            msg += ", " + util.classString(didReject);
	        }
	        this._warn(msg);
	    }
	    return this._then(didFulfill, didReject, undefined, undefined, undefined);
	};
	
	Promise.prototype.done = function (didFulfill, didReject) {
	    var promise =
	        this._then(didFulfill, didReject, undefined, undefined, undefined);
	    promise._setIsFinal();
	};
	
	Promise.prototype.spread = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
	};
	
	Promise.prototype.toJSON = function () {
	    var ret = {
	        isFulfilled: false,
	        isRejected: false,
	        fulfillmentValue: undefined,
	        rejectionReason: undefined
	    };
	    if (this.isFulfilled()) {
	        ret.fulfillmentValue = this.value();
	        ret.isFulfilled = true;
	    } else if (this.isRejected()) {
	        ret.rejectionReason = this.reason();
	        ret.isRejected = true;
	    }
	    return ret;
	};
	
	Promise.prototype.all = function () {
	    if (arguments.length > 0) {
	        this._warn(".all() was passed arguments but it does not take any");
	    }
	    return new PromiseArray(this).promise();
	};
	
	Promise.prototype.error = function (fn) {
	    return this.caught(util.originatesFromRejection, fn);
	};
	
	Promise.getNewLibraryCopy = module.exports;
	
	Promise.is = function (val) {
	    return val instanceof Promise;
	};
	
	Promise.fromNode = Promise.fromCallback = function(fn) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
	                                         : false;
	    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
	    if (result === errorObj) {
	        ret._rejectCallback(result.e, true);
	    }
	    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.all = function (promises) {
	    return new PromiseArray(promises).promise();
	};
	
	Promise.cast = function (obj) {
	    var ret = tryConvertToPromise(obj);
	    if (!(ret instanceof Promise)) {
	        ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._setFulfilled();
	        ret._rejectionHandler0 = obj;
	    }
	    return ret;
	};
	
	Promise.resolve = Promise.fulfilled = Promise.cast;
	
	Promise.reject = Promise.rejected = function (reason) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._rejectCallback(reason, true);
	    return ret;
	};
	
	Promise.setScheduler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return async.setScheduler(fn);
	};
	
	Promise.prototype._then = function (
	    didFulfill,
	    didReject,
	    _,    receiver,
	    internalData
	) {
	    var haveInternalData = internalData !== undefined;
	    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
	    var target = this._target();
	    var bitField = target._bitField;
	
	    if (!haveInternalData) {
	        promise._propagateFrom(this, 3);
	        promise._captureStackTrace();
	        if (receiver === undefined &&
	            ((this._bitField & 2097152) !== 0)) {
	            if (!((bitField & 50397184) === 0)) {
	                receiver = this._boundValue();
	            } else {
	                receiver = target === this ? undefined : this._boundTo;
	            }
	        }
	        this._fireEvent("promiseChained", this, promise);
	    }
	
	    var domain = getDomain();
	    if (!((bitField & 50397184) === 0)) {
	        var handler, value, settler = target._settlePromiseCtx;
	        if (((bitField & 33554432) !== 0)) {
	            value = target._rejectionHandler0;
	            handler = didFulfill;
	        } else if (((bitField & 16777216) !== 0)) {
	            value = target._fulfillmentHandler0;
	            handler = didReject;
	            target._unsetRejectionIsUnhandled();
	        } else {
	            settler = target._settlePromiseLateCancellationObserver;
	            value = new CancellationError("late cancellation observer");
	            target._attachExtraTrace(value);
	            handler = didReject;
	        }
	
	        async.invoke(settler, target, {
	            handler: domain === null ? handler
	                : (typeof handler === "function" &&
	                    util.domainBind(domain, handler)),
	            promise: promise,
	            receiver: receiver,
	            value: value
	        });
	    } else {
	        target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
	    }
	
	    return promise;
	};
	
	Promise.prototype._length = function () {
	    return this._bitField & 65535;
	};
	
	Promise.prototype._isFateSealed = function () {
	    return (this._bitField & 117506048) !== 0;
	};
	
	Promise.prototype._isFollowing = function () {
	    return (this._bitField & 67108864) === 67108864;
	};
	
	Promise.prototype._setLength = function (len) {
	    this._bitField = (this._bitField & -65536) |
	        (len & 65535);
	};
	
	Promise.prototype._setFulfilled = function () {
	    this._bitField = this._bitField | 33554432;
	    this._fireEvent("promiseFulfilled", this);
	};
	
	Promise.prototype._setRejected = function () {
	    this._bitField = this._bitField | 16777216;
	    this._fireEvent("promiseRejected", this);
	};
	
	Promise.prototype._setFollowing = function () {
	    this._bitField = this._bitField | 67108864;
	    this._fireEvent("promiseResolved", this);
	};
	
	Promise.prototype._setIsFinal = function () {
	    this._bitField = this._bitField | 4194304;
	};
	
	Promise.prototype._isFinal = function () {
	    return (this._bitField & 4194304) > 0;
	};
	
	Promise.prototype._unsetCancelled = function() {
	    this._bitField = this._bitField & (~65536);
	};
	
	Promise.prototype._setCancelled = function() {
	    this._bitField = this._bitField | 65536;
	    this._fireEvent("promiseCancelled", this);
	};
	
	Promise.prototype._setWillBeCancelled = function() {
	    this._bitField = this._bitField | 8388608;
	};
	
	Promise.prototype._setAsyncGuaranteed = function() {
	    if (async.hasCustomScheduler()) return;
	    this._bitField = this._bitField | 134217728;
	};
	
	Promise.prototype._receiverAt = function (index) {
	    var ret = index === 0 ? this._receiver0 : this[
	            index * 4 - 4 + 3];
	    if (ret === UNDEFINED_BINDING) {
	        return undefined;
	    } else if (ret === undefined && this._isBound()) {
	        return this._boundValue();
	    }
	    return ret;
	};
	
	Promise.prototype._promiseAt = function (index) {
	    return this[
	            index * 4 - 4 + 2];
	};
	
	Promise.prototype._fulfillmentHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 0];
	};
	
	Promise.prototype._rejectionHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 1];
	};
	
	Promise.prototype._boundValue = function() {};
	
	Promise.prototype._migrateCallback0 = function (follower) {
	    var bitField = follower._bitField;
	    var fulfill = follower._fulfillmentHandler0;
	    var reject = follower._rejectionHandler0;
	    var promise = follower._promise0;
	    var receiver = follower._receiverAt(0);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._migrateCallbackAt = function (follower, index) {
	    var fulfill = follower._fulfillmentHandlerAt(index);
	    var reject = follower._rejectionHandlerAt(index);
	    var promise = follower._promiseAt(index);
	    var receiver = follower._receiverAt(index);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._addCallbacks = function (
	    fulfill,
	    reject,
	    promise,
	    receiver,
	    domain
	) {
	    var index = this._length();
	
	    if (index >= 65535 - 4) {
	        index = 0;
	        this._setLength(0);
	    }
	
	    if (index === 0) {
	        this._promise0 = promise;
	        this._receiver0 = receiver;
	        if (typeof fulfill === "function") {
	            this._fulfillmentHandler0 =
	                domain === null ? fulfill : util.domainBind(domain, fulfill);
	        }
	        if (typeof reject === "function") {
	            this._rejectionHandler0 =
	                domain === null ? reject : util.domainBind(domain, reject);
	        }
	    } else {
	        var base = index * 4 - 4;
	        this[base + 2] = promise;
	        this[base + 3] = receiver;
	        if (typeof fulfill === "function") {
	            this[base + 0] =
	                domain === null ? fulfill : util.domainBind(domain, fulfill);
	        }
	        if (typeof reject === "function") {
	            this[base + 1] =
	                domain === null ? reject : util.domainBind(domain, reject);
	        }
	    }
	    this._setLength(index + 1);
	    return index;
	};
	
	Promise.prototype._proxy = function (proxyable, arg) {
	    this._addCallbacks(undefined, undefined, arg, proxyable, null);
	};
	
	Promise.prototype._resolveCallback = function(value, shouldBind) {
	    if (((this._bitField & 117506048) !== 0)) return;
	    if (value === this)
	        return this._rejectCallback(makeSelfResolutionError(), false);
	    var maybePromise = tryConvertToPromise(value, this);
	    if (!(maybePromise instanceof Promise)) return this._fulfill(value);
	
	    if (shouldBind) this._propagateFrom(maybePromise, 2);
	
	    var promise = maybePromise._target();
	
	    if (promise === this) {
	        this._reject(makeSelfResolutionError());
	        return;
	    }
	
	    var bitField = promise._bitField;
	    if (((bitField & 50397184) === 0)) {
	        var len = this._length();
	        if (len > 0) promise._migrateCallback0(this);
	        for (var i = 1; i < len; ++i) {
	            promise._migrateCallbackAt(this, i);
	        }
	        this._setFollowing();
	        this._setLength(0);
	        this._setFollowee(promise);
	    } else if (((bitField & 33554432) !== 0)) {
	        this._fulfill(promise._value());
	    } else if (((bitField & 16777216) !== 0)) {
	        this._reject(promise._reason());
	    } else {
	        var reason = new CancellationError("late cancellation observer");
	        promise._attachExtraTrace(reason);
	        this._reject(reason);
	    }
	};
	
	Promise.prototype._rejectCallback =
	function(reason, synchronous, ignoreNonErrorWarnings) {
	    var trace = util.ensureErrorObject(reason);
	    var hasStack = trace === reason;
	    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
	        var message = "a promise was rejected with a non-error: " +
	            util.classString(reason);
	        this._warn(message, true);
	    }
	    this._attachExtraTrace(trace, synchronous ? hasStack : false);
	    this._reject(reason);
	};
	
	Promise.prototype._resolveFromExecutor = function (executor) {
	    if (executor === INTERNAL) return;
	    var promise = this;
	    this._captureStackTrace();
	    this._pushContext();
	    var synchronous = true;
	    var r = this._execute(executor, function(value) {
	        promise._resolveCallback(value);
	    }, function (reason) {
	        promise._rejectCallback(reason, synchronous);
	    });
	    synchronous = false;
	    this._popContext();
	
	    if (r !== undefined) {
	        promise._rejectCallback(r, true);
	    }
	};
	
	Promise.prototype._settlePromiseFromHandler = function (
	    handler, receiver, value, promise
	) {
	    var bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	    promise._pushContext();
	    var x;
	    if (receiver === APPLY) {
	        if (!value || typeof value.length !== "number") {
	            x = errorObj;
	            x.e = new TypeError("cannot .spread() a non-array: " +
	                                    util.classString(value));
	        } else {
	            x = tryCatch(handler).apply(this._boundValue(), value);
	        }
	    } else {
	        x = tryCatch(handler).call(receiver, value);
	    }
	    var promiseCreated = promise._popContext();
	    bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	
	    if (x === NEXT_FILTER) {
	        promise._reject(value);
	    } else if (x === errorObj) {
	        promise._rejectCallback(x.e, false);
	    } else {
	        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
	        promise._resolveCallback(x);
	    }
	};
	
	Promise.prototype._target = function() {
	    var ret = this;
	    while (ret._isFollowing()) ret = ret._followee();
	    return ret;
	};
	
	Promise.prototype._followee = function() {
	    return this._rejectionHandler0;
	};
	
	Promise.prototype._setFollowee = function(promise) {
	    this._rejectionHandler0 = promise;
	};
	
	Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
	    var isPromise = promise instanceof Promise;
	    var bitField = this._bitField;
	    var asyncGuaranteed = ((bitField & 134217728) !== 0);
	    if (((bitField & 65536) !== 0)) {
	        if (isPromise) promise._invokeInternalOnCancel();
	
	        if (receiver instanceof PassThroughHandlerContext &&
	            receiver.isFinallyHandler()) {
	            receiver.cancelPromise = promise;
	            if (tryCatch(handler).call(receiver, value) === errorObj) {
	                promise._reject(errorObj.e);
	            }
	        } else if (handler === reflectHandler) {
	            promise._fulfill(reflectHandler.call(receiver));
	        } else if (receiver instanceof Proxyable) {
	            receiver._promiseCancelled(promise);
	        } else if (isPromise || promise instanceof PromiseArray) {
	            promise._cancel();
	        } else {
	            receiver.cancel();
	        }
	    } else if (typeof handler === "function") {
	        if (!isPromise) {
	            handler.call(receiver, value, promise);
	        } else {
	            if (asyncGuaranteed) promise._setAsyncGuaranteed();
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (receiver instanceof Proxyable) {
	        if (!receiver._isResolved()) {
	            if (((bitField & 33554432) !== 0)) {
	                receiver._promiseFulfilled(value, promise);
	            } else {
	                receiver._promiseRejected(value, promise);
	            }
	        }
	    } else if (isPromise) {
	        if (asyncGuaranteed) promise._setAsyncGuaranteed();
	        if (((bitField & 33554432) !== 0)) {
	            promise._fulfill(value);
	        } else {
	            promise._reject(value);
	        }
	    }
	};
	
	Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
	    var handler = ctx.handler;
	    var promise = ctx.promise;
	    var receiver = ctx.receiver;
	    var value = ctx.value;
	    if (typeof handler === "function") {
	        if (!(promise instanceof Promise)) {
	            handler.call(receiver, value, promise);
	        } else {
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (promise instanceof Promise) {
	        promise._reject(value);
	    }
	};
	
	Promise.prototype._settlePromiseCtx = function(ctx) {
	    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
	};
	
	Promise.prototype._settlePromise0 = function(handler, value, bitField) {
	    var promise = this._promise0;
	    var receiver = this._receiverAt(0);
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._settlePromise(promise, handler, receiver, value);
	};
	
	Promise.prototype._clearCallbackDataAtIndex = function(index) {
	    var base = index * 4 - 4;
	    this[base + 2] =
	    this[base + 3] =
	    this[base + 0] =
	    this[base + 1] = undefined;
	};
	
	Promise.prototype._fulfill = function (value) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    if (value === this) {
	        var err = makeSelfResolutionError();
	        this._attachExtraTrace(err);
	        return this._reject(err);
	    }
	    this._setFulfilled();
	    this._rejectionHandler0 = value;
	
	    if ((bitField & 65535) > 0) {
	        if (((bitField & 134217728) !== 0)) {
	            this._settlePromises();
	        } else {
	            async.settlePromises(this);
	        }
	    }
	};
	
	Promise.prototype._reject = function (reason) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    this._setRejected();
	    this._fulfillmentHandler0 = reason;
	
	    if (this._isFinal()) {
	        return async.fatalError(reason, util.isNode);
	    }
	
	    if ((bitField & 65535) > 0) {
	        async.settlePromises(this);
	    } else {
	        this._ensurePossibleRejectionHandled();
	    }
	};
	
	Promise.prototype._fulfillPromises = function (len, value) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._fulfillmentHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, value);
	    }
	};
	
	Promise.prototype._rejectPromises = function (len, reason) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._rejectionHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, reason);
	    }
	};
	
	Promise.prototype._settlePromises = function () {
	    var bitField = this._bitField;
	    var len = (bitField & 65535);
	
	    if (len > 0) {
	        if (((bitField & 16842752) !== 0)) {
	            var reason = this._fulfillmentHandler0;
	            this._settlePromise0(this._rejectionHandler0, reason, bitField);
	            this._rejectPromises(len, reason);
	        } else {
	            var value = this._rejectionHandler0;
	            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
	            this._fulfillPromises(len, value);
	        }
	        this._setLength(0);
	    }
	    this._clearCancellationData();
	};
	
	Promise.prototype._settledValue = function() {
	    var bitField = this._bitField;
	    if (((bitField & 33554432) !== 0)) {
	        return this._rejectionHandler0;
	    } else if (((bitField & 16777216) !== 0)) {
	        return this._fulfillmentHandler0;
	    }
	};
	
	function deferResolve(v) {this.promise._resolveCallback(v);}
	function deferReject(v) {this.promise._rejectCallback(v, false);}
	
	Promise.defer = Promise.pending = function() {
	    debug.deprecated("Promise.defer", "new Promise");
	    var promise = new Promise(INTERNAL);
	    return {
	        promise: promise,
	        resolve: deferResolve,
	        reject: deferReject
	    };
	};
	
	util.notEnumerableProp(Promise,
	                       "_makeSelfResolutionError",
	                       makeSelfResolutionError);
	
	__webpack_require__(27)(Promise, INTERNAL, tryConvertToPromise, apiRejection,
	    debug);
	__webpack_require__(28)(Promise, INTERNAL, tryConvertToPromise, debug);
	__webpack_require__(29)(Promise, PromiseArray, apiRejection, debug);
	__webpack_require__(30)(Promise);
	__webpack_require__(31)(Promise);
	__webpack_require__(32)(
	    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
	Promise.Promise = Promise;
	Promise.version = "3.5.0";
	__webpack_require__(33)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	__webpack_require__(34)(Promise);
	__webpack_require__(35)(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
	__webpack_require__(36)(Promise, INTERNAL, debug);
	__webpack_require__(37)(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
	__webpack_require__(38)(Promise);
	__webpack_require__(39)(Promise, INTERNAL);
	__webpack_require__(40)(Promise, PromiseArray, tryConvertToPromise, apiRejection);
	__webpack_require__(41)(Promise, INTERNAL, tryConvertToPromise, apiRejection);
	__webpack_require__(42)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	__webpack_require__(43)(Promise, PromiseArray, debug);
	__webpack_require__(44)(Promise, PromiseArray, apiRejection);
	__webpack_require__(45)(Promise, INTERNAL);
	__webpack_require__(46)(Promise, INTERNAL);
	__webpack_require__(47)(Promise);
	                                                         
	    util.toFastProperties(Promise);                                          
	    util.toFastProperties(Promise.prototype);                                
	    function fillTypes(value) {                                              
	        var p = new Promise(INTERNAL);                                       
	        p._fulfillmentHandler0 = value;                                      
	        p._rejectionHandler0 = value;                                        
	        p._promise0 = value;                                                 
	        p._receiver0 = value;                                                
	    }                                                                        
	    // Complete slack tracking, opt out of field-type tracking and           
	    // stabilize map                                                         
	    fillTypes({a: 1});                                                       
	    fillTypes({b: 2});                                                       
	    fillTypes({c: 3});                                                       
	    fillTypes(1);                                                            
	    fillTypes(function(){});                                                 
	    fillTypes(undefined);                                                    
	    fillTypes(false);                                                        
	    fillTypes(new Promise(INTERNAL));                                        
	    debug.setBounds(Async.firstLineError, util.lastLineError);               
	    return Promise;                                                          
	
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ },
/* 12 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {"use strict";
	var es5 = __webpack_require__(14);
	var canEvaluate = typeof navigator == "undefined";
	
	var errorObj = {e: {}};
	var tryCatchTarget;
	var globalObject = typeof self !== "undefined" ? self :
	    typeof window !== "undefined" ? window :
	    typeof global !== "undefined" ? global :
	    this !== undefined ? this : null;
	
	function tryCatcher() {
	    try {
	        var target = tryCatchTarget;
	        tryCatchTarget = null;
	        return target.apply(this, arguments);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	
	var inherits = function(Child, Parent) {
	    var hasProp = {}.hasOwnProperty;
	
	    function T() {
	        this.constructor = Child;
	        this.constructor$ = Parent;
	        for (var propertyName in Parent.prototype) {
	            if (hasProp.call(Parent.prototype, propertyName) &&
	                propertyName.charAt(propertyName.length-1) !== "$"
	           ) {
	                this[propertyName + "$"] = Parent.prototype[propertyName];
	            }
	        }
	    }
	    T.prototype = Parent.prototype;
	    Child.prototype = new T();
	    return Child.prototype;
	};
	
	
	function isPrimitive(val) {
	    return val == null || val === true || val === false ||
	        typeof val === "string" || typeof val === "number";
	
	}
	
	function isObject(value) {
	    return typeof value === "function" ||
	           typeof value === "object" && value !== null;
	}
	
	function maybeWrapAsError(maybeError) {
	    if (!isPrimitive(maybeError)) return maybeError;
	
	    return new Error(safeToString(maybeError));
	}
	
	function withAppended(target, appendee) {
	    var len = target.length;
	    var ret = new Array(len + 1);
	    var i;
	    for (i = 0; i < len; ++i) {
	        ret[i] = target[i];
	    }
	    ret[i] = appendee;
	    return ret;
	}
	
	function getDataPropertyOrDefault(obj, key, defaultValue) {
	    if (es5.isES5) {
	        var desc = Object.getOwnPropertyDescriptor(obj, key);
	
	        if (desc != null) {
	            return desc.get == null && desc.set == null
	                    ? desc.value
	                    : defaultValue;
	        }
	    } else {
	        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
	    }
	}
	
	function notEnumerableProp(obj, name, value) {
	    if (isPrimitive(obj)) return obj;
	    var descriptor = {
	        value: value,
	        configurable: true,
	        enumerable: false,
	        writable: true
	    };
	    es5.defineProperty(obj, name, descriptor);
	    return obj;
	}
	
	function thrower(r) {
	    throw r;
	}
	
	var inheritedDataKeys = (function() {
	    var excludedPrototypes = [
	        Array.prototype,
	        Object.prototype,
	        Function.prototype
	    ];
	
	    var isExcludedProto = function(val) {
	        for (var i = 0; i < excludedPrototypes.length; ++i) {
	            if (excludedPrototypes[i] === val) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    if (es5.isES5) {
	        var getKeys = Object.getOwnPropertyNames;
	        return function(obj) {
	            var ret = [];
	            var visitedKeys = Object.create(null);
	            while (obj != null && !isExcludedProto(obj)) {
	                var keys;
	                try {
	                    keys = getKeys(obj);
	                } catch (e) {
	                    return ret;
	                }
	                for (var i = 0; i < keys.length; ++i) {
	                    var key = keys[i];
	                    if (visitedKeys[key]) continue;
	                    visitedKeys[key] = true;
	                    var desc = Object.getOwnPropertyDescriptor(obj, key);
	                    if (desc != null && desc.get == null && desc.set == null) {
	                        ret.push(key);
	                    }
	                }
	                obj = es5.getPrototypeOf(obj);
	            }
	            return ret;
	        };
	    } else {
	        var hasProp = {}.hasOwnProperty;
	        return function(obj) {
	            if (isExcludedProto(obj)) return [];
	            var ret = [];
	
	            /*jshint forin:false */
	            enumeration: for (var key in obj) {
	                if (hasProp.call(obj, key)) {
	                    ret.push(key);
	                } else {
	                    for (var i = 0; i < excludedPrototypes.length; ++i) {
	                        if (hasProp.call(excludedPrototypes[i], key)) {
	                            continue enumeration;
	                        }
	                    }
	                    ret.push(key);
	                }
	            }
	            return ret;
	        };
	    }
	
	})();
	
	var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
	function isClass(fn) {
	    try {
	        if (typeof fn === "function") {
	            var keys = es5.names(fn.prototype);
	
	            var hasMethods = es5.isES5 && keys.length > 1;
	            var hasMethodsOtherThanConstructor = keys.length > 0 &&
	                !(keys.length === 1 && keys[0] === "constructor");
	            var hasThisAssignmentAndStaticMethods =
	                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
	
	            if (hasMethods || hasMethodsOtherThanConstructor ||
	                hasThisAssignmentAndStaticMethods) {
	                return true;
	            }
	        }
	        return false;
	    } catch (e) {
	        return false;
	    }
	}
	
	function toFastProperties(obj) {
	    /*jshint -W027,-W055,-W031*/
	    function FakeConstructor() {}
	    FakeConstructor.prototype = obj;
	    var l = 8;
	    while (l--) new FakeConstructor();
	    return obj;
	    eval(obj);
	}
	
	var rident = /^[a-z$_][a-z$_0-9]*$/i;
	function isIdentifier(str) {
	    return rident.test(str);
	}
	
	function filledRange(count, prefix, suffix) {
	    var ret = new Array(count);
	    for(var i = 0; i < count; ++i) {
	        ret[i] = prefix + i + suffix;
	    }
	    return ret;
	}
	
	function safeToString(obj) {
	    try {
	        return obj + "";
	    } catch (e) {
	        return "[no string representation]";
	    }
	}
	
	function isError(obj) {
	    return obj !== null &&
	           typeof obj === "object" &&
	           typeof obj.message === "string" &&
	           typeof obj.name === "string";
	}
	
	function markAsOriginatingFromRejection(e) {
	    try {
	        notEnumerableProp(e, "isOperational", true);
	    }
	    catch(ignore) {}
	}
	
	function originatesFromRejection(e) {
	    if (e == null) return false;
	    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
	        e["isOperational"] === true);
	}
	
	function canAttachTrace(obj) {
	    return isError(obj) && es5.propertyIsWritable(obj, "stack");
	}
	
	var ensureErrorObject = (function() {
	    if (!("stack" in new Error())) {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            try {throw new Error(safeToString(value));}
	            catch(err) {return err;}
	        };
	    } else {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            return new Error(safeToString(value));
	        };
	    }
	})();
	
	function classString(obj) {
	    return {}.toString.call(obj);
	}
	
	function copyDescriptors(from, to, filter) {
	    var keys = es5.names(from);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        if (filter(key)) {
	            try {
	                es5.defineProperty(to, key, es5.getDescriptor(from, key));
	            } catch (ignore) {}
	        }
	    }
	}
	
	var asArray = function(v) {
	    if (es5.isArray(v)) {
	        return v;
	    }
	    return null;
	};
	
	if (typeof Symbol !== "undefined" && Symbol.iterator) {
	    var ArrayFrom = typeof Array.from === "function" ? function(v) {
	        return Array.from(v);
	    } : function(v) {
	        var ret = [];
	        var it = v[Symbol.iterator]();
	        var itResult;
	        while (!((itResult = it.next()).done)) {
	            ret.push(itResult.value);
	        }
	        return ret;
	    };
	
	    asArray = function(v) {
	        if (es5.isArray(v)) {
	            return v;
	        } else if (v != null && typeof v[Symbol.iterator] === "function") {
	            return ArrayFrom(v);
	        }
	        return null;
	    };
	}
	
	var isNode = typeof process !== "undefined" &&
	        classString(process).toLowerCase() === "[object process]";
	
	var hasEnvVariables = typeof process !== "undefined" &&
	    typeof process.env !== "undefined";
	
	function env(key) {
	    return hasEnvVariables ? process.env[key] : undefined;
	}
	
	function getNativePromise() {
	    if (typeof Promise === "function") {
	        try {
	            var promise = new Promise(function(){});
	            if ({}.toString.call(promise) === "[object Promise]") {
	                return Promise;
	            }
	        } catch (e) {}
	    }
	}
	
	function domainBind(self, cb) {
	    return self.bind(cb);
	}
	
	var ret = {
	    isClass: isClass,
	    isIdentifier: isIdentifier,
	    inheritedDataKeys: inheritedDataKeys,
	    getDataPropertyOrDefault: getDataPropertyOrDefault,
	    thrower: thrower,
	    isArray: es5.isArray,
	    asArray: asArray,
	    notEnumerableProp: notEnumerableProp,
	    isPrimitive: isPrimitive,
	    isObject: isObject,
	    isError: isError,
	    canEvaluate: canEvaluate,
	    errorObj: errorObj,
	    tryCatch: tryCatch,
	    inherits: inherits,
	    withAppended: withAppended,
	    maybeWrapAsError: maybeWrapAsError,
	    toFastProperties: toFastProperties,
	    filledRange: filledRange,
	    toString: safeToString,
	    canAttachTrace: canAttachTrace,
	    ensureErrorObject: ensureErrorObject,
	    originatesFromRejection: originatesFromRejection,
	    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
	    classString: classString,
	    copyDescriptors: copyDescriptors,
	    hasDevTools: typeof chrome !== "undefined" && chrome &&
	                 typeof chrome.loadTimes === "function",
	    isNode: isNode,
	    hasEnvVariables: hasEnvVariables,
	    env: env,
	    global: globalObject,
	    getNativePromise: getNativePromise,
	    domainBind: domainBind
	};
	ret.isRecentNode = ret.isNode && (function() {
	    var version = process.versions.node.split(".").map(Number);
	    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
	})();
	
	if (ret.isNode) ret.toFastProperties(process);
	
	try {throw new Error(); } catch (e) {ret.lastLineError = e;}
	module.exports = ret;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(12)))

/***/ },
/* 14 */
/***/ function(module, exports) {

	var isES5 = (function(){
	    "use strict";
	    return this === undefined;
	})();
	
	if (isES5) {
	    module.exports = {
	        freeze: Object.freeze,
	        defineProperty: Object.defineProperty,
	        getDescriptor: Object.getOwnPropertyDescriptor,
	        keys: Object.keys,
	        names: Object.getOwnPropertyNames,
	        getPrototypeOf: Object.getPrototypeOf,
	        isArray: Array.isArray,
	        isES5: isES5,
	        propertyIsWritable: function(obj, prop) {
	            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
	            return !!(!descriptor || descriptor.writable || descriptor.set);
	        }
	    };
	} else {
	    var has = {}.hasOwnProperty;
	    var str = {}.toString;
	    var proto = {}.constructor.prototype;
	
	    var ObjectKeys = function (o) {
	        var ret = [];
	        for (var key in o) {
	            if (has.call(o, key)) {
	                ret.push(key);
	            }
	        }
	        return ret;
	    };
	
	    var ObjectGetDescriptor = function(o, key) {
	        return {value: o[key]};
	    };
	
	    var ObjectDefineProperty = function (o, key, desc) {
	        o[key] = desc.value;
	        return o;
	    };
	
	    var ObjectFreeze = function (obj) {
	        return obj;
	    };
	
	    var ObjectGetPrototypeOf = function (obj) {
	        try {
	            return Object(obj).constructor.prototype;
	        }
	        catch (e) {
	            return proto;
	        }
	    };
	
	    var ArrayIsArray = function (obj) {
	        try {
	            return str.call(obj) === "[object Array]";
	        }
	        catch(e) {
	            return false;
	        }
	    };
	
	    module.exports = {
	        isArray: ArrayIsArray,
	        keys: ObjectKeys,
	        names: ObjectKeys,
	        defineProperty: ObjectDefineProperty,
	        getDescriptor: ObjectGetDescriptor,
	        freeze: ObjectFreeze,
	        getPrototypeOf: ObjectGetPrototypeOf,
	        isES5: isES5,
	        propertyIsWritable: function() {
	            return true;
	        }
	    };
	}


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	var firstLineError;
	try {throw new Error(); } catch (e) {firstLineError = e;}
	var schedule = __webpack_require__(16);
	var Queue = __webpack_require__(18);
	var util = __webpack_require__(13);
	
	function Async() {
	    this._customScheduler = false;
	    this._isTickUsed = false;
	    this._lateQueue = new Queue(16);
	    this._normalQueue = new Queue(16);
	    this._haveDrainedQueues = false;
	    this._trampolineEnabled = true;
	    var self = this;
	    this.drainQueues = function () {
	        self._drainQueues();
	    };
	    this._schedule = schedule;
	}
	
	Async.prototype.setScheduler = function(fn) {
	    var prev = this._schedule;
	    this._schedule = fn;
	    this._customScheduler = true;
	    return prev;
	};
	
	Async.prototype.hasCustomScheduler = function() {
	    return this._customScheduler;
	};
	
	Async.prototype.enableTrampoline = function() {
	    this._trampolineEnabled = true;
	};
	
	Async.prototype.disableTrampolineIfNecessary = function() {
	    if (util.hasDevTools) {
	        this._trampolineEnabled = false;
	    }
	};
	
	Async.prototype.haveItemsQueued = function () {
	    return this._isTickUsed || this._haveDrainedQueues;
	};
	
	
	Async.prototype.fatalError = function(e, isNode) {
	    if (isNode) {
	        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
	            "\n");
	        process.exit(2);
	    } else {
	        this.throwLater(e);
	    }
	};
	
	Async.prototype.throwLater = function(fn, arg) {
	    if (arguments.length === 1) {
	        arg = fn;
	        fn = function () { throw arg; };
	    }
	    if (typeof setTimeout !== "undefined") {
	        setTimeout(function() {
	            fn(arg);
	        }, 0);
	    } else try {
	        this._schedule(function() {
	            fn(arg);
	        });
	    } catch (e) {
	        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	};
	
	function AsyncInvokeLater(fn, receiver, arg) {
	    this._lateQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncInvoke(fn, receiver, arg) {
	    this._normalQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncSettlePromises(promise) {
	    this._normalQueue._pushOne(promise);
	    this._queueTick();
	}
	
	if (!util.hasDevTools) {
	    Async.prototype.invokeLater = AsyncInvokeLater;
	    Async.prototype.invoke = AsyncInvoke;
	    Async.prototype.settlePromises = AsyncSettlePromises;
	} else {
	    Async.prototype.invokeLater = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvokeLater.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                setTimeout(function() {
	                    fn.call(receiver, arg);
	                }, 100);
	            });
	        }
	    };
	
	    Async.prototype.invoke = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvoke.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                fn.call(receiver, arg);
	            });
	        }
	    };
	
	    Async.prototype.settlePromises = function(promise) {
	        if (this._trampolineEnabled) {
	            AsyncSettlePromises.call(this, promise);
	        } else {
	            this._schedule(function() {
	                promise._settlePromises();
	            });
	        }
	    };
	}
	
	Async.prototype._drainQueue = function(queue) {
	    while (queue.length() > 0) {
	        var fn = queue.shift();
	        if (typeof fn !== "function") {
	            fn._settlePromises();
	            continue;
	        }
	        var receiver = queue.shift();
	        var arg = queue.shift();
	        fn.call(receiver, arg);
	    }
	};
	
	Async.prototype._drainQueues = function () {
	    this._drainQueue(this._normalQueue);
	    this._reset();
	    this._haveDrainedQueues = true;
	    this._drainQueue(this._lateQueue);
	};
	
	Async.prototype._queueTick = function () {
	    if (!this._isTickUsed) {
	        this._isTickUsed = true;
	        this._schedule(this.drainQueues);
	    }
	};
	
	Async.prototype._reset = function () {
	    this._isTickUsed = false;
	};
	
	module.exports = Async;
	module.exports.firstLineError = firstLineError;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process, setImmediate) {"use strict";
	var util = __webpack_require__(13);
	var schedule;
	var noAsyncScheduler = function() {
	    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var NativePromise = util.getNativePromise();
	if (util.isNode && typeof MutationObserver === "undefined") {
	    var GlobalSetImmediate = global.setImmediate;
	    var ProcessNextTick = process.nextTick;
	    schedule = util.isRecentNode
	                ? function(fn) { GlobalSetImmediate.call(global, fn); }
	                : function(fn) { ProcessNextTick.call(process, fn); };
	} else if (typeof NativePromise === "function" &&
	           typeof NativePromise.resolve === "function") {
	    var nativePromise = NativePromise.resolve();
	    schedule = function(fn) {
	        nativePromise.then(fn);
	    };
	} else if ((typeof MutationObserver !== "undefined") &&
	          !(typeof window !== "undefined" &&
	            window.navigator &&
	            (window.navigator.standalone || window.cordova))) {
	    schedule = (function() {
	        var div = document.createElement("div");
	        var opts = {attributes: true};
	        var toggleScheduled = false;
	        var div2 = document.createElement("div");
	        var o2 = new MutationObserver(function() {
	            div.classList.toggle("foo");
	            toggleScheduled = false;
	        });
	        o2.observe(div2, opts);
	
	        var scheduleToggle = function() {
	            if (toggleScheduled) return;
	            toggleScheduled = true;
	            div2.classList.toggle("foo");
	        };
	
	        return function schedule(fn) {
	            var o = new MutationObserver(function() {
	                o.disconnect();
	                fn();
	            });
	            o.observe(div, opts);
	            scheduleToggle();
	        };
	    })();
	} else if (typeof setImmediate !== "undefined") {
	    schedule = function (fn) {
	        setImmediate(fn);
	    };
	} else if (typeof setTimeout !== "undefined") {
	    schedule = function (fn) {
	        setTimeout(fn, 0);
	    };
	} else {
	    schedule = noAsyncScheduler;
	}
	module.exports = schedule;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(12), __webpack_require__(17).setImmediate))

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(12).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17).setImmediate, __webpack_require__(17).clearImmediate))

/***/ },
/* 18 */
/***/ function(module, exports) {

	"use strict";
	function arrayMove(src, srcIndex, dst, dstIndex, len) {
	    for (var j = 0; j < len; ++j) {
	        dst[j + dstIndex] = src[j + srcIndex];
	        src[j + srcIndex] = void 0;
	    }
	}
	
	function Queue(capacity) {
	    this._capacity = capacity;
	    this._length = 0;
	    this._front = 0;
	}
	
	Queue.prototype._willBeOverCapacity = function (size) {
	    return this._capacity < size;
	};
	
	Queue.prototype._pushOne = function (arg) {
	    var length = this.length();
	    this._checkCapacity(length + 1);
	    var i = (this._front + length) & (this._capacity - 1);
	    this[i] = arg;
	    this._length = length + 1;
	};
	
	Queue.prototype.push = function (fn, receiver, arg) {
	    var length = this.length() + 3;
	    if (this._willBeOverCapacity(length)) {
	        this._pushOne(fn);
	        this._pushOne(receiver);
	        this._pushOne(arg);
	        return;
	    }
	    var j = this._front + length - 3;
	    this._checkCapacity(length);
	    var wrapMask = this._capacity - 1;
	    this[(j + 0) & wrapMask] = fn;
	    this[(j + 1) & wrapMask] = receiver;
	    this[(j + 2) & wrapMask] = arg;
	    this._length = length;
	};
	
	Queue.prototype.shift = function () {
	    var front = this._front,
	        ret = this[front];
	
	    this[front] = undefined;
	    this._front = (front + 1) & (this._capacity - 1);
	    this._length--;
	    return ret;
	};
	
	Queue.prototype.length = function () {
	    return this._length;
	};
	
	Queue.prototype._checkCapacity = function (size) {
	    if (this._capacity < size) {
	        this._resizeTo(this._capacity << 1);
	    }
	};
	
	Queue.prototype._resizeTo = function (capacity) {
	    var oldCapacity = this._capacity;
	    this._capacity = capacity;
	    var front = this._front;
	    var length = this._length;
	    var moveItemsCount = (front + length) & (oldCapacity - 1);
	    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
	};
	
	module.exports = Queue;


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var es5 = __webpack_require__(14);
	var Objectfreeze = es5.freeze;
	var util = __webpack_require__(13);
	var inherits = util.inherits;
	var notEnumerableProp = util.notEnumerableProp;
	
	function subError(nameProperty, defaultMessage) {
	    function SubError(message) {
	        if (!(this instanceof SubError)) return new SubError(message);
	        notEnumerableProp(this, "message",
	            typeof message === "string" ? message : defaultMessage);
	        notEnumerableProp(this, "name", nameProperty);
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(this, this.constructor);
	        } else {
	            Error.call(this);
	        }
	    }
	    inherits(SubError, Error);
	    return SubError;
	}
	
	var _TypeError, _RangeError;
	var Warning = subError("Warning", "warning");
	var CancellationError = subError("CancellationError", "cancellation error");
	var TimeoutError = subError("TimeoutError", "timeout error");
	var AggregateError = subError("AggregateError", "aggregate error");
	try {
	    _TypeError = TypeError;
	    _RangeError = RangeError;
	} catch(e) {
	    _TypeError = subError("TypeError", "type error");
	    _RangeError = subError("RangeError", "range error");
	}
	
	var methods = ("join pop push shift unshift slice filter forEach some " +
	    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
	
	for (var i = 0; i < methods.length; ++i) {
	    if (typeof Array.prototype[methods[i]] === "function") {
	        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
	    }
	}
	
	es5.defineProperty(AggregateError.prototype, "length", {
	    value: 0,
	    configurable: false,
	    writable: true,
	    enumerable: true
	});
	AggregateError.prototype["isOperational"] = true;
	var level = 0;
	AggregateError.prototype.toString = function() {
	    var indent = Array(level * 4 + 1).join(" ");
	    var ret = "\n" + indent + "AggregateError of:" + "\n";
	    level++;
	    indent = Array(level * 4 + 1).join(" ");
	    for (var i = 0; i < this.length; ++i) {
	        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
	        var lines = str.split("\n");
	        for (var j = 0; j < lines.length; ++j) {
	            lines[j] = indent + lines[j];
	        }
	        str = lines.join("\n");
	        ret += str + "\n";
	    }
	    level--;
	    return ret;
	};
	
	function OperationalError(message) {
	    if (!(this instanceof OperationalError))
	        return new OperationalError(message);
	    notEnumerableProp(this, "name", "OperationalError");
	    notEnumerableProp(this, "message", message);
	    this.cause = message;
	    this["isOperational"] = true;
	
	    if (message instanceof Error) {
	        notEnumerableProp(this, "message", message.message);
	        notEnumerableProp(this, "stack", message.stack);
	    } else if (Error.captureStackTrace) {
	        Error.captureStackTrace(this, this.constructor);
	    }
	
	}
	inherits(OperationalError, Error);
	
	var errorTypes = Error["__BluebirdErrorTypes__"];
	if (!errorTypes) {
	    errorTypes = Objectfreeze({
	        CancellationError: CancellationError,
	        TimeoutError: TimeoutError,
	        OperationalError: OperationalError,
	        RejectionError: OperationalError,
	        AggregateError: AggregateError
	    });
	    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
	        value: errorTypes,
	        writable: false,
	        enumerable: false,
	        configurable: false
	    });
	}
	
	module.exports = {
	    Error: Error,
	    TypeError: _TypeError,
	    RangeError: _RangeError,
	    CancellationError: errorTypes.CancellationError,
	    OperationalError: errorTypes.OperationalError,
	    TimeoutError: errorTypes.TimeoutError,
	    AggregateError: errorTypes.AggregateError,
	    Warning: Warning
	};


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var util = __webpack_require__(13);
	var errorObj = util.errorObj;
	var isObject = util.isObject;
	
	function tryConvertToPromise(obj, context) {
	    if (isObject(obj)) {
	        if (obj instanceof Promise) return obj;
	        var then = getThen(obj);
	        if (then === errorObj) {
	            if (context) context._pushContext();
	            var ret = Promise.reject(then.e);
	            if (context) context._popContext();
	            return ret;
	        } else if (typeof then === "function") {
	            if (isAnyBluebirdPromise(obj)) {
	                var ret = new Promise(INTERNAL);
	                obj._then(
	                    ret._fulfill,
	                    ret._reject,
	                    undefined,
	                    ret,
	                    null
	                );
	                return ret;
	            }
	            return doThenable(obj, then, context);
	        }
	    }
	    return obj;
	}
	
	function doGetThen(obj) {
	    return obj.then;
	}
	
	function getThen(obj) {
	    try {
	        return doGetThen(obj);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	
	var hasProp = {}.hasOwnProperty;
	function isAnyBluebirdPromise(obj) {
	    try {
	        return hasProp.call(obj, "_promise0");
	    } catch (e) {
	        return false;
	    }
	}
	
	function doThenable(x, then, context) {
	    var promise = new Promise(INTERNAL);
	    var ret = promise;
	    if (context) context._pushContext();
	    promise._captureStackTrace();
	    if (context) context._popContext();
	    var synchronous = true;
	    var result = util.tryCatch(then).call(x, resolve, reject);
	    synchronous = false;
	
	    if (promise && result === errorObj) {
	        promise._rejectCallback(result.e, true, true);
	        promise = null;
	    }
	
	    function resolve(value) {
	        if (!promise) return;
	        promise._resolveCallback(value);
	        promise = null;
	    }
	
	    function reject(reason) {
	        if (!promise) return;
	        promise._rejectCallback(reason, synchronous, true);
	        promise = null;
	    }
	    return ret;
	}
	
	return tryConvertToPromise;
	};


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise,
	    apiRejection, Proxyable) {
	var util = __webpack_require__(13);
	var isArray = util.isArray;
	
	function toResolutionValue(val) {
	    switch(val) {
	    case -2: return [];
	    case -3: return {};
	    case -6: return new Map();
	    }
	}
	
	function PromiseArray(values) {
	    var promise = this._promise = new Promise(INTERNAL);
	    if (values instanceof Promise) {
	        promise._propagateFrom(values, 3);
	    }
	    promise._setOnCancel(this);
	    this._values = values;
	    this._length = 0;
	    this._totalResolved = 0;
	    this._init(undefined, -2);
	}
	util.inherits(PromiseArray, Proxyable);
	
	PromiseArray.prototype.length = function () {
	    return this._length;
	};
	
	PromiseArray.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
	    var values = tryConvertToPromise(this._values, this._promise);
	    if (values instanceof Promise) {
	        values = values._target();
	        var bitField = values._bitField;
	        ;
	        this._values = values;
	
	        if (((bitField & 50397184) === 0)) {
	            this._promise._setAsyncGuaranteed();
	            return values._then(
	                init,
	                this._reject,
	                undefined,
	                this,
	                resolveValueIfEmpty
	           );
	        } else if (((bitField & 33554432) !== 0)) {
	            values = values._value();
	        } else if (((bitField & 16777216) !== 0)) {
	            return this._reject(values._reason());
	        } else {
	            return this._cancel();
	        }
	    }
	    values = util.asArray(values);
	    if (values === null) {
	        var err = apiRejection(
	            "expecting an array or an iterable object but got " + util.classString(values)).reason();
	        this._promise._rejectCallback(err, false);
	        return;
	    }
	
	    if (values.length === 0) {
	        if (resolveValueIfEmpty === -5) {
	            this._resolveEmptyArray();
	        }
	        else {
	            this._resolve(toResolutionValue(resolveValueIfEmpty));
	        }
	        return;
	    }
	    this._iterate(values);
	};
	
	PromiseArray.prototype._iterate = function(values) {
	    var len = this.getActualLength(values.length);
	    this._length = len;
	    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
	    var result = this._promise;
	    var isResolved = false;
	    var bitField = null;
	    for (var i = 0; i < len; ++i) {
	        var maybePromise = tryConvertToPromise(values[i], result);
	
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            bitField = maybePromise._bitField;
	        } else {
	            bitField = null;
	        }
	
	        if (isResolved) {
	            if (bitField !== null) {
	                maybePromise.suppressUnhandledRejections();
	            }
	        } else if (bitField !== null) {
	            if (((bitField & 50397184) === 0)) {
	                maybePromise._proxy(this, i);
	                this._values[i] = maybePromise;
	            } else if (((bitField & 33554432) !== 0)) {
	                isResolved = this._promiseFulfilled(maybePromise._value(), i);
	            } else if (((bitField & 16777216) !== 0)) {
	                isResolved = this._promiseRejected(maybePromise._reason(), i);
	            } else {
	                isResolved = this._promiseCancelled(i);
	            }
	        } else {
	            isResolved = this._promiseFulfilled(maybePromise, i);
	        }
	    }
	    if (!isResolved) result._setAsyncGuaranteed();
	};
	
	PromiseArray.prototype._isResolved = function () {
	    return this._values === null;
	};
	
	PromiseArray.prototype._resolve = function (value) {
	    this._values = null;
	    this._promise._fulfill(value);
	};
	
	PromiseArray.prototype._cancel = function() {
	    if (this._isResolved() || !this._promise._isCancellable()) return;
	    this._values = null;
	    this._promise._cancel();
	};
	
	PromiseArray.prototype._reject = function (reason) {
	    this._values = null;
	    this._promise._rejectCallback(reason, false);
	};
	
	PromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	PromiseArray.prototype._promiseCancelled = function() {
	    this._cancel();
	    return true;
	};
	
	PromiseArray.prototype._promiseRejected = function (reason) {
	    this._totalResolved++;
	    this._reject(reason);
	    return true;
	};
	
	PromiseArray.prototype._resultCancelled = function() {
	    if (this._isResolved()) return;
	    var values = this._values;
	    this._cancel();
	    if (values instanceof Promise) {
	        values.cancel();
	    } else {
	        for (var i = 0; i < values.length; ++i) {
	            if (values[i] instanceof Promise) {
	                values[i].cancel();
	            }
	        }
	    }
	};
	
	PromiseArray.prototype.shouldCopyValues = function () {
	    return true;
	};
	
	PromiseArray.prototype.getActualLength = function (len) {
	    return len;
	};
	
	return PromiseArray;
	};


/***/ },
/* 22 */
/***/ function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	var longStackTraces = false;
	var contextStack = [];
	
	Promise.prototype._promiseCreated = function() {};
	Promise.prototype._pushContext = function() {};
	Promise.prototype._popContext = function() {return null;};
	Promise._peekContext = Promise.prototype._peekContext = function() {};
	
	function Context() {
	    this._trace = new Context.CapturedTrace(peekContext());
	}
	Context.prototype._pushContext = function () {
	    if (this._trace !== undefined) {
	        this._trace._promiseCreated = null;
	        contextStack.push(this._trace);
	    }
	};
	
	Context.prototype._popContext = function () {
	    if (this._trace !== undefined) {
	        var trace = contextStack.pop();
	        var ret = trace._promiseCreated;
	        trace._promiseCreated = null;
	        return ret;
	    }
	    return null;
	};
	
	function createContext() {
	    if (longStackTraces) return new Context();
	}
	
	function peekContext() {
	    var lastIndex = contextStack.length - 1;
	    if (lastIndex >= 0) {
	        return contextStack[lastIndex];
	    }
	    return undefined;
	}
	Context.CapturedTrace = null;
	Context.create = createContext;
	Context.deactivateLongStackTraces = function() {};
	Context.activateLongStackTraces = function() {
	    var Promise_pushContext = Promise.prototype._pushContext;
	    var Promise_popContext = Promise.prototype._popContext;
	    var Promise_PeekContext = Promise._peekContext;
	    var Promise_peekContext = Promise.prototype._peekContext;
	    var Promise_promiseCreated = Promise.prototype._promiseCreated;
	    Context.deactivateLongStackTraces = function() {
	        Promise.prototype._pushContext = Promise_pushContext;
	        Promise.prototype._popContext = Promise_popContext;
	        Promise._peekContext = Promise_PeekContext;
	        Promise.prototype._peekContext = Promise_peekContext;
	        Promise.prototype._promiseCreated = Promise_promiseCreated;
	        longStackTraces = false;
	    };
	    longStackTraces = true;
	    Promise.prototype._pushContext = Context.prototype._pushContext;
	    Promise.prototype._popContext = Context.prototype._popContext;
	    Promise._peekContext = Promise.prototype._peekContext = peekContext;
	    Promise.prototype._promiseCreated = function() {
	        var ctx = this._peekContext();
	        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
	    };
	};
	return Context;
	};


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	module.exports = function(Promise, Context) {
	var getDomain = Promise._getDomain;
	var async = Promise._async;
	var Warning = __webpack_require__(19).Warning;
	var util = __webpack_require__(13);
	var canAttachTrace = util.canAttachTrace;
	var unhandledRejectionHandled;
	var possiblyUnhandledRejection;
	var bluebirdFramePattern =
	    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
	var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
	var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
	var stackFramePattern = null;
	var formatStack = null;
	var indentStackFrames = false;
	var printWarning;
	var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
	                        (false ||
	                         util.env("BLUEBIRD_DEBUG") ||
	                         util.env("NODE_ENV") === "development"));
	
	var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
	    (debugging || util.env("BLUEBIRD_WARNINGS")));
	
	var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
	    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
	
	var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
	    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
	
	Promise.prototype.suppressUnhandledRejections = function() {
	    var target = this._target();
	    target._bitField = ((target._bitField & (~1048576)) |
	                      524288);
	};
	
	Promise.prototype._ensurePossibleRejectionHandled = function () {
	    if ((this._bitField & 524288) !== 0) return;
	    this._setRejectionIsUnhandled();
	    async.invokeLater(this._notifyUnhandledRejection, this, undefined);
	};
	
	Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
	    fireRejectionEvent("rejectionHandled",
	                                  unhandledRejectionHandled, undefined, this);
	};
	
	Promise.prototype._setReturnedNonUndefined = function() {
	    this._bitField = this._bitField | 268435456;
	};
	
	Promise.prototype._returnedNonUndefined = function() {
	    return (this._bitField & 268435456) !== 0;
	};
	
	Promise.prototype._notifyUnhandledRejection = function () {
	    if (this._isRejectionUnhandled()) {
	        var reason = this._settledValue();
	        this._setUnhandledRejectionIsNotified();
	        fireRejectionEvent("unhandledRejection",
	                                      possiblyUnhandledRejection, reason, this);
	    }
	};
	
	Promise.prototype._setUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField | 262144;
	};
	
	Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField & (~262144);
	};
	
	Promise.prototype._isUnhandledRejectionNotified = function () {
	    return (this._bitField & 262144) > 0;
	};
	
	Promise.prototype._setRejectionIsUnhandled = function () {
	    this._bitField = this._bitField | 1048576;
	};
	
	Promise.prototype._unsetRejectionIsUnhandled = function () {
	    this._bitField = this._bitField & (~1048576);
	    if (this._isUnhandledRejectionNotified()) {
	        this._unsetUnhandledRejectionIsNotified();
	        this._notifyUnhandledRejectionIsHandled();
	    }
	};
	
	Promise.prototype._isRejectionUnhandled = function () {
	    return (this._bitField & 1048576) > 0;
	};
	
	Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
	    return warn(message, shouldUseOwnTrace, promise || this);
	};
	
	Promise.onPossiblyUnhandledRejection = function (fn) {
	    var domain = getDomain();
	    possiblyUnhandledRejection =
	        typeof fn === "function" ? (domain === null ?
	                                            fn : util.domainBind(domain, fn))
	                                 : undefined;
	};
	
	Promise.onUnhandledRejectionHandled = function (fn) {
	    var domain = getDomain();
	    unhandledRejectionHandled =
	        typeof fn === "function" ? (domain === null ?
	                                            fn : util.domainBind(domain, fn))
	                                 : undefined;
	};
	
	var disableLongStackTraces = function() {};
	Promise.longStackTraces = function () {
	    if (async.haveItemsQueued() && !config.longStackTraces) {
	        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (!config.longStackTraces && longStackTracesIsSupported()) {
	        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
	        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
	        config.longStackTraces = true;
	        disableLongStackTraces = function() {
	            if (async.haveItemsQueued() && !config.longStackTraces) {
	                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	            }
	            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
	            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
	            Context.deactivateLongStackTraces();
	            async.enableTrampoline();
	            config.longStackTraces = false;
	        };
	        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
	        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
	        Context.activateLongStackTraces();
	        async.disableTrampolineIfNecessary();
	    }
	};
	
	Promise.hasLongStackTraces = function () {
	    return config.longStackTraces && longStackTracesIsSupported();
	};
	
	var fireDomEvent = (function() {
	    try {
	        if (typeof CustomEvent === "function") {
	            var event = new CustomEvent("CustomEvent");
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = new CustomEvent(name.toLowerCase(), {
	                    detail: event,
	                    cancelable: true
	                });
	                return !util.global.dispatchEvent(domEvent);
	            };
	        } else if (typeof Event === "function") {
	            var event = new Event("CustomEvent");
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = new Event(name.toLowerCase(), {
	                    cancelable: true
	                });
	                domEvent.detail = event;
	                return !util.global.dispatchEvent(domEvent);
	            };
	        } else {
	            var event = document.createEvent("CustomEvent");
	            event.initCustomEvent("testingtheevent", false, true, {});
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = document.createEvent("CustomEvent");
	                domEvent.initCustomEvent(name.toLowerCase(), false, true,
	                    event);
	                return !util.global.dispatchEvent(domEvent);
	            };
	        }
	    } catch (e) {}
	    return function() {
	        return false;
	    };
	})();
	
	var fireGlobalEvent = (function() {
	    if (util.isNode) {
	        return function() {
	            return process.emit.apply(process, arguments);
	        };
	    } else {
	        if (!util.global) {
	            return function() {
	                return false;
	            };
	        }
	        return function(name) {
	            var methodName = "on" + name.toLowerCase();
	            var method = util.global[methodName];
	            if (!method) return false;
	            method.apply(util.global, [].slice.call(arguments, 1));
	            return true;
	        };
	    }
	})();
	
	function generatePromiseLifecycleEventObject(name, promise) {
	    return {promise: promise};
	}
	
	var eventToObjectGenerator = {
	    promiseCreated: generatePromiseLifecycleEventObject,
	    promiseFulfilled: generatePromiseLifecycleEventObject,
	    promiseRejected: generatePromiseLifecycleEventObject,
	    promiseResolved: generatePromiseLifecycleEventObject,
	    promiseCancelled: generatePromiseLifecycleEventObject,
	    promiseChained: function(name, promise, child) {
	        return {promise: promise, child: child};
	    },
	    warning: function(name, warning) {
	        return {warning: warning};
	    },
	    unhandledRejection: function (name, reason, promise) {
	        return {reason: reason, promise: promise};
	    },
	    rejectionHandled: generatePromiseLifecycleEventObject
	};
	
	var activeFireEvent = function (name) {
	    var globalEventFired = false;
	    try {
	        globalEventFired = fireGlobalEvent.apply(null, arguments);
	    } catch (e) {
	        async.throwLater(e);
	        globalEventFired = true;
	    }
	
	    var domEventFired = false;
	    try {
	        domEventFired = fireDomEvent(name,
	                    eventToObjectGenerator[name].apply(null, arguments));
	    } catch (e) {
	        async.throwLater(e);
	        domEventFired = true;
	    }
	
	    return domEventFired || globalEventFired;
	};
	
	Promise.config = function(opts) {
	    opts = Object(opts);
	    if ("longStackTraces" in opts) {
	        if (opts.longStackTraces) {
	            Promise.longStackTraces();
	        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
	            disableLongStackTraces();
	        }
	    }
	    if ("warnings" in opts) {
	        var warningsOption = opts.warnings;
	        config.warnings = !!warningsOption;
	        wForgottenReturn = config.warnings;
	
	        if (util.isObject(warningsOption)) {
	            if ("wForgottenReturn" in warningsOption) {
	                wForgottenReturn = !!warningsOption.wForgottenReturn;
	            }
	        }
	    }
	    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
	        if (async.haveItemsQueued()) {
	            throw new Error(
	                "cannot enable cancellation after promises are in use");
	        }
	        Promise.prototype._clearCancellationData =
	            cancellationClearCancellationData;
	        Promise.prototype._propagateFrom = cancellationPropagateFrom;
	        Promise.prototype._onCancel = cancellationOnCancel;
	        Promise.prototype._setOnCancel = cancellationSetOnCancel;
	        Promise.prototype._attachCancellationCallback =
	            cancellationAttachCancellationCallback;
	        Promise.prototype._execute = cancellationExecute;
	        propagateFromFunction = cancellationPropagateFrom;
	        config.cancellation = true;
	    }
	    if ("monitoring" in opts) {
	        if (opts.monitoring && !config.monitoring) {
	            config.monitoring = true;
	            Promise.prototype._fireEvent = activeFireEvent;
	        } else if (!opts.monitoring && config.monitoring) {
	            config.monitoring = false;
	            Promise.prototype._fireEvent = defaultFireEvent;
	        }
	    }
	    return Promise;
	};
	
	function defaultFireEvent() { return false; }
	
	Promise.prototype._fireEvent = defaultFireEvent;
	Promise.prototype._execute = function(executor, resolve, reject) {
	    try {
	        executor(resolve, reject);
	    } catch (e) {
	        return e;
	    }
	};
	Promise.prototype._onCancel = function () {};
	Promise.prototype._setOnCancel = function (handler) { ; };
	Promise.prototype._attachCancellationCallback = function(onCancel) {
	    ;
	};
	Promise.prototype._captureStackTrace = function () {};
	Promise.prototype._attachExtraTrace = function () {};
	Promise.prototype._clearCancellationData = function() {};
	Promise.prototype._propagateFrom = function (parent, flags) {
	    ;
	    ;
	};
	
	function cancellationExecute(executor, resolve, reject) {
	    var promise = this;
	    try {
	        executor(resolve, reject, function(onCancel) {
	            if (typeof onCancel !== "function") {
	                throw new TypeError("onCancel must be a function, got: " +
	                                    util.toString(onCancel));
	            }
	            promise._attachCancellationCallback(onCancel);
	        });
	    } catch (e) {
	        return e;
	    }
	}
	
	function cancellationAttachCancellationCallback(onCancel) {
	    if (!this._isCancellable()) return this;
	
	    var previousOnCancel = this._onCancel();
	    if (previousOnCancel !== undefined) {
	        if (util.isArray(previousOnCancel)) {
	            previousOnCancel.push(onCancel);
	        } else {
	            this._setOnCancel([previousOnCancel, onCancel]);
	        }
	    } else {
	        this._setOnCancel(onCancel);
	    }
	}
	
	function cancellationOnCancel() {
	    return this._onCancelField;
	}
	
	function cancellationSetOnCancel(onCancel) {
	    this._onCancelField = onCancel;
	}
	
	function cancellationClearCancellationData() {
	    this._cancellationParent = undefined;
	    this._onCancelField = undefined;
	}
	
	function cancellationPropagateFrom(parent, flags) {
	    if ((flags & 1) !== 0) {
	        this._cancellationParent = parent;
	        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
	        if (branchesRemainingToCancel === undefined) {
	            branchesRemainingToCancel = 0;
	        }
	        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
	    }
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	
	function bindingPropagateFrom(parent, flags) {
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	var propagateFromFunction = bindingPropagateFrom;
	
	function boundValueFunction() {
	    var ret = this._boundTo;
	    if (ret !== undefined) {
	        if (ret instanceof Promise) {
	            if (ret.isFulfilled()) {
	                return ret.value();
	            } else {
	                return undefined;
	            }
	        }
	    }
	    return ret;
	}
	
	function longStackTracesCaptureStackTrace() {
	    this._trace = new CapturedTrace(this._peekContext());
	}
	
	function longStackTracesAttachExtraTrace(error, ignoreSelf) {
	    if (canAttachTrace(error)) {
	        var trace = this._trace;
	        if (trace !== undefined) {
	            if (ignoreSelf) trace = trace._parent;
	        }
	        if (trace !== undefined) {
	            trace.attachExtraTrace(error);
	        } else if (!error.__stackCleaned__) {
	            var parsed = parseStackAndMessage(error);
	            util.notEnumerableProp(error, "stack",
	                parsed.message + "\n" + parsed.stack.join("\n"));
	            util.notEnumerableProp(error, "__stackCleaned__", true);
	        }
	    }
	}
	
	function checkForgottenReturns(returnValue, promiseCreated, name, promise,
	                               parent) {
	    if (returnValue === undefined && promiseCreated !== null &&
	        wForgottenReturn) {
	        if (parent !== undefined && parent._returnedNonUndefined()) return;
	        if ((promise._bitField & 65535) === 0) return;
	
	        if (name) name = name + " ";
	        var handlerLine = "";
	        var creatorLine = "";
	        if (promiseCreated._trace) {
	            var traceLines = promiseCreated._trace.stack.split("\n");
	            var stack = cleanStack(traceLines);
	            for (var i = stack.length - 1; i >= 0; --i) {
	                var line = stack[i];
	                if (!nodeFramePattern.test(line)) {
	                    var lineMatches = line.match(parseLinePattern);
	                    if (lineMatches) {
	                        handlerLine  = "at " + lineMatches[1] +
	                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
	                    }
	                    break;
	                }
	            }
	
	            if (stack.length > 0) {
	                var firstUserLine = stack[0];
	                for (var i = 0; i < traceLines.length; ++i) {
	
	                    if (traceLines[i] === firstUserLine) {
	                        if (i > 0) {
	                            creatorLine = "\n" + traceLines[i - 1];
	                        }
	                        break;
	                    }
	                }
	
	            }
	        }
	        var msg = "a promise was created in a " + name +
	            "handler " + handlerLine + "but was not returned from it, " +
	            "see http://goo.gl/rRqMUw" +
	            creatorLine;
	        promise._warn(msg, true, promiseCreated);
	    }
	}
	
	function deprecated(name, replacement) {
	    var message = name +
	        " is deprecated and will be removed in a future version.";
	    if (replacement) message += " Use " + replacement + " instead.";
	    return warn(message);
	}
	
	function warn(message, shouldUseOwnTrace, promise) {
	    if (!config.warnings) return;
	    var warning = new Warning(message);
	    var ctx;
	    if (shouldUseOwnTrace) {
	        promise._attachExtraTrace(warning);
	    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
	        ctx.attachExtraTrace(warning);
	    } else {
	        var parsed = parseStackAndMessage(warning);
	        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
	    }
	
	    if (!activeFireEvent("warning", warning)) {
	        formatAndLogError(warning, "", true);
	    }
	}
	
	function reconstructStack(message, stacks) {
	    for (var i = 0; i < stacks.length - 1; ++i) {
	        stacks[i].push("From previous event:");
	        stacks[i] = stacks[i].join("\n");
	    }
	    if (i < stacks.length) {
	        stacks[i] = stacks[i].join("\n");
	    }
	    return message + "\n" + stacks.join("\n");
	}
	
	function removeDuplicateOrEmptyJumps(stacks) {
	    for (var i = 0; i < stacks.length; ++i) {
	        if (stacks[i].length === 0 ||
	            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
	            stacks.splice(i, 1);
	            i--;
	        }
	    }
	}
	
	function removeCommonRoots(stacks) {
	    var current = stacks[0];
	    for (var i = 1; i < stacks.length; ++i) {
	        var prev = stacks[i];
	        var currentLastIndex = current.length - 1;
	        var currentLastLine = current[currentLastIndex];
	        var commonRootMeetPoint = -1;
	
	        for (var j = prev.length - 1; j >= 0; --j) {
	            if (prev[j] === currentLastLine) {
	                commonRootMeetPoint = j;
	                break;
	            }
	        }
	
	        for (var j = commonRootMeetPoint; j >= 0; --j) {
	            var line = prev[j];
	            if (current[currentLastIndex] === line) {
	                current.pop();
	                currentLastIndex--;
	            } else {
	                break;
	            }
	        }
	        current = prev;
	    }
	}
	
	function cleanStack(stack) {
	    var ret = [];
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        var isTraceLine = "    (No stack trace)" === line ||
	            stackFramePattern.test(line);
	        var isInternalFrame = isTraceLine && shouldIgnore(line);
	        if (isTraceLine && !isInternalFrame) {
	            if (indentStackFrames && line.charAt(0) !== " ") {
	                line = "    " + line;
	            }
	            ret.push(line);
	        }
	    }
	    return ret;
	}
	
	function stackFramesAsArray(error) {
	    var stack = error.stack.replace(/\s+$/g, "").split("\n");
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
	            break;
	        }
	    }
	    if (i > 0 && error.name != "SyntaxError") {
	        stack = stack.slice(i);
	    }
	    return stack;
	}
	
	function parseStackAndMessage(error) {
	    var stack = error.stack;
	    var message = error.toString();
	    stack = typeof stack === "string" && stack.length > 0
	                ? stackFramesAsArray(error) : ["    (No stack trace)"];
	    return {
	        message: message,
	        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
	    };
	}
	
	function formatAndLogError(error, title, isSoft) {
	    if (typeof console !== "undefined") {
	        var message;
	        if (util.isObject(error)) {
	            var stack = error.stack;
	            message = title + formatStack(stack, error);
	        } else {
	            message = title + String(error);
	        }
	        if (typeof printWarning === "function") {
	            printWarning(message, isSoft);
	        } else if (typeof console.log === "function" ||
	            typeof console.log === "object") {
	            console.log(message);
	        }
	    }
	}
	
	function fireRejectionEvent(name, localHandler, reason, promise) {
	    var localEventFired = false;
	    try {
	        if (typeof localHandler === "function") {
	            localEventFired = true;
	            if (name === "rejectionHandled") {
	                localHandler(promise);
	            } else {
	                localHandler(reason, promise);
	            }
	        }
	    } catch (e) {
	        async.throwLater(e);
	    }
	
	    if (name === "unhandledRejection") {
	        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
	            formatAndLogError(reason, "Unhandled rejection ");
	        }
	    } else {
	        activeFireEvent(name, promise);
	    }
	}
	
	function formatNonError(obj) {
	    var str;
	    if (typeof obj === "function") {
	        str = "[function " +
	            (obj.name || "anonymous") +
	            "]";
	    } else {
	        str = obj && typeof obj.toString === "function"
	            ? obj.toString() : util.toString(obj);
	        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
	        if (ruselessToString.test(str)) {
	            try {
	                var newStr = JSON.stringify(obj);
	                str = newStr;
	            }
	            catch(e) {
	
	            }
	        }
	        if (str.length === 0) {
	            str = "(empty array)";
	        }
	    }
	    return ("(<" + snip(str) + ">, no stack trace)");
	}
	
	function snip(str) {
	    var maxChars = 41;
	    if (str.length < maxChars) {
	        return str;
	    }
	    return str.substr(0, maxChars - 3) + "...";
	}
	
	function longStackTracesIsSupported() {
	    return typeof captureStackTrace === "function";
	}
	
	var shouldIgnore = function() { return false; };
	var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
	function parseLineInfo(line) {
	    var matches = line.match(parseLineInfoRegex);
	    if (matches) {
	        return {
	            fileName: matches[1],
	            line: parseInt(matches[2], 10)
	        };
	    }
	}
	
	function setBounds(firstLineError, lastLineError) {
	    if (!longStackTracesIsSupported()) return;
	    var firstStackLines = firstLineError.stack.split("\n");
	    var lastStackLines = lastLineError.stack.split("\n");
	    var firstIndex = -1;
	    var lastIndex = -1;
	    var firstFileName;
	    var lastFileName;
	    for (var i = 0; i < firstStackLines.length; ++i) {
	        var result = parseLineInfo(firstStackLines[i]);
	        if (result) {
	            firstFileName = result.fileName;
	            firstIndex = result.line;
	            break;
	        }
	    }
	    for (var i = 0; i < lastStackLines.length; ++i) {
	        var result = parseLineInfo(lastStackLines[i]);
	        if (result) {
	            lastFileName = result.fileName;
	            lastIndex = result.line;
	            break;
	        }
	    }
	    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
	        firstFileName !== lastFileName || firstIndex >= lastIndex) {
	        return;
	    }
	
	    shouldIgnore = function(line) {
	        if (bluebirdFramePattern.test(line)) return true;
	        var info = parseLineInfo(line);
	        if (info) {
	            if (info.fileName === firstFileName &&
	                (firstIndex <= info.line && info.line <= lastIndex)) {
	                return true;
	            }
	        }
	        return false;
	    };
	}
	
	function CapturedTrace(parent) {
	    this._parent = parent;
	    this._promisesCreated = 0;
	    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
	    captureStackTrace(this, CapturedTrace);
	    if (length > 32) this.uncycle();
	}
	util.inherits(CapturedTrace, Error);
	Context.CapturedTrace = CapturedTrace;
	
	CapturedTrace.prototype.uncycle = function() {
	    var length = this._length;
	    if (length < 2) return;
	    var nodes = [];
	    var stackToIndex = {};
	
	    for (var i = 0, node = this; node !== undefined; ++i) {
	        nodes.push(node);
	        node = node._parent;
	    }
	    length = this._length = i;
	    for (var i = length - 1; i >= 0; --i) {
	        var stack = nodes[i].stack;
	        if (stackToIndex[stack] === undefined) {
	            stackToIndex[stack] = i;
	        }
	    }
	    for (var i = 0; i < length; ++i) {
	        var currentStack = nodes[i].stack;
	        var index = stackToIndex[currentStack];
	        if (index !== undefined && index !== i) {
	            if (index > 0) {
	                nodes[index - 1]._parent = undefined;
	                nodes[index - 1]._length = 1;
	            }
	            nodes[i]._parent = undefined;
	            nodes[i]._length = 1;
	            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
	
	            if (index < length - 1) {
	                cycleEdgeNode._parent = nodes[index + 1];
	                cycleEdgeNode._parent.uncycle();
	                cycleEdgeNode._length =
	                    cycleEdgeNode._parent._length + 1;
	            } else {
	                cycleEdgeNode._parent = undefined;
	                cycleEdgeNode._length = 1;
	            }
	            var currentChildLength = cycleEdgeNode._length + 1;
	            for (var j = i - 2; j >= 0; --j) {
	                nodes[j]._length = currentChildLength;
	                currentChildLength++;
	            }
	            return;
	        }
	    }
	};
	
	CapturedTrace.prototype.attachExtraTrace = function(error) {
	    if (error.__stackCleaned__) return;
	    this.uncycle();
	    var parsed = parseStackAndMessage(error);
	    var message = parsed.message;
	    var stacks = [parsed.stack];
	
	    var trace = this;
	    while (trace !== undefined) {
	        stacks.push(cleanStack(trace.stack.split("\n")));
	        trace = trace._parent;
	    }
	    removeCommonRoots(stacks);
	    removeDuplicateOrEmptyJumps(stacks);
	    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
	    util.notEnumerableProp(error, "__stackCleaned__", true);
	};
	
	var captureStackTrace = (function stackDetection() {
	    var v8stackFramePattern = /^\s*at\s*/;
	    var v8stackFormatter = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if (error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    if (typeof Error.stackTraceLimit === "number" &&
	        typeof Error.captureStackTrace === "function") {
	        Error.stackTraceLimit += 6;
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        var captureStackTrace = Error.captureStackTrace;
	
	        shouldIgnore = function(line) {
	            return bluebirdFramePattern.test(line);
	        };
	        return function(receiver, ignoreUntil) {
	            Error.stackTraceLimit += 6;
	            captureStackTrace(receiver, ignoreUntil);
	            Error.stackTraceLimit -= 6;
	        };
	    }
	    var err = new Error();
	
	    if (typeof err.stack === "string" &&
	        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
	        stackFramePattern = /@/;
	        formatStack = v8stackFormatter;
	        indentStackFrames = true;
	        return function captureStackTrace(o) {
	            o.stack = new Error().stack;
	        };
	    }
	
	    var hasStackAfterThrow;
	    try { throw new Error(); }
	    catch(e) {
	        hasStackAfterThrow = ("stack" in e);
	    }
	    if (!("stack" in err) && hasStackAfterThrow &&
	        typeof Error.stackTraceLimit === "number") {
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        return function captureStackTrace(o) {
	            Error.stackTraceLimit += 6;
	            try { throw new Error(); }
	            catch(e) { o.stack = e.stack; }
	            Error.stackTraceLimit -= 6;
	        };
	    }
	
	    formatStack = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if ((typeof error === "object" ||
	            typeof error === "function") &&
	            error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    return null;
	
	})([]);
	
	if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
	    printWarning = function (message) {
	        console.warn(message);
	    };
	    if (util.isNode && process.stderr.isTTY) {
	        printWarning = function(message, isSoft) {
	            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
	            console.warn(color + message + "\u001b[0m\n");
	        };
	    } else if (!util.isNode && typeof (new Error().stack) === "string") {
	        printWarning = function(message, isSoft) {
	            console.warn("%c" + message,
	                        isSoft ? "color: darkorange" : "color: red");
	        };
	    }
	}
	
	var config = {
	    warnings: warnings,
	    longStackTraces: false,
	    cancellation: false,
	    monitoring: false
	};
	
	if (longStackTraces) Promise.longStackTraces();
	
	return {
	    longStackTraces: function() {
	        return config.longStackTraces;
	    },
	    warnings: function() {
	        return config.warnings;
	    },
	    cancellation: function() {
	        return config.cancellation;
	    },
	    monitoring: function() {
	        return config.monitoring;
	    },
	    propagateFromFunction: function() {
	        return propagateFromFunction;
	    },
	    boundValueFunction: function() {
	        return boundValueFunction;
	    },
	    checkForgottenReturns: checkForgottenReturns,
	    setBounds: setBounds,
	    warn: warn,
	    deprecated: deprecated,
	    CapturedTrace: CapturedTrace,
	    fireDomEvent: fireDomEvent,
	    fireGlobalEvent: fireGlobalEvent
	};
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, tryConvertToPromise, NEXT_FILTER) {
	var util = __webpack_require__(13);
	var CancellationError = Promise.CancellationError;
	var errorObj = util.errorObj;
	var catchFilter = __webpack_require__(25)(NEXT_FILTER);
	
	function PassThroughHandlerContext(promise, type, handler) {
	    this.promise = promise;
	    this.type = type;
	    this.handler = handler;
	    this.called = false;
	    this.cancelPromise = null;
	}
	
	PassThroughHandlerContext.prototype.isFinallyHandler = function() {
	    return this.type === 0;
	};
	
	function FinallyHandlerCancelReaction(finallyHandler) {
	    this.finallyHandler = finallyHandler;
	}
	
	FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
	    checkCancel(this.finallyHandler);
	};
	
	function checkCancel(ctx, reason) {
	    if (ctx.cancelPromise != null) {
	        if (arguments.length > 1) {
	            ctx.cancelPromise._reject(reason);
	        } else {
	            ctx.cancelPromise._cancel();
	        }
	        ctx.cancelPromise = null;
	        return true;
	    }
	    return false;
	}
	
	function succeed() {
	    return finallyHandler.call(this, this.promise._target()._settledValue());
	}
	function fail(reason) {
	    if (checkCancel(this, reason)) return;
	    errorObj.e = reason;
	    return errorObj;
	}
	function finallyHandler(reasonOrValue) {
	    var promise = this.promise;
	    var handler = this.handler;
	
	    if (!this.called) {
	        this.called = true;
	        var ret = this.isFinallyHandler()
	            ? handler.call(promise._boundValue())
	            : handler.call(promise._boundValue(), reasonOrValue);
	        if (ret === NEXT_FILTER) {
	            return ret;
	        } else if (ret !== undefined) {
	            promise._setReturnedNonUndefined();
	            var maybePromise = tryConvertToPromise(ret, promise);
	            if (maybePromise instanceof Promise) {
	                if (this.cancelPromise != null) {
	                    if (maybePromise._isCancelled()) {
	                        var reason =
	                            new CancellationError("late cancellation observer");
	                        promise._attachExtraTrace(reason);
	                        errorObj.e = reason;
	                        return errorObj;
	                    } else if (maybePromise.isPending()) {
	                        maybePromise._attachCancellationCallback(
	                            new FinallyHandlerCancelReaction(this));
	                    }
	                }
	                return maybePromise._then(
	                    succeed, fail, undefined, this, undefined);
	            }
	        }
	    }
	
	    if (promise.isRejected()) {
	        checkCancel(this);
	        errorObj.e = reasonOrValue;
	        return errorObj;
	    } else {
	        checkCancel(this);
	        return reasonOrValue;
	    }
	}
	
	Promise.prototype._passThrough = function(handler, type, success, fail) {
	    if (typeof handler !== "function") return this.then();
	    return this._then(success,
	                      fail,
	                      undefined,
	                      new PassThroughHandlerContext(this, type, handler),
	                      undefined);
	};
	
	Promise.prototype.lastly =
	Promise.prototype["finally"] = function (handler) {
	    return this._passThrough(handler,
	                             0,
	                             finallyHandler,
	                             finallyHandler);
	};
	
	
	Promise.prototype.tap = function (handler) {
	    return this._passThrough(handler, 1, finallyHandler);
	};
	
	Promise.prototype.tapCatch = function (handlerOrPredicate) {
	    var len = arguments.length;
	    if(len === 1) {
	        return this._passThrough(handlerOrPredicate,
	                                 1,
	                                 undefined,
	                                 finallyHandler);
	    } else {
	         var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return Promise.reject(new TypeError(
	                    "tapCatch statement predicate: "
	                    + "expecting an object but got " + util.classString(item)
	                ));
	            }
	        }
	        catchInstances.length = j;
	        var handler = arguments[i];
	        return this._passThrough(catchFilter(catchInstances, handler, this),
	                                 1,
	                                 undefined,
	                                 finallyHandler);
	    }
	
	};
	
	return PassThroughHandlerContext;
	};


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(NEXT_FILTER) {
	var util = __webpack_require__(13);
	var getKeys = __webpack_require__(14).keys;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function catchFilter(instances, cb, promise) {
	    return function(e) {
	        var boundTo = promise._boundValue();
	        predicateLoop: for (var i = 0; i < instances.length; ++i) {
	            var item = instances[i];
	
	            if (item === Error ||
	                (item != null && item.prototype instanceof Error)) {
	                if (e instanceof item) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (typeof item === "function") {
	                var matchesPredicate = tryCatch(item).call(boundTo, e);
	                if (matchesPredicate === errorObj) {
	                    return matchesPredicate;
	                } else if (matchesPredicate) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (util.isObject(e)) {
	                var keys = getKeys(item);
	                for (var j = 0; j < keys.length; ++j) {
	                    var key = keys[j];
	                    if (item[key] != e[key]) {
	                        continue predicateLoop;
	                    }
	                }
	                return tryCatch(cb).call(boundTo, e);
	            }
	        }
	        return NEXT_FILTER;
	    };
	}
	
	return catchFilter;
	};


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var util = __webpack_require__(13);
	var maybeWrapAsError = util.maybeWrapAsError;
	var errors = __webpack_require__(19);
	var OperationalError = errors.OperationalError;
	var es5 = __webpack_require__(14);
	
	function isUntypedError(obj) {
	    return obj instanceof Error &&
	        es5.getPrototypeOf(obj) === Error.prototype;
	}
	
	var rErrorKey = /^(?:name|message|stack|cause)$/;
	function wrapAsOperationalError(obj) {
	    var ret;
	    if (isUntypedError(obj)) {
	        ret = new OperationalError(obj);
	        ret.name = obj.name;
	        ret.message = obj.message;
	        ret.stack = obj.stack;
	        var keys = es5.keys(obj);
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!rErrorKey.test(key)) {
	                ret[key] = obj[key];
	            }
	        }
	        return ret;
	    }
	    util.markAsOriginatingFromRejection(obj);
	    return obj;
	}
	
	function nodebackForPromise(promise, multiArgs) {
	    return function(err, value) {
	        if (promise === null) return;
	        if (err) {
	            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
	            promise._attachExtraTrace(wrapped);
	            promise._reject(wrapped);
	        } else if (!multiArgs) {
	            promise._fulfill(value);
	        } else {
	            var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0)); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];};
	            promise._fulfill(args);
	        }
	        promise = null;
	    };
	}
	
	module.exports = nodebackForPromise;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
	var util = __webpack_require__(13);
	var tryCatch = util.tryCatch;
	
	Promise.method = function (fn) {
	    if (typeof fn !== "function") {
	        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return function () {
	        var ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._pushContext();
	        var value = tryCatch(fn).apply(this, arguments);
	        var promiseCreated = ret._popContext();
	        debug.checkForgottenReturns(
	            value, promiseCreated, "Promise.method", ret);
	        ret._resolveFromSyncValue(value);
	        return ret;
	    };
	};
	
	Promise.attempt = Promise["try"] = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._pushContext();
	    var value;
	    if (arguments.length > 1) {
	        debug.deprecated("calling Promise.try with more than 1 argument");
	        var arg = arguments[1];
	        var ctx = arguments[2];
	        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
	                                  : tryCatch(fn).call(ctx, arg);
	    } else {
	        value = tryCatch(fn)();
	    }
	    var promiseCreated = ret._popContext();
	    debug.checkForgottenReturns(
	        value, promiseCreated, "Promise.try", ret);
	    ret._resolveFromSyncValue(value);
	    return ret;
	};
	
	Promise.prototype._resolveFromSyncValue = function (value) {
	    if (value === util.errorObj) {
	        this._rejectCallback(value.e, false);
	    } else {
	        this._resolveCallback(value, true);
	    }
	};
	};


/***/ },
/* 28 */
/***/ function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
	var calledBind = false;
	var rejectThis = function(_, e) {
	    this._reject(e);
	};
	
	var targetRejected = function(e, context) {
	    context.promiseRejectionQueued = true;
	    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
	};
	
	var bindingResolved = function(thisArg, context) {
	    if (((this._bitField & 50397184) === 0)) {
	        this._resolveCallback(context.target);
	    }
	};
	
	var bindingRejected = function(e, context) {
	    if (!context.promiseRejectionQueued) this._reject(e);
	};
	
	Promise.prototype.bind = function (thisArg) {
	    if (!calledBind) {
	        calledBind = true;
	        Promise.prototype._propagateFrom = debug.propagateFromFunction();
	        Promise.prototype._boundValue = debug.boundValueFunction();
	    }
	    var maybePromise = tryConvertToPromise(thisArg);
	    var ret = new Promise(INTERNAL);
	    ret._propagateFrom(this, 1);
	    var target = this._target();
	    ret._setBoundTo(maybePromise);
	    if (maybePromise instanceof Promise) {
	        var context = {
	            promiseRejectionQueued: false,
	            promise: ret,
	            target: target,
	            bindingPromise: maybePromise
	        };
	        target._then(INTERNAL, targetRejected, undefined, ret, context);
	        maybePromise._then(
	            bindingResolved, bindingRejected, undefined, ret, context);
	        ret._setOnCancel(maybePromise);
	    } else {
	        ret._resolveCallback(target);
	    }
	    return ret;
	};
	
	Promise.prototype._setBoundTo = function (obj) {
	    if (obj !== undefined) {
	        this._bitField = this._bitField | 2097152;
	        this._boundTo = obj;
	    } else {
	        this._bitField = this._bitField & (~2097152);
	    }
	};
	
	Promise.prototype._isBound = function () {
	    return (this._bitField & 2097152) === 2097152;
	};
	
	Promise.bind = function (thisArg, value) {
	    return Promise.resolve(value).bind(thisArg);
	};
	};


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, PromiseArray, apiRejection, debug) {
	var util = __webpack_require__(13);
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	Promise.prototype["break"] = Promise.prototype.cancel = function() {
	    if (!debug.cancellation()) return this._warn("cancellation is disabled");
	
	    var promise = this;
	    var child = promise;
	    while (promise._isCancellable()) {
	        if (!promise._cancelBy(child)) {
	            if (child._isFollowing()) {
	                child._followee().cancel();
	            } else {
	                child._cancelBranched();
	            }
	            break;
	        }
	
	        var parent = promise._cancellationParent;
	        if (parent == null || !parent._isCancellable()) {
	            if (promise._isFollowing()) {
	                promise._followee().cancel();
	            } else {
	                promise._cancelBranched();
	            }
	            break;
	        } else {
	            if (promise._isFollowing()) promise._followee().cancel();
	            promise._setWillBeCancelled();
	            child = promise;
	            promise = parent;
	        }
	    }
	};
	
	Promise.prototype._branchHasCancelled = function() {
	    this._branchesRemainingToCancel--;
	};
	
	Promise.prototype._enoughBranchesHaveCancelled = function() {
	    return this._branchesRemainingToCancel === undefined ||
	           this._branchesRemainingToCancel <= 0;
	};
	
	Promise.prototype._cancelBy = function(canceller) {
	    if (canceller === this) {
	        this._branchesRemainingToCancel = 0;
	        this._invokeOnCancel();
	        return true;
	    } else {
	        this._branchHasCancelled();
	        if (this._enoughBranchesHaveCancelled()) {
	            this._invokeOnCancel();
	            return true;
	        }
	    }
	    return false;
	};
	
	Promise.prototype._cancelBranched = function() {
	    if (this._enoughBranchesHaveCancelled()) {
	        this._cancel();
	    }
	};
	
	Promise.prototype._cancel = function() {
	    if (!this._isCancellable()) return;
	    this._setCancelled();
	    async.invoke(this._cancelPromises, this, undefined);
	};
	
	Promise.prototype._cancelPromises = function() {
	    if (this._length() > 0) this._settlePromises();
	};
	
	Promise.prototype._unsetOnCancel = function() {
	    this._onCancelField = undefined;
	};
	
	Promise.prototype._isCancellable = function() {
	    return this.isPending() && !this._isCancelled();
	};
	
	Promise.prototype.isCancellable = function() {
	    return this.isPending() && !this.isCancelled();
	};
	
	Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
	    if (util.isArray(onCancelCallback)) {
	        for (var i = 0; i < onCancelCallback.length; ++i) {
	            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
	        }
	    } else if (onCancelCallback !== undefined) {
	        if (typeof onCancelCallback === "function") {
	            if (!internalOnly) {
	                var e = tryCatch(onCancelCallback).call(this._boundValue());
	                if (e === errorObj) {
	                    this._attachExtraTrace(e.e);
	                    async.throwLater(e.e);
	                }
	            }
	        } else {
	            onCancelCallback._resultCancelled(this);
	        }
	    }
	};
	
	Promise.prototype._invokeOnCancel = function() {
	    var onCancelCallback = this._onCancel();
	    this._unsetOnCancel();
	    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
	};
	
	Promise.prototype._invokeInternalOnCancel = function() {
	    if (this._isCancellable()) {
	        this._doInvokeOnCancel(this._onCancel(), true);
	        this._unsetOnCancel();
	    }
	};
	
	Promise.prototype._resultCancelled = function() {
	    this.cancel();
	};
	
	};


/***/ },
/* 30 */
/***/ function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	function returner() {
	    return this.value;
	}
	function thrower() {
	    throw this.reason;
	}
	
	Promise.prototype["return"] =
	Promise.prototype.thenReturn = function (value) {
	    if (value instanceof Promise) value.suppressUnhandledRejections();
	    return this._then(
	        returner, undefined, undefined, {value: value}, undefined);
	};
	
	Promise.prototype["throw"] =
	Promise.prototype.thenThrow = function (reason) {
	    return this._then(
	        thrower, undefined, undefined, {reason: reason}, undefined);
	};
	
	Promise.prototype.catchThrow = function (reason) {
	    if (arguments.length <= 1) {
	        return this._then(
	            undefined, thrower, undefined, {reason: reason}, undefined);
	    } else {
	        var _reason = arguments[1];
	        var handler = function() {throw _reason;};
	        return this.caught(reason, handler);
	    }
	};
	
	Promise.prototype.catchReturn = function (value) {
	    if (arguments.length <= 1) {
	        if (value instanceof Promise) value.suppressUnhandledRejections();
	        return this._then(
	            undefined, returner, undefined, {value: value}, undefined);
	    } else {
	        var _value = arguments[1];
	        if (_value instanceof Promise) _value.suppressUnhandledRejections();
	        var handler = function() {return _value;};
	        return this.caught(value, handler);
	    }
	};
	};


/***/ },
/* 31 */
/***/ function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	function PromiseInspection(promise) {
	    if (promise !== undefined) {
	        promise = promise._target();
	        this._bitField = promise._bitField;
	        this._settledValueField = promise._isFateSealed()
	            ? promise._settledValue() : undefined;
	    }
	    else {
	        this._bitField = 0;
	        this._settledValueField = undefined;
	    }
	}
	
	PromiseInspection.prototype._settledValue = function() {
	    return this._settledValueField;
	};
	
	var value = PromiseInspection.prototype.value = function () {
	    if (!this.isFulfilled()) {
	        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var reason = PromiseInspection.prototype.error =
	PromiseInspection.prototype.reason = function () {
	    if (!this.isRejected()) {
	        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
	    return (this._bitField & 33554432) !== 0;
	};
	
	var isRejected = PromiseInspection.prototype.isRejected = function () {
	    return (this._bitField & 16777216) !== 0;
	};
	
	var isPending = PromiseInspection.prototype.isPending = function () {
	    return (this._bitField & 50397184) === 0;
	};
	
	var isResolved = PromiseInspection.prototype.isResolved = function () {
	    return (this._bitField & 50331648) !== 0;
	};
	
	PromiseInspection.prototype.isCancelled = function() {
	    return (this._bitField & 8454144) !== 0;
	};
	
	Promise.prototype.__isCancelled = function() {
	    return (this._bitField & 65536) === 65536;
	};
	
	Promise.prototype._isCancelled = function() {
	    return this._target().__isCancelled();
	};
	
	Promise.prototype.isCancelled = function() {
	    return (this._target()._bitField & 8454144) !== 0;
	};
	
	Promise.prototype.isPending = function() {
	    return isPending.call(this._target());
	};
	
	Promise.prototype.isRejected = function() {
	    return isRejected.call(this._target());
	};
	
	Promise.prototype.isFulfilled = function() {
	    return isFulfilled.call(this._target());
	};
	
	Promise.prototype.isResolved = function() {
	    return isResolved.call(this._target());
	};
	
	Promise.prototype.value = function() {
	    return value.call(this._target());
	};
	
	Promise.prototype.reason = function() {
	    var target = this._target();
	    target._unsetRejectionIsUnhandled();
	    return reason.call(target);
	};
	
	Promise.prototype._value = function() {
	    return this._settledValue();
	};
	
	Promise.prototype._reason = function() {
	    this._unsetRejectionIsUnhandled();
	    return this._settledValue();
	};
	
	Promise.PromiseInspection = PromiseInspection;
	};


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async,
	         getDomain) {
	var util = __webpack_require__(13);
	var canEvaluate = util.canEvaluate;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var reject;
	
	if (true) {
	if (canEvaluate) {
	    var thenCallback = function(i) {
	        return new Function("value", "holder", "                             \n\
	            'use strict';                                                    \n\
	            holder.pIndex = value;                                           \n\
	            holder.checkFulfillment(this);                                   \n\
	            ".replace(/Index/g, i));
	    };
	
	    var promiseSetter = function(i) {
	        return new Function("promise", "holder", "                           \n\
	            'use strict';                                                    \n\
	            holder.pIndex = promise;                                         \n\
	            ".replace(/Index/g, i));
	    };
	
	    var generateHolderClass = function(total) {
	        var props = new Array(total);
	        for (var i = 0; i < props.length; ++i) {
	            props[i] = "this.p" + (i+1);
	        }
	        var assignment = props.join(" = ") + " = null;";
	        var cancellationCode= "var promise;\n" + props.map(function(prop) {
	            return "                                                         \n\
	                promise = " + prop + ";                                      \n\
	                if (promise instanceof Promise) {                            \n\
	                    promise.cancel();                                        \n\
	                }                                                            \n\
	            ";
	        }).join("\n");
	        var passedArguments = props.join(", ");
	        var name = "Holder$" + total;
	
	
	        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
	            'use strict';                                                    \n\
	            function [TheName](fn) {                                         \n\
	                [TheProperties]                                              \n\
	                this.fn = fn;                                                \n\
	                this.asyncNeeded = true;                                     \n\
	                this.now = 0;                                                \n\
	            }                                                                \n\
	                                                                             \n\
	            [TheName].prototype._callFunction = function(promise) {          \n\
	                promise._pushContext();                                      \n\
	                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
	                promise._popContext();                                       \n\
	                if (ret === errorObj) {                                      \n\
	                    promise._rejectCallback(ret.e, false);                   \n\
	                } else {                                                     \n\
	                    promise._resolveCallback(ret);                           \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype.checkFulfillment = function(promise) {       \n\
	                var now = ++this.now;                                        \n\
	                if (now === [TheTotal]) {                                    \n\
	                    if (this.asyncNeeded) {                                  \n\
	                        async.invoke(this._callFunction, this, promise);     \n\
	                    } else {                                                 \n\
	                        this._callFunction(promise);                         \n\
	                    }                                                        \n\
	                                                                             \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype._resultCancelled = function() {              \n\
	                [CancellationCode]                                           \n\
	            };                                                               \n\
	                                                                             \n\
	            return [TheName];                                                \n\
	        }(tryCatch, errorObj, Promise, async);                               \n\
	        ";
	
	        code = code.replace(/\[TheName\]/g, name)
	            .replace(/\[TheTotal\]/g, total)
	            .replace(/\[ThePassedArguments\]/g, passedArguments)
	            .replace(/\[TheProperties\]/g, assignment)
	            .replace(/\[CancellationCode\]/g, cancellationCode);
	
	        return new Function("tryCatch", "errorObj", "Promise", "async", code)
	                           (tryCatch, errorObj, Promise, async);
	    };
	
	    var holderClasses = [];
	    var thenCallbacks = [];
	    var promiseSetters = [];
	
	    for (var i = 0; i < 8; ++i) {
	        holderClasses.push(generateHolderClass(i + 1));
	        thenCallbacks.push(thenCallback(i + 1));
	        promiseSetters.push(promiseSetter(i + 1));
	    }
	
	    reject = function (reason) {
	        this._reject(reason);
	    };
	}}
	
	Promise.join = function () {
	    var last = arguments.length - 1;
	    var fn;
	    if (last > 0 && typeof arguments[last] === "function") {
	        fn = arguments[last];
	        if (true) {
	            if (last <= 8 && canEvaluate) {
	                var ret = new Promise(INTERNAL);
	                ret._captureStackTrace();
	                var HolderClass = holderClasses[last - 1];
	                var holder = new HolderClass(fn);
	                var callbacks = thenCallbacks;
	
	                for (var i = 0; i < last; ++i) {
	                    var maybePromise = tryConvertToPromise(arguments[i], ret);
	                    if (maybePromise instanceof Promise) {
	                        maybePromise = maybePromise._target();
	                        var bitField = maybePromise._bitField;
	                        ;
	                        if (((bitField & 50397184) === 0)) {
	                            maybePromise._then(callbacks[i], reject,
	                                               undefined, ret, holder);
	                            promiseSetters[i](maybePromise, holder);
	                            holder.asyncNeeded = false;
	                        } else if (((bitField & 33554432) !== 0)) {
	                            callbacks[i].call(ret,
	                                              maybePromise._value(), holder);
	                        } else if (((bitField & 16777216) !== 0)) {
	                            ret._reject(maybePromise._reason());
	                        } else {
	                            ret._cancel();
	                        }
	                    } else {
	                        callbacks[i].call(ret, maybePromise, holder);
	                    }
	                }
	
	                if (!ret._isFateSealed()) {
	                    if (holder.asyncNeeded) {
	                        var domain = getDomain();
	                        if (domain !== null) {
	                            holder.fn = util.domainBind(domain, holder.fn);
	                        }
	                    }
	                    ret._setAsyncGuaranteed();
	                    ret._setOnCancel(holder);
	                }
	                return ret;
	            }
	        }
	    }
	    var $_len = arguments.length;var args = new Array($_len); for(var $_i = 0; $_i < $_len; ++$_i) {args[$_i] = arguments[$_i];};
	    if (fn) args.pop();
	    var ret = new PromiseArray(args).promise();
	    return fn !== undefined ? ret.spread(fn) : ret;
	};
	
	};


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL,
	                          debug) {
	var getDomain = Promise._getDomain;
	var util = __webpack_require__(13);
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	function MappingPromiseArray(promises, fn, limit, _filter) {
	    this.constructor$(promises);
	    this._promise._captureStackTrace();
	    var domain = getDomain();
	    this._callback = domain === null ? fn : util.domainBind(domain, fn);
	    this._preservedValues = _filter === INTERNAL
	        ? new Array(this.length())
	        : null;
	    this._limit = limit;
	    this._inFlight = 0;
	    this._queue = [];
	    async.invoke(this._asyncInit, this, undefined);
	}
	util.inherits(MappingPromiseArray, PromiseArray);
	
	MappingPromiseArray.prototype._asyncInit = function() {
	    this._init$(undefined, -2);
	};
	
	MappingPromiseArray.prototype._init = function () {};
	
	MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var values = this._values;
	    var length = this.length();
	    var preservedValues = this._preservedValues;
	    var limit = this._limit;
	
	    if (index < 0) {
	        index = (index * -1) - 1;
	        values[index] = value;
	        if (limit >= 1) {
	            this._inFlight--;
	            this._drainQueue();
	            if (this._isResolved()) return true;
	        }
	    } else {
	        if (limit >= 1 && this._inFlight >= limit) {
	            values[index] = value;
	            this._queue.push(index);
	            return false;
	        }
	        if (preservedValues !== null) preservedValues[index] = value;
	
	        var promise = this._promise;
	        var callback = this._callback;
	        var receiver = promise._boundValue();
	        promise._pushContext();
	        var ret = tryCatch(callback).call(receiver, value, index, length);
	        var promiseCreated = promise._popContext();
	        debug.checkForgottenReturns(
	            ret,
	            promiseCreated,
	            preservedValues !== null ? "Promise.filter" : "Promise.map",
	            promise
	        );
	        if (ret === errorObj) {
	            this._reject(ret.e);
	            return true;
	        }
	
	        var maybePromise = tryConvertToPromise(ret, this._promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            var bitField = maybePromise._bitField;
	            ;
	            if (((bitField & 50397184) === 0)) {
	                if (limit >= 1) this._inFlight++;
	                values[index] = maybePromise;
	                maybePromise._proxy(this, (index + 1) * -1);
	                return false;
	            } else if (((bitField & 33554432) !== 0)) {
	                ret = maybePromise._value();
	            } else if (((bitField & 16777216) !== 0)) {
	                this._reject(maybePromise._reason());
	                return true;
	            } else {
	                this._cancel();
	                return true;
	            }
	        }
	        values[index] = ret;
	    }
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= length) {
	        if (preservedValues !== null) {
	            this._filter(values, preservedValues);
	        } else {
	            this._resolve(values);
	        }
	        return true;
	    }
	    return false;
	};
	
	MappingPromiseArray.prototype._drainQueue = function () {
	    var queue = this._queue;
	    var limit = this._limit;
	    var values = this._values;
	    while (queue.length > 0 && this._inFlight < limit) {
	        if (this._isResolved()) return;
	        var index = queue.pop();
	        this._promiseFulfilled(values[index], index);
	    }
	};
	
	MappingPromiseArray.prototype._filter = function (booleans, values) {
	    var len = values.length;
	    var ret = new Array(len);
	    var j = 0;
	    for (var i = 0; i < len; ++i) {
	        if (booleans[i]) ret[j++] = values[i];
	    }
	    ret.length = j;
	    this._resolve(ret);
	};
	
	MappingPromiseArray.prototype.preservedValues = function () {
	    return this._preservedValues;
	};
	
	function map(promises, fn, options, _filter) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	
	    var limit = 0;
	    if (options !== undefined) {
	        if (typeof options === "object" && options !== null) {
	            if (typeof options.concurrency !== "number") {
	                return Promise.reject(
	                    new TypeError("'concurrency' must be a number but it is " +
	                                    util.classString(options.concurrency)));
	            }
	            limit = options.concurrency;
	        } else {
	            return Promise.reject(new TypeError(
	                            "options argument must be an object but it is " +
	                             util.classString(options)));
	        }
	    }
	    limit = typeof limit === "number" &&
	        isFinite(limit) && limit >= 1 ? limit : 0;
	    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
	}
	
	Promise.prototype.map = function (fn, options) {
	    return map(this, fn, options, null);
	};
	
	Promise.map = function (promises, fn, options, _filter) {
	    return map(promises, fn, options, _filter);
	};
	
	
	};


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var cr = Object.create;
	if (cr) {
	    var callerCache = cr(null);
	    var getterCache = cr(null);
	    callerCache[" size"] = getterCache[" size"] = 0;
	}
	
	module.exports = function(Promise) {
	var util = __webpack_require__(13);
	var canEvaluate = util.canEvaluate;
	var isIdentifier = util.isIdentifier;
	
	var getMethodCaller;
	var getGetter;
	if (true) {
	var makeMethodCaller = function (methodName) {
	    return new Function("ensureMethod", "                                    \n\
	        return function(obj) {                                               \n\
	            'use strict'                                                     \n\
	            var len = this.length;                                           \n\
	            ensureMethod(obj, 'methodName');                                 \n\
	            switch(len) {                                                    \n\
	                case 1: return obj.methodName(this[0]);                      \n\
	                case 2: return obj.methodName(this[0], this[1]);             \n\
	                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
	                case 0: return obj.methodName();                             \n\
	                default:                                                     \n\
	                    return obj.methodName.apply(obj, this);                  \n\
	            }                                                                \n\
	        };                                                                   \n\
	        ".replace(/methodName/g, methodName))(ensureMethod);
	};
	
	var makeGetter = function (propertyName) {
	    return new Function("obj", "                                             \n\
	        'use strict';                                                        \n\
	        return obj.propertyName;                                             \n\
	        ".replace("propertyName", propertyName));
	};
	
	var getCompiled = function(name, compiler, cache) {
	    var ret = cache[name];
	    if (typeof ret !== "function") {
	        if (!isIdentifier(name)) {
	            return null;
	        }
	        ret = compiler(name);
	        cache[name] = ret;
	        cache[" size"]++;
	        if (cache[" size"] > 512) {
	            var keys = Object.keys(cache);
	            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
	            cache[" size"] = keys.length - 256;
	        }
	    }
	    return ret;
	};
	
	getMethodCaller = function(name) {
	    return getCompiled(name, makeMethodCaller, callerCache);
	};
	
	getGetter = function(name) {
	    return getCompiled(name, makeGetter, getterCache);
	};
	}
	
	function ensureMethod(obj, methodName) {
	    var fn;
	    if (obj != null) fn = obj[methodName];
	    if (typeof fn !== "function") {
	        var message = "Object " + util.classString(obj) + " has no method '" +
	            util.toString(methodName) + "'";
	        throw new Promise.TypeError(message);
	    }
	    return fn;
	}
	
	function caller(obj) {
	    var methodName = this.pop();
	    var fn = ensureMethod(obj, methodName);
	    return fn.apply(obj, this);
	}
	Promise.prototype.call = function (methodName) {
	    var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0)); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];};
	    if (true) {
	        if (canEvaluate) {
	            var maybeCaller = getMethodCaller(methodName);
	            if (maybeCaller !== null) {
	                return this._then(
	                    maybeCaller, undefined, undefined, args, undefined);
	            }
	        }
	    }
	    args.push(methodName);
	    return this._then(caller, undefined, undefined, args, undefined);
	};
	
	function namedGetter(obj) {
	    return obj[this];
	}
	function indexedGetter(obj) {
	    var index = +this;
	    if (index < 0) index = Math.max(0, index + obj.length);
	    return obj[index];
	}
	Promise.prototype.get = function (propertyName) {
	    var isIndex = (typeof propertyName === "number");
	    var getter;
	    if (!isIndex) {
	        if (canEvaluate) {
	            var maybeGetter = getGetter(propertyName);
	            getter = maybeGetter !== null ? maybeGetter : namedGetter;
	        } else {
	            getter = namedGetter;
	        }
	    } else {
	        getter = indexedGetter;
	    }
	    return this._then(getter, undefined, undefined, propertyName, undefined);
	};
	};


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function (Promise, apiRejection, tryConvertToPromise,
	    createContext, INTERNAL, debug) {
	    var util = __webpack_require__(13);
	    var TypeError = __webpack_require__(19).TypeError;
	    var inherits = __webpack_require__(13).inherits;
	    var errorObj = util.errorObj;
	    var tryCatch = util.tryCatch;
	    var NULL = {};
	
	    function thrower(e) {
	        setTimeout(function(){throw e;}, 0);
	    }
	
	    function castPreservingDisposable(thenable) {
	        var maybePromise = tryConvertToPromise(thenable);
	        if (maybePromise !== thenable &&
	            typeof thenable._isDisposable === "function" &&
	            typeof thenable._getDisposer === "function" &&
	            thenable._isDisposable()) {
	            maybePromise._setDisposable(thenable._getDisposer());
	        }
	        return maybePromise;
	    }
	    function dispose(resources, inspection) {
	        var i = 0;
	        var len = resources.length;
	        var ret = new Promise(INTERNAL);
	        function iterator() {
	            if (i >= len) return ret._fulfill();
	            var maybePromise = castPreservingDisposable(resources[i++]);
	            if (maybePromise instanceof Promise &&
	                maybePromise._isDisposable()) {
	                try {
	                    maybePromise = tryConvertToPromise(
	                        maybePromise._getDisposer().tryDispose(inspection),
	                        resources.promise);
	                } catch (e) {
	                    return thrower(e);
	                }
	                if (maybePromise instanceof Promise) {
	                    return maybePromise._then(iterator, thrower,
	                                              null, null, null);
	                }
	            }
	            iterator();
	        }
	        iterator();
	        return ret;
	    }
	
	    function Disposer(data, promise, context) {
	        this._data = data;
	        this._promise = promise;
	        this._context = context;
	    }
	
	    Disposer.prototype.data = function () {
	        return this._data;
	    };
	
	    Disposer.prototype.promise = function () {
	        return this._promise;
	    };
	
	    Disposer.prototype.resource = function () {
	        if (this.promise().isFulfilled()) {
	            return this.promise().value();
	        }
	        return NULL;
	    };
	
	    Disposer.prototype.tryDispose = function(inspection) {
	        var resource = this.resource();
	        var context = this._context;
	        if (context !== undefined) context._pushContext();
	        var ret = resource !== NULL
	            ? this.doDispose(resource, inspection) : null;
	        if (context !== undefined) context._popContext();
	        this._promise._unsetDisposable();
	        this._data = null;
	        return ret;
	    };
	
	    Disposer.isDisposer = function (d) {
	        return (d != null &&
	                typeof d.resource === "function" &&
	                typeof d.tryDispose === "function");
	    };
	
	    function FunctionDisposer(fn, promise, context) {
	        this.constructor$(fn, promise, context);
	    }
	    inherits(FunctionDisposer, Disposer);
	
	    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
	        var fn = this.data();
	        return fn.call(resource, resource, inspection);
	    };
	
	    function maybeUnwrapDisposer(value) {
	        if (Disposer.isDisposer(value)) {
	            this.resources[this.index]._setDisposable(value);
	            return value.promise();
	        }
	        return value;
	    }
	
	    function ResourceList(length) {
	        this.length = length;
	        this.promise = null;
	        this[length-1] = null;
	    }
	
	    ResourceList.prototype._resultCancelled = function() {
	        var len = this.length;
	        for (var i = 0; i < len; ++i) {
	            var item = this[i];
	            if (item instanceof Promise) {
	                item.cancel();
	            }
	        }
	    };
	
	    Promise.using = function () {
	        var len = arguments.length;
	        if (len < 2) return apiRejection(
	                        "you must pass at least 2 arguments to Promise.using");
	        var fn = arguments[len - 1];
	        if (typeof fn !== "function") {
	            return apiRejection("expecting a function but got " + util.classString(fn));
	        }
	        var input;
	        var spreadArgs = true;
	        if (len === 2 && Array.isArray(arguments[0])) {
	            input = arguments[0];
	            len = input.length;
	            spreadArgs = false;
	        } else {
	            input = arguments;
	            len--;
	        }
	        var resources = new ResourceList(len);
	        for (var i = 0; i < len; ++i) {
	            var resource = input[i];
	            if (Disposer.isDisposer(resource)) {
	                var disposer = resource;
	                resource = resource.promise();
	                resource._setDisposable(disposer);
	            } else {
	                var maybePromise = tryConvertToPromise(resource);
	                if (maybePromise instanceof Promise) {
	                    resource =
	                        maybePromise._then(maybeUnwrapDisposer, null, null, {
	                            resources: resources,
	                            index: i
	                    }, undefined);
	                }
	            }
	            resources[i] = resource;
	        }
	
	        var reflectedResources = new Array(resources.length);
	        for (var i = 0; i < reflectedResources.length; ++i) {
	            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
	        }
	
	        var resultPromise = Promise.all(reflectedResources)
	            .then(function(inspections) {
	                for (var i = 0; i < inspections.length; ++i) {
	                    var inspection = inspections[i];
	                    if (inspection.isRejected()) {
	                        errorObj.e = inspection.error();
	                        return errorObj;
	                    } else if (!inspection.isFulfilled()) {
	                        resultPromise.cancel();
	                        return;
	                    }
	                    inspections[i] = inspection.value();
	                }
	                promise._pushContext();
	
	                fn = tryCatch(fn);
	                var ret = spreadArgs
	                    ? fn.apply(undefined, inspections) : fn(inspections);
	                var promiseCreated = promise._popContext();
	                debug.checkForgottenReturns(
	                    ret, promiseCreated, "Promise.using", promise);
	                return ret;
	            });
	
	        var promise = resultPromise.lastly(function() {
	            var inspection = new Promise.PromiseInspection(resultPromise);
	            return dispose(resources, inspection);
	        });
	        resources.promise = promise;
	        promise._setOnCancel(resources);
	        return promise;
	    };
	
	    Promise.prototype._setDisposable = function (disposer) {
	        this._bitField = this._bitField | 131072;
	        this._disposer = disposer;
	    };
	
	    Promise.prototype._isDisposable = function () {
	        return (this._bitField & 131072) > 0;
	    };
	
	    Promise.prototype._getDisposer = function () {
	        return this._disposer;
	    };
	
	    Promise.prototype._unsetDisposable = function () {
	        this._bitField = this._bitField & (~131072);
	        this._disposer = undefined;
	    };
	
	    Promise.prototype.disposer = function (fn) {
	        if (typeof fn === "function") {
	            return new FunctionDisposer(fn, this, createContext());
	        }
	        throw new TypeError();
	    };
	
	};


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL, debug) {
	var util = __webpack_require__(13);
	var TimeoutError = Promise.TimeoutError;
	
	function HandleWrapper(handle)  {
	    this.handle = handle;
	}
	
	HandleWrapper.prototype._resultCancelled = function() {
	    clearTimeout(this.handle);
	};
	
	var afterValue = function(value) { return delay(+this).thenReturn(value); };
	var delay = Promise.delay = function (ms, value) {
	    var ret;
	    var handle;
	    if (value !== undefined) {
	        ret = Promise.resolve(value)
	                ._then(afterValue, null, null, ms, undefined);
	        if (debug.cancellation() && value instanceof Promise) {
	            ret._setOnCancel(value);
	        }
	    } else {
	        ret = new Promise(INTERNAL);
	        handle = setTimeout(function() { ret._fulfill(); }, +ms);
	        if (debug.cancellation()) {
	            ret._setOnCancel(new HandleWrapper(handle));
	        }
	        ret._captureStackTrace();
	    }
	    ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.prototype.delay = function (ms) {
	    return delay(ms, this);
	};
	
	var afterTimeout = function (promise, message, parent) {
	    var err;
	    if (typeof message !== "string") {
	        if (message instanceof Error) {
	            err = message;
	        } else {
	            err = new TimeoutError("operation timed out");
	        }
	    } else {
	        err = new TimeoutError(message);
	    }
	    util.markAsOriginatingFromRejection(err);
	    promise._attachExtraTrace(err);
	    promise._reject(err);
	
	    if (parent != null) {
	        parent.cancel();
	    }
	};
	
	function successClear(value) {
	    clearTimeout(this.handle);
	    return value;
	}
	
	function failureClear(reason) {
	    clearTimeout(this.handle);
	    throw reason;
	}
	
	Promise.prototype.timeout = function (ms, message) {
	    ms = +ms;
	    var ret, parent;
	
	    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
	        if (ret.isPending()) {
	            afterTimeout(ret, message, parent);
	        }
	    }, ms));
	
	    if (debug.cancellation()) {
	        parent = this.then();
	        ret = parent._then(successClear, failureClear,
	                            undefined, handleWrapper, undefined);
	        ret._setOnCancel(handleWrapper);
	    } else {
	        ret = this._then(successClear, failureClear,
	                            undefined, handleWrapper, undefined);
	    }
	
	    return ret;
	};
	
	};


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          apiRejection,
	                          INTERNAL,
	                          tryConvertToPromise,
	                          Proxyable,
	                          debug) {
	var errors = __webpack_require__(19);
	var TypeError = errors.TypeError;
	var util = __webpack_require__(13);
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	var yieldHandlers = [];
	
	function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
	    for (var i = 0; i < yieldHandlers.length; ++i) {
	        traceParent._pushContext();
	        var result = tryCatch(yieldHandlers[i])(value);
	        traceParent._popContext();
	        if (result === errorObj) {
	            traceParent._pushContext();
	            var ret = Promise.reject(errorObj.e);
	            traceParent._popContext();
	            return ret;
	        }
	        var maybePromise = tryConvertToPromise(result, traceParent);
	        if (maybePromise instanceof Promise) return maybePromise;
	    }
	    return null;
	}
	
	function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
	    if (debug.cancellation()) {
	        var internal = new Promise(INTERNAL);
	        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
	        this._promise = internal.lastly(function() {
	            return _finallyPromise;
	        });
	        internal._captureStackTrace();
	        internal._setOnCancel(this);
	    } else {
	        var promise = this._promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	    }
	    this._stack = stack;
	    this._generatorFunction = generatorFunction;
	    this._receiver = receiver;
	    this._generator = undefined;
	    this._yieldHandlers = typeof yieldHandler === "function"
	        ? [yieldHandler].concat(yieldHandlers)
	        : yieldHandlers;
	    this._yieldedPromise = null;
	    this._cancellationPhase = false;
	}
	util.inherits(PromiseSpawn, Proxyable);
	
	PromiseSpawn.prototype._isResolved = function() {
	    return this._promise === null;
	};
	
	PromiseSpawn.prototype._cleanup = function() {
	    this._promise = this._generator = null;
	    if (debug.cancellation() && this._finallyPromise !== null) {
	        this._finallyPromise._fulfill();
	        this._finallyPromise = null;
	    }
	};
	
	PromiseSpawn.prototype._promiseCancelled = function() {
	    if (this._isResolved()) return;
	    var implementsReturn = typeof this._generator["return"] !== "undefined";
	
	    var result;
	    if (!implementsReturn) {
	        var reason = new Promise.CancellationError(
	            "generator .return() sentinel");
	        Promise.coroutine.returnSentinel = reason;
	        this._promise._attachExtraTrace(reason);
	        this._promise._pushContext();
	        result = tryCatch(this._generator["throw"]).call(this._generator,
	                                                         reason);
	        this._promise._popContext();
	    } else {
	        this._promise._pushContext();
	        result = tryCatch(this._generator["return"]).call(this._generator,
	                                                          undefined);
	        this._promise._popContext();
	    }
	    this._cancellationPhase = true;
	    this._yieldedPromise = null;
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._promiseFulfilled = function(value) {
	    this._yieldedPromise = null;
	    this._promise._pushContext();
	    var result = tryCatch(this._generator.next).call(this._generator, value);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._promiseRejected = function(reason) {
	    this._yieldedPromise = null;
	    this._promise._attachExtraTrace(reason);
	    this._promise._pushContext();
	    var result = tryCatch(this._generator["throw"])
	        .call(this._generator, reason);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._resultCancelled = function() {
	    if (this._yieldedPromise instanceof Promise) {
	        var promise = this._yieldedPromise;
	        this._yieldedPromise = null;
	        promise.cancel();
	    }
	};
	
	PromiseSpawn.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseSpawn.prototype._run = function () {
	    this._generator = this._generatorFunction.call(this._receiver);
	    this._receiver =
	        this._generatorFunction = undefined;
	    this._promiseFulfilled(undefined);
	};
	
	PromiseSpawn.prototype._continue = function (result) {
	    var promise = this._promise;
	    if (result === errorObj) {
	        this._cleanup();
	        if (this._cancellationPhase) {
	            return promise.cancel();
	        } else {
	            return promise._rejectCallback(result.e, false);
	        }
	    }
	
	    var value = result.value;
	    if (result.done === true) {
	        this._cleanup();
	        if (this._cancellationPhase) {
	            return promise.cancel();
	        } else {
	            return promise._resolveCallback(value);
	        }
	    } else {
	        var maybePromise = tryConvertToPromise(value, this._promise);
	        if (!(maybePromise instanceof Promise)) {
	            maybePromise =
	                promiseFromYieldHandler(maybePromise,
	                                        this._yieldHandlers,
	                                        this._promise);
	            if (maybePromise === null) {
	                this._promiseRejected(
	                    new TypeError(
	                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) +
	                        "From coroutine:\u000a" +
	                        this._stack.split("\n").slice(1, -7).join("\n")
	                    )
	                );
	                return;
	            }
	        }
	        maybePromise = maybePromise._target();
	        var bitField = maybePromise._bitField;
	        ;
	        if (((bitField & 50397184) === 0)) {
	            this._yieldedPromise = maybePromise;
	            maybePromise._proxy(this, null);
	        } else if (((bitField & 33554432) !== 0)) {
	            Promise._async.invoke(
	                this._promiseFulfilled, this, maybePromise._value()
	            );
	        } else if (((bitField & 16777216) !== 0)) {
	            Promise._async.invoke(
	                this._promiseRejected, this, maybePromise._reason()
	            );
	        } else {
	            this._promiseCancelled();
	        }
	    }
	};
	
	Promise.coroutine = function (generatorFunction, options) {
	    if (typeof generatorFunction !== "function") {
	        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var yieldHandler = Object(options).yieldHandler;
	    var PromiseSpawn$ = PromiseSpawn;
	    var stack = new Error().stack;
	    return function () {
	        var generator = generatorFunction.apply(this, arguments);
	        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
	                                      stack);
	        var ret = spawn.promise();
	        spawn._generator = generator;
	        spawn._promiseFulfilled(undefined);
	        return ret;
	    };
	};
	
	Promise.coroutine.addYieldHandler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    yieldHandlers.push(fn);
	};
	
	Promise.spawn = function (generatorFunction) {
	    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
	    if (typeof generatorFunction !== "function") {
	        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var spawn = new PromiseSpawn(generatorFunction, this);
	    var ret = spawn.promise();
	    spawn._run(Promise.spawn);
	    return ret;
	};
	};


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise) {
	var util = __webpack_require__(13);
	var async = Promise._async;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function spreadAdapter(val, nodeback) {
	    var promise = this;
	    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
	    var ret =
	        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	function successAdapter(val, nodeback) {
	    var promise = this;
	    var receiver = promise._boundValue();
	    var ret = val === undefined
	        ? tryCatch(nodeback).call(receiver, null)
	        : tryCatch(nodeback).call(receiver, null, val);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	function errorAdapter(reason, nodeback) {
	    var promise = this;
	    if (!reason) {
	        var newReason = new Error(reason + "");
	        newReason.cause = reason;
	        reason = newReason;
	    }
	    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
	                                                                     options) {
	    if (typeof nodeback == "function") {
	        var adapter = successAdapter;
	        if (options !== undefined && Object(options).spread) {
	            adapter = spreadAdapter;
	        }
	        this._then(
	            adapter,
	            errorAdapter,
	            undefined,
	            this,
	            nodeback
	        );
	    }
	    return this;
	};
	};


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var THIS = {};
	var util = __webpack_require__(13);
	var nodebackForPromise = __webpack_require__(26);
	var withAppended = util.withAppended;
	var maybeWrapAsError = util.maybeWrapAsError;
	var canEvaluate = util.canEvaluate;
	var TypeError = __webpack_require__(19).TypeError;
	var defaultSuffix = "Async";
	var defaultPromisified = {__isPromisified__: true};
	var noCopyProps = [
	    "arity",    "length",
	    "name",
	    "arguments",
	    "caller",
	    "callee",
	    "prototype",
	    "__isPromisified__"
	];
	var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
	
	var defaultFilter = function(name) {
	    return util.isIdentifier(name) &&
	        name.charAt(0) !== "_" &&
	        name !== "constructor";
	};
	
	function propsFilter(key) {
	    return !noCopyPropsPattern.test(key);
	}
	
	function isPromisified(fn) {
	    try {
	        return fn.__isPromisified__ === true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	
	function hasPromisified(obj, key, suffix) {
	    var val = util.getDataPropertyOrDefault(obj, key + suffix,
	                                            defaultPromisified);
	    return val ? isPromisified(val) : false;
	}
	function checkValid(ret, suffix, suffixRegexp) {
	    for (var i = 0; i < ret.length; i += 2) {
	        var key = ret[i];
	        if (suffixRegexp.test(key)) {
	            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
	            for (var j = 0; j < ret.length; j += 2) {
	                if (ret[j] === keyWithoutAsyncSuffix) {
	                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
	                        .replace("%s", suffix));
	                }
	            }
	        }
	    }
	}
	
	function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
	    var keys = util.inheritedDataKeys(obj);
	    var ret = [];
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var value = obj[key];
	        var passesDefaultFilter = filter === defaultFilter
	            ? true : defaultFilter(key, value, obj);
	        if (typeof value === "function" &&
	            !isPromisified(value) &&
	            !hasPromisified(obj, key, suffix) &&
	            filter(key, value, obj, passesDefaultFilter)) {
	            ret.push(key, value);
	        }
	    }
	    checkValid(ret, suffix, suffixRegexp);
	    return ret;
	}
	
	var escapeIdentRegex = function(str) {
	    return str.replace(/([$])/, "\\$");
	};
	
	var makeNodePromisifiedEval;
	if (true) {
	var switchCaseArgumentOrder = function(likelyArgumentCount) {
	    var ret = [likelyArgumentCount];
	    var min = Math.max(0, likelyArgumentCount - 1 - 3);
	    for(var i = likelyArgumentCount - 1; i >= min; --i) {
	        ret.push(i);
	    }
	    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
	        ret.push(i);
	    }
	    return ret;
	};
	
	var argumentSequence = function(argumentCount) {
	    return util.filledRange(argumentCount, "_arg", "");
	};
	
	var parameterDeclaration = function(parameterCount) {
	    return util.filledRange(
	        Math.max(parameterCount, 3), "_arg", "");
	};
	
	var parameterCount = function(fn) {
	    if (typeof fn.length === "number") {
	        return Math.max(Math.min(fn.length, 1023 + 1), 0);
	    }
	    return 0;
	};
	
	makeNodePromisifiedEval =
	function(callback, receiver, originalName, fn, _, multiArgs) {
	    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
	    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
	    var shouldProxyThis = typeof callback === "string" || receiver === THIS;
	
	    function generateCallForArgumentCount(count) {
	        var args = argumentSequence(count).join(", ");
	        var comma = count > 0 ? ", " : "";
	        var ret;
	        if (shouldProxyThis) {
	            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
	        } else {
	            ret = receiver === undefined
	                ? "ret = callback({{args}}, nodeback); break;\n"
	                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
	        }
	        return ret.replace("{{args}}", args).replace(", ", comma);
	    }
	
	    function generateArgumentSwitchCase() {
	        var ret = "";
	        for (var i = 0; i < argumentOrder.length; ++i) {
	            ret += "case " + argumentOrder[i] +":" +
	                generateCallForArgumentCount(argumentOrder[i]);
	        }
	
	        ret += "                                                             \n\
	        default:                                                             \n\
	            var args = new Array(len + 1);                                   \n\
	            var i = 0;                                                       \n\
	            for (var i = 0; i < len; ++i) {                                  \n\
	               args[i] = arguments[i];                                       \n\
	            }                                                                \n\
	            args[i] = nodeback;                                              \n\
	            [CodeForCall]                                                    \n\
	            break;                                                           \n\
	        ".replace("[CodeForCall]", (shouldProxyThis
	                                ? "ret = callback.apply(this, args);\n"
	                                : "ret = callback.apply(receiver, args);\n"));
	        return ret;
	    }
	
	    var getFunctionCode = typeof callback === "string"
	                                ? ("this != null ? this['"+callback+"'] : fn")
	                                : "fn";
	    var body = "'use strict';                                                \n\
	        var ret = function (Parameters) {                                    \n\
	            'use strict';                                                    \n\
	            var len = arguments.length;                                      \n\
	            var promise = new Promise(INTERNAL);                             \n\
	            promise._captureStackTrace();                                    \n\
	            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
	            var ret;                                                         \n\
	            var callback = tryCatch([GetFunctionCode]);                      \n\
	            switch(len) {                                                    \n\
	                [CodeForSwitchCase]                                          \n\
	            }                                                                \n\
	            if (ret === errorObj) {                                          \n\
	                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
	            }                                                                \n\
	            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
	            return promise;                                                  \n\
	        };                                                                   \n\
	        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
	        return ret;                                                          \n\
	    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
	        .replace("[GetFunctionCode]", getFunctionCode);
	    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
	    return new Function("Promise",
	                        "fn",
	                        "receiver",
	                        "withAppended",
	                        "maybeWrapAsError",
	                        "nodebackForPromise",
	                        "tryCatch",
	                        "errorObj",
	                        "notEnumerableProp",
	                        "INTERNAL",
	                        body)(
	                    Promise,
	                    fn,
	                    receiver,
	                    withAppended,
	                    maybeWrapAsError,
	                    nodebackForPromise,
	                    util.tryCatch,
	                    util.errorObj,
	                    util.notEnumerableProp,
	                    INTERNAL);
	};
	}
	
	function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
	    var defaultThis = (function() {return this;})();
	    var method = callback;
	    if (typeof method === "string") {
	        callback = fn;
	    }
	    function promisified() {
	        var _receiver = receiver;
	        if (receiver === THIS) _receiver = this;
	        var promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	        var cb = typeof method === "string" && this !== defaultThis
	            ? this[method] : callback;
	        var fn = nodebackForPromise(promise, multiArgs);
	        try {
	            cb.apply(_receiver, withAppended(arguments, fn));
	        } catch(e) {
	            promise._rejectCallback(maybeWrapAsError(e), true, true);
	        }
	        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
	        return promise;
	    }
	    util.notEnumerableProp(promisified, "__isPromisified__", true);
	    return promisified;
	}
	
	var makeNodePromisified = canEvaluate
	    ? makeNodePromisifiedEval
	    : makeNodePromisifiedClosure;
	
	function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
	    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
	    var methods =
	        promisifiableMethods(obj, suffix, suffixRegexp, filter);
	
	    for (var i = 0, len = methods.length; i < len; i+= 2) {
	        var key = methods[i];
	        var fn = methods[i+1];
	        var promisifiedKey = key + suffix;
	        if (promisifier === makeNodePromisified) {
	            obj[promisifiedKey] =
	                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
	        } else {
	            var promisified = promisifier(fn, function() {
	                return makeNodePromisified(key, THIS, key,
	                                           fn, suffix, multiArgs);
	            });
	            util.notEnumerableProp(promisified, "__isPromisified__", true);
	            obj[promisifiedKey] = promisified;
	        }
	    }
	    util.toFastProperties(obj);
	    return obj;
	}
	
	function promisify(callback, receiver, multiArgs) {
	    return makeNodePromisified(callback, receiver, undefined,
	                                callback, null, multiArgs);
	}
	
	Promise.promisify = function (fn, options) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    if (isPromisified(fn)) {
	        return fn;
	    }
	    options = Object(options);
	    var receiver = options.context === undefined ? THIS : options.context;
	    var multiArgs = !!options.multiArgs;
	    var ret = promisify(fn, receiver, multiArgs);
	    util.copyDescriptors(fn, ret, propsFilter);
	    return ret;
	};
	
	Promise.promisifyAll = function (target, options) {
	    if (typeof target !== "function" && typeof target !== "object") {
	        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    options = Object(options);
	    var multiArgs = !!options.multiArgs;
	    var suffix = options.suffix;
	    if (typeof suffix !== "string") suffix = defaultSuffix;
	    var filter = options.filter;
	    if (typeof filter !== "function") filter = defaultFilter;
	    var promisifier = options.promisifier;
	    if (typeof promisifier !== "function") promisifier = makeNodePromisified;
	
	    if (!util.isIdentifier(suffix)) {
	        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	
	    var keys = util.inheritedDataKeys(target);
	    for (var i = 0; i < keys.length; ++i) {
	        var value = target[keys[i]];
	        if (keys[i] !== "constructor" &&
	            util.isClass(value)) {
	            promisifyAll(value.prototype, suffix, filter, promisifier,
	                multiArgs);
	            promisifyAll(value, suffix, filter, promisifier, multiArgs);
	        }
	    }
	
	    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
	};
	};
	


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(
	    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
	var util = __webpack_require__(13);
	var isObject = util.isObject;
	var es5 = __webpack_require__(14);
	var Es6Map;
	if (typeof Map === "function") Es6Map = Map;
	
	var mapToEntries = (function() {
	    var index = 0;
	    var size = 0;
	
	    function extractEntry(value, key) {
	        this[index] = value;
	        this[index + size] = key;
	        index++;
	    }
	
	    return function mapToEntries(map) {
	        size = map.size;
	        index = 0;
	        var ret = new Array(map.size * 2);
	        map.forEach(extractEntry, ret);
	        return ret;
	    };
	})();
	
	var entriesToMap = function(entries) {
	    var ret = new Es6Map();
	    var length = entries.length / 2 | 0;
	    for (var i = 0; i < length; ++i) {
	        var key = entries[length + i];
	        var value = entries[i];
	        ret.set(key, value);
	    }
	    return ret;
	};
	
	function PropertiesPromiseArray(obj) {
	    var isMap = false;
	    var entries;
	    if (Es6Map !== undefined && obj instanceof Es6Map) {
	        entries = mapToEntries(obj);
	        isMap = true;
	    } else {
	        var keys = es5.keys(obj);
	        var len = keys.length;
	        entries = new Array(len * 2);
	        for (var i = 0; i < len; ++i) {
	            var key = keys[i];
	            entries[i] = obj[key];
	            entries[i + len] = key;
	        }
	    }
	    this.constructor$(entries);
	    this._isMap = isMap;
	    this._init$(undefined, isMap ? -6 : -3);
	}
	util.inherits(PropertiesPromiseArray, PromiseArray);
	
	PropertiesPromiseArray.prototype._init = function () {};
	
	PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        var val;
	        if (this._isMap) {
	            val = entriesToMap(this._values);
	        } else {
	            val = {};
	            var keyOffset = this.length();
	            for (var i = 0, len = this.length(); i < len; ++i) {
	                val[this._values[i + keyOffset]] = this._values[i];
	            }
	        }
	        this._resolve(val);
	        return true;
	    }
	    return false;
	};
	
	PropertiesPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	PropertiesPromiseArray.prototype.getActualLength = function (len) {
	    return len >> 1;
	};
	
	function props(promises) {
	    var ret;
	    var castValue = tryConvertToPromise(promises);
	
	    if (!isObject(castValue)) {
	        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    } else if (castValue instanceof Promise) {
	        ret = castValue._then(
	            Promise.props, undefined, undefined, undefined, undefined);
	    } else {
	        ret = new PropertiesPromiseArray(castValue).promise();
	    }
	
	    if (castValue instanceof Promise) {
	        ret._propagateFrom(castValue, 2);
	    }
	    return ret;
	}
	
	Promise.prototype.props = function () {
	    return props(this);
	};
	
	Promise.props = function (promises) {
	    return props(promises);
	};
	};


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(
	    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
	var util = __webpack_require__(13);
	
	var raceLater = function (promise) {
	    return promise.then(function(array) {
	        return race(array, promise);
	    });
	};
	
	function race(promises, parent) {
	    var maybePromise = tryConvertToPromise(promises);
	
	    if (maybePromise instanceof Promise) {
	        return raceLater(maybePromise);
	    } else {
	        promises = util.asArray(promises);
	        if (promises === null)
	            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
	    }
	
	    var ret = new Promise(INTERNAL);
	    if (parent !== undefined) {
	        ret._propagateFrom(parent, 3);
	    }
	    var fulfill = ret._fulfill;
	    var reject = ret._reject;
	    for (var i = 0, len = promises.length; i < len; ++i) {
	        var val = promises[i];
	
	        if (val === undefined && !(i in promises)) {
	            continue;
	        }
	
	        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
	    }
	    return ret;
	}
	
	Promise.race = function (promises) {
	    return race(promises, undefined);
	};
	
	Promise.prototype.race = function () {
	    return race(this, undefined);
	};
	
	};


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL,
	                          debug) {
	var getDomain = Promise._getDomain;
	var util = __webpack_require__(13);
	var tryCatch = util.tryCatch;
	
	function ReductionPromiseArray(promises, fn, initialValue, _each) {
	    this.constructor$(promises);
	    var domain = getDomain();
	    this._fn = domain === null ? fn : util.domainBind(domain, fn);
	    if (initialValue !== undefined) {
	        initialValue = Promise.resolve(initialValue);
	        initialValue._attachCancellationCallback(this);
	    }
	    this._initialValue = initialValue;
	    this._currentCancellable = null;
	    if(_each === INTERNAL) {
	        this._eachValues = Array(this._length);
	    } else if (_each === 0) {
	        this._eachValues = null;
	    } else {
	        this._eachValues = undefined;
	    }
	    this._promise._captureStackTrace();
	    this._init$(undefined, -5);
	}
	util.inherits(ReductionPromiseArray, PromiseArray);
	
	ReductionPromiseArray.prototype._gotAccum = function(accum) {
	    if (this._eachValues !== undefined && 
	        this._eachValues !== null && 
	        accum !== INTERNAL) {
	        this._eachValues.push(accum);
	    }
	};
	
	ReductionPromiseArray.prototype._eachComplete = function(value) {
	    if (this._eachValues !== null) {
	        this._eachValues.push(value);
	    }
	    return this._eachValues;
	};
	
	ReductionPromiseArray.prototype._init = function() {};
	
	ReductionPromiseArray.prototype._resolveEmptyArray = function() {
	    this._resolve(this._eachValues !== undefined ? this._eachValues
	                                                 : this._initialValue);
	};
	
	ReductionPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	ReductionPromiseArray.prototype._resolve = function(value) {
	    this._promise._resolveCallback(value);
	    this._values = null;
	};
	
	ReductionPromiseArray.prototype._resultCancelled = function(sender) {
	    if (sender === this._initialValue) return this._cancel();
	    if (this._isResolved()) return;
	    this._resultCancelled$();
	    if (this._currentCancellable instanceof Promise) {
	        this._currentCancellable.cancel();
	    }
	    if (this._initialValue instanceof Promise) {
	        this._initialValue.cancel();
	    }
	};
	
	ReductionPromiseArray.prototype._iterate = function (values) {
	    this._values = values;
	    var value;
	    var i;
	    var length = values.length;
	    if (this._initialValue !== undefined) {
	        value = this._initialValue;
	        i = 0;
	    } else {
	        value = Promise.resolve(values[0]);
	        i = 1;
	    }
	
	    this._currentCancellable = value;
	
	    if (!value.isRejected()) {
	        for (; i < length; ++i) {
	            var ctx = {
	                accum: null,
	                value: values[i],
	                index: i,
	                length: length,
	                array: this
	            };
	            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
	        }
	    }
	
	    if (this._eachValues !== undefined) {
	        value = value
	            ._then(this._eachComplete, undefined, undefined, this, undefined);
	    }
	    value._then(completed, completed, undefined, value, this);
	};
	
	Promise.prototype.reduce = function (fn, initialValue) {
	    return reduce(this, fn, initialValue, null);
	};
	
	Promise.reduce = function (promises, fn, initialValue, _each) {
	    return reduce(promises, fn, initialValue, _each);
	};
	
	function completed(valueOrReason, array) {
	    if (this.isFulfilled()) {
	        array._resolve(valueOrReason);
	    } else {
	        array._reject(valueOrReason);
	    }
	}
	
	function reduce(promises, fn, initialValue, _each) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
	    return array.promise();
	}
	
	function gotAccum(accum) {
	    this.accum = accum;
	    this.array._gotAccum(accum);
	    var value = tryConvertToPromise(this.value, this.array._promise);
	    if (value instanceof Promise) {
	        this.array._currentCancellable = value;
	        return value._then(gotValue, undefined, undefined, this, undefined);
	    } else {
	        return gotValue.call(this, value);
	    }
	}
	
	function gotValue(value) {
	    var array = this.array;
	    var promise = array._promise;
	    var fn = tryCatch(array._fn);
	    promise._pushContext();
	    var ret;
	    if (array._eachValues !== undefined) {
	        ret = fn.call(promise._boundValue(), value, this.index, this.length);
	    } else {
	        ret = fn.call(promise._boundValue(),
	                              this.accum, value, this.index, this.length);
	    }
	    if (ret instanceof Promise) {
	        array._currentCancellable = ret;
	    }
	    var promiseCreated = promise._popContext();
	    debug.checkForgottenReturns(
	        ret,
	        promiseCreated,
	        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
	        promise
	    );
	    return ret;
	}
	};


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	    function(Promise, PromiseArray, debug) {
	var PromiseInspection = Promise.PromiseInspection;
	var util = __webpack_require__(13);
	
	function SettledPromiseArray(values) {
	    this.constructor$(values);
	}
	util.inherits(SettledPromiseArray, PromiseArray);
	
	SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
	    this._values[index] = inspection;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 33554432;
	    ret._settledValueField = value;
	    return this._promiseResolved(index, ret);
	};
	SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 16777216;
	    ret._settledValueField = reason;
	    return this._promiseResolved(index, ret);
	};
	
	Promise.settle = function (promises) {
	    debug.deprecated(".settle()", ".reflect()");
	    return new SettledPromiseArray(promises).promise();
	};
	
	Promise.prototype.settle = function () {
	    return Promise.settle(this);
	};
	};


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, PromiseArray, apiRejection) {
	var util = __webpack_require__(13);
	var RangeError = __webpack_require__(19).RangeError;
	var AggregateError = __webpack_require__(19).AggregateError;
	var isArray = util.isArray;
	var CANCELLATION = {};
	
	
	function SomePromiseArray(values) {
	    this.constructor$(values);
	    this._howMany = 0;
	    this._unwrap = false;
	    this._initialized = false;
	}
	util.inherits(SomePromiseArray, PromiseArray);
	
	SomePromiseArray.prototype._init = function () {
	    if (!this._initialized) {
	        return;
	    }
	    if (this._howMany === 0) {
	        this._resolve([]);
	        return;
	    }
	    this._init$(undefined, -5);
	    var isArrayResolved = isArray(this._values);
	    if (!this._isResolved() &&
	        isArrayResolved &&
	        this._howMany > this._canPossiblyFulfill()) {
	        this._reject(this._getRangeError(this.length()));
	    }
	};
	
	SomePromiseArray.prototype.init = function () {
	    this._initialized = true;
	    this._init();
	};
	
	SomePromiseArray.prototype.setUnwrap = function () {
	    this._unwrap = true;
	};
	
	SomePromiseArray.prototype.howMany = function () {
	    return this._howMany;
	};
	
	SomePromiseArray.prototype.setHowMany = function (count) {
	    this._howMany = count;
	};
	
	SomePromiseArray.prototype._promiseFulfilled = function (value) {
	    this._addFulfilled(value);
	    if (this._fulfilled() === this.howMany()) {
	        this._values.length = this.howMany();
	        if (this.howMany() === 1 && this._unwrap) {
	            this._resolve(this._values[0]);
	        } else {
	            this._resolve(this._values);
	        }
	        return true;
	    }
	    return false;
	
	};
	SomePromiseArray.prototype._promiseRejected = function (reason) {
	    this._addRejected(reason);
	    return this._checkOutcome();
	};
	
	SomePromiseArray.prototype._promiseCancelled = function () {
	    if (this._values instanceof Promise || this._values == null) {
	        return this._cancel();
	    }
	    this._addRejected(CANCELLATION);
	    return this._checkOutcome();
	};
	
	SomePromiseArray.prototype._checkOutcome = function() {
	    if (this.howMany() > this._canPossiblyFulfill()) {
	        var e = new AggregateError();
	        for (var i = this.length(); i < this._values.length; ++i) {
	            if (this._values[i] !== CANCELLATION) {
	                e.push(this._values[i]);
	            }
	        }
	        if (e.length > 0) {
	            this._reject(e);
	        } else {
	            this._cancel();
	        }
	        return true;
	    }
	    return false;
	};
	
	SomePromiseArray.prototype._fulfilled = function () {
	    return this._totalResolved;
	};
	
	SomePromiseArray.prototype._rejected = function () {
	    return this._values.length - this.length();
	};
	
	SomePromiseArray.prototype._addRejected = function (reason) {
	    this._values.push(reason);
	};
	
	SomePromiseArray.prototype._addFulfilled = function (value) {
	    this._values[this._totalResolved++] = value;
	};
	
	SomePromiseArray.prototype._canPossiblyFulfill = function () {
	    return this.length() - this._rejected();
	};
	
	SomePromiseArray.prototype._getRangeError = function (count) {
	    var message = "Input array must contain at least " +
	            this._howMany + " items but contains only " + count + " items";
	    return new RangeError(message);
	};
	
	SomePromiseArray.prototype._resolveEmptyArray = function () {
	    this._reject(this._getRangeError(0));
	};
	
	function some(promises, howMany) {
	    if ((howMany | 0) !== howMany || howMany < 0) {
	        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(howMany);
	    ret.init();
	    return promise;
	}
	
	Promise.some = function (promises, howMany) {
	    return some(promises, howMany);
	};
	
	Promise.prototype.some = function (howMany) {
	    return some(this, howMany);
	};
	
	Promise._SomePromiseArray = SomePromiseArray;
	};


/***/ },
/* 45 */
/***/ function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseMap = Promise.map;
	
	Promise.prototype.filter = function (fn, options) {
	    return PromiseMap(this, fn, options, INTERNAL);
	};
	
	Promise.filter = function (promises, fn, options) {
	    return PromiseMap(promises, fn, options, INTERNAL);
	};
	};


/***/ },
/* 46 */
/***/ function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseReduce = Promise.reduce;
	var PromiseAll = Promise.all;
	
	function promiseAllThis() {
	    return PromiseAll(this);
	}
	
	function PromiseMapSeries(promises, fn) {
	    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
	}
	
	Promise.prototype.each = function (fn) {
	    return PromiseReduce(this, fn, INTERNAL, 0)
	              ._then(promiseAllThis, undefined, undefined, this, undefined);
	};
	
	Promise.prototype.mapSeries = function (fn) {
	    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
	};
	
	Promise.each = function (promises, fn) {
	    return PromiseReduce(promises, fn, INTERNAL, 0)
	              ._then(promiseAllThis, undefined, undefined, promises, undefined);
	};
	
	Promise.mapSeries = PromiseMapSeries;
	};
	


/***/ },
/* 47 */
/***/ function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	var SomePromiseArray = Promise._SomePromiseArray;
	function any(promises) {
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(1);
	    ret.setUnwrap();
	    ret.init();
	    return promise;
	}
	
	Promise.any = function (promises) {
	    return any(promises);
	};
	
	Promise.prototype.any = function () {
	    return any(this);
	};
	
	};


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(49);
	var Utils_1 = __webpack_require__(5);
	var momentLocal = moment;
	var momentUtc = moment.utc;
	(function (DateFormatType) {
	    DateFormatType[DateFormatType["FullLongDateTime"] = 0] = "FullLongDateTime";
	    DateFormatType[DateFormatType["FullShortDateTime"] = 1] = "FullShortDateTime";
	    DateFormatType[DateFormatType["Time"] = 2] = "Time";
	    DateFormatType[DateFormatType["FullTime"] = 3] = "FullTime";
	})(exports.DateFormatType || (exports.DateFormatType = {}));
	var DateFormatType = exports.DateFormatType;
	(function (DiffType) {
	    DiffType[DiffType["Years"] = 'y'] = "Years";
	    DiffType[DiffType["Months"] = 'M'] = "Months";
	    DiffType[DiffType["Days"] = 'd'] = "Days";
	    DiffType[DiffType["Hours"] = 'h'] = "Hours";
	    DiffType[DiffType["Minutes"] = 'm'] = "Minutes";
	    DiffType[DiffType["Seconds"] = 's'] = "Seconds";
	    DiffType[DiffType["Milliseconds"] = 'ms'] = "Milliseconds";
	})(exports.DiffType || (exports.DiffType = {}));
	var DiffType = exports.DiffType;
	var Formats = {
	    Time: {
	        Format24: "HH:mm",
	        Format24Seconds: "HH:mm:ss",
	        FormatMeridian: "h:mm tt",
	        FormatMeridianSeconds: "h:mm:ss tt"
	    },
	    Date: {
	        Format: 'DD.MM.Y'
	    },
	    DateTime: {
	        Format24Seconds: 'DD.MM.Y HH:mm:ss',
	        Format24: 'DD.MM.Y HH:mm'
	    }
	};
	var DateUtils = (function () {
	    function DateUtils() {
	    }
	    DateUtils.formatTime = function (time) {
	        if (Utils_1.Utils.isNullOrUndefined(time)) {
	            throw new Error('Parameter "time" is required!');
	        }
	        var result = time.hours + ":" + time.minutes;
	        if (!Utils_1.Utils.isNullOrUndefined(time.seconds)) {
	            result += ":" + time.seconds;
	        }
	        if (!Utils_1.Utils.isNullOrUndefined(time.period)) {
	            result += " " + time.period;
	        }
	        return result;
	    };
	    DateUtils.parseTime = function (time) {
	        var result = null;
	        function parseNumberAndPeriod(value) {
	            var resValue = null;
	            var resPeriod = null;
	            var parsed = Utils_1.Utils.tryParseNumber(value);
	            if (parsed.isValid) {
	                resValue = parsed.value;
	            }
	            else {
	                var vals = value.split(' ');
	                if (vals !== null && vals.length === 2) {
	                    parsed = Utils_1.Utils.tryParseNumber(vals[0]);
	                    if (parsed.isValid) {
	                        resValue = parsed.value;
	                        if (vals[1] === 'AM' || vals[1] === 'PM') {
	                            resPeriod = vals[1];
	                        }
	                    }
	                }
	            }
	            return {
	                value: resValue,
	                period: resPeriod
	            };
	        }
	        if (!Utils_1.Utils.isNullOrUndefined(time)) {
	            var values = time.split(':');
	            if (values !== null && values.length > 1) {
	                var parsedHour = Utils_1.Utils.tryParseNumber(values[0]);
	                var parsedMinute = Utils_1.Utils.tryParseNumber(values[1]);
	                if (parsedHour.isValid && parsedMinute.isValid) {
	                    result = {
	                        hours: parsedHour.value,
	                        minutes: parsedMinute.value
	                    };
	                    if (values.length > 2) {
	                        var parsedSecond = parseNumberAndPeriod(values[2]);
	                        if (parsedSecond.value !== null) {
	                            result.seconds = parsedSecond.value;
	                        }
	                        if (parsedSecond.period !== null) {
	                            result.period = parsedSecond.period;
	                        }
	                    }
	                }
	            }
	        }
	        return result;
	    };
	    DateUtils.getUtcMoment = function () {
	        return DateUtils._getUtcMoment(false);
	    };
	    DateUtils.getUtcMomentAsIso = function () {
	        return DateUtils._getUtcMoment(true);
	    };
	    DateUtils._getUtcMoment = function (asIso) {
	        var result = momentUtc();
	        asIso = Utils_1.Utils.valueOrDefault(asIso, false);
	        if (asIso) {
	            result = result.toISOString();
	        }
	        return result;
	    };
	    DateUtils.parse = function (value, format) {
	        if (format === void 0) { format = Formats.DateTime.Format24Seconds; }
	        return moment(value, format);
	    };
	    DateUtils.asUtcMoment = function (value) {
	        if (value instanceof Date) {
	            return momentUtc(value);
	        }
	        else if (value instanceof moment) {
	            var m = value;
	            if (m && !m.creationData().isUTC) {
	                m.utc();
	            }
	            return m;
	        }
	        else if (typeof value === 'string') {
	            return momentUtc(value);
	        }
	        else {
	            throw new Error('convertToMoment, unknown date type: ' + Object.prototype.toString.call(value));
	        }
	    };
	    DateUtils.toIso = function (date) {
	        return date.toISOString();
	    };
	    DateUtils.getDateFormatString = function (type) {
	        switch (type) {
	            case DateFormatType.FullLongDateTime:
	                return 'LLL';
	            case DateFormatType.FullShortDateTime:
	                return 'l LTS';
	            case DateFormatType.Time:
	                return 'LT';
	            case DateFormatType.FullTime:
	                return 'LTS';
	            default:
	                throw new Error("Unknown DateFormatType value \"" + type + "\"");
	        }
	    };
	    DateUtils.toLocal = function (value) {
	        var utcDate = DateUtils.asUtcMoment(value);
	        var localDate = utcDate.toDate();
	        return momentLocal(localDate);
	    };
	    DateUtils.isEqual = function (date1, date2) {
	        var date1IsNull = Utils_1.Utils.isNullOrUndefined(date1);
	        var date2IsNull = Utils_1.Utils.isNullOrUndefined(date2);
	        if (date1IsNull && date2IsNull) {
	            return true;
	        }
	        if (!date1IsNull && !date2IsNull) {
	            var m1 = DateUtils.asUtcMoment(date1);
	            var m2 = DateUtils.asUtcMoment(date2);
	            return m1.isSame(m2);
	        }
	        return false;
	    };
	    DateUtils.orderByTime = function (a, b, asc) {
	        var result = 0;
	        if (a.isSame(b)) {
	            var a_millis = a.milliseconds();
	            var b_millis = b.milliseconds();
	            if (a_millis < b_millis) {
	                result = -1;
	            }
	            else if (a_millis > b_millis) {
	                result = 1;
	            }
	        }
	        else {
	            result = a.isAfter(b) ? 1 : -1;
	        }
	        return asc ? result : -1 * result;
	    };
	    DateUtils.isGreater = function (source, than) {
	        var a = DateUtils.asUtcMoment(source);
	        var b = DateUtils.asUtcMoment(than);
	        return DateUtils.orderByTime(a, b, true) === 1;
	    };
	    DateUtils.orderListBy = function (list, asc, selector) {
	        list.sort(function (itemA, itemB) {
	            var a = selector(itemA);
	            var b = selector(itemB);
	            return DateUtils.orderByTime(a, b, asc);
	        });
	        return list;
	    };
	    DateUtils.getDiff = function (date1, date2, type) {
	        var k = type.toString();
	        var m1 = DateUtils.asUtcMoment(date1);
	        var m2 = DateUtils.asUtcMoment(date2);
	        return m1.diff(m2, k);
	    };
	    DateUtils.addDiff = function (value, diff, type) {
	        var k = type.toString();
	        var m = moment(DateUtils.asUtcMoment(value));
	        return m.add(diff, k);
	    };
	    DateUtils.getUnixTimestamp = function () {
	        return Number(momentUtc().format('x'));
	    };
	    DateUtils.asUnixTimestamp = function (value) {
	        var m = DateUtils.asUtcMoment(value);
	        return Number(m.format('x'));
	    };
	    DateUtils.toDefaultWithTime = function (value) {
	        if (Utils_1.Utils.isNullOrUndefined(value)) {
	            return "";
	        }
	        var a = moment(value);
	        return a.format(Formats.DateTime.Format24Seconds);
	    };
	    DateUtils.toDefaultWithTimeExt = function (value, useSeconds) {
	        if (useSeconds === void 0) { useSeconds = true; }
	        if (Utils_1.Utils.isNullOrUndefined(value)) {
	            return "";
	        }
	        var a = moment(value);
	        return a.format(useSeconds ? Formats.DateTime.Format24Seconds : Formats.DateTime.Format24);
	    };
	    DateUtils.Formats = Formats;
	    return DateUtils;
	}());
	exports.DateUtils = DateUtils;


/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports = moment;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery, $) {"use strict";
	var StatusMessageHelper = (function () {
	    function StatusMessageHelper() {
	    }
	    StatusMessageHelper.initValidator = function () {
	        jQuery.validator.setDefaults({
	            highlight: function (element) {
	                jQuery(element).closest('.form-group').addClass('has-error');
	            },
	            unhighlight: function (element) {
	                jQuery(element).closest('.form-group').removeClass('has-error');
	            },
	            errorElement: 'span',
	            errorClass: 'label label-danger',
	            errorPlacement: function (error, element) {
	                if (element.parent('.input-group').length) {
	                    error.insertAfter(element.parent());
	                }
	                else {
	                    error.insertAfter(element);
	                }
	            }
	        });
	    };
	    StatusMessageHelper.initSatusMessage = function () {
	        var statusMessagesToAutoClose = $('div[data-componentType="statusMessage"][data-autoClose="true"]');
	        if (statusMessagesToAutoClose.length > 0) {
	            setTimeout(function () {
	                statusMessagesToAutoClose.fadeOut('slow', function () {
	                    $(this).remove();
	                });
	            }, this.secondsToAutoCloseStatusMessages);
	        }
	        var statusMessageCloseBtns = $('div[data-componentType="statusMessage"] button.close');
	        statusMessageCloseBtns.on('click', function (e) {
	            var btn = $(e.target);
	            var panel = btn.parent('[data-componentType="statusMessage"]');
	            panel.remove();
	        });
	    };
	    StatusMessageHelper.secondsToAutoCloseStatusMessages = 5 * 1000;
	    return StatusMessageHelper;
	}());
	exports.StatusMessageHelper = StatusMessageHelper;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(1)))

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var MultiSelect_1 = __webpack_require__(52);
	exports.MultiSelectApi = MultiSelect_1.MultiSelectApi;
	exports.MultiSelect = MultiSelect_1.MultiSelect;
	var Datatable_1 = __webpack_require__(54);
	exports.DatatableApi = Datatable_1.DatatableApi;
	exports.Datatable = Datatable_1.Datatable;
	var Typeahead_1 = __webpack_require__(56);
	exports.TypeaheadApi = Typeahead_1.TypeaheadApi;
	exports.Typeahead = Typeahead_1.Typeahead;
	var DateTimePicker_1 = __webpack_require__(57);
	exports.DateTimePickerApi = DateTimePicker_1.DateTimePickerApi;
	exports.DateTimePicker = DateTimePicker_1.DateTimePicker;
	var Section_1 = __webpack_require__(58);
	exports.Section = Section_1.Section;
	var TreeView_1 = __webpack_require__(59);
	exports.TreeViewApi = TreeView_1.TreeViewApi;
	exports.TreeView = TreeView_1.TreeView;
	var Modal_1 = __webpack_require__(60);
	exports.ModalApi = Modal_1.ModalApi;
	exports.Modal = Modal_1.Modal;
	var Dialog_1 = __webpack_require__(55);
	exports.Dialog = Dialog_1.Dialog;
	var StatusMessage_1 = __webpack_require__(61);
	exports.StatusMessage = StatusMessage_1.StatusMessage;


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var _ = __webpack_require__(7);
	var WidgetBase_1 = __webpack_require__(53);
	var MultiSelectApi = (function (_super) {
	    __extends(MultiSelectApi, _super);
	    function MultiSelectApi(id) {
	        _super.call(this, id);
	    }
	    MultiSelectApi.prototype.getInitOptions = function () {
	        return null;
	    };
	    MultiSelectApi.prototype.getMultiselect = function (doInit) {
	        if (doInit === void 0) { doInit = false; }
	        if (!this._multiselect) {
	            var opt = doInit ? this.getInitOptions() : undefined;
	            this._multiselect = this.jq.multiselect(opt);
	        }
	        return this._multiselect;
	    };
	    MultiSelectApi.prototype.setOptions = function (options, value) {
	        this.jq.multiselect(options, value);
	    };
	    MultiSelectApi.prototype.getSelect = function () {
	        return this.getMultiselect();
	    };
	    MultiSelectApi.prototype.getOptions = function (onlySelected) {
	        var options = $('option', this.getSelect());
	        var result = [];
	        var count = 0;
	        options.each(function (idx, option) {
	            var include = !onlySelected || $(option).is(':selected');
	            if (include) {
	                result.push(option);
	            }
	            count++;
	        });
	        return { options: result, count: count };
	    };
	    MultiSelectApi.prototype.getAllOptions = function () {
	        return this.getOptions(false).options;
	    };
	    MultiSelectApi.prototype.getSelections = function () {
	        return this.getOptions(true).options;
	    };
	    MultiSelectApi.prototype.getSelectionCount = function () {
	        return this.getSelections().length;
	    };
	    MultiSelectApi.prototype.isAllSelected = function () {
	        var r = this.getOptions(true);
	        return r.options.length === r.count;
	    };
	    MultiSelectApi.prototype.getSelectionValues = function (delimiter) {
	        if (delimiter === void 0) { delimiter = ';'; }
	        var selection = this.getSelections();
	        return selection.length === 0 ? '' : _.map(selection, function (x) { return x.value; }).join(delimiter);
	    };
	    MultiSelectApi.prototype.setSelectionValues = function (values, delimiter) {
	        if (delimiter === void 0) { delimiter = ";"; }
	        this.deselectAll();
	        var vals = values.split(delimiter);
	        this.setOptions('select', vals);
	    };
	    MultiSelectApi.prototype.selectAll = function () {
	        var options = this.getOptions(false).options;
	        var values = _.map(options, function (o) { return o.value; });
	        this.setOptions('select', values);
	    };
	    MultiSelectApi.prototype.deselectAll = function () {
	        var options = this.getOptions(false).options;
	        var values = _.map(options, function (o) { return o.value; });
	        this.setOptions('deselect', values);
	    };
	    return MultiSelectApi;
	}(WidgetBase_1.WidgetApiBase));
	exports.MultiSelectApi = MultiSelectApi;
	var MultiSelect = (function (_super) {
	    __extends(MultiSelect, _super);
	    function MultiSelect(id, options) {
	        _super.call(this, id);
	        this._initialized = false;
	        this._options = options;
	        this.getMultiselect(true);
	    }
	    MultiSelect.prototype.getInitOptions = function () {
	        var self = this;
	        var o = this._options;
	        return {
	            includeSelectAllOption: o.includeSelectAllOption,
	            selectAllText: o.selectAllText,
	            allSelectedText: o.allSelectedText,
	            selectAllNumber: o.selectAllNumber,
	            maxHeight: o.maxHeight,
	            numberDisplayed: o.numberDisplayed,
	            buttonClass: o.buttonClass,
	            checkboxName: o.checkboxName,
	            buttonText: function (options, select) {
	                var allOptionCount = $('option', select).length;
	                var selectedCount = 0;
	                $.each(options, function (idx, opt) {
	                    if ($(opt).is(':selected')) {
	                        selectedCount++;
	                    }
	                });
	                if (selectedCount === allOptionCount) {
	                    return o.allSelectedText;
	                }
	                return _.map(options, function (o) { return o.text; }).join(',');
	            },
	            onInitialized: function (select, container) {
	                self._initialized = true;
	            },
	            onChange: function (element, checked) {
	                var selectedCount = self.getSelectionCount();
	                if (selectedCount === 0 && self._options.leaveOneSelected && element) {
	                    self.setOptions('select', element.val());
	                }
	            },
	        };
	    };
	    return MultiSelect;
	}(MultiSelectApi));
	exports.MultiSelect = MultiSelect;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Utils_1 = __webpack_require__(5);
	var ArgValidator_1 = __webpack_require__(2);
	var WidgetApiBase = (function () {
	    function WidgetApiBase(id) {
	        ArgValidator_1.ArgValidator.ensureStringIsNotNullOrEmpty(id, 'id');
	        this._id = id;
	    }
	    Object.defineProperty(WidgetApiBase.prototype, "jq", {
	        get: function () {
	            if (!this._jq) {
	                this._jq = Utils_1.Utils.getJQueryById(this._id);
	            }
	            return this._jq;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    WidgetApiBase.prototype._changeid = function (newId) {
	        ArgValidator_1.ArgValidator.ensureStringIsNotNullOrEmpty(newId, 'newId');
	        this._id = newId;
	        this._jq = null;
	        return this.jq;
	    };
	    return WidgetApiBase;
	}());
	exports.WidgetApiBase = WidgetApiBase;


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, jQuery) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var _ = __webpack_require__(7);
	var Utils_1 = __webpack_require__(5);
	var StringUtils_1 = __webpack_require__(3);
	var ArgValidator_1 = __webpack_require__(2);
	var ArrayUtils_1 = __webpack_require__(4);
	var WidgetBase_1 = __webpack_require__(53);
	var Dialog_1 = __webpack_require__(55);
	var DatatableApi = (function (_super) {
	    __extends(DatatableApi, _super);
	    function DatatableApi(id) {
	        _super.call(this, id);
	    }
	    DatatableApi.prototype.getInitOptions = function () {
	        return null;
	    };
	    DatatableApi.prototype.getDatatable = function (doInit) {
	        if (doInit === void 0) { doInit = false; }
	        if (!this._dataTable) {
	            var opt = doInit ? this.getInitOptions() : undefined;
	            this._dataTable = this.jq.DataTable(opt);
	        }
	        return this._dataTable;
	    };
	    DatatableApi.prototype.getElement = function (selector) {
	        return $(selector, this.jq);
	    };
	    DatatableApi.prototype.columns = function (columnIndex) {
	        return this.getDatatable().columns(columnIndex);
	    };
	    DatatableApi.prototype.search = function (value) {
	        this.getDatatable().search(value);
	    };
	    DatatableApi.prototype.row = function (rowSelector) {
	        var row = this.getDatatable().row(rowSelector);
	        return row.length > 0 ? row : null;
	    };
	    DatatableApi.prototype.rowDataId = function (row) {
	        var r = row;
	        var tr;
	        if (r instanceof $.fn.DataTable.Api) {
	            tr = Utils_1.Utils.getJQueryById(r.id());
	        }
	        else if (r instanceof jQuery) {
	            tr = row;
	        }
	        else {
	            throw new Error("Row type " + typeof row + " is not supported!");
	        }
	        return tr.attr('data-id');
	    };
	    DatatableApi.prototype.rowById = function (rowId) {
	        return this.row("[data-id=\"" + rowId + "\"]");
	    };
	    DatatableApi.prototype.draw = function (reset) {
	        this.getDatatable().draw(reset);
	    };
	    DatatableApi.attach = function (id) {
	        var elem = Utils_1.Utils.getJQueryById(id);
	        elem.DataTable();
	    };
	    return DatatableApi;
	}(WidgetBase_1.WidgetApiBase));
	exports.DatatableApi = DatatableApi;
	var defaultOptions = {
	    url: null,
	    dom: null,
	    rowId: null,
	    columns: null,
	    autoFocusSearch: true
	};
	var Datatable = (function (_super) {
	    __extends(Datatable, _super);
	    function Datatable(id, options) {
	        _super.call(this, id);
	        ArgValidator_1.ArgValidator.ensureIsNotNullOrUndefined(options, 'options');
	        ArgValidator_1.ArgValidator.ensureStringIsNotNullOrEmpty(options.url, 'options.url');
	        ArgValidator_1.ArgValidator.ensureIsNotNullOrUndefined(options.columns, 'options.columns');
	        this._options = _.assign({}, defaultOptions, options);
	        this.internalCreatedRow = this.internalCreatedRow.bind(this);
	        this.internalDrawCallback = this.internalDrawCallback.bind(this);
	        this.toggleDetailRow = this.toggleDetailRow.bind(this);
	        this.internalInitComplete = this.internalInitComplete.bind(this);
	        this.getDatatable(true);
	        var rowDetail = this._options.rowDetail;
	        if (rowDetail) {
	            this._detailRowsIds = [];
	            this.getElement('tbody').on('click', rowDetail.toggleSelector, this.toggleDetailRow);
	        }
	    }
	    Datatable.prototype.toggleDetailRow = function (e) {
	        var tr = $(e.target).closest('tr');
	        var row = this.row(tr);
	        this.showDetailRow(row, true);
	        this.getDatatable().fixedHeader.adjust();
	    };
	    Datatable.prototype.showDetailRow = function (row, toggle) {
	        if (!row) {
	            return;
	        }
	        var tr = $(row.node());
	        var rowData = row.data();
	        var hasDetail = false;
	        var rowDetail = this._options.rowDetail;
	        if (rowDetail) {
	            if (typeof rowDetail.hasDetail === 'function') {
	                hasDetail = rowDetail.hasDetail(rowData, row);
	            }
	            else if (typeof rowDetail.hasDetail === 'boolean') {
	                hasDetail = rowDetail.hasDetail;
	            }
	        }
	        if (!hasDetail) {
	            return;
	        }
	        var rowId = this.rowDataId(row);
	        var idx = ArrayUtils_1.ArrayUtils.findIndex(this._detailRowsIds, rowId);
	        if (toggle && row.child.isShown()) {
	            tr.removeClass('details bg-blue bg-font-blue');
	            row.child.hide();
	            this._detailRowsIds.splice(idx, 1);
	        }
	        else {
	            tr.addClass('details bg-blue bg-font-blue');
	            var detailRow = rowDetail.render(rowData, row);
	            row.child(detailRow).show();
	            if (idx === -1) {
	                this._detailRowsIds.push(rowId);
	            }
	        }
	    };
	    Datatable.prototype.internalCreatedRow = function (row, data, dataIndex) {
	        var $tr = $(row);
	        $tr.attr('data-id', data[this._options.rowId]);
	        var createdRow = this._options.callbacks ? this._options.callbacks.createdRow : null;
	        if (createdRow) {
	            createdRow(row, data, dataIndex);
	        }
	    };
	    Datatable.prototype.internalDrawCallback = function (settings) {
	        var _this = this;
	        if (Utils_1.Utils.isNullOrUndefined(this._options.rowDetail)) {
	            return;
	        }
	        _.each(this._detailRowsIds, function (rowId) {
	            var row = _this.rowById(rowId);
	            if (row) {
	                _this.showDetailRow(row, false);
	            }
	        });
	        var drawCallback = this._options.callbacks ? this._options.callbacks.drawCallback : null;
	        if (drawCallback) {
	            return drawCallback(this);
	        }
	    };
	    Datatable.prototype.internalInitComplete = function (settings) {
	        this._searchEdit = $('div.dataTables_filter input', settings.nTableWrapper);
	        if (this._options.autoFocusSearch) {
	            Utils_1.Utils.focusControl(this._searchEdit);
	        }
	    };
	    Datatable.prototype.getInitOptions = function () {
	        var _this = this;
	        var self = this;
	        var o = this._options;
	        o.processing = Utils_1.Utils.valueOrDefault(o.processing, true);
	        o.serverSide = Utils_1.Utils.valueOrDefault(o.serverSide, true);
	        o.autoWidth = Utils_1.Utils.valueOrDefault(o.autoWidth, true);
	        o.pageLength = Utils_1.Utils.valueOrDefault(o.pageLength, 10);
	        if (o.rowDetail) {
	            o.rowDetail.toggleSelector = Utils_1.Utils.valueOrDefault(o.rowDetail.toggleSelector, 'tr td');
	        }
	        function removeProcessingPanel() {
	            var id = self._id + '_processing';
	            var divProcessing = $("#" + id);
	            if (!divProcessing) {
	                return;
	            }
	            divProcessing.css("display", "none");
	        }
	        var result = {
	            ajax: {
	                url: o.url,
	                method: "POST",
	                beforeSend: function () { },
	                error: function (xhr, textStatus, error) {
	                    removeProcessingPanel();
	                    if (Utils_1.Utils.isNullOrUndefined(o.errorHandler)) {
	                        if (xhr.status === 404 || xhr.status === 401) {
	                            window.location.reload();
	                        }
	                        else {
	                            var parent = _this.jq.parent();
	                            if (!StringUtils_1.StringUtils.isNullOrEmpty(xhr.responseText)) {
	                                var parseResult_1 = Utils_1.Utils.parseJson(xhr.responseText);
	                                if (parseResult_1.isValid && parseResult_1.json &&
	                                    !StringUtils_1.StringUtils.isNullOrEmpty(parseResult_1.json['Message'])) {
	                                    setTimeout(function () {
	                                        var msg = parseResult_1.json['Message'];
	                                        Dialog_1.Dialog.error(msg);
	                                    }, 0);
	                                    return;
	                                }
	                            }
	                            var style = "display: block; margin-top: 15px; padding-top: 7px; background-color: white; color: red; z-index: 1000;" +
	                                "position: relative;left: auto;margin-left: 0; width: 500px; font-size: 11pt; height: auto;";
	                            var errDiv = $(("<div class=\"dataTables_processing panel panel-default\" style=\"" + style + "\">") +
	                                ("Could not load data!<br/>" + error + " (" + xhr.status + ")") +
	                                "</div>");
	                            parent.append(errDiv);
	                        }
	                    }
	                    else {
	                        o.errorHandler(xhr, textStatus, error);
	                    }
	                }
	            },
	            rowId: function (data) { return (_this._id + "_row_" + data[o.rowId]); },
	            dom: o.dom,
	            lengthChange: true,
	            lengthMenu: Utils_1.Utils.valueOrDefault(o.lengthMenu, [10, 20, 50, 100]),
	            orderCellsTop: true,
	            processing: o.processing,
	            serverSide: o.serverSide,
	            autoWidth: o.autoWidth,
	            pageLength: o.pageLength,
	            columns: o.columns,
	            order: o.order,
	            ordering: o.ordering,
	            paging: o.paging,
	            fixedHeader: o.fixedHeader,
	            scrollX: o.scrollX,
	            createdRow: this.internalCreatedRow,
	            drawCallback: this.internalDrawCallback,
	            initComplete: this.internalInitComplete
	        };
	        if (o.callbacks) {
	            if (o.callbacks.preDrawCallback) {
	                result.preDrawCallback = function (settings) {
	                    return o.callbacks.preDrawCallback(self);
	                };
	            }
	            if (o.callbacks.drawCallback) {
	                result.drawCallback = function (settings) {
	                    return o.callbacks.drawCallback(self);
	                };
	            }
	        }
	        return result;
	    };
	    return Datatable;
	}(DatatableApi));
	exports.Datatable = Datatable;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(1)))

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Utils_1 = __webpack_require__(5);
	var StringUtils_1 = __webpack_require__(3);
	var Promise = __webpack_require__(10);
	var Dialog = (function () {
	    function Dialog() {
	    }
	    Dialog.toCssClass = function (dialogType, prefix) {
	        if (prefix === void 0) { prefix = ''; }
	        if (Utils_1.Utils.isNullOrUndefined(dialogType)) {
	            return '';
	        }
	        var res = dialogType.toString().split('-')[1];
	        if (!StringUtils_1.StringUtils.isNullOrEmpty(prefix)) {
	            res = prefix + res;
	        }
	        return res;
	    };
	    Dialog.show = function (options) {
	        options.animate = false;
	        BootstrapDialog.show(options);
	    };
	    Dialog.info = function (message, title) {
	        return Dialog.alert(message, title, DialogType.Info);
	    };
	    Dialog.error = function (message, title) {
	        if (title === void 0) { title = 'Error'; }
	        return Dialog.alert(message, title, DialogType.Danger);
	    };
	    Dialog.alert = function (message, title, type, size) {
	        if (title === void 0) { title = null; }
	        if (type === void 0) { type = DialogType.Default; }
	        if (size === void 0) { size = DialogSize.Normal; }
	        return new Promise(function (resolve, reject) {
	            var button = {
	                label: 'Ok',
	                cssClass: Dialog.toCssClass(type, 'btn-'),
	                action: function (dialogRef) {
	                    dialogRef.close();
	                    resolve();
	                }
	            };
	            var options = {
	                message: message,
	                title: title,
	                type: type,
	                size: size,
	                draggable: true,
	                buttons: [button]
	            };
	            Dialog.show(options);
	        });
	    };
	    return Dialog;
	}());
	exports.Dialog = Dialog;
	(function (DialogType) {
	    DialogType[DialogType["Default"] = 'type-default'] = "Default";
	    DialogType[DialogType["Info"] = 'type-info'] = "Info";
	    DialogType[DialogType["Primary"] = 'type-primary'] = "Primary";
	    DialogType[DialogType["Success"] = 'type-success'] = "Success";
	    DialogType[DialogType["Warning"] = 'type-warning'] = "Warning";
	    DialogType[DialogType["Danger"] = 'type-danger'] = "Danger";
	})(exports.DialogType || (exports.DialogType = {}));
	var DialogType = exports.DialogType;
	(function (DialogSize) {
	    DialogSize[DialogSize["Normal"] = 'size-normal'] = "Normal";
	    DialogSize[DialogSize["Wide"] = 'size-wide'] = "Wide";
	    DialogSize[DialogSize["Large"] = 'size-large'] = "Large";
	})(exports.DialogSize || (exports.DialogSize = {}));
	var DialogSize = exports.DialogSize;


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var StringUtils_1 = __webpack_require__(3);
	var WidgetBase_1 = __webpack_require__(53);
	var TypeaheadApi = (function (_super) {
	    __extends(TypeaheadApi, _super);
	    function TypeaheadApi(id) {
	        _super.call(this, id);
	    }
	    TypeaheadApi.prototype.getInitOptions = function () {
	        return null;
	    };
	    TypeaheadApi.prototype.getTypeahead = function (doInit) {
	        if (doInit === void 0) { doInit = false; }
	        if (!this._typeahead) {
	            var opt = doInit ? this.getInitOptions() : undefined;
	            this._typeahead = this.jq.typeahead(opt);
	        }
	        return this._typeahead;
	    };
	    TypeaheadApi.prototype.callApi = function (options, value) {
	        this.getTypeahead();
	        this.jq.typeahead(options, value);
	    };
	    TypeaheadApi.prototype.lookup = function () {
	        this.getTypeahead().lookup();
	    };
	    TypeaheadApi.prototype.getActiveItem = function () {
	        return this.getTypeahead().getActive();
	    };
	    return TypeaheadApi;
	}(WidgetBase_1.WidgetApiBase));
	exports.TypeaheadApi = TypeaheadApi;
	var Typeahead = (function (_super) {
	    __extends(Typeahead, _super);
	    function Typeahead(id, options) {
	        _super.call(this, id);
	        this._itemTemplate = '<li><a class="dropdown-item" href="javascript: void(0);" role="option"></a></li>';
	        this._options = options;
	        this.getTypeahead(true);
	    }
	    Typeahead.prototype.getInitOptions = function () {
	        var o = this._options;
	        var css = StringUtils_1.StringUtils.isNullOrEmpty(o.cssClass) ? '' : o.cssClass;
	        var style = StringUtils_1.StringUtils.isNullOrEmpty(o.overflowHeight) ? '' : "overflow: auto; height: auto; max-height: " + o.overflowHeight + ";";
	        var menu = "<ul class=\"typeahead dropdown-menu" + css + "\" role=\"listbox\" style=\"" + style + "\"></ul>";
	        return {
	            menu: menu,
	            item: this._itemTemplate,
	            afterSelect: o.afterSelect,
	            autoSelect: o.autoSelect,
	            delay: o.delay,
	            displayText: o.displayText,
	            fitToElement: o.fitToElement,
	            items: o.items,
	            minLength: o.minLength,
	            scrollHeight: o.scrollHeight,
	            showHintOnFocus: o.showHintOnFocus,
	            source: o.source
	        };
	    };
	    return Typeahead;
	}(TypeaheadApi));
	exports.Typeahead = Typeahead;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Utils_1 = __webpack_require__(5);
	var DateUtils_1 = __webpack_require__(48);
	var StringUtils_1 = __webpack_require__(3);
	var ArgValidator_1 = __webpack_require__(2);
	var moment = __webpack_require__(49);
	var DateTimePickerApi = (function () {
	    function DateTimePickerApi(id) {
	        ArgValidator_1.ArgValidator.ensureStringIsNotNullOrEmpty(id, 'id');
	        this._id = id;
	        this._idDate = id + "-date-container";
	        this._idDateBtn = id + "-date-button";
	        this._idTime = id + "-time";
	        this._idTimeBtn = id + "-time-button";
	        this._jqDate = Utils_1.Utils.getJQueryById(this._idDate);
	        this._jqTime = Utils_1.Utils.getJQueryById(this._idTime);
	        this._dateFormat = this._jqDate.data('format');
	        this._timeFormat = this._jqTime.data('format');
	        this._hasTime = !Utils_1.Utils.isNullOrUndefined(this._jqTime) && this._jqTime.length === 1;
	    }
	    Object.defineProperty(DateTimePickerApi.prototype, "hasTime", {
	        get: function () {
	            return this._hasTime;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DateTimePickerApi.prototype.getInitOptions = function (component) {
	        return null;
	    };
	    DateTimePickerApi.prototype.getComponent = function (component, doInit) {
	        if (doInit === void 0) { doInit = false; }
	        var result = component === 'date' ? this._datePicker : this._timePicker;
	        if (!result) {
	            var opt = doInit ? this.getInitOptions(component) : undefined;
	            if (component === 'date') {
	                this._datePicker = this._jqDate.datepicker(opt);
	                result = this._datePicker;
	            }
	            else {
	                this._timePicker = this._jqTime.timepicker(opt);
	                result = this._timePicker;
	            }
	        }
	        return result;
	    };
	    DateTimePickerApi.prototype.callApi = function (component, options, value) {
	        var cmp = this.getComponent(component);
	        if (component === 'date') {
	            return this._jqDate.datepicker(options, value);
	        }
	        return this._jqTime.timepicker(options, value);
	    };
	    DateTimePickerApi.prototype.getUTCDate = function () {
	        return this.getDate(true);
	    };
	    DateTimePickerApi.prototype.getDate = function (utc) {
	        var result = null;
	        var dateValue = this.callApi('date', utc ? 'getUTCDate' : 'getDate');
	        var date = dateValue ? (utc ? DateUtils_1.DateUtils.asUtcMoment(dateValue) : DateUtils_1.DateUtils.toLocal(dateValue)) : null;
	        if (!Utils_1.Utils.isNullOrUndefined(date)) {
	            result = date;
	            if (this.hasTime) {
	                this.getComponent('time');
	                var timeValue = this._timePicker.data("timepicker").getTime();
	                if (!StringUtils_1.StringUtils.isNullOrEmpty(timeValue)) {
	                    var strDate = date.format(DateUtils_1.DateUtils.Formats.Date.Format);
	                    result = moment.utc(strDate + ' ' + timeValue, DateUtils_1.DateUtils.Formats.DateTime.Format24Seconds);
	                }
	            }
	        }
	        return result;
	    };
	    DateTimePickerApi.prototype.getUnixTimestamp = function () {
	        var date = this.getUTCDate();
	        return date ? DateUtils_1.DateUtils.asUnixTimestamp(date) : 0;
	    };
	    DateTimePickerApi.prototype.clearDates = function () {
	        this.callApi('date', 'clearDates');
	        this.callApi('time', 'setTime', null);
	    };
	    DateTimePickerApi.prototype.setUTCDate = function (date) {
	        var utcDate = DateUtils_1.DateUtils.asUtcMoment(date);
	        this.callApi('date', 'setUTCDate', utcDate.toDate());
	        var time = utcDate.format(this._timeFormat);
	        this.callApi('time', 'setTime', time);
	    };
	    return DateTimePickerApi;
	}());
	exports.DateTimePickerApi = DateTimePickerApi;
	var DateTimePicker = (function (_super) {
	    __extends(DateTimePicker, _super);
	    function DateTimePicker(id, options) {
	        _super.call(this, id);
	        this._options = options;
	        this.getComponent('date', true);
	        this.getComponent('time', true);
	    }
	    DateTimePicker.prototype.getInitOptions = function (component) {
	        if (component === 'date') {
	            return this.getDateOptions();
	        }
	        else if (component === 'time') {
	            return this.getTimeOptions();
	        }
	        throw new Error("Unknown component type '" + component + "'");
	    };
	    DateTimePicker.prototype.getDateOptions = function () {
	        var o = this._options.date;
	        return {
	            autoclose: o.autoclose,
	            todayBtn: o.todayBtn,
	            format: o.format,
	            todayHighlight: true
	        };
	    };
	    DateTimePicker.prototype.getTimeOptions = function () {
	        var o = this._options.time;
	        return {
	            template: 'dropdown',
	            maxHours: 24,
	            snapToStep: o.snapToStep,
	            minuteStep: o.minuteStep,
	            showSeconds: o.showSeconds,
	            secondStep: o.secondStep,
	            showMeridian: o.showMeridian,
	            showInputs: true,
	            disableFocus: false,
	            disableMousewheel: true,
	            modalBackdrop: false,
	            explicitMode: false,
	            owerflowUpdateParent: false,
	            defaultTime: this._options.timeValue
	        };
	    };
	    return DateTimePicker;
	}(DateTimePickerApi));
	exports.DateTimePicker = DateTimePicker;


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var ArgValidator_1 = __webpack_require__(2);
	var Section = (function () {
	    function Section() {
	    }
	    Section.showField = function (field, focusField) {
	        ArgValidator_1.ArgValidator.ensureStringIsNotNullOrEmpty(field, 'field');
	        $(".multi-hide").hide();
	        $(".multi-show").show();
	        $(".multi-show").closest(".form-group").removeClass("gray");
	        var label = "#lbl" + field;
	        var frm = "#frm" + field;
	        $(label).hide();
	        $(frm).show();
	        $(label).closest(".form-group").addClass("gray");
	        if (focusField) {
	            $('#' + focusField).focus();
	        }
	    };
	    Section.hideField = function (field) {
	        ArgValidator_1.ArgValidator.ensureStringIsNotNullOrEmpty(field, 'field');
	        var label = "#lbl" + field;
	        var frm = "#frm" + field;
	        $(label).show();
	        $(frm).hide();
	        $(label).closest(".form-group").removeClass("gray");
	    };
	    return Section;
	}());
	exports.Section = Section;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var _ = __webpack_require__(7);
	var Utils_1 = __webpack_require__(5);
	var StringUtils_1 = __webpack_require__(3);
	var WidgetBase_1 = __webpack_require__(53);
	var TreeViewApi = (function (_super) {
	    __extends(TreeViewApi, _super);
	    function TreeViewApi(id) {
	        _super.call(this, id);
	    }
	    Object.defineProperty(TreeViewApi.prototype, "fancytree", {
	        get: function () {
	            return this.getFancytree();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TreeViewApi.prototype.getInitOptions = function () {
	        return null;
	    };
	    TreeViewApi.prototype.getFancytree = function (doInit) {
	        if (doInit === void 0) { doInit = false; }
	        if (!this._fancytree) {
	            if (doInit) {
	                this.jq.fancytree(this.getInitOptions());
	            }
	            this._fancytree = this.jq.fancytree("getTree");
	        }
	        return this._fancytree;
	    };
	    TreeViewApi.prototype.expandAll = function () {
	        this.fancytree.visit(function (node) { return node.setExpanded(true); });
	    };
	    TreeViewApi.prototype.collapseAll = function () {
	        this.fancytree.visit(function (node) { return node.setExpanded(false); });
	    };
	    TreeViewApi.prototype.selectAll = function (select) {
	        this.fancytree.visit(function (node) {
	            node.setSelected(select);
	        });
	    };
	    TreeViewApi.prototype.visit = function (visitFn) {
	        this.fancytree.visit(function (node) {
	            visitFn(node);
	        });
	    };
	    TreeViewApi.prototype.getSelectedNodeKeys = function (filter) {
	        var nodes = this.fancytree.getSelectedNodes();
	        if (filter) {
	            nodes = _.filter(nodes, filter);
	        }
	        return _.map(nodes, function (n) { return n.key; });
	    };
	    TreeViewApi.prototype.getNodeByKey = function (key, searchRoot) {
	        return this.fancytree.getNodeByKey(key, searchRoot);
	    };
	    return TreeViewApi;
	}(WidgetBase_1.WidgetApiBase));
	exports.TreeViewApi = TreeViewApi;
	var TreeView = (function (_super) {
	    __extends(TreeView, _super);
	    function TreeView(id, options) {
	        _super.call(this, id);
	        this._initialized = false;
	        var hiddenIdSelection = "#" + id + "-selection-hdn";
	        this._selectionInput = $(hiddenIdSelection);
	        this._options = options;
	    }
	    Object.defineProperty(TreeView.prototype, "options", {
	        get: function () {
	            return this._options;
	        },
	        set: function (value) {
	            this.assertOptions(value);
	            this._options = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TreeView.prototype.assertOptions = function (opt) {
	        var o = opt || this._options;
	        if (Utils_1.Utils.isNullOrUndefined(o)) {
	            throw new Error('Options for TreeView could not be null or undefined!');
	        }
	    };
	    TreeView.prototype.initialize = function () {
	        if (this._initialized) {
	            throw new Error("Tree view '" + this._id + "' was already initialized!");
	        }
	        this.assertOptions();
	        this.handleInit = this.handleInit.bind(this);
	        this.handleBeforeSelect = this.handleBeforeSelect.bind(this);
	        this.handleRenderNode = this.handleRenderNode.bind(this);
	        this.handleSelect = this.handleSelect.bind(this);
	        this.getFancytree(true);
	        this.updateSelection();
	        this._initialized = true;
	    };
	    TreeView.get = function (id) {
	        var tv = window[("_Neo_TreeView_" + id)];
	        return tv;
	    };
	    TreeView.prototype.updateSelection = function () {
	        var self = this;
	        var selectionJson = [];
	        this.fancytree.visit(function (node) {
	            if (node.isSelected()) {
	                if (self.canAcceptSelection(node)) {
	                    selectionJson.push(node.key);
	                }
	            }
	        });
	        this._selectionInput.val(JSON.stringify(selectionJson));
	    };
	    TreeView.prototype.getInitOptions = function () {
	        var self = this;
	        var o = this._options;
	        var fancyTreeOptions = {
	            selectMode: o.selectMode,
	            quicksearch: o.quicksearch,
	            focusOnSelect: o.focusOnSelect,
	            checkbox: o.checkbox,
	            activeVisible: o.activeVisible,
	            autoActivate: o.autoActivate,
	            autoCollapse: o.autoCollapse,
	            autoScroll: o.autoScroll,
	            clickFolderMode: o.clickFolderMode,
	            minExpandLevel: o.minExpandLevel,
	            source: o.source,
	            init: this.handleInit,
	            beforeSelect: this.handleBeforeSelect,
	            renderNode: this.handleRenderNode,
	            select: this.handleSelect
	        };
	        fancyTreeOptions.escapeTitles = o.escapeTitles;
	        fancyTreeOptions.icon = o.icon;
	        return fancyTreeOptions;
	    };
	    TreeView.prototype.canAcceptSelection = function (node) {
	        var res = undefined;
	        if (this.onAcceptSelection) {
	            res = this.onAcceptSelection({
	                fancyNode: node
	            });
	        }
	        return Utils_1.Utils.valueOrDefault(res, true);
	    };
	    TreeView.prototype.fireOnInit = function (event, data) {
	        if (!Utils_1.Utils.isNullOrUndefined(this.onInit)) {
	            this.onInit(event, {
	                treeView: this,
	                node: {
	                    fancyNode: data.node
	                }
	            });
	        }
	    };
	    TreeView.prototype.fireOnRenderNode = function (event, data) {
	        if (!Utils_1.Utils.isNullOrUndefined(this.onRenderNode)) {
	            this.onRenderNode(event, {
	                treeView: this,
	                node: {
	                    fancyNode: data.node
	                }
	            });
	        }
	    };
	    TreeView.prototype.fireOnSelectionChanged = function (event, data) {
	        if (!Utils_1.Utils.isNullOrUndefined(this.onSelectionChanged)) {
	            this.onSelectionChanged(event, {
	                treeView: this,
	                node: {
	                    fancyNode: data.node
	                }
	            });
	        }
	    };
	    TreeView.prototype.handleSelect = function (event, data) {
	        this.updateSelection();
	        this.fireOnSelectionChanged(event, data);
	    };
	    TreeView.prototype.handleBeforeSelect = function (event, data) {
	        var node = data.node;
	        var canSelect = node.unselectable === false;
	        return canSelect;
	    };
	    TreeView.prototype.handleRenderNode = function (event, data) {
	        this.fireOnRenderNode(event, data);
	    };
	    TreeView.prototype.handleInit = function (event, data) {
	        var tree = data.tree;
	        var o = this._options;
	        var h = o.height;
	        if (h && h > 0) {
	            var ul = tree.$container;
	            ul.css('height', h + "px");
	            ul.css('overflowY', 'auto');
	            if (!StringUtils_1.StringUtils.isNullOrEmpty(o.ulcss)) {
	                ul.addClass(o.ulcss);
	            }
	            if (!o.border) {
	                ul.addClass('no-border');
	            }
	        }
	        tree.visit(function (node) {
	            node.setSelected(node.data.preselected);
	        });
	        this.fireOnInit(event, data);
	    };
	    TreeView.updateNodeDisabled = function (node, disabled) {
	        var jq = $(node.li);
	        if (disabled) {
	            jq.addClass('fancytree-graytext');
	        }
	        else {
	            jq.removeClass('fancytree-graytext');
	        }
	    };
	    TreeView.updateNodeStrikeThrough = function (node, strikeThrough) {
	        var jq = $(node.li);
	        if (strikeThrough) {
	            jq.addClass('fancytree-strikethrough');
	        }
	        else {
	            jq.removeClass('fancytree-strikethrough');
	        }
	    };
	    return TreeView;
	}(TreeViewApi));
	exports.TreeView = TreeView;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var WidgetBase_1 = __webpack_require__(53);
	var ModalApi = (function (_super) {
	    __extends(ModalApi, _super);
	    function ModalApi(id) {
	        _super.call(this, id);
	    }
	    ModalApi.prototype.getInitOptions = function () {
	        return null;
	    };
	    ModalApi.prototype.getModal = function (doInit) {
	        if (doInit === void 0) { doInit = false; }
	        if (!this._modal) {
	            var opt = doInit ? this.getInitOptions() : undefined;
	            this._modal = this.jq.modal(opt);
	        }
	        return this._modal;
	    };
	    ModalApi.prototype.callApi = function (method) {
	        this.getModal();
	        this.jq.modal(method);
	    };
	    ModalApi.prototype.show = function () {
	        this.callApi('show');
	    };
	    ModalApi.prototype.hide = function () {
	        this.callApi('hide');
	    };
	    ModalApi.prototype.toggle = function () {
	        this.callApi('toggle');
	    };
	    ModalApi.prototype.update = function () {
	        this.callApi('handleUpdate');
	    };
	    ModalApi.prototype.updateTitle = function (title) {
	        var modalTitle = this.jq.find('.modal-title');
	        modalTitle.text(title);
	    };
	    ModalApi.prototype.updateBody = function (body) {
	        var modalBody = this.jq.find('.modal-body');
	        modalBody.html(body);
	    };
	    return ModalApi;
	}(WidgetBase_1.WidgetApiBase));
	exports.ModalApi = ModalApi;
	var Modal = (function (_super) {
	    __extends(Modal, _super);
	    function Modal(id, options) {
	        _super.call(this, id);
	        this._options = options;
	        this.getModal(true);
	    }
	    Modal.prototype.getInitOptions = function () {
	        var o = this._options;
	        return {
	            backdrop: true,
	            keyboard: o.keyboard,
	            show: o.show
	        };
	    };
	    return Modal;
	}(ModalApi));
	exports.Modal = Modal;


/***/ },
/* 61 */
/***/ function(module, exports) {

	"use strict";
	(function (StatusMessageType) {
	    StatusMessageType[StatusMessageType["Success"] = 0] = "Success";
	    StatusMessageType[StatusMessageType["Information"] = 1] = "Information";
	    StatusMessageType[StatusMessageType["Warning"] = 2] = "Warning";
	    StatusMessageType[StatusMessageType["Error"] = 3] = "Error";
	})(exports.StatusMessageType || (exports.StatusMessageType = {}));
	var StatusMessageType = exports.StatusMessageType;
	var StatusMessage = (function () {
	    function StatusMessage(statusMessages) {
	        this.statusMessage = statusMessages;
	    }
	    StatusMessage.prototype.getHTMLmessage = function () {
	        var result;
	        var container = this.getMainDivContainer(this.statusMessage);
	        var closeButton = this.getCloseButton();
	        container.appendChild(closeButton);
	        var titleType = this.getTitleType(this.statusMessage.type);
	        container.appendChild(titleType);
	        var messageText = this.getMessage(this.statusMessage.message);
	        container.appendChild(messageText);
	        if (this.statusMessage.code) {
	            var codeText = this.getMessage("[" + this.statusMessage.code + "]");
	            container.appendChild(codeText);
	        }
	        if (this.statusMessage.innerMessages) {
	            var innerMessages = this.getListElement(this.statusMessage.innerMessages);
	            container.appendChild(innerMessages);
	        }
	        result = container.outerHTML;
	        return result;
	    };
	    StatusMessage.prototype.getGeneratedGuid = function () {
	        return 'xxxxxxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
	            return v.toString(16);
	        });
	    };
	    StatusMessage.prototype.getListElement = function (innerMessages) {
	        var _this = this;
	        var listElement = (document.createElement('ul'));
	        innerMessages.forEach(function (item) {
	            var itemElement = (document.createElement('li'));
	            itemElement.appendChild(_this.getMessage(item.message));
	            listElement.appendChild(itemElement);
	        });
	        return listElement;
	    };
	    StatusMessage.prototype.getMessage = function (message) {
	        var textElement = (document.createElement('p'));
	        textElement.textContent = message;
	        return textElement;
	    };
	    StatusMessage.prototype.getTitleType = function (type) {
	        var heading = (document.createElement('h4'));
	        heading.className = 'block';
	        heading.textContent = StatusMessageType[type].toString();
	        return heading;
	    };
	    StatusMessage.prototype.getCloseButton = function () {
	        var button = (document.createElement('button'));
	        button.className = 'close';
	        button.id = "closeStatusMessage" + this.getGeneratedGuid();
	        button.type = 'button';
	        button.setAttribute('data-dismiss', 'alert');
	        button.setAttribute('aria-hidden', 'true');
	        return button;
	    };
	    StatusMessage.prototype.getMainDivContainer = function (statusMessage) {
	        var container = (document.createElement('div'));
	        container.className = "note note-" + statusMessage.class;
	        container.id = "statusMessage-" + this.getGeneratedGuid();
	        container.setAttribute('data-componentType', 'statusMessage');
	        container.setAttribute('data-autoClose', statusMessage.autoClose.toString().toLowerCase());
	        return container;
	    };
	    return StatusMessage;
	}());
	exports.StatusMessage = StatusMessage;


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ErrorLog = __webpack_require__(63);
	exports.ErrorLog = ErrorLog;
	var Users = __webpack_require__(65);
	exports.Users = Users;
	var Roles = __webpack_require__(70);
	exports.Roles = Roles;
	var AuditLog = __webpack_require__(73);
	exports.AuditLog = AuditLog;
	var Customers = __webpack_require__(77);
	exports.Customers = Customers;
	var FreeRoundCampaigns = __webpack_require__(89);
	exports.FreeRoundCampaigns = FreeRoundCampaigns;
	var Players = __webpack_require__(96);
	exports.Players = Players;
	var Games = __webpack_require__(98);
	exports.Games = Games;
	var Channels = __webpack_require__(103);
	exports.Channels = Channels;
	var Platforms = __webpack_require__(106);
	exports.Platforms = Platforms;
	var RequestLog = __webpack_require__(109);
	exports.RequestLog = RequestLog;
	var ConfigurationImport = __webpack_require__(111);
	exports.ConfigurationImport = ConfigurationImport;
	var FreeRoundConfigurationImport = __webpack_require__(115);
	exports.FreeRoundConfigurationImport = FreeRoundConfigurationImport;
	var Logs = __webpack_require__(118);
	exports.Logs = Logs;
	var FrontofficeUsers = __webpack_require__(120);
	exports.FrontofficeUsers = FrontofficeUsers;
	var GameBuildConfiguration = __webpack_require__(123);
	exports.GameBuildConfiguration = GameBuildConfiguration;
	var ProgressiveBonuses = __webpack_require__(126);
	exports.ProgressiveBonuses = ProgressiveBonuses;
	var Reviews = __webpack_require__(138);
	exports.Reviews = Reviews;
	var Jurisdictions = __webpack_require__(142);
	exports.Jurisdictions = Jurisdictions;
	var ConfigurationOverview = __webpack_require__(145);
	exports.ConfigurationOverview = ConfigurationOverview;
	var GamePresentation = __webpack_require__(148);
	exports.GamePresentation = GamePresentation;
	var ConfigurationCleanup = __webpack_require__(150);
	exports.ConfigurationCleanup = ConfigurationCleanup;
	var GameConfigurations = __webpack_require__(152);
	exports.GameConfigurations = GameConfigurations;
	var GameClientVersions = __webpack_require__(157);
	exports.GameClientVersions = GameClientVersions;


/***/ },
/* 63 */
[172, 64],
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var _ = __webpack_require__(7);
	var MultiSelect_1 = __webpack_require__(52);
	var DateTimePicker_1 = __webpack_require__(57);
	var Utils_1 = __webpack_require__(5);
	var DateUtils_1 = __webpack_require__(48);
	var StringUtils_1 = __webpack_require__(3);
	var StatusMessage_1 = __webpack_require__(61);
	var StatusMessageHelper_1 = __webpack_require__(50);
	var FILTER_DELIM = '-delim-';
	var batchSize = 100;
	var ErrorLogBrowseRequest = (function () {
	    function ErrorLogBrowseRequest() {
	    }
	    return ErrorLogBrowseRequest;
	}());
	var IndexPage = (function () {
	    function IndexPage(options) {
	        this._options = options;
	        this.run = this.run.bind(this);
	        this.showLoadMoreButton = this.showLoadMoreButton.bind(this);
	        this.hideLoadMoreButton = this.hideLoadMoreButton.bind(this);
	        this.enableRunButton = this.enableRunButton.bind(this);
	        this.loadMore = this.loadMore.bind(this);
	        this.resetFilter = this.resetFilter.bind(this);
	        this.renderDetailRow = this.renderDetailRow.bind(this);
	        this.renderContextData = this.renderContextData.bind(this);
	        this.getCountResult = this.getCountResult.bind(this);
	        this.toggleDetail = this.toggleDetail.bind(this);
	        this._runButton = Utils_1.Utils.getJQueryById("btnRunQuery");
	        this._runButton.on("click", this.run);
	        this._loadMoreButton = Utils_1.Utils.getJQueryById("btnLoadMore");
	        this._loadMoreButton.on("click", this.loadMore);
	        this._resetFilterButton = Utils_1.Utils.getJQueryById("btnResetFilter");
	        this._resetFilterButton.on("click", this.resetFilter);
	        this._btnCountResult = Utils_1.Utils.getJQueryById("btnCountResult");
	        this._btnCountResult.on("click", this.getCountResult);
	        this._totalEntries = Utils_1.Utils.getJQueryById("totalEntries");
	        this._processing = Utils_1.Utils.getJQueryById("processing");
	        this._filterId = Utils_1.Utils.getJQueryById('filterId');
	        this._filterLevel = new MultiSelect_1.MultiSelectApi('filterLevel');
	        this._filterCreatedFrom = new DateTimePicker_1.DateTimePickerApi('filterCreatedFrom');
	        this._filterCreatedTo = new DateTimePicker_1.DateTimePickerApi('filterCreatedTo');
	        this._filterMessage = Utils_1.Utils.getJQueryById('filterMessage');
	        this._filterComputerName = new MultiSelect_1.MultiSelectApi('filterComputerName');
	        this._filterSessionId = Utils_1.Utils.getJQueryById('filterSessionId');
	        this._filterErrorId = Utils_1.Utils.getJQueryById('filterErrorId');
	        this._filterFullText = Utils_1.Utils.getJQueryById('filterFullText');
	        this._filterApplication = new MultiSelect_1.MultiSelectApi('filterApplication');
	        this._filterGameRoundId = Utils_1.Utils.getJQueryById('filterGameRoundId');
	        this._filterPlayerId = Utils_1.Utils.getJQueryById('filterPlayerId');
	        this._excludedMessages = new Array();
	        var that = this;
	        $(document).on('click', '.messageRemove', function (e) {
	            if (e.target.parentElement.hasAttribute("data-msg")) {
	                var message = e.target.parentElement.attributes['data-msg'].value;
	                var index = that._excludedMessages.indexOf(message);
	                if (index != -1) {
	                    that._excludedMessages.splice(index, 1);
	                }
	            }
	            e.target.parentElement.parentElement.remove();
	        });
	        $(document).on('click', 'a.filterRecords', function (e) {
	            var filterMessage = e.target.attributes['data-msg'].value;
	            that.addFilterMessage(filterMessage);
	        });
	    }
	    IndexPage.prototype.addFilterMessage = function (filterMessage) {
	        if (this._excludedMessages.indexOf(filterMessage) != -1) {
	            return;
	        }
	        this._excludedMessages.push(filterMessage);
	        var table = document.getElementById("excludedMessages");
	        var row = table.insertRow(-1);
	        var cell0 = row.insertCell(0);
	        cell0.className = "messageRemove";
	        cell0.setAttribute("data-msg", filterMessage);
	        cell0.innerHTML = '<i class="fa fa-remove color-red cursor-pointer" style="width: 20px;"></i>';
	        var cell1 = row.insertCell(1);
	        cell1.className = "messageText";
	        cell1.innerHTML = "" + StringUtils_1.StringUtils.escapeHtml(filterMessage);
	    };
	    IndexPage.prototype.run = function () {
	        this.disableRunButton();
	        var totalEntries = this._totalEntries[0];
	        totalEntries.innerText = "##";
	        this._currentRequest = this.getBrowseRequest();
	        var table = this.getTableBody();
	        table.innerHTML = "";
	        this.sendRequest(this._currentRequest);
	    };
	    IndexPage.prototype.getTableBody = function () {
	        return document.getElementById("tableLogs").getElementsByTagName("tbody")[0];
	    };
	    IndexPage.prototype.getBrowseRequest = function () {
	        var request = new ErrorLogBrowseRequest();
	        request.ExcludedMessages = this._excludedMessages;
	        request.Id = this._filterId.val();
	        request.ErrorId = this._filterErrorId.val();
	        request.LogLevel = this._filterLevel.isAllSelected() ? '' : this._filterLevel.getSelectionValues(FILTER_DELIM);
	        request.TimestampFrom = this._filterCreatedFrom.getUnixTimestamp();
	        request.TimestampTo = this._filterCreatedTo.getUnixTimestamp();
	        request.Description = this._filterMessage.val();
	        request.Computer = this._filterComputerName.isAllSelected() ? '' : this._filterComputerName.getSelectionValues(FILTER_DELIM);
	        request.SessionId = this._filterSessionId.val();
	        request.FullText = this._filterFullText.val();
	        request.GameRoundId = this._filterGameRoundId.val();
	        request.PlayerId = this._filterPlayerId.val();
	        request.Application = this._filterApplication.isAllSelected() ? '' : this._filterApplication.getSelectionValues(FILTER_DELIM);
	        request.BatchSize = batchSize + 1;
	        return request;
	    };
	    IndexPage.prototype.sendRequest = function (request) {
	        var urlList = this._options.urlList;
	        var table = this.getTableBody();
	        var showLoadMore = this.showLoadMoreButton;
	        var hideLoadMore = this.hideLoadMoreButton;
	        var enableRunButton = this.enableRunButton;
	        var processing = this._processing;
	        var displayMessage = this.displayMessage;
	        var renderDetailRow = this.renderDetailRow;
	        var toggleDetail = this.toggleDetail;
	        var jsonData = JSON.stringify(request);
	        processing.show();
	        $.ajax({
	            url: urlList,
	            type: "POST",
	            dataType: 'json',
	            contentType: "application/json",
	            data: jsonData,
	            success: function (data) {
	                var items = data;
	                if (items.length < batchSize + 1) {
	                    hideLoadMore();
	                }
	                else {
	                    request.LastCreated = items[batchSize].CreatedTicks;
	                    showLoadMore();
	                }
	                $.each(items, function (index, item) {
	                    if (index < batchSize) {
	                        var row_1 = table.insertRow(-1);
	                        row_1.id = "logEntry" + item.Id;
	                        row_1.className = "cursor-pointer";
	                        row_1.onclick = function () { return toggleDetail(row_1.id); };
	                        var cell0 = row_1.insertCell(0);
	                        cell0.innerHTML = item.Id + "<br /> <a class='errorIdLink' id='lnkName" + item.ErrorId + "' href='Logs/Detail/" + item.ErrorId + "'>" + item.ErrorId + "</a>";
	                        cell0.className = "log-level-" + item.Level.toLowerCase();
	                        var cell1 = row_1.insertCell(1);
	                        cell1.innerHTML = "<span>" + item.Level + "</span>";
	                        var cell2 = row_1.insertCell(2);
	                        cell2.innerHTML = "" + item.Created;
	                        var cell3 = row_1.insertCell(3);
	                        cell3.innerHTML = item.ComputerName + "<br/>" + item.Application;
	                        var cell4 = row_1.insertCell(4);
	                        cell4.innerHTML = "" + item.SessionId;
	                        var cell5 = row_1.insertCell(5);
	                        cell5.innerHTML = "" + StringUtils_1.StringUtils.escapeHtml(item.Message);
	                        var detailRow = table.insertRow(-1);
	                        detailRow.setAttribute("style", "display: none");
	                        detailRow.id = "logEntry" + item.Id + "detail";
	                        var detailCell = detailRow.insertCell(0);
	                        detailCell.colSpan = 6;
	                        detailCell.innerHTML = renderDetailRow(item);
	                    }
	                });
	                processing.hide();
	                enableRunButton();
	            },
	            error: function (jqXHR, textStatus, errorThrown) {
	                processing.hide();
	                enableRunButton();
	                displayMessage(jqXHR);
	            }
	        });
	    };
	    IndexPage.prototype.toggleDetail = function (id) {
	        var detailId = id + "detail";
	        var detailRow = document.getElementById(detailId);
	        if (detailRow.hasAttribute("style")) {
	            detailRow.removeAttribute("style");
	        }
	        else {
	            detailRow.setAttribute("style", "display: none");
	        }
	    };
	    IndexPage.prototype.displayMessage = function (jqXHR) {
	        var statusMessageWrapper = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	        var statusMessageData = {
	            code: jqXHR.status.toString(),
	            autoClose: false,
	            class: "danger",
	            message: jqXHR.statusText,
	            type: StatusMessage_1.StatusMessageType.Error
	        };
	        var statusMessage = new StatusMessage_1.StatusMessage(statusMessageData);
	        statusMessageWrapper.html(statusMessage.getHTMLmessage());
	        StatusMessageHelper_1.StatusMessageHelper.initValidator();
	        StatusMessageHelper_1.StatusMessageHelper.initSatusMessage();
	    };
	    IndexPage.prototype.showLoadMoreButton = function () {
	        this._loadMoreButton.removeClass("display-none");
	    };
	    IndexPage.prototype.hideLoadMoreButton = function () {
	        this._loadMoreButton.addClass("display-none");
	    };
	    IndexPage.prototype.disableRunButton = function () {
	        this._runButton.attr("disabled", 1);
	    };
	    IndexPage.prototype.enableRunButton = function () {
	        this._runButton.removeAttr("disabled");
	    };
	    IndexPage.prototype.loadMore = function () {
	        this._currentRequest.ExcludedMessages = this._excludedMessages;
	        this.sendRequest(this._currentRequest);
	    };
	    IndexPage.prototype.resetFilter = function () {
	        this._excludedMessages = new Array();
	        var table = document.getElementById("excludedMessages");
	        table.innerHTML = '';
	        this._filterId.val('');
	        this._filterLevel.selectAll();
	        this._filterLevel.setSelectionValues("Warning;Error;Critical");
	        var createdFrom = DateUtils_1.DateUtils.getUtcMoment().subtract(7, 'days').set({ hours: 0, minutes: 0, seconds: 0 });
	        this._filterCreatedFrom.setUTCDate(createdFrom);
	        var createdTo = DateUtils_1.DateUtils.getUtcMoment().endOf('day');
	        this._filterCreatedTo.setUTCDate(createdTo);
	        this._filterMessage.val('');
	        this._filterComputerName.selectAll();
	        this._filterSessionId.val('');
	        this._filterErrorId.val('');
	        this._filterFullText.val('');
	        this._filterGameRoundId.val('');
	        this._filterPlayerId.val('');
	        this._filterApplication.selectAll();
	    };
	    IndexPage.prototype.renderDetailRow = function (data) {
	        var exceptionData = _.escape(data.ExceptionData);
	        var css = data.Level.toLowerCase();
	        if (css === 'error' || css === 'critical') {
	            css = 'danger';
	        }
	        else if (css === 'information') {
	            css = 'info';
	        }
	        var result = "<div class='note note-" + css + "'>\n                    <p>&nbsp;</p>\n                    <h5>Category</h5>\n                    <p>" + data.CategoryName + "</p>\n                    <p>&nbsp;</p>";
	        if (!StringUtils_1.StringUtils.isNullOrEmpty(data.ExceptionData) ||
	            !StringUtils_1.StringUtils.isNullOrEmpty(data.ContextData)) {
	            result += "<h5>Context</h5>\n                    <p>" + this.renderContextData(data.ContextData) + "</p>\n                    <p>&nbsp;</p>\n                    <h5>Exception</h5>\n                    <p class=\"errorLogContextData\">" + exceptionData + "</p>\n                    <p>&nbsp;</p>";
	        }
	        result += "<a id=\"GenerateAccessLinkButton_" + data.Id + "\" href=\"" + this._options.urlDetailContextInformation + "/?id=" + data.Id + "&type=1\">Generate context information</a>";
	        result += "<a id=\"filterRecord_" + data.Id + "\" style=\"margin-left: 20px;\" class=\"filterRecords\" data-msg=\"" + data.Message + "\">Filter out identical records</a>";
	        result += '</div>';
	        return result;
	    };
	    IndexPage.prototype.renderContextData = function (contextData) {
	        var json = null;
	        try {
	            json = JSON.parse(contextData);
	        }
	        catch (e) {
	            json = null;
	        }
	        var result = '';
	        if (json === null || !_.isArray(json)) {
	            result = contextData;
	        }
	        else {
	            result = '<table class="errorLogContextData table-bordered table-hover">';
	            _.each(json, function (item) {
	                for (var key in item) {
	                    result += "<tr><td>" + key + "</td><td>" + StringUtils_1.StringUtils.escapeHtml(item[key]) + "</td></tr>";
	                }
	            });
	            result += '</table>';
	        }
	        return result;
	    };
	    IndexPage.prototype.getCountResult = function () {
	        var request = Utils_1.Utils.isNullOrUndefined(this._currentRequest) ? this.getBrowseRequest() : this._currentRequest;
	        request.ExcludedMessages = this._excludedMessages;
	        var urlCount = this._options.urlCount;
	        var totalEntries = this._totalEntries[0];
	        var processing = this._processing;
	        var displayMessage = this.displayMessage;
	        var jsonData = JSON.stringify(request);
	        processing.show();
	        $.ajax({
	            url: urlCount,
	            type: "POST",
	            dataType: 'json',
	            contentType: "application/json",
	            data: jsonData,
	            success: function (data) {
	                totalEntries.innerText = data;
	                processing.hide();
	            },
	            error: function (jqXHR, textStatus, errorThrown) {
	                processing.hide();
	                displayMessage(jqXHR);
	            }
	        });
	    };
	    return IndexPage;
	}());
	exports.IndexPage = IndexPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 65 */
[173, 66, 69],
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var Utils_1 = __webpack_require__(5);
	var tableId = 'tableUsers';
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'f><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var IndexPage = (function (_super) {
	    __extends(IndexPage, _super);
	    function IndexPage(options) {
	        _super.call(this, options);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            columns: [
	                {
	                    data: "UserName",
	                    className: "bold",
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkUsername" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: "IsEnabled",
	                    render: function (data, type, rowData) {
	                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                        var css = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                    }
	                },
	                {
	                    data: "LockState",
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        var text = data === 'Locked' ? options.localizer.Locked : options.localizer.Unlocked;
	                        var css = data === 'Locked' ? 'status-disabled' : 'status-enabled';
	                        return "<span id='spnLockState" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                    }
	                },
	                {
	                    data: 'Name',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnName" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Email',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnEmail" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Description',
	                    sortable: false,
	                    defaultContent: '',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnDescription" + rowData.Id + "'>" + Utils_1.Utils.valueOrDefault(data, '') + "</span>");
	                    }
	                },
	                {
	                    data: '',
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkDetail" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + options.localizer.DetailsLink + "</a>");
	                    }
	                }
	            ]
	        };
	    }
	    IndexPage.prototype.init = function () {
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	    };
	    return IndexPage;
	}(PageBase_1.PageBase));
	exports.IndexPage = IndexPage;


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ComponentBase_1 = __webpack_require__(68);
	var PageBase = (function (_super) {
	    __extends(PageBase, _super);
	    function PageBase() {
	        _super.apply(this, arguments);
	        this._filterDelim = "-delim-";
	    }
	    return PageBase;
	}(ComponentBase_1.ComponentBase));
	exports.PageBase = PageBase;


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var ComponentBase = (function () {
	    function ComponentBase(options) {
	        this._options = options;
	        this.init = this.init.bind(this);
	        $(document).ready(this.init);
	    }
	    return ComponentBase;
	}());
	exports.ComponentBase = ComponentBase;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var DetailPage = (function (_super) {
	    __extends(DetailPage, _super);
	    function DetailPage() {
	        _super.apply(this, arguments);
	    }
	    DetailPage.prototype.init = function () {
	    };
	    return DetailPage;
	}(PageBase_1.PageBase));
	exports.DetailPage = DetailPage;


/***/ },
/* 70 */
[173, 71, 72],
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var Utils_1 = __webpack_require__(5);
	var tableId = 'tableRoles';
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'f><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var IndexPage = (function (_super) {
	    __extends(IndexPage, _super);
	    function IndexPage(options) {
	        _super.call(this, options);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            columns: [
	                {
	                    data: "Name",
	                    className: "bold",
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkRoleName" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: 'Membercount',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnMembercount" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Description',
	                    sortable: false,
	                    defaultContent: '',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnDescription" + rowData.Id + "'>" + Utils_1.Utils.valueOrDefault(data, '') + "</span>");
	                    }
	                },
	                {
	                    data: '',
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkRoleName" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + options.localizer.DetailsLink + "</a>");
	                    }
	                }
	            ]
	        };
	    }
	    IndexPage.prototype.init = function () {
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	    };
	    return IndexPage;
	}(PageBase_1.PageBase));
	exports.IndexPage = IndexPage;


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var DetailPage = (function (_super) {
	    __extends(DetailPage, _super);
	    function DetailPage() {
	        _super.apply(this, arguments);
	    }
	    DetailPage.prototype.init = function () {
	        Datatable_1.DatatableApi.attach('userRoleUsers');
	    };
	    return DetailPage;
	}(PageBase_1.PageBase));
	exports.DetailPage = DetailPage;


/***/ },
/* 73 */
[173, 74, 76],
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var MultiSelect_1 = __webpack_require__(52);
	var DateTimePicker_1 = __webpack_require__(57);
	var Utils_1 = __webpack_require__(5);
	var DateUtils_1 = __webpack_require__(48);
	var StatusMessage_1 = __webpack_require__(61);
	var StatusMessageHelper_1 = __webpack_require__(50);
	var Typeahead_1 = __webpack_require__(56);
	var AuditLogDetailHelper_1 = __webpack_require__(75);
	var FILTER_DELIM = '-delim-';
	var batchSize = 100;
	var AuditLogBrowseRequest = (function () {
	    function AuditLogBrowseRequest() {
	    }
	    return AuditLogBrowseRequest;
	}());
	var IndexPage = (function () {
	    function IndexPage(options) {
	        this._options = options;
	        this.run = this.run.bind(this);
	        this.showLoadMoreButton = this.showLoadMoreButton.bind(this);
	        this.hideLoadMoreButton = this.hideLoadMoreButton.bind(this);
	        this.enableRunButton = this.enableRunButton.bind(this);
	        this.loadMore = this.loadMore.bind(this);
	        this.resetFilter = this.resetFilter.bind(this);
	        this.getCountResult = this.getCountResult.bind(this);
	        this.toggleDetail = this.toggleDetail.bind(this);
	        this._filterType = new MultiSelect_1.MultiSelectApi('filterType');
	        this._filterCreatedFrom = new DateTimePicker_1.DateTimePickerApi('filterCreatedFrom');
	        this._filterCreatedTo = new DateTimePicker_1.DateTimePickerApi('filterCreatedTo');
	        this._filterEntityType = new MultiSelect_1.MultiSelectApi('filterEntityType');
	        this._filterEntityName = Utils_1.Utils.getJQueryById('filterEntityName');
	        this._filterUserName = Utils_1.Utils.getJQueryById('filterUserName');
	        this._filterAction = new MultiSelect_1.MultiSelectApi('filterAction');
	        this._filterResult = new MultiSelect_1.MultiSelectApi('filterResult');
	        this._filterId = Utils_1.Utils.getJQueryById('filterId');
	        this._runButton = Utils_1.Utils.getJQueryById("btnRunQuery");
	        this._runButton.on("click", this.run);
	        this._loadMoreButton = Utils_1.Utils.getJQueryById("btnLoadMore");
	        this._loadMoreButton.on("click", this.loadMore);
	        this._resetFilterButton = Utils_1.Utils.getJQueryById("btnResetFilter");
	        this._resetFilterButton.on("click", this.resetFilter);
	        this._btnCountResult = Utils_1.Utils.getJQueryById("btnCountResult");
	        this._btnCountResult.on("click", this.getCountResult);
	        this._totalEntries = Utils_1.Utils.getJQueryById("totalEntries");
	        this._processing = Utils_1.Utils.getJQueryById("processing");
	        var taOptions = {
	            source: this._options.userList
	        };
	        var ta = new Typeahead_1.Typeahead('filterUserName', taOptions);
	    }
	    IndexPage.prototype.run = function () {
	        this.disableRunButton();
	        var totalEntries = this._totalEntries[0];
	        totalEntries.innerText = "##";
	        this._currentRequest = this.getBrowseRequest();
	        var table = this.getTableBody();
	        table.innerHTML = "";
	        this.sendRequest(this._currentRequest);
	    };
	    IndexPage.prototype.getTableBody = function () {
	        return document.getElementById("tableAuditLogs").getElementsByTagName("tbody")[0];
	    };
	    IndexPage.prototype.getBrowseRequest = function () {
	        var request = new AuditLogBrowseRequest();
	        request.Id = this._filterId.val();
	        request.LogType = this._filterType.isAllSelected() ? '' : this._filterType.getSelectionValues(FILTER_DELIM);
	        request.Entity = this._filterEntityName.val();
	        request.TimestampFrom = this._filterCreatedFrom.getUnixTimestamp();
	        request.TimestampTo = this._filterCreatedTo.getUnixTimestamp();
	        request.ChangedBy = this._filterUserName.val();
	        request.EntityType = this._filterEntityType.isAllSelected() ? '' : this._filterEntityType.getSelectionValues(FILTER_DELIM);
	        request.Action = this._filterAction.isAllSelected() ? '' : this._filterAction.getSelectionValues(FILTER_DELIM);
	        request.Result = this._filterResult.isAllSelected() ? '' : this._filterResult.getSelectionValues(FILTER_DELIM);
	        request.BatchSize = batchSize + 1;
	        return request;
	    };
	    IndexPage.prototype.showLoadMoreButton = function () {
	        this._loadMoreButton.removeClass("display-none");
	    };
	    IndexPage.prototype.hideLoadMoreButton = function () {
	        this._loadMoreButton.addClass("display-none");
	    };
	    IndexPage.prototype.disableRunButton = function () {
	        this._runButton.attr("disabled", 1);
	    };
	    IndexPage.prototype.enableRunButton = function () {
	        this._runButton.removeAttr("disabled");
	    };
	    IndexPage.prototype.loadMore = function () {
	        this.sendRequest(this._currentRequest);
	    };
	    IndexPage.prototype.resetFilter = function () {
	        this._filterType.selectAll();
	        var createdFrom = DateUtils_1.DateUtils.getUtcMoment().subtract(1, 'days').set({ hours: 0, minutes: 0, seconds: 0 });
	        this._filterCreatedFrom.setUTCDate(createdFrom);
	        var createdTo = DateUtils_1.DateUtils.getUtcMoment().endOf('day');
	        this._filterCreatedTo.setUTCDate(createdTo);
	        this._filterEntityType.selectAll();
	        this._filterEntityName.val('');
	        this._filterUserName.val('');
	        this._filterAction.selectAll();
	        this._filterResult.selectAll();
	        this._filterId.val('');
	    };
	    IndexPage.prototype.displayMessage = function (jqXHR) {
	        var statusMessageWrapper = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	        var statusMessageData = {
	            code: "500",
	            autoClose: false,
	            class: "danger",
	            message: "Unexpected error",
	            type: StatusMessage_1.StatusMessageType.Error
	        };
	        var statusMessage = new StatusMessage_1.StatusMessage(statusMessageData);
	        statusMessageWrapper.html(statusMessage.getHTMLmessage());
	        StatusMessageHelper_1.StatusMessageHelper.initValidator();
	        StatusMessageHelper_1.StatusMessageHelper.initSatusMessage();
	    };
	    IndexPage.prototype.getDetailUrl = function (detailUrl, data) {
	        return detailUrl + "/" + data;
	    };
	    IndexPage.prototype.sendRequest = function (request) {
	        var urlList = this._options.urlList;
	        var detailUrl = this._options.urlDetail;
	        var getDetailUrl = this.getDetailUrl;
	        var table = this.getTableBody();
	        var showLoadMore = this.showLoadMoreButton;
	        var hideLoadMore = this.hideLoadMoreButton;
	        var enableRunButton = this.enableRunButton;
	        var processing = this._processing;
	        var displayMessage = this.displayMessage;
	        var renderDetailRow = AuditLogDetailHelper_1.AuditLogDetailHelper.renderDetailRow;
	        var toggleDetail = this.toggleDetail;
	        processing.show();
	        $.ajax({
	            url: urlList,
	            type: "POST",
	            dataType: 'html',
	            data: { request: request },
	            success: function (data) {
	                var items = JSON.parse(data);
	                if (items.length < batchSize + 1) {
	                    hideLoadMore();
	                }
	                else {
	                    request.LastId = items[batchSize].Id;
	                    showLoadMore();
	                }
	                var orderNo = 0;
	                var previousId = 0;
	                $.each(items, function (index, item) {
	                    if (index < batchSize) {
	                        if (previousId == item.Id) {
	                            orderNo++;
	                        }
	                        else {
	                            orderNo = 0;
	                        }
	                        previousId = item.Id;
	                        var row_1 = table.insertRow(-1);
	                        row_1.id = "auditLog" + item.Id + "-" + orderNo;
	                        row_1.className = "cursor-pointer";
	                        row_1.onclick = function () { return toggleDetail(row_1.id); };
	                        var cell0 = row_1.insertCell(0);
	                        cell0.innerHTML = "<a href='" + getDetailUrl(detailUrl, item.Id) + "'>" + item.Id + "</a>";
	                        cell0.className = "log-level-" + item.Result.toLowerCase();
	                        var cell1 = row_1.insertCell(1);
	                        cell1.innerHTML = "" + item.Type;
	                        var cell2 = row_1.insertCell(2);
	                        cell2.innerHTML = "" + item.Created;
	                        var cell3 = row_1.insertCell(3);
	                        cell3.innerHTML = "" + item.EntityType;
	                        var cell4 = row_1.insertCell(4);
	                        cell4.innerHTML = item.EntityId == '' ? '' : item.EntityId + (" (" + item.EntityName + ")");
	                        var cell5 = row_1.insertCell(5);
	                        cell5.innerHTML = "" + item.UserName;
	                        var cell6 = row_1.insertCell(6);
	                        cell6.innerHTML = "" + item.Action;
	                        var cell7 = row_1.insertCell(7);
	                        cell7.innerHTML = "" + item.Message;
	                        var cell8 = row_1.insertCell(8);
	                        cell8.innerHTML = "" + item.Result;
	                        var detailRow = table.insertRow(-1);
	                        detailRow.setAttribute("style", "display: none");
	                        detailRow.id = "auditLog" + item.Id + "-" + orderNo + "detail";
	                        var detailCell = detailRow.insertCell(0);
	                        detailCell.colSpan = 9;
	                        detailCell.innerHTML = renderDetailRow(item);
	                        detailCell.innerHTML += "<a href='" + getDetailUrl(detailUrl, item.Id) + "'>View record</a>";
	                    }
	                });
	                processing.hide();
	                enableRunButton();
	            },
	            error: function (jqXHR, textStatus, errorThrown) {
	                processing.hide();
	                enableRunButton();
	                displayMessage(jqXHR);
	            }
	        });
	    };
	    IndexPage.prototype.toggleDetail = function (id) {
	        var detailId = id + "detail";
	        var detailRow = document.getElementById(detailId);
	        if (detailRow.hasAttribute("style")) {
	            detailRow.removeAttribute("style");
	        }
	        else {
	            detailRow.setAttribute("style", "display: none");
	        }
	    };
	    IndexPage.prototype.getCountResult = function () {
	        var request = Utils_1.Utils.isNullOrUndefined(this._currentRequest) ? this.getBrowseRequest() : this._currentRequest;
	        var urlCount = this._options.urlCount;
	        var totalEntries = this._totalEntries[0];
	        var processing = this._processing;
	        var displayMessage = this.displayMessage;
	        processing.show();
	        $.ajax({
	            url: urlCount,
	            type: "POST",
	            dataType: 'html',
	            data: { request: request },
	            success: function (data) {
	                totalEntries.innerText = data;
	                processing.hide();
	            },
	            error: function (jqXHR, textStatus, errorThrown) {
	                processing.hide();
	                displayMessage(jqXHR);
	            }
	        });
	    };
	    return IndexPage;
	}());
	exports.IndexPage = IndexPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Utils_1 = __webpack_require__(5);
	var StringUtils_1 = __webpack_require__(3);
	var AuditLogDetailHelper = (function () {
	    function AuditLogDetailHelper() {
	    }
	    AuditLogDetailHelper.renderDetailRow = function (data) {
	        var css = data.Type.toLowerCase();
	        if (css === 'error') {
	            css = 'danger';
	        }
	        else if (css === 'information') {
	            css = 'info';
	        }
	        var result = "<div class='note note-" + css + "'>\n                    <h5>Description</h5>\n                    <p>" + data.Message + "</p>\n                    <p>&nbsp;</p>";
	        switch (data.Action) {
	            case "CustomerConfigure":
	            case "CustomerOperationConfigure":
	            case "CustomerChannelConfigure":
	            case "ChannelEditConfiguration":
	            case "PlatformEditConfiguration":
	            case "SystemConfigurationEdit":
	            case "JurisdictionEditConfiguration":
	                result += AuditLogDetailHelper.renderConfigurationDataDetailRow(data);
	                break;
	            case "ExportConfigurationOverview":
	                result += AuditLogDetailHelper.renderExportOverviewDetailRow(data);
	                break;
	            default:
	                result += AuditLogDetailHelper.renderDefaultDetailRow(data);
	                break;
	        }
	        result += '</div>';
	        return result;
	    };
	    AuditLogDetailHelper.renderDefaultDetailRow = function (data) {
	        var result = "<h5>Old value</h5>";
	        result += "<p>" + Utils_1.Utils.valueOrDefault(data.OldData, '-') + "</p>\n                    <p>&nbsp;</p>";
	        result += "<h5>New value</h5>";
	        result += "<p>" + Utils_1.Utils.valueOrDefault(data.NewData, '-') + "</p>\n                    <p>&nbsp;</p>";
	        return result;
	    };
	    AuditLogDetailHelper.renderConfigurationDataDetailRow = function (data) {
	        var jsonOld = null;
	        var jsonNew = null;
	        try {
	            jsonOld = JSON.parse(data.OldData);
	        }
	        catch (e) {
	            jsonOld = null;
	        }
	        try {
	            jsonNew = JSON.parse(data.NewData);
	        }
	        catch (e) {
	            jsonNew = null;
	        }
	        var result = '<table style="width: 40%;" class="errorLogContextData table-bordered table-hover table table-striped">';
	        result += '<tr><th>Name</th><th>Old value</th><th>New value</th></tr>';
	        for (var property in jsonOld) {
	            var oldValue = StringUtils_1.StringUtils.escapeHtml(jsonOld[property]).replace("(L)", "<label class='fa fa-lock'></label>");
	            var newValue = StringUtils_1.StringUtils.escapeHtml(jsonNew[property]).replace("(L)", "<label class='fa fa-lock'></label>");
	            result += "<tr><td>" + property + "</td><td>" + oldValue + "</td><td>" + newValue + "</td></tr>";
	        }
	        for (var property in jsonNew) {
	            if (!jsonOld.hasOwnProperty(property)) {
	                var oldValue = StringUtils_1.StringUtils.escapeHtml(jsonOld[property]).replace("(L)", "<label class='fa fa-lock'></label>");
	                var newValue = StringUtils_1.StringUtils.escapeHtml(jsonNew[property]).replace("(L)", "<label class='fa fa-lock'></label>");
	                result += "<tr><td>" + property + "</td><td>" + oldValue + "</td><td>" + newValue + "</td></tr>";
	            }
	        }
	        result += '</table>';
	        return result;
	    };
	    AuditLogDetailHelper.renderExportOverviewDetailRow = function (data) {
	        var result = '<table style="width: 40%;" class="errorLogContextData table-bordered table-hover table table-striped">';
	        var keys = data.NewData.split(",");
	        for (var i = 0; i < keys.length; ++i) {
	            result += "<tr><td>" + keys[i] + "</td></tr>";
	        }
	        result += '</table>';
	        return result;
	    };
	    return AuditLogDetailHelper;
	}());
	exports.AuditLogDetailHelper = AuditLogDetailHelper;


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var AuditLogDetailHelper_1 = __webpack_require__(75);
	var DetailPage = (function () {
	    function DetailPage(item) {
	        var detail = AuditLogDetailHelper_1.AuditLogDetailHelper.renderDetailRow(item);
	        var detailElement = document.getElementById("detailRow");
	        detailElement.innerHTML = detail;
	    }
	    return DetailPage;
	}());
	exports.DetailPage = DetailPage;


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var IndexPage_1 = __webpack_require__(78);
	exports.IndexPage = IndexPage_1.IndexPage;
	var DetailPage_1 = __webpack_require__(79);
	exports.DetailPage = DetailPage_1.DetailPage;
	var OperationDetailPage_1 = __webpack_require__(80);
	exports.OperationChannelsPage = OperationDetailPage_1.OperationChannelsPage;
	var OperationDetailPage_2 = __webpack_require__(80);
	exports.OperationBonusesPage = OperationDetailPage_2.OperationBonusesPage;
	var ChannelDetailPage_1 = __webpack_require__(81);
	exports.ChannelDetailPage = ChannelDetailPage_1.ChannelDetailPage;
	var GameConfigurationDetailPage_1 = __webpack_require__(82);
	exports.GameConfigurationDetailPage = GameConfigurationDetailPage_1.GameConfigurationDetailPage;
	var AddCurrencyPage_1 = __webpack_require__(83);
	exports.AddCurrencyPage = AddCurrencyPage_1.AddCurrencyPage;
	var AddChannelPage_1 = __webpack_require__(84);
	exports.AddChannelPage = AddChannelPage_1.AddChannelPage;
	var CurrencyDetailPage_1 = __webpack_require__(85);
	exports.CurrencyDetailPage = CurrencyDetailPage_1.CurrencyDetailPage;
	var AddBonusPage_1 = __webpack_require__(86);
	exports.AddBonusPage = AddBonusPage_1.AddBonusPage;
	var CreatePage_1 = __webpack_require__(87);
	exports.CreatePage = CreatePage_1.CreatePage;
	var AvailableProgressiveBonusPage_1 = __webpack_require__(88);
	exports.AvailableProgressiveBonusPage = AvailableProgressiveBonusPage_1.AvailableProgressiveBonusPage;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var _ = __webpack_require__(7);
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var tableId = 'tableCustomers';
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'f><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var truncateMessageOptions = {
	    length: 100
	};
	var IndexPage = (function (_super) {
	    __extends(IndexPage, _super);
	    function IndexPage(options) {
	        _super.call(this, options);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            pageLength: 100,
	            lengthMenu: [[100, 200, 300, -1], [100, 200, 300, "All"]],
	            columns: [
	                {
	                    data: 'Name',
	                    className: "bold",
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkName" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: "Code",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCode" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "PlatformName",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnPlatform" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "Status",
	                    render: function (data, type, rowData) {
	                        var css = "status-" + data.toLowerCase();
	                        return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + data + "</span>";
	                    }
	                },
	                {
	                    data: "FreeRoundBonusEnabled",
	                    render: function (data, type, rowData) {
	                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                        var statusCss = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnState" + rowData.Id + "' class='" + statusCss + "'>" + text + "</span>";
	                    }
	                },
	                {
	                    data: "Description",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnDescription" + rowData.Id + "'>" + _.truncate(data, truncateMessageOptions) + "</span>");
	                    }
	                },
	                {
	                    data: '',
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkDetail" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + options.localizer.DetailsLink + "</a>");
	                    }
	                }
	            ]
	        };
	    }
	    IndexPage.prototype.init = function () {
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	    };
	    return IndexPage;
	}(PageBase_1.PageBase));
	exports.IndexPage = IndexPage;


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var MultiSelect_1 = __webpack_require__(52);
	var Utils_1 = __webpack_require__(5);
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var configGamesDom = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var CURRENCY_COLUMN_INDEX = {
	    Code: 0,
	    Name: 1,
	    PlayForFunAmount: 2,
	    Status: 3,
	    FilterButtons: 4
	};
	var GAME_COLUMNS_INDEX = {
	    Id: 0,
	    GameName: 1,
	    Currency: 2,
	    FilterButtons: 3
	};
	var FILTER_DELIM = '-delim-';
	var btnCancelSearchId = 'btnCancelSearch';
	var btnCancelSearchFrbConfigsId = 'btnCancelSearchFrbGamesConfigs';
	var DetailPage = (function (_super) {
	    __extends(DetailPage, _super);
	    function DetailPage(options) {
	        _super.call(this, options);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        var getGameConfigurationUrl = function (rowData) { return (options.urlGameConfigurations + "?operationId=" + rowData.Id); };
	        this.preDrawCallback = this.preDrawCallback.bind(this);
	        this.createdRowCurrency = this.createdRowCurrency.bind(this);
	        this.preDrawFrbConfigCallback = this.preDrawFrbConfigCallback.bind(this);
	        this.formSubmit = this.formSubmit.bind(this);
	        this.cancelSearch = this.cancelSearch.bind(this);
	        this.cancelFrbGamesConfigsSearch = this.cancelFrbGamesConfigsSearch.bind(this);
	        this.enableFrbConfigurationMulti = this.enableFrbConfigurationMulti.bind(this);
	        this.disableFrbConfigurationMulti = this.disableFrbConfigurationMulti.bind(this);
	        this.checkBoxAll = this.checkBoxAll.bind(this);
	        this.setSelectAllConfigCheckbox = this.setSelectAllConfigCheckbox.bind(this);
	        this.copyCurrencies = this.copyCurrencies.bind(this);
	        window['setSelectAllConfigCheckbox'] = this.setSelectAllConfigCheckbox;
	        if (options.dataSwitch === "currency") {
	            this._copyUrl = this._options.urlCopy;
	            this._tableId = "tableCurrencies";
	            this._tableOptions = {
	                url: this._options.urlList,
	                dom: tableDom,
	                rowId: 'Id',
	                autoWidth: true,
	                lengthMenu: [[10, 20, 100, -1], [10, 20, 100, "All"]],
	                ordering: true,
	                columns: [
	                    {
	                        data: 'Currency.Code',
	                        className: "bold",
	                        render: function (data, type, rowData) {
	                            return ("<a id='lnkCode" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + data + "</a>");
	                        }
	                    },
	                    {
	                        data: 'Currency.Name'
	                    },
	                    {
	                        data: 'PlayForFunAmount'
	                    },
	                    {
	                        data: "IsEnabled",
	                        sortable: false,
	                        render: function (data, type, rowData) {
	                            var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                            var css = data === true ? 'status-enabled' : 'status-disabled';
	                            return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                        }
	                    },
	                    {
	                        data: '',
	                        sortable: false,
	                        render: function (data, type, rowData) {
	                            return ("<a id='lnkDetail" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + options.localizer.DetailsLink + "</a>");
	                        }
	                    }
	                ],
	                order: [[CURRENCY_COLUMN_INDEX.Code, "asc"]],
	                callbacks: {
	                    preDrawCallback: this.preDrawCallback,
	                    createdRow: this.createdRowCurrency
	                }
	            };
	        }
	        if (options.dataSwitch === "operation") {
	            this._tableId = "tableOperations";
	            this._tableOptions = {
	                url: this._options.urlList,
	                dom: tableDom,
	                rowId: 'Id',
	                autoWidth: true,
	                ordering: false,
	                pageLength: 100,
	                lengthMenu: [[20, 100, 200, -1], [20, 100, 200, "All"]],
	                columns: [
	                    {
	                        data: 'Name',
	                        className: "bold",
	                        render: function (data, type, rowData) {
	                            return ("<a id='lnkName" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + data + "</a>");
	                        }
	                    },
	                    {
	                        data: "Code",
	                        render: function (data, type, rowData) {
	                            return ("<span id='spnCode" + rowData.Id + "'>" + data + "</span>");
	                        }
	                    },
	                    {
	                        data: "Status",
	                        render: function (data, type, rowData) {
	                            var css = "status-" + data.toLowerCase();
	                            return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + data + "</span>";
	                        }
	                    },
	                    {
	                        data: "Description",
	                        defaultContent: '',
	                        render: function (data, type, rowData) {
	                            return ("<span id='spnDescription" + rowData.Id + "'>" + Utils_1.Utils.valueOrDefault(data, '') + "</span>");
	                        }
	                    },
	                    {
	                        data: '',
	                        render: function (data, type, rowData) {
	                            return ("<a id='lnkGameConfigurations" + rowData.Id + "' href='" + getGameConfigurationUrl(rowData) + "'>" + options.localizer.GameConfigurations + "</a>");
	                        }
	                    }
	                ]
	            };
	        }
	        if (options.dataSwitch === "frbgameconfig") {
	            this._tableId = "tableFreeRoundGamesConfigurations";
	            this._tableOptions = {
	                url: this._options.urlList,
	                dom: configGamesDom,
	                rowId: 'Id',
	                autoWidth: true,
	                ordering: true,
	                pageLength: 100,
	                lengthMenu: [[10, 20, 50, 100, 1000], [10, 20, 50, 100, 1000]],
	                columns: [
	                    {
	                        data: 'Id',
	                        render: function (data, type, rowData) {
	                            return ("<input id='chckbx" + rowData.Id + "' name='selectedFrbConfig' value='" + rowData.Id + "' type='checkbox' onClick=\"setSelectAllConfigCheckbox()\" />");
	                        }
	                    },
	                    {
	                        data: "GameName",
	                        render: function (data, type, rowData) {
	                            return ("<span id='spnGameName" + rowData.Id + "'>" + data + "</span>");
	                        }
	                    },
	                    {
	                        data: "CurrencyCode",
	                        defaultContent: '',
	                        render: function (data, type, rowData) {
	                            return ("<span id='spnCurrencyCode" + rowData.Id + "'>" + Utils_1.Utils.valueOrDefault(data, '') + "</span>");
	                        }
	                    },
	                    {
	                        data: "Status",
	                        defaultContent: '',
	                        render: function (data, type, rowData) {
	                            var text = data ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                            var css = data ? 'status-enabled' : 'status-disabled';
	                            return "<span id='spnLockState" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                        }
	                    },
	                    {
	                        data: '',
	                        sortable: false,
	                        render: function (data, type, rowData) {
	                            return ("<a id='lnkDetail" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + options.localizer.DetailsLink + "</a>");
	                        }
	                    }
	                ],
	                order: [[GAME_COLUMNS_INDEX.Id, "asc"]],
	                callbacks: {
	                    preDrawCallback: this.preDrawFrbConfigCallback
	                }
	            };
	        }
	    }
	    DetailPage.prototype.init = function () {
	        DetailPage.msApi = new MultiSelect_1.MultiSelectApi('roles');
	        DetailPage.rolesInit = DetailPage.msApi.getSelectionValues();
	        this._form = Utils_1.Utils.getJQueryById("form" + this._tableId);
	        this._btnCancelSearch = Utils_1.Utils.getJQueryById(btnCancelSearchId);
	        this._btnCancelSearchFrbGamesConfigs = Utils_1.Utils.getJQueryById(btnCancelSearchFrbConfigsId);
	        this._filterCurrencyCode = Utils_1.Utils.getJQueryById('filterCode');
	        this._filterCurrencyName = Utils_1.Utils.getJQueryById('filterName');
	        this._filterGame = new MultiSelect_1.MultiSelectApi('filterGame');
	        this._filterCurrency = new MultiSelect_1.MultiSelectApi('filterCurrency');
	        this._chckAllConfigs = Utils_1.Utils.getJQueryById("frbConfigurationsSelectAll");
	        this._chckAllConfigs.on("change", this.checkBoxAll);
	        var btnEnableMulti = Utils_1.Utils.getJQueryById("btnEnableMulti");
	        var btnDisableMulti = Utils_1.Utils.getJQueryById("btnDisableMulti");
	        this._btnCopyCurrencies = Utils_1.Utils.getJQueryById("btnCopyCurrencies");
	        btnEnableMulti.on("click", this.enableFrbConfigurationMulti);
	        btnDisableMulti.on("click", this.disableFrbConfigurationMulti);
	        this._btnCopyCurrencies.on("click", this.copyCurrencies);
	        if (Utils_1.Utils.isNullOrUndefined(this._tableOptions))
	            return;
	        this._table = new Datatable_1.Datatable(this._tableId, this._tableOptions);
	        this._form.on('submit', this.formSubmit);
	        this._btnCancelSearch.on('click', this.cancelSearch);
	        this._btnCancelSearchFrbGamesConfigs.on('click', this.cancelFrbGamesConfigsSearch);
	    };
	    DetailPage.showForm = function (field, focusField) {
	        $(".multi-hide").hide();
	        $(".multi-show").show();
	        $(".multi-show").closest(".form-group").removeClass("gray");
	        var label = "#lbl" + field;
	        var frm = "#frm" + field;
	        $(label).hide();
	        $(frm).show();
	        $(label).closest(".form-group").addClass("gray");
	        if (focusField) {
	            $('#' + focusField).focus();
	        }
	    };
	    DetailPage.prototype.formSubmit = function (e) {
	        e.preventDefault();
	        this._table.draw();
	        return false;
	    };
	    DetailPage.prototype.cancelSearch = function (e) {
	        this._filterCurrencyCode.val('');
	        this._filterCurrencyName.val('');
	    };
	    DetailPage.prototype.cancelFrbGamesConfigsSearch = function (e) {
	        this._filterCurrency.selectAll();
	        this._filterGame.selectAll();
	    };
	    DetailPage.prototype.preDrawCallback = function (datatable) {
	        this._chckAllConfigs[0].checked = false;
	        var filterCurrencyCode = this._filterCurrencyCode.val();
	        datatable.columns(CURRENCY_COLUMN_INDEX.Code).search(filterCurrencyCode);
	        var filterCurrencyName = this._filterCurrencyName.val();
	        datatable.columns(CURRENCY_COLUMN_INDEX.Name).search(filterCurrencyName);
	        return true;
	    };
	    DetailPage.prototype.createdRowCurrency = function (row, data, dataIndex) {
	        if (data["IsEnabled"]) {
	            this._btnCopyCurrencies.removeAttr("disabled");
	        }
	    };
	    DetailPage.prototype.preDrawFrbConfigCallback = function (datatable) {
	        var filterGame = this._filterGame.isAllSelected() ? '' : this._filterGame.getSelectionValues(FILTER_DELIM);
	        datatable.columns(GAME_COLUMNS_INDEX.GameName).search(filterGame);
	        var filterCurrency = this._filterCurrency.isAllSelected() ? '' : this._filterCurrency.getSelectionValues(FILTER_DELIM);
	        datatable.columns(GAME_COLUMNS_INDEX.Currency).search(filterCurrency);
	        return true;
	    };
	    DetailPage.hideForm = function (field) {
	        var label = "#lbl" + field;
	        var frm = "#frm" + field;
	        $(label).show();
	        $(frm).hide();
	        DetailPage.msApi.setSelectionValues(DetailPage.rolesInit);
	        $(label).closest(".form-group").removeClass("gray");
	    };
	    DetailPage.prototype.enableFrbConfigurationMulti = function (e) {
	        this.changeFrbConfigurationStatusMulti(e, true);
	    };
	    DetailPage.prototype.disableFrbConfigurationMulti = function (e) {
	        this.changeFrbConfigurationStatusMulti(e, false);
	    };
	    DetailPage.prototype.changeFrbConfigurationStatusMulti = function (e, status) {
	        e.preventDefault();
	        var urlPost = this._options.urlChangeFrbConfigStatus;
	        var ids = $("input[name='selectedFrbConfig']:checked").map(function () {
	            return $(this).val();
	        });
	        $.ajax({
	            async: false,
	            url: urlPost,
	            type: "POST",
	            dataType: 'json',
	            data: { configIds: ids.get(), status: status },
	            success: function (data) {
	                window.location.href = data;
	            }
	        });
	    };
	    DetailPage.prototype.setSelectAllCheckbox = function (selectAllButton, checkboxesIdentifier) {
	        var checkboxes = $(checkboxesIdentifier);
	        var gamesSelectAll = Utils_1.Utils.getJQueryById(selectAllButton)[0];
	        if (Utils_1.Utils.isNullOrUndefined(gamesSelectAll))
	            return;
	        var allCheckboxesChecked = false;
	        for (var i = 0; i < checkboxes.length; i++) {
	            allCheckboxesChecked = checkboxes[i].checked;
	            if (!allCheckboxesChecked)
	                break;
	        }
	        gamesSelectAll.checked = allCheckboxesChecked;
	    };
	    DetailPage.prototype.checkBoxAll = function () {
	        var checkboxes = $("input[name='selectedFrbConfig']");
	        for (var i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = this._chckAllConfigs[0].checked;
	        }
	    };
	    DetailPage.prototype.setSelectAllConfigCheckbox = function () {
	        this.setSelectAllCheckbox("frbConfigurationsSelectAll", "input[name='selectedFrbConfig']");
	    };
	    DetailPage.prototype.copyCurrencies = function (e) {
	        e.preventDefault();
	        var urlPost = this._copyUrl;
	        $.ajax({
	            async: false,
	            url: urlPost,
	            type: "POST",
	            dataType: 'json',
	            success: function (data) {
	                var textToCopy = $('#currenciesClipboard');
	                textToCopy.attr("type", "text");
	                textToCopy.val(data);
	                textToCopy.select();
	                document.execCommand("copy");
	                textToCopy.attr("type", "hidden");
	            }
	        });
	    };
	    return DetailPage;
	}(PageBase_1.PageBase));
	exports.DetailPage = DetailPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var Utils_1 = __webpack_require__(5);
	var tableDom = "<'row'<'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var BONUS_COLUMNS_INDEX = {
	    Id: 0,
	    Name: 1,
	    Currencies: 2,
	    Status: 3
	};
	var OperationChannelsPage = (function (_super) {
	    __extends(OperationChannelsPage, _super);
	    function OperationChannelsPage(options) {
	        _super.call(this, options);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        this.addChannelsMulti = this.addChannelsMulti.bind(this);
	        this._tableId = "tableChannels";
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            ordering: false,
	            columns: [
	                {
	                    data: '',
	                    render: function (data, type, rowData) {
	                        if (rowData.Id === 0) {
	                            return "<input id='chckbx" + rowData.Channel.Code + "' name='selectedChannel' value='" + rowData.Channel.Id + "' type='checkbox'\" />";
	                        }
	                        else {
	                            return "";
	                        }
	                    }
	                },
	                {
	                    data: 'Channel.Name',
	                    className: "bold",
	                    render: function (data, type, rowData) {
	                        if (rowData.Id === 0) {
	                            return data;
	                        }
	                        else {
	                            return "<a id='lnkName" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + data + "</a>";
	                        }
	                    }
	                },
	                {
	                    data: "Channel.Code",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCode" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "IsEnabled",
	                    render: function (data, type, rowData) {
	                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                        var css = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                    }
	                },
	                {
	                    data: '',
	                    render: function (data, type, rowData) {
	                        var assigned = rowData.Id !== 0 ? 'True' : 'False';
	                        var css = rowData.Id !== 0 ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnAssigned" + rowData.Id + "' class='" + css + "'>" + assigned + "</span>";
	                    }
	                }
	            ]
	        };
	    }
	    OperationChannelsPage.prototype.init = function () {
	        var btnAddChannels = Utils_1.Utils.getJQueryById("lnkAddSelectd");
	        btnAddChannels.on("click", this.addChannelsMulti);
	        if (Utils_1.Utils.isNullOrUndefined(this._tableOptions))
	            return;
	        this._table = new Datatable_1.Datatable(this._tableId, this._tableOptions);
	    };
	    OperationChannelsPage.prototype.addChannelsMulti = function (e) {
	        e.preventDefault();
	        var urlPost = this._options.urlPost;
	        var table = this._table;
	        var ids = $("input[name='selectedChannel']:checked").map(function () {
	            return $(this).val();
	        });
	        $.ajax({
	            url: urlPost,
	            type: "POST",
	            dataType: 'html',
	            data: { channelIds: ids.get() },
	            success: function (data) {
	                table.draw();
	            }
	        });
	    };
	    return OperationChannelsPage;
	}(PageBase_1.PageBase));
	exports.OperationChannelsPage = OperationChannelsPage;
	var OperationBonusesPage = (function (_super) {
	    __extends(OperationBonusesPage, _super);
	    function OperationBonusesPage(options) {
	        _super.call(this, options);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        this.addChannelsMulti = this.addChannelsMulti.bind(this);
	        this._tableId = "tableBonuses";
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            lengthMenu: [[10, 20, 100], [10, 20, 100]],
	            columns: [
	                {
	                    data: 'Id'
	                },
	                {
	                    data: 'Name',
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkDetail" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: 'Currencies',
	                    sortable: false
	                },
	                {
	                    data: 'Status'
	                },
	                {
	                    data: 'RelationStatus'
	                }
	            ],
	            order: [[BONUS_COLUMNS_INDEX.Status, "asc"]],
	        };
	    }
	    OperationBonusesPage.prototype.init = function () {
	        var btnAddChannels = Utils_1.Utils.getJQueryById("lnkAddSelected");
	        btnAddChannels.on("click", this.addChannelsMulti);
	        if (Utils_1.Utils.isNullOrUndefined(this._tableOptions))
	            return;
	        this._table = new Datatable_1.Datatable(this._tableId, this._tableOptions);
	    };
	    OperationBonusesPage.prototype.addChannelsMulti = function (e) {
	        e.preventDefault();
	        var urlPost = this._options.urlPost;
	        var table = this._table;
	        var ids = $("input[name='selectedChannel']:checked").map(function () {
	            return $(this).val();
	        });
	        $.ajax({
	            url: urlPost,
	            type: "POST",
	            dataType: 'html',
	            data: { channelIds: ids.get() },
	            success: function (data) {
	                table.draw();
	            }
	        });
	    };
	    return OperationBonusesPage;
	}(PageBase_1.PageBase));
	exports.OperationBonusesPage = OperationBonusesPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var MultiSelect_1 = __webpack_require__(52);
	var Utils_1 = __webpack_require__(5);
	var tableDom = "<'row'<'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var ChannelDetailPage = (function (_super) {
	    __extends(ChannelDetailPage, _super);
	    function ChannelDetailPage(options) {
	        _super.call(this, options);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        this._tableId = "tableGames";
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            columns: [
	                {
	                    data: 'ConfigurationName',
	                    className: "bold",
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkName" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: "GameName",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCode" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "GameCode",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCode" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "CurrencyCode",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCode" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "ConfigurationStatus",
	                    render: function (data, type, rowData) {
	                        var css = "status-" + data.toLowerCase();
	                        return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + data + "</span>";
	                    }
	                },
	                {
	                    data: '',
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkDetail" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + options.localizer.DetailsLink + "</a>");
	                    }
	                }
	            ]
	        };
	    }
	    ChannelDetailPage.prototype.init = function () {
	        ChannelDetailPage.msApi = new MultiSelect_1.MultiSelectApi('roles');
	        ChannelDetailPage.rolesInit = ChannelDetailPage.msApi.getSelectionValues();
	        if (Utils_1.Utils.isNullOrUndefined(this._tableOptions))
	            return;
	        this._table = new Datatable_1.Datatable(this._tableId, this._tableOptions);
	    };
	    ChannelDetailPage.showForm = function (field, focusField) {
	        $(".multi-hide").hide();
	        $(".multi-show").show();
	        $(".multi-show").closest(".form-group").removeClass("gray");
	        var label = "#lbl" + field;
	        var frm = "#frm" + field;
	        $(label).hide();
	        $(frm).show();
	        $(label).closest(".form-group").addClass("gray");
	        if (focusField) {
	            $('#' + focusField).focus();
	        }
	    };
	    ChannelDetailPage.hideForm = function (field) {
	        var label = "#lbl" + field;
	        var frm = "#frm" + field;
	        $(label).show();
	        $(frm).hide();
	        ChannelDetailPage.msApi.setSelectionValues(ChannelDetailPage.rolesInit);
	        $(label).closest(".form-group").removeClass("gray");
	    };
	    return ChannelDetailPage;
	}(PageBase_1.PageBase));
	exports.ChannelDetailPage = ChannelDetailPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var MultiSelect_1 = __webpack_require__(52);
	var Utils_1 = __webpack_require__(5);
	var DateUtils_1 = __webpack_require__(48);
	var tableDom = "<'row'<'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var GameConfigurationDetailPage = (function (_super) {
	    __extends(GameConfigurationDetailPage, _super);
	    function GameConfigurationDetailPage(options) {
	        _super.call(this, options);
	        this.showSetValidity = this.showSetValidity.bind(this);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        var getVersionDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id + "?version=" + rowData.Version); };
	        var getBuildVersionDetailUrl = function (rowData) { return (options.urlBuildDetail + "/" + options.gameId + "/" + rowData.ModuleVersion); };
	        if (options.dataSwitch === "channel") {
	            this._tableId = "tableChannels";
	            this._tableOptions = {
	                url: this._options.urlList,
	                dom: tableDom,
	                rowId: 'Id',
	                autoWidth: true,
	                ordering: false,
	                columns: [
	                    {
	                        data: 'Channel.Name',
	                        className: "bold",
	                        render: function (data, type, rowData) {
	                            return ("<a id='lnkName" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + data + "</a>");
	                        }
	                    },
	                    {
	                        data: "Channel.Code",
	                        render: function (data, type, rowData) {
	                            return ("<span id='spnCode" + rowData.Id + "'>" + data + "</span>");
	                        }
	                    },
	                    {
	                        data: "IsEnabled",
	                        render: function (data, type, rowData) {
	                            var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                            var css = data === true ? 'status-enabled' : 'status-disabled';
	                            return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                        }
	                    },
	                    {
	                        data: '',
	                        sortable: false,
	                        render: function (data, type, rowData) {
	                            return ("<a id='lnkDetail" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + options.localizer.DetailsLink + "</a>");
	                        }
	                    }
	                ]
	            };
	        }
	        if (options.dataSwitch === "configuration") {
	            this._tableId = "tableVersions";
	            this._tableOptions = {
	                url: this._options.urlList,
	                dom: tableDom,
	                rowId: 'Id',
	                autoWidth: true,
	                columns: [
	                    {
	                        data: 'Version',
	                        className: "bold",
	                        render: function (data, type, rowData) {
	                            return ("<a id='lnkName" + rowData.Version + "' href='" + getVersionDetailUrl(rowData) + "'>" + data + "</a>");
	                        }
	                    },
	                    {
	                        data: 'ModuleVersion',
	                        render: function (data, type, rowData) {
	                            return ("<a id='lnkGameBuildVersion" + rowData.Version + "' href='" + getBuildVersionDetailUrl(rowData) + "'>" + data + "</a>");
	                        }
	                    },
	                    {
	                        data: 'CreateDate',
	                        render: function (data, type, rowData) {
	                            return ("<span id='spnCreateDate" + rowData.Id + "'>" + DateUtils_1.DateUtils.toDefaultWithTime(data) + "</span>");
	                        }
	                    },
	                    {
	                        data: 'GameVariant',
	                        render: function (data, type, rowData) {
	                            return ("<span id='spnGameVariant" + rowData.Id + "'>" + data + "</span>");
	                        }
	                    },
	                    {
	                        data: 'Rtp',
	                        render: function (data, type, rowData) {
	                            return ("<span id='spnRtp" + rowData.Id + "'>" + data + "</span>");
	                        }
	                    },
	                    {
	                        data: '',
	                        sortable: false,
	                        render: function (data, type, rowData) {
	                            return ("<a id='lnkDetail" + rowData.Version + "' href='" + getVersionDetailUrl(rowData) + "'>" + options.localizer.DetailsLink + "</a>");
	                        }
	                    }
	                ],
	                order: [[0, "desc"]]
	            };
	        }
	    }
	    GameConfigurationDetailPage.prototype.init = function () {
	        GameConfigurationDetailPage.msApi = new MultiSelect_1.MultiSelectApi('roles');
	        GameConfigurationDetailPage.rolesInit = GameConfigurationDetailPage.msApi.getSelectionValues();
	        var btnValidity = Utils_1.Utils.getJQueryById("btnValidity");
	        btnValidity.on("click", this.showSetValidity);
	        if (Utils_1.Utils.isNullOrUndefined(this._tableOptions))
	            return;
	        this._table = new Datatable_1.Datatable(this._tableId, this._tableOptions);
	    };
	    GameConfigurationDetailPage.showForm = function (field, focusField) {
	        $(".multi-hide").hide();
	        $(".multi-show").show();
	        $(".multi-show").closest(".form-group").removeClass("gray");
	        var label = "#lbl" + field;
	        var frm = "#frm" + field;
	        $(label).hide();
	        $(frm).show();
	        $(label).closest(".form-group").addClass("gray");
	        if (focusField) {
	            $('#' + focusField).focus();
	        }
	    };
	    GameConfigurationDetailPage.hideForm = function (field) {
	        var label = "#lbl" + field;
	        var frm = "#frm" + field;
	        $(label).show();
	        $(frm).hide();
	        GameConfigurationDetailPage.msApi.setSelectionValues(GameConfigurationDetailPage.rolesInit);
	        $(label).closest(".form-group").removeClass("gray");
	    };
	    GameConfigurationDetailPage.prototype.showSetValidity = function () {
	        $('#validitySettings').removeAttr("hidden");
	    };
	    return GameConfigurationDetailPage;
	}(PageBase_1.PageBase));
	exports.GameConfigurationDetailPage = GameConfigurationDetailPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Utils_1 = __webpack_require__(5);
	var AddCurrencyPage = (function (_super) {
	    __extends(AddCurrencyPage, _super);
	    function AddCurrencyPage(options) {
	        _super.call(this, options);
	        this.onCurrencyChange = this.onCurrencyChange.bind(this);
	    }
	    AddCurrencyPage.prototype.init = function () {
	        this.ddCurrency = $('#currency');
	        this.ddCurrency.on('change', this.onCurrencyChange);
	        this.txtCurrencyName = $('#txtCurrencyName');
	        this.txtDefaultDisplaySign = $('#txtDefaultDisplaySign');
	        this.txtDefaultDecimalPlaces = $('#txtDefaultDecimalPlaces');
	        this.inputPlayForFunAmount = $('#PlayForFunAmount');
	        this.onCurrencyChange();
	    };
	    AddCurrencyPage.prototype.onCurrencyChange = function () {
	        var selectedItem = this.ddCurrency.find(':selected');
	        var currencyId = parseInt(selectedItem.val());
	        if (!isNaN(currencyId)) {
	            var currency = this._options.currenciesMap[currencyId];
	            if (currency) {
	                this.txtCurrencyName.text(currency.Name);
	                if (Utils_1.Utils.isNullOrUndefined(currency.DisplaySign)) {
	                    this.txtDefaultDisplaySign.text("");
	                }
	                else {
	                    this.txtDefaultDisplaySign.text(currency.DisplaySign);
	                }
	                if (Utils_1.Utils.isNullOrUndefined(currency.DecimalPlaces)) {
	                    this.txtDefaultDecimalPlaces.text("");
	                }
	                else {
	                    this.txtDefaultDecimalPlaces.text(currency.DecimalPlaces);
	                }
	                if (Utils_1.Utils.isNullOrUndefined(currency.PlayForFunDefaultValue)) {
	                    this.inputPlayForFunAmount.val("");
	                }
	                else {
	                    this.inputPlayForFunAmount.val(currency.PlayForFunDefaultValue);
	                }
	            }
	        }
	    };
	    return AddCurrencyPage;
	}(PageBase_1.PageBase));
	exports.AddCurrencyPage = AddCurrencyPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var AddChannelPage = (function (_super) {
	    __extends(AddChannelPage, _super);
	    function AddChannelPage(options) {
	        _super.call(this, options);
	        this.onChannelChange = this.onChannelChange.bind(this);
	    }
	    AddChannelPage.prototype.init = function () {
	        this.ddChannel = $('#channel');
	        this.ddChannel.on('change', this.onChannelChange);
	        this.txtChannelUrl = document.getElementById('textChannelUrl');
	        this.selectChannelUrl = document.getElementById('selectChannelUrl');
	        this.onChannelChange();
	    };
	    AddChannelPage.prototype.onChannelChange = function () {
	        var selectedItem = this.ddChannel.find(':selected');
	        var channelId = parseInt(selectedItem.val());
	        if (Number(channelId) <= 0) {
	            return;
	        }
	        this.selectChannelUrl.options.length = 0;
	        this.txtChannelUrl.value = '';
	        var channelDefault = this._options.channelsMap[channelId];
	        if (channelDefault) {
	            var o = (document.createElement('option'));
	            o.value = channelDefault.Url;
	            o.text = channelDefault.Url;
	            this.selectChannelUrl.options.add(o);
	            this.txtChannelUrl.value = channelDefault.Url;
	        }
	        for (var key in this._options.customerChannelsMap) {
	            var channelCustomer = this._options.customerChannelsMap[key];
	            if (!channelCustomer || channelCustomer.ChannelId !== channelId) {
	                continue;
	            }
	            var o = (document.createElement('option'));
	            o.text = channelCustomer.Url;
	            o.value = channelCustomer.Url;
	            this.selectChannelUrl.options.add(o);
	        }
	    };
	    return AddChannelPage;
	}(PageBase_1.PageBase));
	exports.AddChannelPage = AddChannelPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var CurrencyDetailPage = (function (_super) {
	    __extends(CurrencyDetailPage, _super);
	    function CurrencyDetailPage() {
	        _super.apply(this, arguments);
	    }
	    CurrencyDetailPage.prototype.init = function () {
	    };
	    CurrencyDetailPage.showForm = function (field, focusField) {
	        $(".multi-hide").hide();
	        $(".multi-show").show();
	        $(".multi-show").closest(".form-group").removeClass("gray");
	        var label = "#lbl" + field;
	        var frm = "#frm" + field;
	        $(label).hide();
	        $(frm).show();
	        $(label).closest(".form-group").addClass("gray");
	        if (focusField) {
	            $('#' + focusField).focus();
	        }
	    };
	    CurrencyDetailPage.hideForm = function (field) {
	        var label = "#lbl" + field;
	        var frm = "#frm" + field;
	        $(label).show();
	        $(frm).hide();
	        $(label).closest(".form-group").removeClass("gray");
	    };
	    return CurrencyDetailPage;
	}(PageBase_1.PageBase));
	exports.CurrencyDetailPage = CurrencyDetailPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var StatusMessage_1 = __webpack_require__(61);
	var Utils_1 = __webpack_require__(5);
	var StatusMessageHelper_1 = __webpack_require__(50);
	var AddBonusPage = (function (_super) {
	    __extends(AddBonusPage, _super);
	    function AddBonusPage(options) {
	        var _this = this;
	        _super.call(this, options);
	        this.setConfiguration = this.setConfiguration.bind(this);
	        this.submitButton = document.getElementById("btnSubmit");
	        if (this.submitButton != null) {
	            this.submitButton.onclick = function () { return _this.calculateContribution(); };
	        }
	        this.closeDialogButton = document.getElementById("btnHideConfirmation");
	        this.closeDialogButton.onclick = function () { return _this.closeDialog(); };
	        this.configurationForm = document.getElementById("frmBonusConfiguration");
	    }
	    AddBonusPage.prototype.init = function () {
	        var _this = this;
	        this.fileInput = document.getElementById("fileInput");
	        this.fileInput.onchange = function () { return _this.setImportFileButtonDisabledProp(); };
	        this.importButton = document.getElementById("btnImportFile");
	        this.importButton.onclick = function () { return _this.setConfiguration(); };
	        this.setImportFileButtonDisabledProp();
	    };
	    AddBonusPage.prototype.setConfiguration = function () {
	        var importButton = this.importButton;
	        importButton.disabled = true;
	        var bonusInput = Utils_1.Utils.getJQueryById("bonusName");
	        var data = new FormData();
	        data.append('file', this.fileInput.files[0]);
	        data.append('name', bonusInput.val());
	        $.ajax({
	            url: this._options.processUrl,
	            type: "POST",
	            processData: false,
	            contentType: false,
	            data: data,
	            success: function (data) {
	                window.editor.set(data.configuration);
	                Utils_1.Utils.getJQueryById("BonusConfigurationJson").val(window.editor.getText());
	            },
	            complete: function (data) {
	                var statusMessageWrapper = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	                var statusMessageData = JSON.parse(data.responseJSON.statusMessages);
	                var statusMessage = new StatusMessage_1.StatusMessage(statusMessageData);
	                statusMessageWrapper.html(statusMessage.getHTMLmessage());
	                StatusMessageHelper_1.StatusMessageHelper.initValidator();
	                StatusMessageHelper_1.StatusMessageHelper.initSatusMessage();
	            },
	            error: function (jqXHR, textStatus, errorThrown) {
	                importButton.disabled = false;
	                if (jqXHR.status === 404) {
	                    window.location.replace(window.location.href);
	                }
	            }
	        });
	    };
	    AddBonusPage.prototype.openDialog = function () {
	        document.getElementById("configurationConfirmation").hidden = false;
	    };
	    AddBonusPage.prototype.closeDialog = function () {
	        document.getElementById("configurationConfirmation").hidden = true;
	    };
	    AddBonusPage.prototype.calculateContribution = function () {
	        var jsonString = Utils_1.Utils.getJQueryById("#BonusConfigurationJson").val();
	        var json = JSON.parse(jsonString);
	        var totalContribution = 0;
	        totalContribution += json['bonusData']['baseBufferContribution'];
	        var levels = json['levelsData']['levelConfigurations'];
	        for (var i = 0; i < levels.length; i++) {
	            totalContribution += levels[i]['hiddenContribution'];
	            totalContribution += levels[i]['visibleContribution'];
	        }
	        Utils_1.Utils.getJQueryById("#spnContributionValue").text(totalContribution.toFixed(4).replace(/\.?0+$/, ""));
	        if (totalContribution > 10) {
	            document.getElementById("spnContributionTooHigh").style.display = null;
	            document.getElementById("spnContributionWarning").style.display = "none";
	            document.getElementById("btnConfirm").style.display = "none";
	            this.openDialog();
	        }
	        else if (totalContribution >= 2) {
	            document.getElementById("spnContributionTooHigh").style.display = "none";
	            document.getElementById("spnContributionWarning").style.display = null;
	            document.getElementById("btnConfirm").style.display = null;
	            this.openDialog();
	        }
	        else {
	            this.configurationForm.submit();
	        }
	    };
	    AddBonusPage.prototype.setImportFileButtonDisabledProp = function () {
	        this.importButton.disabled = this.fileInput.files.length == 0;
	    };
	    return AddBonusPage;
	}(PageBase_1.PageBase));
	exports.AddBonusPage = AddBonusPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Utils_1 = __webpack_require__(5);
	var CreatePage = (function (_super) {
	    __extends(CreatePage, _super);
	    function CreatePage(options) {
	        _super.call(this, options);
	        this.onCheckBoxChange = this.onCheckBoxChange.bind(this);
	    }
	    CreatePage.prototype.init = function () {
	        this._slctChannels = Utils_1.Utils.getJQueryById('channels');
	        this._slctChannels.multiselect('disable');
	        this._chckAssignOperation = Utils_1.Utils.getJQueryById('IncludeOperation');
	        this._chckAssignOperation.on('change', this.onCheckBoxChange);
	    };
	    CreatePage.prototype.onCheckBoxChange = function () {
	        if (this._chckAssignOperation.is(':checked')) {
	            this._slctChannels.multiselect('enable');
	        }
	        else {
	            this._slctChannels.multiselect('clearSelection');
	            this._slctChannels.multiselect('disable');
	        }
	    };
	    return CreatePage;
	}(PageBase_1.PageBase));
	exports.CreatePage = CreatePage;


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var Utils_1 = __webpack_require__(5);
	var DateUtils_1 = __webpack_require__(48);
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var COLUMNS_INDEX = {
	    BonusId: 0,
	    BonusName: 1
	};
	var AvailableProgressiveBonusPage = (function (_super) {
	    __extends(AvailableProgressiveBonusPage, _super);
	    function AvailableProgressiveBonusPage(options) {
	        _super.call(this, options);
	        this.formSubmit = this.formSubmit.bind(this);
	        this.cancelSearch = this.cancelSearch.bind(this);
	        this.preDrawCallback = this.preDrawCallback.bind(this);
	        var getBonusDetailUrl = function (rowData) { return (options.urlProgressiveBonusDetail + "/" + rowData.BonusId); };
	        var getAssignBonusUrl = function (rowData) { return (options.urlAssignBonus + "&bonusId=" + rowData.BonusId); };
	        this._tableId = "tableAvailableBonuses";
	        this._formId = "formAvailableBonuses";
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'BonusId',
	            autoWidth: true,
	            columns: [
	                {
	                    data: 'BonusId'
	                },
	                {
	                    data: "BonusName",
	                    render: function (data, type, rowData) {
	                        return ("<a href='" + getBonusDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: "Created",
	                    render: function (data, type, rowData) {
	                        return (DateUtils_1.DateUtils.toDefaultWithTime(data));
	                    }
	                },
	                {
	                    data: "BonusStatus",
	                },
	                {
	                    data: "Currencies",
	                },
	                {
	                    sortable: false,
	                    orderable: false,
	                    render: function (data, type, rowData) {
	                        return ("<a class=\"assignBonusLink\" data-id=\"" + rowData.BonusId + "\" data-name=\"" + rowData.BonusName + "\" href=" + getAssignBonusUrl(rowData) + ">Assign</a>");
	                    }
	                },
	            ],
	            callbacks: {
	                preDrawCallback: this.preDrawCallback
	            }
	        };
	    }
	    AvailableProgressiveBonusPage.prototype.assignBonus = function (e) {
	        e.preventDefault();
	        this.openDialog();
	    };
	    AvailableProgressiveBonusPage.prototype.openDialog = function () {
	        document.getElementById("areYouSureConfirmation").hidden = false;
	    };
	    AvailableProgressiveBonusPage.prototype.closeDialog = function () {
	        document.getElementById("areYouSureConfirmation").hidden = true;
	    };
	    AvailableProgressiveBonusPage.prototype.init = function () {
	        var _this = this;
	        this._form = Utils_1.Utils.getJQueryById(this._formId);
	        this._form.on('submit', this.formSubmit);
	        var btnCancelSearch = Utils_1.Utils.getJQueryById("btnCancelSearch");
	        btnCancelSearch.on('click', this.cancelSearch);
	        this._filterBonusId = Utils_1.Utils.getJQueryById('filterBonusId');
	        this._filterBonusName = Utils_1.Utils.getJQueryById('filterBonusName');
	        this._table = new Datatable_1.Datatable(this._tableId, this._tableOptions);
	        var that = this;
	        var confirmButton = document.getElementById("btnConfirm");
	        var closeButton = document.getElementById("btnHideConfirmation");
	        var assignBonusLink;
	        $(document).on('click', '.assignBonusLink', function (e) {
	            var bonusNameAndId = e.target.attributes['data-name'].value + ' (' + e.target.attributes['data-id'].value + ')';
	            $("#bonus-name-confirmation").text(bonusNameAndId);
	            assignBonusLink = e.target.attributes['href'].value;
	            that.assignBonus(e);
	        });
	        confirmButton.onclick = function () {
	            window.location.href = assignBonusLink;
	        };
	        closeButton.onclick = function () { return _this.closeDialog(); };
	    };
	    AvailableProgressiveBonusPage.prototype.cancelSearch = function (e) {
	        this._filterBonusId.val('');
	        this._filterBonusName.val('');
	    };
	    AvailableProgressiveBonusPage.prototype.formSubmit = function (e) {
	        e.preventDefault();
	        this._table.draw();
	        return false;
	    };
	    AvailableProgressiveBonusPage.prototype.preDrawCallback = function (datatable) {
	        var filterBonusId = this._filterBonusId.val();
	        datatable.columns(COLUMNS_INDEX.BonusId).search(filterBonusId);
	        var filterBonusName = this._filterBonusName.val();
	        datatable.columns(COLUMNS_INDEX.BonusName).search(filterBonusName);
	    };
	    return AvailableProgressiveBonusPage;
	}(PageBase_1.PageBase));
	exports.AvailableProgressiveBonusPage = AvailableProgressiveBonusPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var IndexPage_1 = __webpack_require__(90);
	exports.IndexPage = IndexPage_1.IndexPage;
	var DetailPage_1 = __webpack_require__(91);
	exports.DetailPage = DetailPage_1.DetailPage;
	exports.AssignedOffers = DetailPage_1.AssignedOffers;
	exports.AssignedGames = DetailPage_1.AssignedGames;
	exports.OffersOverview = DetailPage_1.OffersOverview;
	exports.CampaignStatistics = DetailPage_1.CampaignStatistics;
	var GamesSelectionPage_1 = __webpack_require__(92);
	exports.GamesSelectionPage = GamesSelectionPage_1.GamesSelectionPage;
	exports.AssignedGamesSelectionPage = GamesSelectionPage_1.AssignedGamesSelectionPage;
	exports.UnassignedGamesSelectionPage = GamesSelectionPage_1.UnassignedGamesSelectionPage;
	var DefaultCampaignPage_1 = __webpack_require__(93);
	exports.DefaultCampaignPage = DefaultCampaignPage_1.DefaultCampaignPage;
	var OfferDetailPage_1 = __webpack_require__(94);
	exports.OfferDetailPage = OfferDetailPage_1.OfferDetailPage;
	var OfferDashboard_1 = __webpack_require__(95);
	exports.OfferDashboard = OfferDashboard_1.OfferDashboard;


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Utils_1 = __webpack_require__(5);
	var MultiSelect_1 = __webpack_require__(52);
	var StatusMessageHelper_1 = __webpack_require__(50);
	var StatusMessage_1 = __webpack_require__(61);
	var FILTER_DELIM = '-delim-';
	var batchSize = 100;
	var FreeRoundBrowseRequest = (function () {
	    function FreeRoundBrowseRequest() {
	    }
	    return FreeRoundBrowseRequest;
	}());
	var IndexPage = (function (_super) {
	    __extends(IndexPage, _super);
	    function IndexPage(options) {
	        _super.call(this, options);
	        this.run = this.run.bind(this);
	        this.loadMore = this.loadMore.bind(this);
	        this.resetFilter = this.resetFilter.bind(this);
	        this.getCountResult = this.getCountResult.bind(this);
	        this.showLoadMoreButton = this.showLoadMoreButton.bind(this);
	        this.hideLoadMoreButton = this.hideLoadMoreButton.bind(this);
	        this.enableRunButton = this.enableRunButton.bind(this);
	        this.checkBoxAll = this.checkBoxAll.bind(this);
	        this._options = options;
	    }
	    IndexPage.prototype.init = function () {
	        this._filterPlayerName = Utils_1.Utils.getJQueryById('filterPlayerName');
	        this._filterRemoteId = Utils_1.Utils.getJQueryById('filterRemoteId');
	        this._filterStatus = new MultiSelect_1.MultiSelectApi('filterStatus');
	        this._filterSource = Utils_1.Utils.getJQueryById("filterSource");
	        this._runButton = Utils_1.Utils.getJQueryById("btnRunQuery");
	        this._runButton.on("click", this.run);
	        this._loadMoreButton = Utils_1.Utils.getJQueryById("btnLoadMore");
	        this._loadMoreButton.on("click", this.loadMore);
	        this._resetFilterButton = Utils_1.Utils.getJQueryById("btnResetFilter");
	        this._resetFilterButton.on("click", this.resetFilter);
	        this._btnCountResult = Utils_1.Utils.getJQueryById("btnCountResult");
	        this._btnCountResult.on("click", this.getCountResult);
	        this._totalEntries = Utils_1.Utils.getJQueryById("totalEntries");
	        this._checkAll = Utils_1.Utils.getJQueryById("selectAll");
	        this._checkAll.on("change", this.checkBoxAll);
	        this._processing = Utils_1.Utils.getJQueryById("processing");
	        this._statusMessage = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	    };
	    IndexPage.prototype.run = function () {
	        this.disableRunButton();
	        var totalEntries = this._totalEntries[0];
	        totalEntries.innerText = "##";
	        this._currentRequest = this.getBrowseRequest();
	        var table = this.getTableBody();
	        table.innerHTML = "";
	        this.sendRequest(this._currentRequest);
	    };
	    IndexPage.prototype.loadMore = function () {
	        this.sendRequest(this._currentRequest);
	    };
	    IndexPage.prototype.showLoadMoreButton = function () {
	        this._loadMoreButton.removeClass("display-none");
	    };
	    IndexPage.prototype.hideLoadMoreButton = function () {
	        this._loadMoreButton.addClass("display-none");
	    };
	    IndexPage.prototype.disableRunButton = function () {
	        this._runButton.attr("disabled", 1);
	    };
	    IndexPage.prototype.enableRunButton = function () {
	        this._runButton.removeAttr("disabled");
	    };
	    IndexPage.prototype.resetFilter = function () {
	        this._filterPlayerName.val('');
	        this._filterRemoteId.val('');
	        this._filterStatus.selectAll();
	        this._filterSource.val('Live');
	    };
	    IndexPage.prototype.getCountResult = function () {
	        var request = Utils_1.Utils.isNullOrUndefined(this._currentRequest) ? this.getBrowseRequest() : this._currentRequest;
	        var urlCount = this._options.urlCount;
	        var totalEntries = this._totalEntries[0];
	        var processing = this._processing;
	        var statusMessage = this._statusMessage;
	        var displayMessage = this.displayMessage;
	        processing.show();
	        $.ajax({
	            url: urlCount,
	            type: "POST",
	            dataType: 'html',
	            data: { request: request },
	            success: function (data) {
	                totalEntries.innerText = data;
	                processing.hide();
	                statusMessage.hide();
	            },
	            error: function (jqXHR, textStatus, errorThrown) {
	                processing.hide();
	                displayMessage(jqXHR);
	            }
	        });
	    };
	    IndexPage.prototype.sendRequest = function (request) {
	        var urlGetList = this._options.urlGetList;
	        var table = this.getTableBody();
	        var showLoadMore = this.showLoadMoreButton;
	        var hideLoadMore = this.hideLoadMoreButton;
	        var enableRunButton = this.enableRunButton;
	        var processing = this._processing;
	        var statusMessage = this._statusMessage;
	        var displayMessage = this.displayMessage;
	        var totalEntries = this._totalEntries[0];
	        var getDetailUrl = this._options.urlDetail;
	        processing.show();
	        $.ajax({
	            url: urlGetList,
	            type: "POST",
	            dataType: 'html',
	            data: { request: request },
	            success: function (data) {
	                var parsedData = JSON.parse(data);
	                var items = parsedData.Items;
	                var totalCount = parsedData.FilteredCount;
	                if (items.length < batchSize + 1) {
	                    hideLoadMore();
	                }
	                else {
	                    request.LastOfferId = items[batchSize].Id;
	                    showLoadMore();
	                }
	                var enabled = ['Completed', 'Canceled'];
	                $.each(items, function (index, item) {
	                    if (index < batchSize) {
	                        var row = table.insertRow(-1);
	                        var cell0 = row.insertCell(0);
	                        cell0.innerHTML = "<b><a href='" + getDetailUrl + "/" + item.Id + "' id=" + item.Name + "\"></b>" + item.Name + "</a>";
	                        var cell1 = row.insertCell(1);
	                        cell1.innerHTML = "" + item.RemoteId;
	                        var cell2 = row.insertCell(2);
	                        cell2.innerHTML = "" + item.ValidFrom;
	                        var cell3 = row.insertCell(3);
	                        cell3.innerHTML = "" + item.ValidTo;
	                        var cell4 = row.insertCell(4);
	                        cell4.innerHTML = "" + item.RoundsAssigned;
	                        var cell5 = row.insertCell(5);
	                        var css = enabled.indexOf(item.Status) > -1 ? "status-enabled" : "status-disabled";
	                        cell5.innerHTML = "<span class=\"" + css + "\">" + item.Status + "</span>";
	                    }
	                });
	                totalEntries.innerText = totalCount;
	                processing.hide();
	                enableRunButton();
	                statusMessage.hide();
	            },
	            error: function (jqXHR, textStatus, errorThrown) {
	                processing.hide();
	                enableRunButton();
	                displayMessage(jqXHR);
	            }
	        });
	    };
	    IndexPage.prototype.displayMessage = function (jqXHR) {
	        var statusMessageWrapper = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	        var statusMessageData = {
	            code: "500",
	            autoClose: false,
	            class: "danger",
	            message: "Unexpected error",
	            type: StatusMessage_1.StatusMessageType.Error
	        };
	        var statusMessage = new StatusMessage_1.StatusMessage(statusMessageData);
	        statusMessageWrapper.html(statusMessage.getHTMLmessage());
	        StatusMessageHelper_1.StatusMessageHelper.initValidator();
	        StatusMessageHelper_1.StatusMessageHelper.initSatusMessage();
	        statusMessageWrapper.show();
	    };
	    IndexPage.prototype.getTableBody = function () {
	        return document.getElementById("tableFreeRoundCampaign").getElementsByTagName("tbody")[0];
	    };
	    IndexPage.prototype.checkBoxAll = function () {
	        var checkboxes = $("input[name='selectedOffer']");
	        for (var i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = this._checkAll[0].checked;
	        }
	    };
	    IndexPage.prototype.getBrowseRequest = function () {
	        var request = new FreeRoundBrowseRequest();
	        request.PlayerName = this._filterPlayerName.val();
	        request.RemoteId = this._filterRemoteId.val();
	        request.Status = this._filterStatus.isAllSelected() ? '' : this._filterStatus.getSelectionValues(FILTER_DELIM);
	        request.Source = this._filterSource.val();
	        request.BatchSize = batchSize + 1;
	        return request;
	    };
	    return IndexPage;
	}(PageBase_1.PageBase));
	exports.IndexPage = IndexPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var MultiSelect_1 = __webpack_require__(52);
	var Utils_1 = __webpack_require__(5);
	var StatusMessageHelper_1 = __webpack_require__(50);
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var tableDomAssignedGames = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var OFFERS_COLUMN_INDEX = {
	    Checkbox: 0,
	    Id: 1,
	    Name: 2,
	    PlayerRemoteId: 3,
	    RemoteId: 4,
	    Currency: 5,
	    Status: 10,
	    Result: 11,
	    Source: 12
	};
	var FILTER_DELIM = '-delim-';
	var btnCancelSearchId = 'btnCancelSearch';
	var DetailPage = (function (_super) {
	    __extends(DetailPage, _super);
	    function DetailPage(options) {
	        _super.call(this, options);
	        this.formSubmit = this.formSubmit.bind(this);
	    }
	    DetailPage.prototype.init = function () {
	        this._form = Utils_1.Utils.getJQueryById("form" + this._tableId);
	        if (Utils_1.Utils.isNullOrUndefined(this._tableOptions))
	            return;
	        this._table = new Datatable_1.Datatable(this._tableId, this._tableOptions);
	        this._form.on('submit', this.formSubmit);
	    };
	    DetailPage.showForm = function (field, focusField) {
	        $(".multi-hide").hide();
	        $(".multi-show").show();
	        $(".multi-show").closest(".form-group").removeClass("gray");
	        var label = "#lbl" + field;
	        var frm = "#frm" + field;
	        $(label).hide();
	        $(frm).show();
	        $(label).closest(".form-group").addClass("gray");
	        if (focusField) {
	            $('#' + focusField).focus();
	        }
	    };
	    DetailPage.prototype.formSubmit = function (e) {
	        e.preventDefault();
	        this._table.draw();
	        return false;
	    };
	    DetailPage.hideForm = function (field) {
	        var label = "#lbl" + field;
	        var frm = "#frm" + field;
	        $(label).show();
	        $(frm).hide();
	        $(label).closest(".form-group").removeClass("gray");
	    };
	    DetailPage.prototype.showHideSelectAllCheckbox = function (selectAllButton, checkboxesIdentifier) {
	        var selectAllCheckbox = Utils_1.Utils.getJQueryById(selectAllButton)[0];
	        if (Utils_1.Utils.isNullOrUndefined(selectAllCheckbox))
	            return;
	        var checkboxes = $(checkboxesIdentifier);
	        if (checkboxes.length === 0) {
	            selectAllCheckbox.hidden = true;
	        }
	        else {
	            selectAllCheckbox.hidden = false;
	        }
	    };
	    DetailPage.prototype.setSelectAllCheckbox = function (selectAllButton, checkboxesIdentifier) {
	        var gamesSelectAll = Utils_1.Utils.getJQueryById(selectAllButton)[0];
	        if (Utils_1.Utils.isNullOrUndefined(gamesSelectAll))
	            return;
	        var allCheckboxesChecked = false;
	        var checkboxes = $(checkboxesIdentifier);
	        for (var i = 0; i < checkboxes.length; i++) {
	            allCheckboxesChecked = checkboxes[i].checked;
	            if (!allCheckboxesChecked)
	                break;
	        }
	        gamesSelectAll.checked = allCheckboxesChecked;
	    };
	    return DetailPage;
	}(PageBase_1.PageBase));
	exports.DetailPage = DetailPage;
	var AssignedOffers = (function (_super) {
	    __extends(AssignedOffers, _super);
	    function AssignedOffers(options) {
	        _super.call(this, options);
	        this.cancelSelectedOffers = this.cancelSelectedOffers.bind(this);
	        this.cancelSearch = this.cancelSearch.bind(this);
	        this.preDrawCallback = this.preDrawCallback.bind(this);
	        this.checkBoxAll = this.checkBoxAll.bind(this);
	        this.drawCallback = this.drawCallback.bind(this);
	        this.setSelectAllOfferCheckbox = this.setSelectAllOfferCheckbox.bind(this);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        window['setSelectAllOfferCheckbox'] = this.setSelectAllOfferCheckbox;
	        this._tableId = "tableCampaignAssignedOffers";
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'id',
	            autoWidth: true,
	            ordering: true,
	            lengthMenu: [[10, 20, 100, -1], [10, 20, 100, "All"]],
	            columns: [
	                {
	                    sortable: false,
	                    data: 'Id',
	                    render: function (data, type, rowData) {
	                        return ("<input id='chckbx" + rowData.Id + "' name='selectedOffer' value='" + rowData.Id + "' type='checkbox' onClick=\"setSelectAllOfferCheckbox()\" />");
	                    }
	                },
	                {
	                    data: 'Id',
	                    className: "bold",
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkOfferId" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: "PlayerName",
	                    render: function (data, type, rowData) {
	                        return data != undefined ? ("<span id='spnOfferPlayerName" + rowData.Id + "'>" + data + "</span>") : "";
	                    }
	                },
	                {
	                    data: "PlayerRemoteId",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnOfferPlayerId" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "RemoteId",
	                    render: function (data, type, rowData) {
	                        return data != undefined ? ("<span id='spnOfferRemoteId" + rowData.Id + "'>" + data + "</span>") : "";
	                    }
	                },
	                {
	                    data: "CurrencyCode",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnOfferPlayerCurrency" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "RoundsAssigned",
	                    className: 'dt-right',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnOfferAwardedSpins" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "RoundsPlayed",
	                    className: 'dt-right',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnOfferUsedSpins" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "PendingSpins",
	                    className: 'dt-right',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnOfferPendingSpins" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "TotalWin",
	                    className: 'dt-right',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnOfferTotalWin" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "Status",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnOfferStatus" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "Result",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnOfferResult" + rowData.Id + "'>" + (Utils_1.Utils.isNullOrUndefined(data) ? '' : data) + "</span>");
	                    }
	                },
	                {
	                    data: "Source",
	                    defaultContent: '',
	                    visible: false
	                }
	            ],
	            order: [[OFFERS_COLUMN_INDEX.Name, "asc"]],
	            callbacks: {
	                preDrawCallback: this.preDrawCallback,
	                drawCallback: this.drawCallback
	            }
	        };
	    }
	    AssignedOffers.prototype.init = function () {
	        var btnCancelOffersMulti = Utils_1.Utils.getJQueryById("btnCancelSelected");
	        btnCancelOffersMulti.on("click", this.cancelSelectedOffers);
	        this._filterSource = Utils_1.Utils.getJQueryById("filterSource");
	        this._btnCancelSearch = Utils_1.Utils.getJQueryById(btnCancelSearchId);
	        this._filterPlayerName = Utils_1.Utils.getJQueryById('filterPlayerName');
	        this._filterPlayerRemoteId = Utils_1.Utils.getJQueryById('filterPlayerRemoteId');
	        this._filterRemoteId = Utils_1.Utils.getJQueryById('filterRemoteId');
	        this._filterCurrency = new MultiSelect_1.MultiSelectApi('filterCurrency');
	        this._filterStatus = new MultiSelect_1.MultiSelectApi('filterStatus');
	        this._filterResult = new MultiSelect_1.MultiSelectApi('filterResult');
	        this._btnCancelSearch.on('click', this.cancelSearch);
	        this._chckAllOffers = Utils_1.Utils.getJQueryById("offersSelectAll");
	        this._chckAllOffers.on("change", this.checkBoxAll);
	        _super.prototype.init.call(this);
	    };
	    AssignedOffers.prototype.cancelSelectedOffers = function (e) {
	        e.preventDefault();
	        if (!confirm(this._options.localizer.ConfirmCancel)) {
	            return;
	        }
	        var urlPost = this._options.urlPost;
	        var table = this._table;
	        var overview = Utils_1.Utils.getJQueryById('tableCampaignFinanceOverview').DataTable();
	        var ids = $("input[name='selectedOffer']:checked").map(function () {
	            return $(this).val();
	        });
	        var idsToCancel = ids.get();
	        if (!idsToCancel || idsToCancel.length === 0) {
	            return;
	        }
	        var statusMessage = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	        $.ajax({
	            url: urlPost,
	            type: "POST",
	            dataType: 'html',
	            data: { offerIds: idsToCancel },
	            success: function (data) {
	                table.draw();
	                overview.draw();
	                statusMessage.html(data);
	                StatusMessageHelper_1.StatusMessageHelper.initValidator();
	                StatusMessageHelper_1.StatusMessageHelper.initSatusMessage();
	            }
	        });
	        Utils_1.Utils.scrollToTop();
	    };
	    AssignedOffers.prototype.preDrawCallback = function (datatable) {
	        this._chckAllOffers[0].checked = false;
	        var filterPlayerName = this._filterPlayerName.val();
	        datatable.columns(OFFERS_COLUMN_INDEX.Name).search(filterPlayerName);
	        var filterPlayerRemoteId = this._filterPlayerRemoteId.val();
	        datatable.columns(OFFERS_COLUMN_INDEX.PlayerRemoteId).search(filterPlayerRemoteId);
	        var filterRemoteId = this._filterRemoteId.val();
	        datatable.columns(OFFERS_COLUMN_INDEX.RemoteId).search(filterRemoteId);
	        var filterCurrency = this._filterCurrency.isAllSelected() ? '' : this._filterCurrency.getSelectionValues(FILTER_DELIM);
	        datatable.columns(OFFERS_COLUMN_INDEX.Currency).search(filterCurrency);
	        var filterStatus = this._filterStatus.isAllSelected() ? '' : this._filterStatus.getSelectionValues(FILTER_DELIM);
	        datatable.columns(OFFERS_COLUMN_INDEX.Status).search(filterStatus);
	        var filterResult = this._filterResult.isAllSelected() ? '' : this._filterResult.getSelectionValues(FILTER_DELIM);
	        datatable.columns(OFFERS_COLUMN_INDEX.Result).search(filterResult);
	        var filterSource = this._filterSource.val();
	        if (filterSource != undefined) {
	            datatable.columns(OFFERS_COLUMN_INDEX.Source).search(filterSource);
	        }
	        return true;
	    };
	    AssignedOffers.prototype.drawCallback = function (datatable) {
	        this.showHideSelectAllCheckbox("offersSelectAll", "input[name='selectedOffer']");
	    };
	    AssignedOffers.prototype.cancelSearch = function (e) {
	        this._filterPlayerName.val('');
	        this._filterPlayerRemoteId.val('');
	        this._filterRemoteId.val('');
	        this._filterCurrency.selectAll();
	        this._filterStatus.selectAll();
	        this._filterResult.selectAll();
	        this._filterSource.val('Live');
	    };
	    AssignedOffers.prototype.checkBoxAll = function () {
	        var checkboxes = $("input[name='selectedOffer']");
	        for (var i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = this._chckAllOffers[0].checked;
	        }
	    };
	    AssignedOffers.prototype.setSelectAllOfferCheckbox = function () {
	        this.setSelectAllCheckbox("offersSelectAll", "input[name='selectedOffer']");
	    };
	    return AssignedOffers;
	}(DetailPage));
	exports.AssignedOffers = AssignedOffers;
	var AssignedGames = (function (_super) {
	    __extends(AssignedGames, _super);
	    function AssignedGames(options) {
	        _super.call(this, options);
	        var getSetupUrl = function (rowData) { return (options.urlDetail + "/" + rowData.BetSettingId); };
	        this.removeSelectedGames = this.removeSelectedGames.bind(this);
	        this.checkBoxAll = this.checkBoxAll.bind(this);
	        this.preDrawCallback = this.preDrawCallback.bind(this);
	        this.drawCallback = this.drawCallback.bind(this);
	        this.setSelectAllGamesCheckbox = this.setSelectAllGamesCheckbox.bind(this);
	        window['setSelectAllGamesCheckbox'] = this.setSelectAllGamesCheckbox;
	        this._tableId = "tableCampaignAssignedGames";
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDomAssignedGames,
	            rowId: 'betSettingId',
	            autoWidth: true,
	            ordering: true,
	            lengthMenu: [[10, 20, 100, -1], [10, 20, 100, "All"]],
	            columns: [
	                {
	                    data: 'BetSettingId',
	                    width: '5%',
	                    sortable: false,
	                    visible: !this._options.hideCheckboxes,
	                    render: function (data, type, rowData) {
	                        return ("<input id='chckbx" + rowData.BetSettingId + "' name='selectedGame' value='" + rowData.BetSettingId + "' type='checkbox' onClick=\"setSelectAllGamesCheckbox()\" />");
	                    }
	                },
	                {
	                    data: "GameName",
	                    width: '15%',
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkGameName" + rowData.BetSettingId + "' href='" + getSetupUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: "CurrencyCode",
	                    width: '5%',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnGameCurrency" + rowData.BetSettingId + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "GambleEnabled",
	                    width: '10%',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnGameGambleEnabled" + rowData.BetSettingId + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "BetType",
	                    width: '10%',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnGamebetType" + rowData.BetSettingId + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "PaylineCount",
	                    width: '10%',
	                    render: function (data, type, rowData) {
	                        var val = data == null ? 'N/A' : data;
	                        return ("<span id='spnGamePaylineCount" + rowData.BetSettingId + "'>" + val + "</span>");
	                    }
	                },
	                {
	                    data: "CoinCount",
	                    width: '10%',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnGameCoinCount" + rowData.BetSettingId + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "CoinSize",
	                    width: '10%',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnGameCoinSize" + rowData.BetSettingId + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "ValuePerSpin",
	                    width: '10%',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnGameValuePerSpin" + rowData.BetSettingId + "'>" + data + "</span>");
	                    }
	                }
	            ],
	            order: [[1, "asc"]],
	            callbacks: {
	                preDrawCallback: this.preDrawCallback,
	                drawCallback: this.drawCallback
	            }
	        };
	    }
	    AssignedGames.prototype.init = function () {
	        var btnRemoveMulti = Utils_1.Utils.getJQueryById("btnRemoveSelected");
	        btnRemoveMulti.on("click", this.removeSelectedGames);
	        this._chckAllGames = Utils_1.Utils.getJQueryById("gamesSelectAll");
	        this._chckAllGames.on("change", this.checkBoxAll);
	        _super.prototype.init.call(this);
	    };
	    AssignedGames.prototype.checkBoxAll = function () {
	        var checkboxes = $("input[name='selectedGame']");
	        for (var i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = this._chckAllGames[0].checked;
	        }
	    };
	    AssignedGames.prototype.removeSelectedGames = function (e) {
	        e.preventDefault();
	        var urlPost = this._options.urlPost;
	        var table = this._table;
	        var overview = Utils_1.Utils.getJQueryById('tableCampaignFinanceOverview').DataTable();
	        var ids = $("input[name='selectedGame']:checked").map(function () {
	            return $(this).val();
	        });
	        var statusMessage = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	        $.ajax({
	            url: urlPost,
	            type: "POST",
	            dataType: 'html',
	            data: { betSettingIds: ids.get() },
	            success: function (data) {
	                statusMessage.html(data);
	                StatusMessageHelper_1.StatusMessageHelper.initValidator();
	                StatusMessageHelper_1.StatusMessageHelper.initSatusMessage();
	                table.draw();
	                overview.draw();
	            }
	        });
	        Utils_1.Utils.scrollToTop();
	    };
	    AssignedGames.prototype.preDrawCallback = function (datatable) {
	        this._chckAllGames[0].checked = false;
	        return true;
	    };
	    AssignedGames.prototype.drawCallback = function (datatable) {
	        this.showHideSelectAllCheckbox("gamesSelectAll", "input[name='selectedGame']");
	    };
	    AssignedGames.prototype.setSelectAllGamesCheckbox = function () {
	        this.setSelectAllCheckbox("gamesSelectAll", "input[name='selectedGame']");
	    };
	    return AssignedGames;
	}(DetailPage));
	exports.AssignedGames = AssignedGames;
	var CampaignStatistics = (function (_super) {
	    __extends(CampaignStatistics, _super);
	    function CampaignStatistics(options) {
	        _super.call(this, options);
	        this._tableId = "tableCampaignStatistics";
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'CurrencyCode',
	            autoWidth: true,
	            ordering: false,
	            columns: [
	                {
	                    data: "CurrencyCode",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCurrency" + rowData.CurrencyCode + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "RoundsAssigned",
	                    className: 'dt-right',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnAwardedSpins" + rowData.CurrencyCode + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "PendingSpins",
	                    className: 'dt-right',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnPendingSpins" + rowData.CurrencyCode + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "UsedSpins",
	                    className: 'dt-right',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnUsedSpins" + rowData.CurrencyCode + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "AvgSpinValue",
	                    className: 'dt-right',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnAvgSpinValue" + rowData.CurrencyCode + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "TotalWin",
	                    className: 'dt-right',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnTotalWin" + rowData.CurrencyCode + "'>" + data + "</span>");
	                    }
	                }
	            ]
	        };
	    }
	    return CampaignStatistics;
	}(DetailPage));
	exports.CampaignStatistics = CampaignStatistics;
	var OffersOverview = (function (_super) {
	    __extends(OffersOverview, _super);
	    function OffersOverview(options) {
	        var _this = this;
	        _super.call(this, options);
	        this._tableId = "tableOffersOverview";
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'CampaignId',
	            paging: false,
	            autoWidth: true,
	            ordering: false,
	            columns: [
	                {
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnOffers'>" + _this._options.localizer.Offers + "</span>");
	                    }
	                },
	                {
	                    data: "TotalOffers",
	                    className: 'dt-right',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnTotalOffers'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "Remaining",
	                    className: 'dt-right',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnRemainingOffers'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "Completed",
	                    className: 'dt-right',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCompletedOffers'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "Accepted",
	                    className: 'dt-right',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnAcceptedOffers'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "Declined",
	                    className: 'dt-right',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnDeclinedOffers'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "Canceled",
	                    className: 'dt-right',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCanceledOffers'>" + data + "</span>");
	                    }
	                }
	            ]
	        };
	    }
	    return OffersOverview;
	}(DetailPage));
	exports.OffersOverview = OffersOverview;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var MultiSelect_1 = __webpack_require__(52);
	var Utils_1 = __webpack_require__(5);
	var StatusMessageHelper_1 = __webpack_require__(50);
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var tableDomUnassigned = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var OFFERS_COLUMN_INDEX = {
	    Name: 0,
	    Currency: 1
	};
	var FILTER_DELIM = '-delim-';
	var btnCancelSearchId = 'btnCancelSearch';
	var GamesSelectionPage = (function (_super) {
	    __extends(GamesSelectionPage, _super);
	    function GamesSelectionPage(options) {
	        _super.call(this, options);
	        this.formSubmit = this.formSubmit.bind(this);
	    }
	    GamesSelectionPage.prototype.init = function () {
	        GamesSelectionPage.msApi = new MultiSelect_1.MultiSelectApi('roles');
	        GamesSelectionPage.rolesInit = GamesSelectionPage.msApi.getSelectionValues();
	        this._form = Utils_1.Utils.getJQueryById("form" + this._tableId);
	        if (Utils_1.Utils.isNullOrUndefined(this._tableOptions))
	            return;
	        this._table = new Datatable_1.Datatable(this._tableId, this._tableOptions);
	        this._form.on('submit', this.formSubmit);
	    };
	    GamesSelectionPage.showForm = function (field, focusField) {
	        $(".multi-hide").hide();
	        $(".multi-show").show();
	        $(".multi-show").closest(".form-group").removeClass("gray");
	        var label = "#lbl" + field;
	        var frm = "#frm" + field;
	        $(label).hide();
	        $(frm).show();
	        $(label).closest(".form-group").addClass("gray");
	        if (focusField) {
	            $('#' + focusField).focus();
	        }
	    };
	    GamesSelectionPage.prototype.formSubmit = function (e) {
	        e.preventDefault();
	        this._table.draw();
	        return false;
	    };
	    GamesSelectionPage.prototype.showHideSelectAllCheckbox = function (selectAllButton, checkboxesIdentifier) {
	        var selectAllCheckbox = Utils_1.Utils.getJQueryById(selectAllButton)[0];
	        if (Utils_1.Utils.isNullOrUndefined(selectAllCheckbox))
	            return;
	        var checkboxes = $(checkboxesIdentifier);
	        if (checkboxes.length === 0) {
	            selectAllCheckbox.hidden = true;
	        }
	        else {
	            selectAllCheckbox.hidden = false;
	        }
	    };
	    GamesSelectionPage.hideForm = function (field) {
	        var label = "#lbl" + field;
	        var frm = "#frm" + field;
	        $(label).show();
	        $(frm).hide();
	        GamesSelectionPage.msApi.setSelectionValues(GamesSelectionPage.rolesInit);
	        $(label).closest(".form-group").removeClass("gray");
	    };
	    return GamesSelectionPage;
	}(PageBase_1.PageBase));
	exports.GamesSelectionPage = GamesSelectionPage;
	var AssignedGamesSelectionPage = (function (_super) {
	    __extends(AssignedGamesSelectionPage, _super);
	    function AssignedGamesSelectionPage(options) {
	        _super.call(this, options);
	        this.preDrawCallback = this.preDrawCallback.bind(this);
	        this.removeSelectedGames = this.removeSelectedGames.bind(this);
	        this.checkBoxAll = this.checkBoxAll.bind(this);
	        this.drawCallback = this.drawCallback.bind(this);
	        window['setGamesSelectAllCheckbox'] = this.setGamesSelectAllCheckbox;
	        if (options.dataSwitch === "assignedGames") {
	            this._tableId = "tableAssignedGames";
	            this._tableOptions = {
	                url: this._options.urlList,
	                dom: tableDom,
	                rowId: 'betSettingId',
	                autoWidth: true,
	                ordering: true,
	                columns: [
	                    {
	                        data: 'BetSettingId',
	                        sortable: false,
	                        render: function (data, type, rowData) {
	                            return ("<input id='chckbx" + rowData.BetSettingId + "' name='selectedGame' value='" + rowData.BetSettingId + "' type='checkbox' onClick=\"setGamesSelectAllCheckbox()\" />");
	                        }
	                    },
	                    {
	                        data: "GameName",
	                        sortable: true,
	                        render: function (data, type, rowData) {
	                            return ("<span id='spnGameName" + rowData.BetSettingId + "'>" + data + "</span>");
	                        }
	                    },
	                    {
	                        data: "CurrencyCode",
	                        sortable: true,
	                        render: function (data, type, rowData) {
	                            return ("<span id='spnGameCurrency" + rowData.BetSettingId + "'>" + data + "</span>");
	                        }
	                    },
	                    {
	                        data: "ValuePerSpin",
	                        sortable: true,
	                        render: function (data, type, rowData) {
	                            return ("<span id='spnValuePerSpin" + rowData.BetSettingId + "'>" + data + "</span>");
	                        }
	                    }
	                ],
	                order: [[1, "asc"]],
	                callbacks: {
	                    preDrawCallback: this.preDrawCallback,
	                    drawCallback: this.drawCallback
	                }
	            };
	        }
	    }
	    AssignedGamesSelectionPage.prototype.init = function () {
	        GamesSelectionPage.msApi = new MultiSelect_1.MultiSelectApi('roles');
	        GamesSelectionPage.rolesInit = GamesSelectionPage.msApi.getSelectionValues();
	        var btnRemoveMulti = Utils_1.Utils.getJQueryById("btnRemoveSelected");
	        this._form = Utils_1.Utils.getJQueryById("form" + this._tableId);
	        btnRemoveMulti.on("click", this.removeSelectedGames);
	        this._chckAllGames = Utils_1.Utils.getJQueryById("gamesSelectAll");
	        this._chckAllGames.on("change", this.checkBoxAll);
	        if (Utils_1.Utils.isNullOrUndefined(this._tableOptions))
	            return;
	        _super.prototype.init.call(this);
	    };
	    AssignedGamesSelectionPage.prototype.setGamesSelectAllCheckbox = function () {
	        var checkboxes = $("input[name='selectedGame']");
	        var gamesSelectAll = Utils_1.Utils.getJQueryById("gamesSelectAll")[0];
	        if (Utils_1.Utils.isNullOrUndefined(gamesSelectAll))
	            return;
	        var allCheckboxesChecked = false;
	        for (var i = 0; i < checkboxes.length; i++) {
	            allCheckboxesChecked = checkboxes[i].checked;
	            if (!allCheckboxesChecked)
	                break;
	        }
	        gamesSelectAll.checked = allCheckboxesChecked;
	    };
	    AssignedGamesSelectionPage.prototype.checkBoxAll = function () {
	        var checkboxes = $("input[name='selectedGame']");
	        for (var i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = this._chckAllGames[0].checked;
	        }
	    };
	    AssignedGamesSelectionPage.prototype.removeSelectedGames = function (e) {
	        e.preventDefault();
	        var urlPost = this._options.urlPost;
	        var table = this._table;
	        var unassignedGamesTable = Utils_1.Utils.getJQueryById('tableUnassignedGames').DataTable();
	        var ids = $("input[name='selectedGame']:checked").map(function () {
	            return $(this).val();
	        });
	        var statusMessage = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	        $.ajax({
	            url: urlPost,
	            type: "POST",
	            dataType: 'html',
	            data: { betSettingIds: ids.get() },
	            success: function (data) {
	                statusMessage.html(data);
	                StatusMessageHelper_1.StatusMessageHelper.initValidator();
	                StatusMessageHelper_1.StatusMessageHelper.initSatusMessage();
	                table.draw();
	                unassignedGamesTable.draw();
	            }
	        });
	    };
	    AssignedGamesSelectionPage.prototype.preDrawCallback = function (datatable) {
	        this._chckAllGames[0].checked = false;
	        this.showHideSelectAllCheckboxes();
	        return true;
	    };
	    AssignedGamesSelectionPage.prototype.drawCallback = function (datatable) {
	        this.showHideSelectAllCheckboxes();
	    };
	    AssignedGamesSelectionPage.prototype.showHideSelectAllCheckboxes = function () {
	        this.showHideSelectAllCheckbox("gamesSelectAll", "input[name='selectedGame']");
	    };
	    return AssignedGamesSelectionPage;
	}(GamesSelectionPage));
	exports.AssignedGamesSelectionPage = AssignedGamesSelectionPage;
	var UnassignedGamesSelectionPage = (function (_super) {
	    __extends(UnassignedGamesSelectionPage, _super);
	    function UnassignedGamesSelectionPage(options) {
	        _super.call(this, options);
	        this._optionUrl = options.urlDetail;
	        this.preDrawCallback = this.preDrawCallback.bind(this);
	        this.cancelSearch = this.cancelSearch.bind(this);
	        this.addGame = this.addGame.bind(this);
	        window['addGameClick'] = this.addGame;
	        if (options.dataSwitch === "unassignedGames") {
	            this._tableId = "tableUnassignedGames";
	            this._tableOptions = {
	                url: this._options.urlList,
	                dom: tableDomUnassigned,
	                rowId: 'configurationId',
	                autoWidth: true,
	                ordering: true,
	                columns: [
	                    {
	                        data: "GameName",
	                        render: function (data, type, rowData) {
	                            return ("<span id='spnUnassignedGameName" + rowData.ConfigurationId + "'>" + data + "</span>");
	                        }
	                    },
	                    {
	                        data: "CurrencyCode",
	                        render: function (data, type, rowData) {
	                            return ("<span id='spnUnassignedGameCurrency" + rowData.ConfigurationId + "'>" + data + "</span>");
	                        }
	                    },
	                    {
	                        data: "ValuesPerSpin",
	                        sortable: false,
	                        render: function (data, type, rowData) {
	                            var option = "<select id='comboSpinValue" + rowData.ConfigurationId + "'>";
	                            data.forEach(function (value) {
	                                option += "<option value=\"" + value.Key + "\">" + value.BetValue + "</option>";
	                            });
	                            option += '</select>';
	                            return option;
	                        }
	                    },
	                    {
	                        data: '',
	                        sortable: false,
	                        render: function (data, type, rowData) {
	                            if (rowData.AllowAdd) {
	                                return ("<a id='lnkDetail" + rowData.ConfigurationId + "' href='#' onClick='addGameClick(" + rowData.ConfigurationId + ");'>" + options.localizer.AddLink + "</a>");
	                            }
	                            else {
	                                return ("\n                                    <a id='lnkDetail" + rowData.ConfigurationId + "'\n                                       href='#'\n                                       onClick='event.preventDefault();'\n                                       style='color: gray; cursor: not-allowed; pointer-events: none;'>\n                                       " + options.localizer.AddLink + "\n                                    </a>");
	                            }
	                        }
	                    }
	                ],
	                order: [[OFFERS_COLUMN_INDEX.Name, "asc"]],
	                callbacks: {
	                    preDrawCallback: this.preDrawCallback
	                }
	            };
	        }
	    }
	    UnassignedGamesSelectionPage.prototype.init = function () {
	        this._btnCancelSearch = Utils_1.Utils.getJQueryById(btnCancelSearchId);
	        this._filterGame = new MultiSelect_1.MultiSelectApi('filterGame');
	        this._filterCurrency = new MultiSelect_1.MultiSelectApi('filterCurrency');
	        this._btnCancelSearch.on('click', this.cancelSearch);
	        _super.prototype.init.call(this);
	    };
	    UnassignedGamesSelectionPage.prototype.addGame = function (configurationId) {
	        var urlPost = this._optionUrl;
	        var table = this._table;
	        var assignedGamesTable = Utils_1.Utils.getJQueryById('tableAssignedGames').DataTable();
	        var statusMessage = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	        var spinValue = Utils_1.Utils.getJQueryById("#comboSpinValue" + configurationId + " option:selected").val();
	        $.ajax({
	            url: urlPost,
	            type: "POST",
	            dataType: 'html',
	            data: { configurationId: configurationId, spinValue: spinValue },
	            success: function (data) {
	                statusMessage.html(data);
	                StatusMessageHelper_1.StatusMessageHelper.initValidator();
	                StatusMessageHelper_1.StatusMessageHelper.initSatusMessage();
	                table.draw();
	                assignedGamesTable.draw();
	            }
	        });
	    };
	    UnassignedGamesSelectionPage.prototype.cancelSearch = function (e) {
	        this._filterGame.selectAll();
	        this._filterCurrency.selectAll();
	    };
	    UnassignedGamesSelectionPage.prototype.preDrawCallback = function (datatable) {
	        var filterGame = this._filterGame.isAllSelected() ? '' : this._filterGame.getSelectionValues(FILTER_DELIM);
	        datatable.columns(OFFERS_COLUMN_INDEX.Name).search(filterGame);
	        var filterCurrency = this._filterCurrency.isAllSelected() ? '' : this._filterCurrency.getSelectionValues(FILTER_DELIM);
	        datatable.columns(OFFERS_COLUMN_INDEX.Currency).search(filterCurrency);
	        return true;
	    };
	    return UnassignedGamesSelectionPage;
	}(GamesSelectionPage));
	exports.UnassignedGamesSelectionPage = UnassignedGamesSelectionPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var DateTimePicker_1 = __webpack_require__(57);
	var MultiSelect_1 = __webpack_require__(52);
	var Utils_1 = __webpack_require__(5);
	var StatusMessageHelper_1 = __webpack_require__(50);
	var StatusMessage_1 = __webpack_require__(61);
	var tableDomAssignedGames = "<'row'<'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var FILTER_DELIM = '-delim-';
	var tableCampaignAssignedOffers = 'tableCampaignAssignedOffers_row_';
	var batchSize = 100;
	var FreeRoundBrowseRequest = (function () {
	    function FreeRoundBrowseRequest() {
	    }
	    return FreeRoundBrowseRequest;
	}());
	var DefaultCampaignPage = (function (_super) {
	    __extends(DefaultCampaignPage, _super);
	    function DefaultCampaignPage(options) {
	        _super.call(this, options);
	        if (options.dataSwitch === "assignedOffers") {
	            window['setSelectAllCheckbox'] = this.setSelectAllCheckbox;
	            this.run = this.run.bind(this);
	            this.loadMore = this.loadMore.bind(this);
	            this.resetFilter = this.resetFilter.bind(this);
	            this.getCountResult = this.getCountResult.bind(this);
	            this.showLoadMoreButton = this.showLoadMoreButton.bind(this);
	            this.hideLoadMoreButton = this.hideLoadMoreButton.bind(this);
	            this.enableRunButton = this.enableRunButton.bind(this);
	            this.checkBoxAll = this.checkBoxAll.bind(this);
	            this._options = options;
	            this.cancelSelectedOffers = this.cancelSelectedOffers.bind(this);
	        }
	        if (options.dataSwitch === "assignedGames") {
	            var getSetupUrl = function (rowData) { return (options.urlDetail + "/" + rowData.BetSettingId); };
	            this._tableId = "tableCampaignAssignedGames";
	            this._tableOptions = {
	                url: this._options.urlList,
	                dom: tableDomAssignedGames,
	                rowId: 'Id',
	                autoWidth: true,
	                ordering: false,
	                columns: [
	                    {
	                        data: "GameName",
	                        render: function (data, type, rowData) {
	                            return ("<a id='lnkGameName" + rowData.BetSettingId + "' href='" + getSetupUrl(rowData) + "'>" + data + "</a>");
	                        }
	                    },
	                    {
	                        data: "CurrencyCode",
	                        render: function (data, type, rowData) {
	                            return ("<span id='spnGameCurrency" + rowData.BetSettingId + "'>" + data + "</span>");
	                        }
	                    },
	                    {
	                        data: "CoinCount",
	                        render: function (data, type, rowData) {
	                            return ("<span id='spnGameCoinCount" + rowData.BetSettingId + "'>" + data + "</span>");
	                        }
	                    },
	                    {
	                        data: "CoinSize",
	                        render: function (data, type, rowData) {
	                            return ("<span id='spnGameCoinSize" + rowData.BetSettingId + "'>" + data + "</span>");
	                        }
	                    },
	                    {
	                        data: "ValuePerSpin",
	                        render: function (data, type, rowData) {
	                            return ("<span id='spnGameValuePerSpin" + rowData.BetSettingId + "'>" + data + "</span>");
	                        }
	                    }
	                ]
	            };
	        }
	    }
	    DefaultCampaignPage.prototype.init = function () {
	        if (this._options.dataSwitch === "assignedGames") {
	            if (Utils_1.Utils.isNullOrUndefined(this._tableOptions))
	                return;
	            this._table = new Datatable_1.Datatable(this._tableId, this._tableOptions);
	            return;
	        }
	        this._btnCancelOffersMulti = Utils_1.Utils.getJQueryById("btnCancelSelected");
	        this._filterPlayerId = Utils_1.Utils.getJQueryById('filterPlayerId');
	        this._filterCustomerId = new MultiSelect_1.MultiSelectApi('filterCustomerId');
	        this._filterPlayerRemoteId = Utils_1.Utils.getJQueryById('filterPlayerRemoteId');
	        this._filterRemoteId = Utils_1.Utils.getJQueryById('filterRemoteId');
	        this._filterResult = new MultiSelect_1.MultiSelectApi('filterResult');
	        this._filterStatus = new MultiSelect_1.MultiSelectApi('filterStatus');
	        this._filterCurrency = new MultiSelect_1.MultiSelectApi('filterCurrency');
	        this._filterCampaignId = Utils_1.Utils.getJQueryById('_filterCampaignId');
	        this._filterCampaignName = Utils_1.Utils.getJQueryById('filterCampaignName');
	        this._filterCampaignRemoteId = Utils_1.Utils.getJQueryById('filterCampaignRemoteId');
	        this._filterWinPayMethods = new MultiSelect_1.MultiSelectApi('filterWinPayMethods');
	        this._filterWinFrom = Utils_1.Utils.getJQueryById('filterWinFrom');
	        this._filterWinTo = Utils_1.Utils.getJQueryById('filterWinTo');
	        this._filterRoundsAssignedFrom = Utils_1.Utils.getJQueryById('filterRoundsAssignedFrom');
	        this._filterRoundsAssignedTo = Utils_1.Utils.getJQueryById('filterRoundsAssignedTo');
	        this._filterRoundsPlayedFrom = Utils_1.Utils.getJQueryById('filterRoundsPlayedFrom');
	        this._filterRoundsPlayedTo = Utils_1.Utils.getJQueryById('filterRoundsPlayedTo');
	        this._filterPendingSpinsFrom = Utils_1.Utils.getJQueryById('filterPendingSpinsFrom');
	        this._filterPendingSpinsTo = Utils_1.Utils.getJQueryById('filterPendingSpinsTo');
	        this._filterValidFromFrom = new DateTimePicker_1.DateTimePickerApi("filterValidFromFrom");
	        this._filterValidFromTo = new DateTimePicker_1.DateTimePickerApi("filterValidFromTo");
	        this._filterValidToFrom = new DateTimePicker_1.DateTimePickerApi('filterValidToFrom');
	        this._filterValidToTo = new DateTimePicker_1.DateTimePickerApi('filterValidToTo');
	        this._filterSource = Utils_1.Utils.getJQueryById("filterSource");
	        this._runButton = Utils_1.Utils.getJQueryById("btnRunQuery");
	        this._runButton.on("click", this.run);
	        this._loadMoreButton = Utils_1.Utils.getJQueryById("btnLoadMore");
	        this._loadMoreButton.on("click", this.loadMore);
	        this._resetFilterButton = Utils_1.Utils.getJQueryById("btnResetFilter");
	        this._resetFilterButton.on("click", this.resetFilter);
	        this._btnCountResult = Utils_1.Utils.getJQueryById("btnCountResult");
	        this._btnCountResult.on("click", this.getCountResult);
	        this._totalEntries = Utils_1.Utils.getJQueryById("totalEntries");
	        this._checkAll = Utils_1.Utils.getJQueryById("selectAll");
	        this._checkAll.on("change", this.checkBoxAll);
	        this._processing = Utils_1.Utils.getJQueryById("processing");
	        this._statusMessage = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	        this._btnCancelOffersMulti.on("click", this.cancelSelectedOffers);
	    };
	    DefaultCampaignPage.prototype.run = function () {
	        this.disableRunButton();
	        var totalEntries = this._totalEntries[0];
	        totalEntries.innerText = "##";
	        this._currentRequest = this.getBrowseRequest();
	        var table = this.getTableBody();
	        table.innerHTML = "";
	        this.sendRequest(this._currentRequest);
	    };
	    DefaultCampaignPage.prototype.selectedOffer = function (id) {
	        if (id !== '') {
	            $("#tableCampaignAssignedOffers tr").css("background-color", "");
	            if (id === this.selectedOfferRow) {
	                this.hideAssignedGames();
	                this.selectedOfferRow = '';
	            }
	            else {
	                Utils_1.Utils.getJQueryById(id).css("background-color", "lightblue");
	                var itemId = id.replace('tableCampaignAssignedOffers_row_', '');
	                $('#divAssignedGames').css("visibility", "visible");
	                var widthOffers = $('#pageAssignedOffers').width();
	                var games = Utils_1.Utils.getJQueryById('tableCampaignAssignedGames').DataTable();
	                games.ajax.url(this._options.urlDetail + '/' + itemId);
	                games.draw();
	                this.selectedOfferRow = id;
	                $('#pageAssignedGames').width(widthOffers);
	            }
	        }
	    };
	    DefaultCampaignPage.prototype.cancelSelectedOffers = function (e) {
	        e.preventDefault();
	        var urlPost = this._options.urlPost;
	        var ids = $("input[name='selectedOffer']:checked").map(function () {
	            return $(this).val();
	        });
	        var idsGet = ids.get();
	        if (!idsGet || idsGet.length == 0) {
	            return;
	        }
	        var statusMessage = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	        var refreshData = this.run;
	        $.ajax({
	            url: urlPost,
	            type: "POST",
	            dataType: 'html',
	            data: { offerIds: idsGet },
	            success: function (data) {
	                refreshData();
	                statusMessage.html(data);
	                StatusMessageHelper_1.StatusMessageHelper.initValidator();
	                StatusMessageHelper_1.StatusMessageHelper.initSatusMessage();
	            }
	        });
	    };
	    DefaultCampaignPage.prototype.hideAssignedGames = function () {
	        $('#divAssignedGames').css("visibility", "hidden");
	    };
	    DefaultCampaignPage.prototype.loadMore = function () {
	        this.sendRequest(this._currentRequest);
	    };
	    DefaultCampaignPage.prototype.showLoadMoreButton = function () {
	        this._loadMoreButton.removeClass("display-none");
	    };
	    DefaultCampaignPage.prototype.hideLoadMoreButton = function () {
	        this._loadMoreButton.addClass("display-none");
	    };
	    DefaultCampaignPage.prototype.disableRunButton = function () {
	        this._runButton.attr("disabled", 1);
	    };
	    DefaultCampaignPage.prototype.enableRunButton = function () {
	        this._runButton.removeAttr("disabled");
	    };
	    DefaultCampaignPage.prototype.resetFilter = function () {
	        this._filterCustomerId.selectAll();
	        this._filterStatus.selectAll();
	        this._filterResult.selectAll();
	        this._filterCurrency.selectAll();
	        this._filterWinPayMethods.selectAll();
	        this._filterPlayerId.val('');
	        this._filterPlayerRemoteId.val('');
	        this._filterRemoteId.val('');
	        this._filterWinFrom.val('');
	        this._filterWinTo.val('');
	        this._filterCampaignId.val('');
	        this._filterCampaignName.val('');
	        this._filterCampaignRemoteId.val('');
	        this._filterWinFrom.val('');
	        this._filterWinTo.val('');
	        this._filterRoundsAssignedFrom.val('');
	        this._filterRoundsAssignedTo.val('');
	        this._filterRoundsPlayedFrom.val('');
	        this._filterRoundsPlayedTo.val('');
	        this._filterPendingSpinsFrom.val('');
	        this._filterPendingSpinsTo.val('');
	        this._filterValidFromFrom.clearDates();
	        this._filterValidFromTo.clearDates();
	        this._filterValidToFrom.clearDates();
	        this._filterValidToTo.clearDates();
	        this._filterSource.val('Live');
	    };
	    DefaultCampaignPage.prototype.getCountResult = function () {
	        var request = Utils_1.Utils.isNullOrUndefined(this._currentRequest) ? this.getBrowseRequest() : this._currentRequest;
	        var urlCount = this._options.urlCount;
	        var totalEntries = this._totalEntries[0];
	        var processing = this._processing;
	        var statusMessage = this._statusMessage;
	        var displayMessage = this.displayMessage;
	        processing.show();
	        $.ajax({
	            url: urlCount,
	            type: "POST",
	            dataType: 'html',
	            data: { request: request },
	            success: function (data) {
	                totalEntries.innerText = data;
	                processing.hide();
	                statusMessage.hide();
	            },
	            error: function (jqXHR, textStatus, errorThrown) {
	                processing.hide();
	                displayMessage(jqXHR);
	            }
	        });
	    };
	    DefaultCampaignPage.prototype.sendRequest = function (request) {
	        var urlGetList = this._options.urlGetList;
	        var urlOfferDetail = this._options.urlOfferDetail;
	        var table = this.getTableBody();
	        var showLoadMore = this.showLoadMoreButton;
	        var hideLoadMore = this.hideLoadMoreButton;
	        var enableRunButton = this.enableRunButton;
	        var processing = this._processing;
	        var statusMessage = this._statusMessage;
	        var displayMessage = this.displayMessage;
	        var totalEntries = this._totalEntries[0];
	        var btnCancelOffersMulti = this._btnCancelOffersMulti;
	        var that = this;
	        this.hideAssignedGames();
	        processing.show();
	        $.ajax({
	            url: urlGetList,
	            type: "POST",
	            dataType: 'html',
	            data: { request: request },
	            success: function (data) {
	                var parsedData = JSON.parse(data);
	                var items = parsedData.Items;
	                var totalCount = parsedData.FilteredCount;
	                if (items.length < batchSize + 1) {
	                    hideLoadMore();
	                }
	                else {
	                    request.LastOfferId = items[batchSize].Id;
	                    showLoadMore();
	                }
	                var enabled = ['Completed', 'Canceled'];
	                $.each(items, function (index, item) {
	                    if (index < batchSize) {
	                        var row = table.insertRow(-1);
	                        row.style.cursor = 'pointer';
	                        row.id = tableCampaignAssignedOffers + item.Id;
	                        var cell0 = row.insertCell(0);
	                        cell0.innerHTML = "<input name='selectedOffer' value='" + item.Id + "' type='checkbox' onClick=\"setSelectAllCheckbox()\" />";
	                        var cell1 = row.insertCell(1);
	                        cell1.innerHTML = "<b>Offer remote ID: </b><a href=\"" + urlOfferDetail + "/" + item.Id + "\">" + item.RemoteId + "</a>";
	                        var cell2 = row.insertCell(2);
	                        cell2.innerHTML = "<b>Player name: </b>" + item.PlayerRemoteId + "<br/><b>Player ID: </b>" + item.PlayerId;
	                        var cell3 = row.insertCell(3);
	                        var css = enabled.indexOf(item.Status) > -1 ? "status-enabled" : "status-disabled";
	                        cell3.innerHTML = "<b>Status: </b><span class=\"" + css + "\">" + item.Status + "</span>";
	                        var cell4 = row.insertCell(4);
	                        cell4.innerHTML = "<b>Awarded: </b>" + item.RoundsAssigned + "<br/><b>Used: </b>" + item.RoundsPlayed + "<br/><b>Remaining: </b>" + item.PendingSpins;
	                        var cell5 = row.insertCell(5);
	                        cell5.innerHTML = "<b>Win amount: </b>" + item.TotalWin + " " + (item.CurrencyCode ? item.CurrencyCode : "") + "<br/><b>Currency: </b>" + item.CurrencyCode;
	                        var cell6 = row.insertCell(6);
	                        cell6.innerHTML = "<b style=\"width: 76px; display: inline-block;\">Valid from: </b>" + item.ValidFrom + "<br/><b style=\"width: 76px; display: inline-block;\">Valid to: </b>" + item.ValidTo;
	                    }
	                });
	                $('#tableCampaignAssignedOffers').on('click', 'tr', function (event) {
	                    if (event.target.nodeName !== "INPUT") {
	                        var trId = event.target.closest('tr').id;
	                        that.selectedOffer(trId);
	                    }
	                });
	                totalEntries.innerText = totalCount;
	                if (request.Source == 'Archive') {
	                    btnCancelOffersMulti.attr("disabled", 1);
	                }
	                else {
	                    btnCancelOffersMulti.removeAttr("disabled");
	                }
	                processing.hide();
	                enableRunButton();
	                statusMessage.hide();
	            },
	            error: function (jqXHR, textStatus, errorThrown) {
	                processing.hide();
	                enableRunButton();
	                displayMessage(jqXHR);
	            }
	        });
	    };
	    DefaultCampaignPage.prototype.displayMessage = function (jqXHR) {
	        var statusMessageWrapper = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	        var statusMessageData = {
	            code: "500",
	            autoClose: false,
	            class: "danger",
	            message: "Unexpected error",
	            type: StatusMessage_1.StatusMessageType.Error
	        };
	        var statusMessage = new StatusMessage_1.StatusMessage(statusMessageData);
	        statusMessageWrapper.html(statusMessage.getHTMLmessage());
	        StatusMessageHelper_1.StatusMessageHelper.initValidator();
	        StatusMessageHelper_1.StatusMessageHelper.initSatusMessage();
	        statusMessageWrapper.show();
	    };
	    DefaultCampaignPage.prototype.getTableBody = function () {
	        return document.getElementById("tableCampaignAssignedOffers").getElementsByTagName("tbody")[0];
	    };
	    DefaultCampaignPage.prototype.checkBoxAll = function () {
	        var checkboxes = $("input[name='selectedOffer']");
	        for (var i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = this._checkAll[0].checked;
	        }
	    };
	    DefaultCampaignPage.prototype.setSelectAllCheckbox = function () {
	        var checkboxes = $("input[name='selectedOffer']");
	        var selectAll = Utils_1.Utils.getJQueryById("selectAll")[0];
	        if (Utils_1.Utils.isNullOrUndefined(selectAll))
	            return;
	        var allCheckboxesChecked = false;
	        for (var i = 0; i < checkboxes.length; i++) {
	            allCheckboxesChecked = checkboxes[i].checked;
	            if (!allCheckboxesChecked)
	                break;
	        }
	        selectAll.checked = allCheckboxesChecked;
	    };
	    DefaultCampaignPage.prototype.getBrowseRequest = function () {
	        var request = new FreeRoundBrowseRequest();
	        request.CustomerId = this._filterCustomerId.isAllSelected() ? '' : this._filterCustomerId.getSelectionValues(FILTER_DELIM);
	        request.PlayerId = this._filterPlayerId.val();
	        request.PlayerName = this._filterPlayerRemoteId.val();
	        request.PlayerRemoteId = this._filterPlayerRemoteId.val();
	        request.RemoteId = this._filterRemoteId.val();
	        request.CurrencyId = this._filterCurrency.isAllSelected() ? '' : this._filterCurrency.getSelectionValues(FILTER_DELIM);
	        request.CampaignId = this._filterCampaignId.val();
	        request.CampaignName = this._filterCampaignName.val();
	        request.CampaignRemoteId = this._filterCampaignRemoteId.val();
	        request.WinPayMethods = this._filterWinPayMethods.isAllSelected() ? '' : this._filterWinPayMethods.getSelectionValues(FILTER_DELIM);
	        request.WinFrom = this._filterWinFrom.val();
	        request.WinTo = this._filterWinTo.val();
	        request.RoundsAssignedFrom = this._filterRoundsAssignedFrom.val();
	        request.RoundsAssignedTo = this._filterRoundsAssignedTo.val();
	        request.RoundsPlayedFrom = this._filterRoundsPlayedFrom.val();
	        request.RoundsPlayedTo = this._filterRoundsPlayedTo.val();
	        request.PendingSpinsFrom = this._filterPendingSpinsFrom.val();
	        request.PendingSpinsTo = this._filterPendingSpinsTo.val();
	        request.ValidFrom = this._filterValidFromFrom.getUnixTimestamp() + FILTER_DELIM + this._filterValidFromTo.getUnixTimestamp();
	        request.ValidTo = this._filterValidToFrom.getUnixTimestamp() + FILTER_DELIM + this._filterValidToTo.getUnixTimestamp();
	        request.Result = this._filterResult.isAllSelected() ? '' : this._filterResult.getSelectionValues(FILTER_DELIM);
	        request.Status = this._filterStatus.isAllSelected() ? '' : this._filterStatus.getSelectionValues(FILTER_DELIM);
	        request.BatchSize = batchSize + 1;
	        request.Source = this._filterSource.val();
	        return request;
	    };
	    return DefaultCampaignPage;
	}(PageBase_1.PageBase));
	exports.DefaultCampaignPage = DefaultCampaignPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var DateUtils_1 = __webpack_require__(48);
	var tableId = 'tableGameTransactions';
	var tableDom = "<'row'<'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var OfferDetailPage = (function (_super) {
	    __extends(OfferDetailPage, _super);
	    function OfferDetailPage(options) {
	        _super.call(this, options);
	        this.openDialog = this.openDialog.bind(this);
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            columns: [
	                {
	                    data: 'Type',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnType" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Id',
	                    className: "bold",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnName" + rowData.Id + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: 'ExternalParentId',
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnExternalParentId" + rowData.Id + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: 'ReversedBy',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnReversedBy" + rowData.Id + "'>" + (data || '') + "</span>");
	                    },
	                },
	                {
	                    data: 'RealAmount',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnRealAmount" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'BonusAmount',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnBonusAmount" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Status',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnStatus" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Forced',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnForced" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Created',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCreated" + rowData.Id + "'>" + DateUtils_1.DateUtils.toDefaultWithTime(data) + "</span>");
	                    }
	                },
	                {
	                    data: 'Completed',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCompleted" + rowData.Id + "'>" + DateUtils_1.DateUtils.toDefaultWithTime(data) + "</span>");
	                    }
	                },
	                {
	                    data: 'RemoteId',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnRemoteId" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'RealBalance',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnRealBalance" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'BonusBalance',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnBonusBalance" + rowData.Id + "'>" + data + "</span>");
	                    }
	                }
	            ],
	            order: [[1, "asc"]]
	        };
	    }
	    OfferDetailPage.prototype.openDialog = function () {
	        document.getElementById("areYouSureConfirmation").hidden = false;
	    };
	    OfferDetailPage.prototype.closeDialog = function () {
	        document.getElementById("areYouSureConfirmation").hidden = true;
	    };
	    OfferDetailPage.prototype.init = function () {
	        var _this = this;
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	        var submitButton = document.getElementById("lnkReview");
	        if (submitButton != null) {
	            submitButton.onclick = function (e) {
	                e.preventDefault();
	                var confirmButton = document.getElementById("btnConfirm");
	                confirmButton.onclick = function () {
	                    window.location.href = submitButton.href;
	                };
	                var closeButton = document.getElementById("btnHideConfirmation");
	                closeButton.onclick = function () { return _this.closeDialog(); };
	                _this.openDialog();
	            };
	        }
	    };
	    return OfferDetailPage;
	}(PageBase_1.PageBase));
	exports.OfferDetailPage = OfferDetailPage;


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var MultiSelect_1 = __webpack_require__(52);
	var Utils_1 = __webpack_require__(5);
	var StatusMessageHelper_1 = __webpack_require__(50);
	var StatusMessage_1 = __webpack_require__(61);
	var FILTER_DELIM = '-delim-';
	var batchSize = 100;
	var FreeRoundBrowseRequest = (function () {
	    function FreeRoundBrowseRequest() {
	    }
	    return FreeRoundBrowseRequest;
	}());
	var OfferDashboard = (function (_super) {
	    __extends(OfferDashboard, _super);
	    function OfferDashboard(options) {
	        _super.call(this, options);
	        window['setSelectAllCheckbox'] = this.setSelectAllCheckbox;
	        this.run = this.run.bind(this);
	        this.loadMore = this.loadMore.bind(this);
	        this.resetFilter = this.resetFilter.bind(this);
	        this.toggleSortDirection = this.toggleSortDirection.bind(this);
	        this.getCountResult = this.getCountResult.bind(this);
	        this.showLoadMoreButton = this.showLoadMoreButton.bind(this);
	        this.hideLoadMoreButton = this.hideLoadMoreButton.bind(this);
	        this.enableRunButton = this.enableRunButton.bind(this);
	        this.checkBoxAll = this.checkBoxAll.bind(this);
	        this._options = options;
	    }
	    OfferDashboard.prototype.init = function () {
	        this._filterCustomerId = new MultiSelect_1.MultiSelectApi('filterCustomerId');
	        this._filterPlayerRemoteId = Utils_1.Utils.getJQueryById('filterPlayerRemoteId');
	        this._filterRemoteId = Utils_1.Utils.getJQueryById('filterRemoteId');
	        this._filterResult = new MultiSelect_1.MultiSelectApi('filterResult');
	        this._filterStatus = new MultiSelect_1.MultiSelectApi('filterStatus');
	        this._filterCurrency = new MultiSelect_1.MultiSelectApi('filterCurrency');
	        this._filterCampaignId = Utils_1.Utils.getJQueryById('_filterCampaignId');
	        this._filterCampaignName = Utils_1.Utils.getJQueryById('filterCampaignName');
	        this._filterCampaignRemoteId = Utils_1.Utils.getJQueryById('filterCampaignRemoteId');
	        this._filterWinPayMethods = new MultiSelect_1.MultiSelectApi('filterWinPayMethods');
	        this._filterWinFrom = Utils_1.Utils.getJQueryById('filterWinFrom');
	        this._filterWinTo = Utils_1.Utils.getJQueryById('filterWinTo');
	        this._filterRoundsAssignedFrom = Utils_1.Utils.getJQueryById('filterRoundsAssignedFrom');
	        this._filterRoundsAssignedTo = Utils_1.Utils.getJQueryById('filterRoundsAssignedTo');
	        this._filterRoundsPlayedFrom = Utils_1.Utils.getJQueryById('filterRoundsPlayedFrom');
	        this._filterRoundsPlayedTo = Utils_1.Utils.getJQueryById('filterRoundsPlayedTo');
	        this._filterPendingSpinsFrom = Utils_1.Utils.getJQueryById('filterPendingSpinsFrom');
	        this._filterPendingSpinsTo = Utils_1.Utils.getJQueryById('filterPendingSpinsTo');
	        this._filterOfferId = Utils_1.Utils.getJQueryById('filterOfferId');
	        this._filterSource = Utils_1.Utils.getJQueryById("filterSource");
	        this._runButton = Utils_1.Utils.getJQueryById("btnRunQuery");
	        this._runButton.on("click", this.run);
	        this._loadMoreButton = Utils_1.Utils.getJQueryById("btnLoadMore");
	        this._loadMoreButton.on("click", this.loadMore);
	        this._resetFilterButton = Utils_1.Utils.getJQueryById("btnResetFilter");
	        this._resetFilterButton.on("click", this.resetFilter);
	        this._btnCountResult = Utils_1.Utils.getJQueryById("btnCountResult");
	        this._btnCountResult.on("click", this.getCountResult);
	        this._totalEntries = Utils_1.Utils.getJQueryById("totalEntries");
	        this._checkAll = Utils_1.Utils.getJQueryById("selectAll");
	        this._checkAll.on("change", this.checkBoxAll);
	        this._processing = Utils_1.Utils.getJQueryById("processing");
	        this._statusMessage = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	    };
	    OfferDashboard.prototype.run = function () {
	        this.disableRunButton();
	        var totalEntries = this._totalEntries[0];
	        totalEntries.innerText = "##";
	        this._currentRequest = this.getBrowseRequest();
	        var table = this.getTableBody();
	        table.innerHTML = "";
	        this.sendRequest(this._currentRequest);
	    };
	    OfferDashboard.prototype.loadMore = function () {
	        this.sendRequest(this._currentRequest);
	    };
	    OfferDashboard.prototype.showLoadMoreButton = function () {
	        this._loadMoreButton.removeClass("display-none");
	    };
	    OfferDashboard.prototype.hideLoadMoreButton = function () {
	        this._loadMoreButton.addClass("display-none");
	    };
	    OfferDashboard.prototype.disableRunButton = function () {
	        this._runButton.attr("disabled", 1);
	    };
	    OfferDashboard.prototype.enableRunButton = function () {
	        this._runButton.removeAttr("disabled");
	    };
	    OfferDashboard.prototype.resetFilter = function () {
	        this._filterCustomerId.selectAll();
	        this._filterStatus.selectAll();
	        this._filterResult.selectAll();
	        this._filterCurrency.selectAll();
	        this._filterWinPayMethods.selectAll();
	        this._filterPlayerRemoteId.val('');
	        this._filterRemoteId.val('');
	        this._filterWinFrom.val('');
	        this._filterWinTo.val('');
	        this._filterCampaignId.val('');
	        this._filterCampaignName.val('');
	        this._filterCampaignRemoteId.val('');
	        this._filterWinFrom.val('');
	        this._filterWinTo.val('');
	        this._filterRoundsAssignedFrom.val('');
	        this._filterRoundsAssignedTo.val('');
	        this._filterRoundsPlayedFrom.val('');
	        this._filterRoundsPlayedTo.val('');
	        this._filterPendingSpinsFrom.val('');
	        this._filterPendingSpinsTo.val('');
	        this._filterOfferId.val('');
	        this._filterSource.val('Live');
	    };
	    OfferDashboard.prototype.getCountResult = function () {
	        var request = Utils_1.Utils.isNullOrUndefined(this._currentRequest) ? this.getBrowseRequest() : this._currentRequest;
	        var urlCount = this._options.urlCount;
	        var totalEntries = this._totalEntries[0];
	        var processing = this._processing;
	        var statusMessage = this._statusMessage;
	        var displayMessage = this.displayMessage;
	        processing.show();
	        $.ajax({
	            url: urlCount,
	            type: "POST",
	            dataType: 'html',
	            data: { request: request },
	            success: function (data) {
	                totalEntries.innerText = data;
	                processing.hide();
	                statusMessage.hide();
	            },
	            error: function (jqXHR, textStatus, errorThrown) {
	                processing.hide();
	                displayMessage(jqXHR);
	            }
	        });
	    };
	    OfferDashboard.prototype.getDetailUrl = function (detailUrl, data) {
	        return detailUrl + "/" + data;
	    };
	    OfferDashboard.prototype.sendRequest = function (request) {
	        var urlList = this._options.urlList;
	        var detailUrl = this._options.urlDetail;
	        var table = this.getTableBody();
	        var getDetailUrl = this.getDetailUrl;
	        var showLoadMore = this.showLoadMoreButton;
	        var hideLoadMore = this.hideLoadMoreButton;
	        var enableRunButton = this.enableRunButton;
	        var processing = this._processing;
	        var statusMessage = this._statusMessage;
	        var displayMessage = this.displayMessage;
	        var totalEntries = this._totalEntries[0];
	        processing.show();
	        $.ajax({
	            url: urlList,
	            type: "POST",
	            dataType: 'html',
	            data: { request: request },
	            success: function (data) {
	                var parsedData = JSON.parse(data);
	                var items = parsedData.Items;
	                var totalCount = parsedData.FilteredCount;
	                if (items.length < batchSize + 1) {
	                    hideLoadMore();
	                }
	                else {
	                    request.LastOfferId = items[batchSize].Id;
	                    showLoadMore();
	                }
	                var enabled = ['Completed', 'Declined', 'Canceled'];
	                $.each(items, function (index, item) {
	                    if (index < batchSize) {
	                        var row = table.insertRow(-1);
	                        var cell0 = row.insertCell(0);
	                        cell0.innerHTML = "<input name='selectedFreeRound' value='" + item.GameRoundId + "' type='checkbox' onClick=\"setSelectAllCheckbox()\" />";
	                        var cell1 = row.insertCell(1);
	                        cell1.innerHTML = "<a target=\"_blank\" rel=\"noopener noreferrer\" href='" + getDetailUrl(detailUrl, item.Id) + "'><b>Offer ID: </b>" + item.Id + "</a><br/><b>Remote ID: </b>" + item.RemoteId;
	                        var cell2 = row.insertCell(2);
	                        cell2.innerHTML = "<b>Customer: </b>" + item.CustomerName + "<br/><b>Campaign Remote ID: </b>" + item.CampaignRemoteId;
	                        var cell3 = row.insertCell(3);
	                        cell3.innerHTML = "<b>Player ID: </b>" + (item.PlayerRemoteId ? item.PlayerRemoteId : "");
	                        var cell4 = row.insertCell(4);
	                        var css = enabled.indexOf(item.Status) > -1 ? "status-enabled" : "status-disabled";
	                        cell4.innerHTML = "<b>Result: </b>" + (item.Result ? item.Result : "") + "<br/><b>Status: </b><span class=\"" + css + "\">" + item.Status + "</span>";
	                        var cell5 = row.insertCell(5);
	                        cell5.innerHTML = "<b>Awarded: </b>" + item.RoundsAssigned + "<br/><b>Used: </b>" + item.RoundsPlayed + "<br/><b>Remaining: </b>" + item.PendingSpins;
	                        var cell6 = row.insertCell(6);
	                        cell6.innerHTML = "<b>Win amount: </b>" + item.TotalWin + " " + (item.CurrencyCode ? item.CurrencyCode : "") + "<br/><b>Currency: </b>" + (item.CurrencyCode ? item.CurrencyCode : "") + "<br/><b>Win pay method: </b>" + item.WinPayMethod;
	                    }
	                });
	                totalEntries.innerText = totalCount;
	                processing.hide();
	                enableRunButton();
	                statusMessage.hide();
	            },
	            error: function (jqXHR, textStatus, errorThrown) {
	                processing.hide();
	                enableRunButton();
	                displayMessage(jqXHR);
	            }
	        });
	    };
	    OfferDashboard.prototype.displayMessage = function (jqXHR) {
	        var statusMessageWrapper = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	        var statusMessageData = {
	            code: "500",
	            autoClose: false,
	            class: "danger",
	            message: "Unexpected error",
	            type: StatusMessage_1.StatusMessageType.Error
	        };
	        var statusMessage = new StatusMessage_1.StatusMessage(statusMessageData);
	        statusMessageWrapper.html(statusMessage.getHTMLmessage());
	        StatusMessageHelper_1.StatusMessageHelper.initValidator();
	        StatusMessageHelper_1.StatusMessageHelper.initSatusMessage();
	        statusMessageWrapper.show();
	    };
	    OfferDashboard.prototype.getTableBody = function () {
	        return document.getElementById("tableFreeRoundCampaign").getElementsByTagName("tbody")[0];
	    };
	    OfferDashboard.prototype.toggleSortDirection = function (e) {
	        var value = e.currentTarget.value;
	        if (value === "ASC") {
	            e.currentTarget.value = "DESC";
	        }
	        else {
	            e.currentTarget.value = "ASC";
	        }
	    };
	    OfferDashboard.prototype.checkBoxAll = function () {
	        var checkboxes = $("input[name='selectedFreeRound']");
	        for (var i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = this._checkAll[0].checked;
	        }
	    };
	    OfferDashboard.prototype.setSelectAllCheckbox = function () {
	        var checkboxes = $("input[name='selectedFreeRound']");
	        var selectAll = Utils_1.Utils.getJQueryById("selectAll")[0];
	        if (Utils_1.Utils.isNullOrUndefined(selectAll))
	            return;
	        var allCheckboxesChecked = false;
	        for (var i = 0; i < checkboxes.length; i++) {
	            allCheckboxesChecked = checkboxes[i].checked;
	            if (!allCheckboxesChecked)
	                break;
	        }
	        selectAll.checked = allCheckboxesChecked;
	    };
	    OfferDashboard.prototype.getBrowseRequest = function () {
	        var request = new FreeRoundBrowseRequest();
	        request.OfferId = this._filterOfferId.val();
	        request.CustomerId = this._filterCustomerId.isAllSelected() ? '' : this._filterCustomerId.getSelectionValues(FILTER_DELIM);
	        request.PlayerRemoteId = this._filterPlayerRemoteId.val();
	        request.RemoteId = this._filterRemoteId.val();
	        request.CurrencyId = this._filterCurrency.isAllSelected() ? '' : this._filterCurrency.getSelectionValues(FILTER_DELIM);
	        request.CampaignId = this._filterCampaignId.val();
	        request.CampaignName = this._filterCampaignName.val();
	        request.CampaignRemoteId = this._filterCampaignRemoteId.val();
	        request.WinPayMethods = this._filterWinPayMethods.isAllSelected() ? '' : this._filterWinPayMethods.getSelectionValues(FILTER_DELIM);
	        request.WinFrom = this._filterWinFrom.val();
	        request.WinTo = this._filterWinTo.val();
	        request.RoundsAssignedFrom = this._filterRoundsAssignedFrom.val();
	        request.RoundsAssignedTo = this._filterRoundsAssignedTo.val();
	        request.RoundsPlayedFrom = this._filterRoundsPlayedFrom.val();
	        request.RoundsPlayedTo = this._filterRoundsPlayedTo.val();
	        request.PendingSpinsFrom = this._filterPendingSpinsFrom.val();
	        request.PendingSpinsTo = this._filterPendingSpinsTo.val();
	        request.Result = this._filterResult.isAllSelected() ? '' : this._filterResult.getSelectionValues(FILTER_DELIM);
	        request.Status = this._filterStatus.isAllSelected() ? '' : this._filterStatus.getSelectionValues(FILTER_DELIM);
	        request.BatchSize = batchSize + 1;
	        request.Source = this._filterSource.val();
	        return request;
	    };
	    return OfferDashboard;
	}(PageBase_1.PageBase));
	exports.OfferDashboard = OfferDashboard;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 96 */
[172, 97],
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var tableId = 'tablePlayers';
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'f><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var IndexPage = (function (_super) {
	    __extends(IndexPage, _super);
	    function IndexPage(options) {
	        _super.call(this, options);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            columns: [
	                {
	                    data: 'Id',
	                    className: "bold",
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkName" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: "RemoteId",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCode" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "DisplayName",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCode" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "IsEnabled",
	                    render: function (data, type, rowData) {
	                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                        var css = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                    }
	                },
	                {
	                    data: '',
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkDetail" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + options.localizer.DetailsLink + "</a>");
	                    }
	                }
	            ]
	        };
	    }
	    IndexPage.prototype.init = function () {
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	    };
	    return IndexPage;
	}(PageBase_1.PageBase));
	exports.IndexPage = IndexPage;


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var IndexPage_1 = __webpack_require__(99);
	exports.IndexPage = IndexPage_1.IndexPage;
	var DetailPage_1 = __webpack_require__(100);
	exports.DetailPage = DetailPage_1.DetailPage;
	var DetailPage_2 = __webpack_require__(100);
	exports.BuildInformation = DetailPage_2.BuildInformation;
	var BuildDetailpage_1 = __webpack_require__(101);
	exports.BuildDetailPage = BuildDetailpage_1.BuildDetailPage;
	var GameBuildList_1 = __webpack_require__(102);
	exports.GameBuildListPage = GameBuildList_1.GameBuildListPage;


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var tableId = 'tableGames';
	var tableDom = "<'row'<'col-sm-6'><'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var IndexPage = (function (_super) {
	    __extends(IndexPage, _super);
	    function IndexPage(options) {
	        _super.call(this, options);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            pageLength: -1,
	            columns: [
	                {
	                    data: 'Name',
	                    className: "bold",
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkName" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: "Code",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCode" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "IsEnabled",
	                    render: function (data, type, rowData) {
	                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                        var css = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                    }
	                },
	                {
	                    data: '',
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkDetail" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + options.localizer.DetailsLink + "</a>");
	                    }
	                }
	            ]
	        };
	    }
	    IndexPage.prototype.init = function () {
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	    };
	    return IndexPage;
	}(PageBase_1.PageBase));
	exports.IndexPage = IndexPage;


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var Utils_1 = __webpack_require__(5);
	var DateUtils_1 = __webpack_require__(48);
	var StringUtils_1 = __webpack_require__(3);
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'f><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var buildTableDom = "<'row'<'col-sm-6'l><'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var DetailPage = (function (_super) {
	    __extends(DetailPage, _super);
	    function DetailPage(options) {
	        _super.call(this, options);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        this._tableId = "tableCustomerOperations";
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            autoFocusSearch: false,
	            columns: [
	                {
	                    data: "CustomerName",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCustomerName" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'CustomerOperationName',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnName" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'ModuleVersion',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnBuildVersion" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Currencies',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCurrencies" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "GameStatus",
	                    render: function (data, type, rowData) {
	                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                        var css = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                    }
	                },
	                {
	                    data: "ModuleDescription",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnDescription" + rowData.Id + "'>" + data + "</span>");
	                    }
	                }
	            ]
	        };
	    }
	    DetailPage.prototype.init = function () {
	        this._table = new Datatable_1.Datatable(this._tableId, this._tableOptions);
	    };
	    return DetailPage;
	}(PageBase_1.PageBase));
	exports.DetailPage = DetailPage;
	var BuildInformation = (function (_super) {
	    __extends(BuildInformation, _super);
	    function BuildInformation(options) {
	        _super.call(this, options);
	        this.removeSelected = this.removeSelected.bind(this);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.GameId + "/" + rowData.Version); };
	        this._tableId = "tableBuildInformation";
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: buildTableDom,
	            rowId: 'Version',
	            autoWidth: true,
	            autoFocusSearch: false,
	            ordering: false,
	            columns: [
	                {
	                    data: '',
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<input type='checkbox' name='selectedBuild' id='chckVersion" + rowData.Version + "' value='" + rowData.Version + "' />");
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "Version",
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkVersion" + rowData.Version + "' href='" + getDetailUrl(rowData) + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Hashes',
	                    render: function (data, type, rowData) {
	                        var md5 = "";
	                        var sha1 = "";
	                        var sha256 = "";
	                        if (data.hasOwnProperty("MD5")) {
	                            md5 = data['MD5'];
	                        }
	                        if (data.hasOwnProperty("SHA1")) {
	                            sha1 = data['SHA1'];
	                        }
	                        if (data.hasOwnProperty("SHA256")) {
	                            sha256 = data['SHA256'];
	                        }
	                        return "<table id='tblStringContent" + rowData.StringVersion + "' class='buildVersion-table'>\n                                <tr><td>" + options.localizer.MD5 + ": </td><td>" + md5 + "</td></tr>\n                                <tr><td>" + options.localizer.SHA1 + ": </td><td>" + sha1 + "</td></tr>\n                                <tr><td>" + options.localizer.SHA256 + ": </td><td>" + sha256 + "</td></tr>\n                          </table>";
	                    }
	                },
	                {
	                    data: 'Created',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCreated" + rowData.Version + "'>" + DateUtils_1.DateUtils.toDefaultWithTime(data) + "</span>");
	                    }
	                },
	                {
	                    data: 'BuiltOn',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCreated" + rowData.Version + "'>" + DateUtils_1.DateUtils.toDefaultWithTime(data) + "</span>");
	                    }
	                },
	                {
	                    data: 'Description',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnDescription" + rowData.Version + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "IsEnabled",
	                    render: function (data, type, rowData) {
	                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                        var css = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "IsValid",
	                    render: function (data, type, rowData) {
	                        var css = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + StringUtils_1.StringUtils.capitalizeFirstLetter(data.toString()) + "</span>";
	                    }
	                }
	            ]
	        };
	    }
	    BuildInformation.prototype.init = function () {
	        this._table = new Datatable_1.Datatable(this._tableId, this._tableOptions);
	        var btnRemove = Utils_1.Utils.getJQueryById("btnRemoveSelected");
	        btnRemove.on("click", this.removeSelected);
	    };
	    BuildInformation.prototype.removeSelected = function (e) {
	        e.preventDefault();
	        if (!confirm("Are you sure you want to remove selected builds?")) {
	            return;
	        }
	        var urlPost = this._options.urlPost;
	        var versions = $("input[name='selectedBuild']:checked").map(function () {
	            return $(this).val();
	        });
	        var versionsToRemove = versions.get();
	        if (!versionsToRemove || versionsToRemove.length === 0) {
	            return;
	        }
	        $.ajax({
	            url: urlPost,
	            type: "POST",
	            dataType: 'json',
	            data: { versions: versionsToRemove },
	            success: function (data) {
	                window.location.href = data;
	            }
	        });
	    };
	    return BuildInformation;
	}(PageBase_1.PageBase));
	exports.BuildInformation = BuildInformation;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'f><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var BuildDetailPage = (function (_super) {
	    __extends(BuildDetailPage, _super);
	    function BuildDetailPage(options) {
	        _super.call(this, options);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        this._tableId = "tableCustomerOperations";
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            autoFocusSearch: false,
	            columns: [
	                {
	                    data: "CustomerName",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCustomerName" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'CustomerOperationName',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnName" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Currencies',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCurrencies" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "GameStatus",
	                    render: function (data, type, rowData) {
	                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                        var css = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                    }
	                }
	            ]
	        };
	    }
	    BuildDetailPage.prototype.init = function () {
	        this._table = new Datatable_1.Datatable(this._tableId, this._tableOptions);
	    };
	    return BuildDetailPage;
	}(PageBase_1.PageBase));
	exports.BuildDetailPage = BuildDetailPage;


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var Utils_1 = __webpack_require__(5);
	var StringUtils_1 = __webpack_require__(3);
	var tableId = 'tableGameBuilds';
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var GameBuildListPage = (function (_super) {
	    __extends(GameBuildListPage, _super);
	    function GameBuildListPage(options) {
	        _super.call(this, options);
	        var getGameDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        var getGameBuildDetailUrl = function (rowData) { return (options.urlVersionDetail + "/" + rowData.Id + "/" + rowData.VersionString); };
	        this.filterLatestVersions = this.filterLatestVersions.bind(this);
	        this.preDrawCallback = this.preDrawCallback.bind(this);
	        this._latestVersionsFilter = null;
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            columns: [
	                {
	                    data: 'Name',
	                    className: "bold",
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkName" + rowData.Id + "' href='" + getGameDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: "Code",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCode" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "Version",
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkVersion" + rowData.Id + "' href='" + getGameBuildDetailUrl(rowData) + "'>" + rowData.VersionString + "</a>");
	                    }
	                },
	                {
	                    data: "Status",
	                    render: function (data, type, rowData) {
	                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                        var css = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "IsValid",
	                    render: function (data, type, rowData) {
	                        var css = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + StringUtils_1.StringUtils.capitalizeFirstLetter(data.toString()) + "</span>";
	                    }
	                },
	                {
	                    data: "Description",
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnDescription" + rowData.Id + "'>" + data + "</span>");
	                    }
	                }
	            ],
	            callbacks: {
	                drawCallback: function () { },
	                preDrawCallback: this.preDrawCallback
	            }
	        };
	    }
	    GameBuildListPage.prototype.init = function () {
	        var _this = this;
	        this._filterVersions = Utils_1.Utils.getJQueryById("filterVersionsCheckBox");
	        this._filterVersions.change(function (data) { return _this.filterLatestVersions(data); });
	        this._latestVersionsFilter = this._filterVersions[0].checked.toString();
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	    };
	    GameBuildListPage.prototype.filterLatestVersions = function (item) {
	        this._latestVersionsFilter = item.target.checked;
	        this._table.draw();
	    };
	    GameBuildListPage.prototype.preDrawCallback = function (datatable) {
	        datatable.search(this._latestVersionsFilter);
	        return true;
	    };
	    return GameBuildListPage;
	}(PageBase_1.PageBase));
	exports.GameBuildListPage = GameBuildListPage;


/***/ },
/* 103 */
[173, 104, 105],
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var tableId = 'tableChannels';
	var tableDom = "<'row'<'col-sm-6'><'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var IndexPage = (function (_super) {
	    __extends(IndexPage, _super);
	    function IndexPage(options) {
	        _super.call(this, options);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            pageLength: -1,
	            columns: [
	                {
	                    data: 'Name',
	                    className: "bold",
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkName" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: "Code",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCode" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "IsEnabled",
	                    render: function (data, type, rowData) {
	                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                        var css = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                    }
	                },
	                {
	                    data: '',
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkDetail" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + options.localizer.DetailsLink + "</a>");
	                    }
	                }
	            ]
	        };
	    }
	    IndexPage.prototype.init = function () {
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	    };
	    return IndexPage;
	}(PageBase_1.PageBase));
	exports.IndexPage = IndexPage;


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'f><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var DetailPage = (function (_super) {
	    __extends(DetailPage, _super);
	    function DetailPage(options) {
	        _super.call(this, options);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        if (options.dataSwitch === "CustomerOperation") {
	            this._tableId = "tableCustomerOperations";
	            this._tableOptions = {
	                url: this._options.urlList,
	                dom: tableDom,
	                rowId: 'Id',
	                autoWidth: true,
	                autoFocusSearch: false,
	                columns: [
	                    {
	                        data: "CustomerName",
	                        render: function (data, type, rowData) {
	                            return ("<span id='spnCustomerName" + rowData.Id + "'>" + data + "</span>");
	                        }
	                    },
	                    {
	                        data: 'Name',
	                        render: function (data, type, rowData) {
	                            return ("<span id='spnName" + rowData.Id + "'>" + data + "</span>");
	                        }
	                    },
	                    {
	                        data: "IsEnabled",
	                        render: function (data, type, rowData) {
	                            var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                            var css = data === true ? 'status-enabled' : 'status-disabled';
	                            return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                        }
	                    }
	                ]
	            };
	        }
	        if (options.dataSwitch === "Game") {
	            this._tableId = "tableGames";
	            this._tableOptions = {
	                url: this._options.urlList,
	                dom: tableDom,
	                rowId: 'Id',
	                autoWidth: true,
	                autoFocusSearch: false,
	                columns: [
	                    {
	                        data: 'Name',
	                        className: "bold",
	                        render: function (data, type, rowData) {
	                            return ("<a id='lnkName" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + data + "</a>");
	                        }
	                    },
	                    {
	                        data: "Code",
	                        render: function (data, type, rowData) {
	                            return ("<span id='spnCode" + rowData.Id + "'>" + data + "</span>");
	                        }
	                    },
	                    {
	                        data: "IsEnabled",
	                        render: function (data, type, rowData) {
	                            var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                            var css = data === true ? 'status-enabled' : 'status-disabled';
	                            return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                        }
	                    },
	                    {
	                        data: '',
	                        sortable: false,
	                        render: function (data, type, rowData) {
	                            return ("<a id='lnkDetail" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + options.localizer.DetailsLink + "</a>");
	                        }
	                    }
	                ]
	            };
	        }
	    }
	    DetailPage.prototype.init = function () {
	        this._table = new Datatable_1.Datatable(this._tableId, this._tableOptions);
	    };
	    return DetailPage;
	}(PageBase_1.PageBase));
	exports.DetailPage = DetailPage;


/***/ },
/* 106 */
[173, 107, 108],
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var tableId = 'tablePlatforms';
	var tableDom = "<'row'<'col-sm-6'><'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var IndexPage = (function (_super) {
	    __extends(IndexPage, _super);
	    function IndexPage(options) {
	        _super.call(this, options);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            pageLength: -1,
	            columns: [
	                {
	                    data: 'Name',
	                    className: "bold",
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkName" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: "IsEnabled",
	                    render: function (data, type, rowData) {
	                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                        var css = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                    }
	                },
	                {
	                    data: "Version",
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return "<span id='spnVersion" + rowData.Id + "'>" + rowData.Version + " " + rowData.AwaitingVersion + "</span>";
	                    }
	                },
	                {
	                    data: "FreeRoundBonusEnabled",
	                    render: function (data, type, rowData) {
	                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                        var statusCss = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnState" + rowData.Id + "' class='" + statusCss + "'>" + text + "</span>";
	                    }
	                },
	                {
	                    data: '',
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkDetail" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + options.localizer.DetailsLink + "</a>");
	                    }
	                }
	            ]
	        };
	    }
	    IndexPage.prototype.init = function () {
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	    };
	    return IndexPage;
	}(PageBase_1.PageBase));
	exports.IndexPage = IndexPage;


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var tableId = 'tableCustomers';
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'f><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var DetailPage = (function (_super) {
	    __extends(DetailPage, _super);
	    function DetailPage(options) {
	        _super.call(this, options);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            autoFocusSearch: false,
	            columns: [
	                {
	                    data: 'Name',
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkName" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: 'Code',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCode" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "IsEnabled",
	                    render: function (data, type, rowData) {
	                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                        var css = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                    }
	                },
	                {
	                    data: '',
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkDetail" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + options.localizer.DetailsLink + "</a>");
	                    }
	                }
	            ]
	        };
	    }
	    DetailPage.prototype.init = function () {
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	    };
	    return DetailPage;
	}(PageBase_1.PageBase));
	exports.DetailPage = DetailPage;


/***/ },
/* 109 */
[172, 110],
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var _ = __webpack_require__(7);
	var MultiSelect_1 = __webpack_require__(52);
	var DateTimePicker_1 = __webpack_require__(57);
	var Utils_1 = __webpack_require__(5);
	var DateUtils_1 = __webpack_require__(48);
	var StringUtils_1 = __webpack_require__(3);
	var StatusMessage_1 = __webpack_require__(61);
	var StatusMessageHelper_1 = __webpack_require__(50);
	var FILTER_DELIM = '-delim-';
	var batchSize = 100;
	var RequestLogBrowseRequest = (function () {
	    function RequestLogBrowseRequest() {
	    }
	    return RequestLogBrowseRequest;
	}());
	var IndexPage = (function () {
	    function IndexPage(options) {
	        this._options = options;
	        this.run = this.run.bind(this);
	        this.showLoadMoreButton = this.showLoadMoreButton.bind(this);
	        this.hideLoadMoreButton = this.hideLoadMoreButton.bind(this);
	        this.enableRunButton = this.enableRunButton.bind(this);
	        this.loadMore = this.loadMore.bind(this);
	        this.resetFilter = this.resetFilter.bind(this);
	        this.renderDetailRow = this.renderDetailRow.bind(this);
	        this.renderContextData = this.renderContextData.bind(this);
	        this.getCountResult = this.getCountResult.bind(this);
	        this.toggleDetail = this.toggleDetail.bind(this);
	        this._runButton = Utils_1.Utils.getJQueryById("btnRunQuery");
	        this._runButton.on("click", this.run);
	        this._loadMoreButton = Utils_1.Utils.getJQueryById("btnLoadMore");
	        this._loadMoreButton.on("click", this.loadMore);
	        this._resetFilterButton = Utils_1.Utils.getJQueryById("btnResetFilter");
	        this._resetFilterButton.on("click", this.resetFilter);
	        this._btnCountResult = Utils_1.Utils.getJQueryById("btnCountResult");
	        this._btnCountResult.on("click", this.getCountResult);
	        this._totalEntries = Utils_1.Utils.getJQueryById("totalEntries");
	        this._processing = Utils_1.Utils.getJQueryById("processing");
	        this._filterId = Utils_1.Utils.getJQueryById('filterId');
	        this._filterPlayerId = Utils_1.Utils.getJQueryById('filterPlayer');
	        this._filterPlayerSessionId = Utils_1.Utils.getJQueryById('filterPlayerSession');
	        this._filterGameRoundId = Utils_1.Utils.getJQueryById('filterGameRound');
	        this._filterGame = new MultiSelect_1.MultiSelectApi('filterGame');
	        this._filterCustomer = new MultiSelect_1.MultiSelectApi('filterCustomer');
	        this._filterCustomerOperation = new MultiSelect_1.MultiSelectApi('filterCustomerOperation');
	        this._filterCreatedFrom = new DateTimePicker_1.DateTimePickerApi('filterCreatedFrom');
	        this._filterCreatedTo = new DateTimePicker_1.DateTimePickerApi('filterCreatedTo');
	        this._filterDurationFrom = Utils_1.Utils.getJQueryById('filterDurationFrom');
	        this._filterDurationTo = Utils_1.Utils.getJQueryById('filterDurationTo');
	        this._filterIpAddress = Utils_1.Utils.getJQueryById('filterIpAddress');
	        this._filterHostname = Utils_1.Utils.getJQueryById('filterHostName');
	        this._filterSource = new MultiSelect_1.MultiSelectApi('filterSource');
	        this._filterStatus = Utils_1.Utils.getJQueryById('filterStatus');
	        this._filterRequestReference = Utils_1.Utils.getJQueryById('filterRequestReference');
	        this._filterAction = Utils_1.Utils.getJQueryById('filterAction');
	        this._filterErrorId = Utils_1.Utils.getJQueryById('filterErrorId');
	        this._filterResult = new MultiSelect_1.MultiSelectApi('filterResult');
	    }
	    IndexPage.prototype.run = function () {
	        this.disableRunButton();
	        var totalEntries = this._totalEntries[0];
	        totalEntries.innerText = "##";
	        this._currentRequest = this.getBrowseRequest();
	        var table = this.getTableBody();
	        table.innerHTML = "";
	        this.sendRequest(this._currentRequest);
	    };
	    IndexPage.prototype.getTableBody = function () {
	        return document.getElementById("tableRequestLogs").getElementsByTagName("tbody")[0];
	    };
	    IndexPage.prototype.getBrowseRequest = function () {
	        var request = new RequestLogBrowseRequest();
	        request.Id = this._filterId.val();
	        request.PlayerId = this._filterPlayerId.val();
	        request.PlayerSessionId = this._filterPlayerSessionId.val();
	        request.GameRoundId = this._filterGameRoundId.val();
	        request.Game = this._filterGame.isAllSelected() ? '' : this._filterGame.getSelectionValues(FILTER_DELIM);
	        request.Customer = this._filterCustomer.isAllSelected() ? '' : this._filterCustomer.getSelectionValues(FILTER_DELIM);
	        request.CustomerOperation = this._filterCustomerOperation.isAllSelected() ? '' : this._filterCustomerOperation.getSelectionValues(FILTER_DELIM);
	        request.TimestampFrom = this._filterCreatedFrom.getUnixTimestamp();
	        request.TimestampTo = this._filterCreatedTo.getUnixTimestamp();
	        request.DurationFrom = this._filterDurationFrom.val();
	        request.DurationTo = this._filterDurationTo.val();
	        request.IpAddress = this._filterIpAddress.val();
	        request.Hostname = this._filterHostname.val();
	        request.Source = this._filterSource.isAllSelected() ? '' : this._filterSource.getSelectionValues(FILTER_DELIM);
	        request.Status = this._filterStatus.val();
	        request.RequestReference = this._filterRequestReference.val();
	        request.Action = this._filterAction.val();
	        request.ErrorId = this._filterErrorId.val();
	        request.Result = this._filterResult.isAllSelected() ? '' : this._filterResult.getSelectionValues(FILTER_DELIM);
	        request.BatchSize = batchSize + 1;
	        return request;
	    };
	    IndexPage.prototype.sendRequest = function (request) {
	        var urlList = this._options.urlList;
	        var table = this.getTableBody();
	        var showLoadMore = this.showLoadMoreButton;
	        var hideLoadMore = this.hideLoadMoreButton;
	        var enableRunButton = this.enableRunButton;
	        var processing = this._processing;
	        var displayMessage = this.displayMessage;
	        var renderDetailRow = this.renderDetailRow;
	        var toggleDetail = this.toggleDetail;
	        var jsonData = JSON.stringify(request);
	        processing.show();
	        $.ajax({
	            url: urlList,
	            type: "POST",
	            dataType: 'json',
	            contentType: "application/json",
	            data: jsonData,
	            success: function (data) {
	                var items = data;
	                if (items.length < batchSize + 1) {
	                    hideLoadMore();
	                }
	                else {
	                    request.LastId = items[batchSize].Id;
	                    showLoadMore();
	                }
	                $.each(items, function (index, item) {
	                    if (index < batchSize) {
	                        var row_1 = table.insertRow(-1);
	                        row_1.id = "requestLog" + item.Id;
	                        row_1.className = "cursor-pointer";
	                        row_1.onclick = function () { return toggleDetail(row_1.id); };
	                        var cell0 = row_1.insertCell(0);
	                        var errorId = Utils_1.Utils.isNullOrUndefined(item.ErrorId) ? '' : item.ErrorId;
	                        cell0.innerHTML = item.Id + "<br /> <a id='lnkName" + errorId + "' href='Logs/Detail/" + errorId + "'>" + errorId + "</a>";
	                        cell0.className = "log-level-" + item.Result.toLowerCase();
	                        var cell1 = row_1.insertCell(1);
	                        cell1.innerHTML = "<b>Player: </b>" + item.PlayerId + "<br /><b>Session: </b>" + item.PlayerSessionId;
	                        var cell2 = row_1.insertCell(2);
	                        cell2.innerHTML = "<b>Customer: </b>" + item.CustomerCode + "<br /><b>Operation: </b>" + item.OperationCode;
	                        var cell3 = row_1.insertCell(3);
	                        var gameRoundId = Utils_1.Utils.isNullOrUndefined(item.GameRoundId) || item.GameRoundId === 0 ? '' : item.GameRoundId;
	                        cell3.innerHTML = "<b>Game: </b>" + item.GameCode + "<br /><b>Round ID: </b>" + gameRoundId;
	                        var cell4 = row_1.insertCell(4);
	                        cell4.innerHTML = "" + item.Created;
	                        var cell5 = row_1.insertCell(5);
	                        cell5.innerHTML = "" + item.Duration;
	                        var cell6 = row_1.insertCell(6);
	                        cell6.innerHTML = "" + item.IpAddress;
	                        var cell7 = row_1.insertCell(7);
	                        cell7.innerHTML = "<b>Status: </b>" + item.Status + "<br /><b>Result: </b>" + item.Result;
	                        var cell8 = row_1.insertCell(8);
	                        cell8.innerHTML = "" + item.HostName;
	                        var cell9 = row_1.insertCell(9);
	                        cell9.innerHTML = "" + item.Source;
	                        var cell10 = row_1.insertCell(10);
	                        cell10.innerHTML = "" + item.Action;
	                        var detailRow = table.insertRow(-1);
	                        detailRow.setAttribute("style", "display: none");
	                        detailRow.id = "requestLog" + item.Id + "detail";
	                        var detailCell = detailRow.insertCell(0);
	                        detailCell.colSpan = 11;
	                        detailCell.innerHTML = renderDetailRow(item);
	                    }
	                });
	                processing.hide();
	                enableRunButton();
	            },
	            error: function (jqXHR, textStatus, errorThrown) {
	                processing.hide();
	                enableRunButton();
	                displayMessage(jqXHR);
	            }
	        });
	    };
	    IndexPage.prototype.showLoadMoreButton = function () {
	        this._loadMoreButton.removeClass("display-none");
	    };
	    IndexPage.prototype.hideLoadMoreButton = function () {
	        this._loadMoreButton.addClass("display-none");
	    };
	    IndexPage.prototype.loadMore = function () {
	        this.sendRequest(this._currentRequest);
	    };
	    IndexPage.prototype.disableRunButton = function () {
	        this._runButton.attr("disabled", 1);
	    };
	    IndexPage.prototype.enableRunButton = function () {
	        this._runButton.removeAttr("disabled");
	    };
	    IndexPage.prototype.resetFilter = function () {
	        this._filterId.val('');
	        this._filterPlayerId.val('');
	        this._filterPlayerSessionId.val('');
	        this._filterGameRoundId.val('');
	        this._filterGame.selectAll();
	        this._filterCustomer.selectAll();
	        this._filterCustomerOperation.selectAll();
	        var createdFrom = DateUtils_1.DateUtils.getUtcMoment().subtract(7, 'days').set({ hours: 0, minutes: 0, seconds: 0 });
	        this._filterCreatedFrom.setUTCDate(createdFrom);
	        var createdTo = DateUtils_1.DateUtils.getUtcMoment().endOf('day');
	        this._filterCreatedTo.setUTCDate(createdTo);
	        this._filterDurationFrom.val('');
	        this._filterDurationTo.val('');
	        this._filterIpAddress.val('');
	        this._filterHostname.val('');
	        this._filterSource.selectAll();
	        this._filterStatus.val('');
	        this._filterRequestReference.val('');
	        this._filterAction.val('');
	        this._filterErrorId.val('');
	        this._filterResult.selectAll();
	    };
	    IndexPage.prototype.displayMessage = function (jqXHR) {
	        var statusMessageWrapper = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	        var statusMessageData = {
	            code: jqXHR.status.toString(),
	            autoClose: false,
	            class: "danger",
	            message: jqXHR.statusText,
	            type: StatusMessage_1.StatusMessageType.Error
	        };
	        var statusMessage = new StatusMessage_1.StatusMessage(statusMessageData);
	        statusMessageWrapper.html(statusMessage.getHTMLmessage());
	        StatusMessageHelper_1.StatusMessageHelper.initValidator();
	        StatusMessageHelper_1.StatusMessageHelper.initSatusMessage();
	    };
	    IndexPage.prototype.toggleDetail = function (id) {
	        var detailId = id + "detail";
	        var detailRow = document.getElementById(detailId);
	        if (detailRow.hasAttribute("style")) {
	            detailRow.removeAttribute("style");
	        }
	        else {
	            detailRow.setAttribute("style", "display: none");
	        }
	    };
	    IndexPage.prototype.renderDetailRow = function (data) {
	        var css = 'info';
	        if (data.Result === 'Warning') {
	            css = 'warning';
	        }
	        if (data.Result === 'Error') {
	            css = 'danger';
	        }
	        var result = "<div class='note note-" + css + "'>";
	        if (!StringUtils_1.StringUtils.isNullOrEmpty(data.ContextData)) {
	            result += "<h5>Context</h5>\n                    <p>" + this.renderContextData(data.ContextData) + "</p>\n                    <p>&nbsp;</p>";
	        }
	        if (!StringUtils_1.StringUtils.isNullOrEmpty(data.ExceptionData)) {
	            result += "<h5>Exception</h5>\n                    <p class=\"errorLogContextData\">" + _.escape(data.ExceptionData) + "</p>\n                    <p>&nbsp;</p>";
	        }
	        if (!StringUtils_1.StringUtils.isNullOrEmpty(data.RequestData)) {
	            result += "<h5>Request</h5>\n                    <p class=\"errorLogContextData\">" + _.escape(data.RequestData) + "</p>\n                    <p>&nbsp;</p>";
	        }
	        if (!StringUtils_1.StringUtils.isNullOrEmpty(data.ResponseData)) {
	            result += "<h5>Response</h5>\n                    <p class=\"errorLogContextData\">" + _.escape(data.ResponseData) + "</p>\n                    <p>&nbsp;</p>";
	        }
	        if (!StringUtils_1.StringUtils.isNullOrEmpty(data.RequestReference)) {
	            result += "<h5>Request reference</h5>\n                    <p class=\"errorLogContextData\">" + _.escape(data.RequestReference) + "</p>\n                    <p>&nbsp;</p>";
	        }
	        result += '</div>';
	        return result;
	    };
	    IndexPage.prototype.renderContextData = function (contextData) {
	        var json = null;
	        try {
	            json = JSON.parse(contextData);
	        }
	        catch (e) {
	            json = null;
	        }
	        var result = '';
	        if (json === null || !_.isArray(json)) {
	            result = contextData;
	        }
	        else {
	            result = '<table class="errorLogContextData table-bordered table-hover">';
	            _.each(json, function (item) {
	                for (var key in item) {
	                    result += "<tr><td>" + key + "</td><td>" + StringUtils_1.StringUtils.escapeHtml(item[key]) + "</td></tr>";
	                }
	            });
	            result += '</table>';
	        }
	        return result;
	    };
	    IndexPage.prototype.getCountResult = function () {
	        var request = Utils_1.Utils.isNullOrUndefined(this._currentRequest) ? this.getBrowseRequest() : this._currentRequest;
	        var urlCount = this._options.urlCount;
	        var totalEntries = this._totalEntries[0];
	        var processing = this._processing;
	        var displayMessage = this.displayMessage;
	        var jsonData = JSON.stringify(request);
	        processing.show();
	        $.ajax({
	            url: urlCount,
	            type: "POST",
	            dataType: 'json',
	            contentType: "application/json",
	            data: jsonData,
	            success: function (data) {
	                totalEntries.innerText = data;
	                processing.hide();
	            },
	            error: function (jqXHR, textStatus, errorThrown) {
	                processing.hide();
	                displayMessage(jqXHR);
	            }
	        });
	    };
	    return IndexPage;
	}());
	exports.IndexPage = IndexPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ResultPage_1 = __webpack_require__(112);
	exports.ResultPage = ResultPage_1.ResultPage;
	var SettingsPage_1 = __webpack_require__(113);
	exports.SettingsPage = SettingsPage_1.SettingsPage;
	var BuildSelectionPage_1 = __webpack_require__(114);
	exports.BuildSelectionPage = BuildSelectionPage_1.BuildSelectionPage;
	exports.BuildSelectorPage = BuildSelectionPage_1.BuildSelectorPage;


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var _ = __webpack_require__(7);
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var MultiSelect_1 = __webpack_require__(52);
	var Utils_1 = __webpack_require__(5);
	var StringUtils_1 = __webpack_require__(3);
	var tableDom = "<'row'<'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var tableId = 'tableConfigurationImportResult';
	var FILTER_DELIM = '-delim-';
	var COLUMNS_INDEX = {
	    CustomerCode: 0,
	    OperationCode: 1,
	    CurrencyCode: 2,
	    GameCode: 3,
	    Result: 4
	};
	var ResultPage = (function (_super) {
	    __extends(ResultPage, _super);
	    function ResultPage(options) {
	        _super.call(this, options);
	        this._detailRowsIds = [];
	        this.createdRow = this.createdRow.bind(this);
	        this.renderDetailRow = this.renderDetailRow.bind(this);
	        this.preDrawCallback = this.preDrawCallback.bind(this);
	        this.formSubmit = this.formSubmit.bind(this);
	        this.cancelSearch = this.cancelSearch.bind(this);
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: false,
	            pageLength: -1,
	            fixedHeader: {
	                header: true,
	                headerOffset: 50
	            },
	            order: [4, "asc"],
	            columns: [
	                {
	                    data: "CustomerCode"
	                },
	                {
	                    data: "OperationCode"
	                },
	                {
	                    data: "CurrencyCode"
	                },
	                {
	                    data: "GameCode"
	                },
	                {
	                    data: "Result"
	                },
	                {
	                    data: "GameVariant",
	                    defaultContent: ''
	                },
	                {
	                    data: "Rtp",
	                    defaultContent: ''
	                },
	                {
	                    data: "BuildVersion",
	                    defaultContent: ''
	                }
	            ],
	            rowDetail: {
	                hasDetail: true,
	                render: this.renderDetailRow
	            },
	            callbacks: {
	                preDrawCallback: this.preDrawCallback,
	                createdRow: this.createdRow
	            }
	        };
	    }
	    ResultPage.prototype.init = function () {
	        this._form = Utils_1.Utils.getJQueryById("formConfigurationImportResult");
	        this._btnCancelSearch = Utils_1.Utils.getJQueryById('btnCancelSearch');
	        this._filterCustomers = new MultiSelect_1.MultiSelectApi("filterCustomers");
	        this._filterOperations = new MultiSelect_1.MultiSelectApi("filterOperations");
	        this._filterCurrencies = new MultiSelect_1.MultiSelectApi("filterCurrencies");
	        this._filterGames = new MultiSelect_1.MultiSelectApi("filterGames");
	        this._filterResults = new MultiSelect_1.MultiSelectApi("filterResults");
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	        this._form.on('submit', this.formSubmit);
	        this._btnCancelSearch.on('click', this.cancelSearch);
	    };
	    ResultPage.prototype.formSubmit = function (e) {
	        e.preventDefault();
	        this._table.draw();
	        return false;
	    };
	    ResultPage.prototype.cancelSearch = function (e) {
	        this._filterCustomers.selectAll();
	        this._filterOperations.selectAll();
	        this._filterCurrencies.selectAll();
	        this._filterGames.selectAll();
	        this._filterResults.selectAll();
	    };
	    ResultPage.prototype.preDrawCallback = function (datatable) {
	        var filterCustomer = this._filterCustomers.isAllSelected() ? '' : this._filterCustomers.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.CustomerCode).search(filterCustomer);
	        var filterOperations = this._filterOperations.isAllSelected() ? '' : this._filterOperations.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.OperationCode).search(filterOperations);
	        var filterCurrency = this._filterCurrencies.isAllSelected() ? '' : this._filterCurrencies.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.CurrencyCode).search(filterCurrency);
	        var filterGame = this._filterGames.isAllSelected() ? '' : this._filterGames.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.GameCode).search(filterGame);
	        var filterResult = this._filterResults.isAllSelected() ? '' : this._filterResults.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.Result).search(filterResult);
	    };
	    ResultPage.prototype.createdRow = function (row, data, dataIndex) {
	        $('td', row).addClass('cursor-pointer');
	        if (data["Result"] === "Failed") {
	            $(row).addClass('error-log-row');
	        }
	    };
	    ResultPage.prototype.renderDetailRow = function (data) {
	        var result = '';
	        if (!StringUtils_1.StringUtils.isNullOrEmpty(data.Error)) {
	            result = "<div class='note note-danger'>\n                    <h5>Exception</h5>\n                    <p class=\"errorLogContextData\">" + _.escape(data.Error) + "</p>\n                    <p>&nbsp;</p>\n                    </div>";
	        }
	        else {
	            result = "<div class='note'>\n                    <p class=\"jsonContextData\">" + _.escape(JSON.stringify(JSON.parse(data.Configuration))) + "</p>\n                    <p>&nbsp;</p>\n                    </div>";
	        }
	        return result;
	    };
	    return ResultPage;
	}(PageBase_1.PageBase));
	exports.ResultPage = ResultPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var _ = __webpack_require__(7);
	var PageBase_1 = __webpack_require__(67);
	var TreeView_1 = __webpack_require__(59);
	var Modal_1 = __webpack_require__(60);
	var Utils_1 = __webpack_require__(5);
	var FileUtils_1 = __webpack_require__(9);
	var UriHelper_1 = __webpack_require__(8);
	var SettingsPage = (function (_super) {
	    __extends(SettingsPage, _super);
	    function SettingsPage(options) {
	        _super.call(this, options);
	        this.handleCustomerTreeInit = this.handleCustomerTreeInit.bind(this);
	        this.handleCustomerTreeRenderNode = this.handleCustomerTreeRenderNode.bind(this);
	        this.handleCustomerTreeGetIcon = this.handleCustomerTreeGetIcon.bind(this);
	        this.handleCustomerTreeAcceptSelection = this.handleCustomerTreeAcceptSelection.bind(this);
	        this.handleCustomerTreeSelectAll = this.handleCustomerTreeSelectAll.bind(this);
	        this.handleGamesTreeRenderNode = this.handleGamesTreeRenderNode.bind(this);
	        this.handleGamesTreeGetIcon = this.handleGamesTreeGetIcon.bind(this);
	        this.handleGamesTreeSelectAll = this.handleGamesTreeSelectAll.bind(this);
	        this.handleGameListInfoClick = this.handleGameListInfoClick.bind(this);
	        this._urlGameList = this._options.urlGameList;
	        this._treeCustomers_processing = Utils_1.Utils.getJQueryById("treeCustomers_processing");
	        this._treeGames_processing = Utils_1.Utils.getJQueryById("treeGames_processing");
	    }
	    SettingsPage.prototype.init = function () {
	        this._elemSelectAllCustomerTree = $('#chSelectAllCustomerTree');
	        this._elemSelectAllCustomerTree.on('change', this.handleCustomerTreeSelectAll);
	        this._elemSelectAllGamesTree = $('#chSelectAllGames');
	        this._elemSelectAllGamesTree.on('change', this.handleGamesTreeSelectAll);
	        $("#radioImportEnabled").on("click", this.enableDisableSetValidity);
	        $("#radioImportDisabled").on("click", this.enableDisableSetValidity);
	        this.enableDisableSetValidity();
	        this._gameListModal = new Modal_1.ModalApi('gameListModal');
	        var treeCustomers_processing = this._treeCustomers_processing;
	        var treeGames_processing = this._treeGames_processing;
	        this._treeCustomers = TreeView_1.TreeView.get('treeCustomers');
	        this._treeCustomers.onInit = this.handleCustomerTreeInit;
	        this._treeCustomers.onRenderNode = this.handleCustomerTreeRenderNode;
	        this._treeCustomers.onAcceptSelection = this.handleCustomerTreeAcceptSelection;
	        this._treeCustomers.options.icon = this.handleCustomerTreeGetIcon;
	        this._treeCustomers.initialize();
	        treeCustomers_processing.hide();
	        this._treeGames = TreeView_1.TreeView.get('treeGames');
	        this._treeGames.onRenderNode = this.handleGamesTreeRenderNode;
	        this._treeGames.options.icon = this.handleGamesTreeGetIcon;
	        this._treeGames.initialize();
	        treeGames_processing.hide();
	    };
	    SettingsPage.prototype.enableDisableSetValidity = function () {
	        $('#setValidSelector').find("*").prop("disabled", $("#radioImportDisabled").prop('checked'));
	    };
	    SettingsPage.prototype.handleCustomerTreeInit = function (event, data) {
	        this._treeCustomers.collapseAll();
	    };
	    SettingsPage.prototype.handleCustomerTreeRenderNode = function (event, data) {
	        var node = data.node.fancyNode;
	        var metadata = node.data.metadata;
	        var isCurrency = metadata.type === 'Currency';
	        if (isCurrency) {
	            var unselectable = node.unselectable;
	            var style = 'color: cadetblue; padding-left: 5px; cursor: pointer;';
	            var info_span = $("<span class=\"glyphicon glyphicon-info-sign\" data-key='" + node.key + "' style='" + style + "' title='Show game list info...'></span>");
	            var node_span = $(node.span);
	            info_span.appendTo(node_span);
	            info_span.on('click', this.handleGameListInfoClick);
	        }
	        if (metadata.status === 'Closed') {
	            TreeView_1.TreeView.updateNodeStrikeThrough(node, true);
	            return;
	        }
	        if (metadata.isDefined === false && metadata.status !== 'Closed') {
	            TreeView_1.TreeView.updateNodeDisabled(node, true);
	            return;
	        }
	    };
	    SettingsPage.prototype.handleCustomerTreeAcceptSelection = function (node) {
	        return node.fancyNode.data.metadata.type === 'Currency';
	    };
	    SettingsPage.prototype.handleCustomerTreeGetIcon = function (event, data) {
	        if (event.type === 'icon') {
	            var type = data.node.data.metadata.type;
	            var status = data.node.data.metadata.status;
	            var isDisabled = status === 'Disabled';
	            if (type === 'Customer') {
	                return 'fa fa-folder-open';
	            }
	            else if (type === 'Operation') {
	                return 'fa fa-barcode';
	            }
	            else if (type === 'Currency') {
	                return 'fa ' + (isDisabled ? 'fa-exclamation' : 'fa-file-o');
	            }
	        }
	        return undefined;
	    };
	    SettingsPage.prototype.handleCustomerTreeSelectAll = function () {
	        var selectAll = this._elemSelectAllCustomerTree.is(':checked');
	        this._treeCustomers.visit(function (node) {
	            var isCurrency = node.data.metadata.type === 'Currency';
	            if (isCurrency) {
	                node.setSelected(selectAll);
	            }
	        });
	    };
	    SettingsPage.prototype.handleGamesTreeRenderNode = function (event, data) {
	        var node = data.node.fancyNode;
	        var metadata = node.data.metadata;
	        if (metadata.isDefined === false) {
	            TreeView_1.TreeView.updateNodeDisabled(node, true);
	            return;
	        }
	    };
	    SettingsPage.prototype.handleGameListInfoClick = function (e) {
	        var nodeKey = $(e.target).attr('data-key');
	        this.showGameListModal(nodeKey);
	    };
	    SettingsPage.prototype.handleGamesTreeGetIcon = function (event, data) {
	        if (event.type === 'icon') {
	            return 'fa fa-gamepad';
	        }
	        return undefined;
	    };
	    SettingsPage.prototype.handleGamesTreeSelectAll = function () {
	        var selectAll = this._elemSelectAllGamesTree.is(':checked');
	        this._treeGames.selectAll(selectAll);
	    };
	    SettingsPage.prototype.showGameListModal = function (nodeKey) {
	        var self = this;
	        var keyValues = nodeKey.split('-');
	        var urlData = {
	            customerCode: keyValues[0],
	            operationCode: keyValues[1],
	            currencyCode: keyValues[2]
	        };
	        var url = UriHelper_1.UriHelper.setQueryString(this._urlGameList, urlData);
	        function updateModalBody(entries) {
	            var currencyNode = self._treeCustomers.getNodeByKey(nodeKey);
	            var operationNode = currencyNode.parent;
	            var customerNode = operationNode.parent;
	            var info = {
	                customerCode: customerNode.title + " (" + urlData.customerCode + ")",
	                operationCode: operationNode.title + " (" + urlData.operationCode + ")",
	                currencyCode: currencyNode.title + " (" + urlData.currencyCode + ")"
	            };
	            var html = GameList.render(info, entries);
	            self._gameListModal.updateBody(html);
	            self._gameListModal.show();
	        }
	        this._gameListModal.hide();
	        FileUtils_1.FileUtils.jsonPost(url)
	            .then(function (json) {
	            if (json) {
	                updateModalBody(json);
	            }
	        })
	            .catch(function (err) {
	            alert('Failed to get data');
	            console.error(err);
	        });
	    };
	    return SettingsPage;
	}(PageBase_1.PageBase));
	exports.SettingsPage = SettingsPage;
	var GameList = (function () {
	    function GameList() {
	    }
	    GameList.render = function (info, entries) {
	        var hasEntries = entries && _.isArray(entries) && entries.length > 0;
	        var infoHtml = GameList.renderInfo(info);
	        var content = $('<div/>', { style: 'height: 300px; overflow-y: auto; overflow-x: hidden;' });
	        if (hasEntries) {
	            GameList.renderListHeader(content);
	            _.each(entries, function (entry) {
	                GameList.renderListRow(content, entry);
	            });
	        }
	        else {
	            content.append('<b>Game list is empty.</b>');
	        }
	        return infoHtml + content.prop('outerHTML');
	    };
	    GameList.renderInfo = function (info) {
	        return $('<div/>').append($("<div class=\"row\">\n                    <div class=\"col-md-2\"><b>Customer:</b></div><div class=\"col-md-10\">" + info.customerCode + "</div>\n               </div>\n                <div class=\"row\">\n                    <div class=\"col-md-2\"><b>Operation:</b></div><div class=\"col-md-10\">" + info.operationCode + "</div>\n               </div>\n                <div class=\"row\">\n                    <div class=\"col-md-2\"><b>Currency:</b></div><div class=\"col-md-10\">" + info.currencyCode + "</div>\n               </div>\n                <p></p>")).html();
	    };
	    GameList.renderListHeader = function (parent) {
	        parent.append($("<div class=\"row\" style=\"background-color: silver; padding: 2px; font-weight: bold;\">\n                    <div class=\"col-md-4\">Game name</div>\n                    <div class=\"col-md-4\">Game code</div>\n                    <div class=\"col-md-4\">Game variant</div>\n               </div>"));
	    };
	    GameList.renderListRow = function (parent, entry) {
	        parent.append($("<div class=\"row\" style=\"padding: 2px;\">\n                    <div class=\"col-md-4\">" + entry.GameName + "</div>\n                    <div class=\"col-md-4\">" + entry.GameCode + "</div>\n                    <div class=\"col-md-4\">" + entry.GameVariant + "</div>\n               </div>"));
	    };
	    return GameList;
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var MultiSelect_1 = __webpack_require__(52);
	var Utils_1 = __webpack_require__(5);
	var DateUtils_1 = __webpack_require__(48);
	var StringUtils_1 = __webpack_require__(3);
	var tableId = 'tableGameBuildConfigurations';
	var buildSelectorTableId = 'tableBuildSelector';
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var hashTypes = ["MD5", "SHA1", "SHA256"];
	var COLUMN_INDEX = {
	    GameCode: 1,
	    Operation: 2,
	    GameStatus: 3
	};
	var selectedType;
	var FILTER_DELIM = '-delim-';
	var selectedName;
	var BuildSelectionPage = (function (_super) {
	    __extends(BuildSelectionPage, _super);
	    function BuildSelectionPage(options) {
	        var _this = this;
	        _super.call(this, options);
	        selectedType = options.defaultHashButton;
	        this.showMd5 = this.showMd5.bind(this);
	        this.showSha1 = this.showSha1.bind(this);
	        this.showSha256 = this.showSha256.bind(this);
	        this.drawCallback = this.drawCallback.bind(this);
	        this.formSubmit = this.formSubmit.bind(this);
	        this.cancelSearch = this.cancelSearch.bind(this);
	        this.preDrawCallback = this.preDrawCallback.bind(this);
	        this.detectSelectedGame = this.detectSelectedGame.bind(this);
	        this.showBuildSelector = this.showBuildSelector.bind(this);
	        this.checkBoxAll = this.checkBoxAll.bind(this);
	        this.displayHash = this.displayHash.bind(this);
	        window['detectSelectedGame'] = this.detectSelectedGame;
	        window['setBuildsSelectAllCheckbox'] = this.setBuildsSelectAllCheckbox;
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            columns: [
	                {
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<input id='chckbx" + rowData.Id + "' name='selectedBuild' value='" + rowData.Id + "' type='checkbox' onchange=detectSelectedGame() onClick=\"setBuildsSelectAllCheckbox()\" />");
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "GameCode",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnGameCode" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "CustomerOperationCode",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCustomerOperationCode" + rowData.Id + "'>" + rowData.CustomerCode + " | " + data + "</span>");
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "GameStatus",
	                    render: function (data, type, rowData) {
	                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                        var css = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnGameStatus" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "SelectedModuleVersion",
	                    render: function (data, type, rowData) {
	                        var manifest = JSON.parse(rowData.SelectedStringContent);
	                        var file = manifest.Files[0];
	                        var md5 = "";
	                        var sha1 = "";
	                        var sha256 = "";
	                        if (file.Hashes.hasOwnProperty("MD5")) {
	                            md5 = file.Hashes['MD5'];
	                        }
	                        if (file.Hashes.hasOwnProperty("SHA1")) {
	                            sha1 = file.Hashes['SHA1'];
	                        }
	                        if (file.Hashes.hasOwnProperty("SHA256")) {
	                            sha256 = file.Hashes['SHA256'];
	                        }
	                        return "<span class='buildVersion-format' id='spnSelectedModuleVersion" + rowData.Id + "'>" + data + "</span>\n                          <span id='spnSelectedModuleVersionMd5Hash' name=\"md5hash\" class=\"hash-format\" title=\"" + md5 + "\">" + _this.shortHash(md5) + "</span>\n                          <span id='spnSelectedModuleVersionSha1Hash' name=\"sha1hash\" class=\"hash-format\" title=\"" + sha1 + "\">" + _this.shortHash(sha1) + "</span>\n                          <span id='spnSelectedModuleVersionSha256Hash' name=\"sha256hash\" class=\"hash-format\" title=\"" + sha256 + "\">" + _this.shortHash(sha256) + "</span>";
	                    }
	                },
	                {
	                    orderable: false,
	                    data: 'filterButtons',
	                    defaultContent: '',
	                    searchable: false,
	                    sortable: false
	                }
	            ],
	            callbacks: {
	                drawCallback: this.drawCallback,
	                preDrawCallback: this.preDrawCallback
	            }
	        };
	    }
	    BuildSelectionPage.prototype.init = function () {
	        this._form = Utils_1.Utils.getJQueryById("formGameBuilConfigurations");
	        this._btnCancelSearch = Utils_1.Utils.getJQueryById("btnCancelSearch");
	        this._filterGame = new MultiSelect_1.MultiSelectApi('filterGame');
	        this._filterOperation = new MultiSelect_1.MultiSelectApi('filterOperation');
	        this._filterGameStatus = new MultiSelect_1.MultiSelectApi('filterGameStatus');
	        this._btnShowMd5 = Utils_1.Utils.getJQueryById("MD5button");
	        this._btnShowMd5.on("click", this.showMd5);
	        this._btnShowSha1 = Utils_1.Utils.getJQueryById("SHA1button");
	        this._btnShowSha1.on("click", this.showSha1);
	        this._btnShowSha256 = Utils_1.Utils.getJQueryById("SHA256button");
	        this._btnShowSha256.on("click", this.showSha256);
	        this._btnSelectBuild = Utils_1.Utils.getJQueryById("btnSelectBuild");
	        this._btnSelectBuild.attr("disabled", 1);
	        this._btnSelectBuild.on("click", this.showBuildSelector);
	        this._chckAllBuilds = Utils_1.Utils.getJQueryById("buildSelectAll");
	        this._chckAllBuilds.on("change", this.checkBoxAll);
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	        this._form.on('submit', this.formSubmit);
	        this._btnCancelSearch.on('click', this.cancelSearch);
	    };
	    BuildSelectionPage.prototype.setBuildsSelectAllCheckbox = function () {
	        var checkboxes = $("input[name='selectedBuild']");
	        var buildSelectAll = Utils_1.Utils.getJQueryById("buildSelectAll")[0];
	        if (Utils_1.Utils.isNullOrUndefined(buildSelectAll))
	            return;
	        var allCheckboxesChecked = false;
	        for (var i = 0; i < checkboxes.length; i++) {
	            allCheckboxesChecked = checkboxes[i].checked;
	            if (!allCheckboxesChecked)
	                break;
	        }
	        buildSelectAll.checked = allCheckboxesChecked;
	    };
	    BuildSelectionPage.prototype.checkBoxAll = function () {
	        var checkboxes = $("input[name='selectedBuild']");
	        for (var i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = this._chckAllBuilds[0].checked;
	        }
	        this.detectSelectedGame();
	    };
	    BuildSelectionPage.prototype.cancelSearch = function (e) {
	        this._filterGame.selectAll();
	        this._filterOperation.selectAll();
	        this._filterGameStatus.selectAll();
	    };
	    BuildSelectionPage.prototype.formSubmit = function (e) {
	        e.preventDefault();
	        this._table.draw();
	        return false;
	    };
	    BuildSelectionPage.prototype.showMd5 = function () {
	        selectedType = "MD5";
	        this.displayHash();
	    };
	    BuildSelectionPage.prototype.showSha1 = function () {
	        selectedType = "SHA1";
	        this.displayHash();
	    };
	    BuildSelectionPage.prototype.showSha256 = function () {
	        selectedType = "SHA256";
	        this.displayHash();
	    };
	    BuildSelectionPage.prototype.displayHash = function () {
	        hashTypes.forEach(function (type) {
	            $("span[name='" + type.toLowerCase() + "hash']").toggle(selectedType === type);
	            $("#" + type + "button").toggleClass("green", selectedType === type);
	        });
	    };
	    BuildSelectionPage.prototype.shortHash = function (hash) {
	        if (hash.length > 0) {
	            return hash.substring(0, 4) + "..." + hash.substring(hash.length - 4);
	        }
	        return "";
	    };
	    BuildSelectionPage.prototype.drawCallback = function (datatable) {
	        this.showHideSelectAllCheckboxes();
	        this.displayHash();
	    };
	    BuildSelectionPage.prototype.preDrawCallback = function (datatable) {
	        this._chckAllBuilds[0].checked = false;
	        this.showHideSelectAllCheckboxes();
	        var filterGame = this._filterGame.isAllSelected() ? '' : this._filterGame.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMN_INDEX.GameCode).search(filterGame);
	        var filterCustomerOperation = this._filterOperation.isAllSelected() ? '' : this._filterOperation.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMN_INDEX.Operation).search(filterCustomerOperation);
	        var filterGameStatus = this._filterGameStatus.isAllSelected() ? '' : this._filterGameStatus.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMN_INDEX.GameStatus).search(filterGameStatus);
	        return true;
	    };
	    BuildSelectionPage.prototype.detectSelectedGame = function () {
	        var ids = $("input[name='selectedBuild']:checked").map(function () {
	            var val = $(this).val();
	            return val.substring(0, val.indexOf("-"));
	        });
	        var unique = ids.toArray().filter(function (value, index, array) { return array.indexOf(value) === index; });
	        if (unique.length === 1) {
	            this._btnSelectBuild.removeAttr("disabled");
	            selectedName = unique.join();
	        }
	        else {
	            this._btnSelectBuild.attr("disabled", 1);
	            selectedName = "";
	        }
	    };
	    BuildSelectionPage.prototype.showBuildSelector = function () {
	        var buildSelectorTable = Utils_1.Utils.getJQueryById(buildSelectorTableId).DataTable();
	        buildSelectorTable.draw();
	        $('#buildSelector').removeAttr("hidden");
	    };
	    BuildSelectionPage.prototype.showHideSelectAllCheckbox = function (selectAllButton, checkboxesIdentifier) {
	        var selectAllCheckbox = Utils_1.Utils.getJQueryById(selectAllButton)[0];
	        if (Utils_1.Utils.isNullOrUndefined(selectAllCheckbox))
	            return;
	        var checkboxes = $(checkboxesIdentifier);
	        if (checkboxes.length === 0) {
	            selectAllCheckbox.hidden = true;
	        }
	        else {
	            selectAllCheckbox.hidden = false;
	        }
	    };
	    BuildSelectionPage.prototype.showHideSelectAllCheckboxes = function () {
	        this.showHideSelectAllCheckbox("buildSelectAll", "input[name='selectedBuild']");
	    };
	    return BuildSelectionPage;
	}(PageBase_1.PageBase));
	exports.BuildSelectionPage = BuildSelectionPage;
	var BuildSelectorPage = (function (_super) {
	    __extends(BuildSelectorPage, _super);
	    function BuildSelectorPage(options) {
	        _super.call(this, options);
	        this.preDrawCallback = this.preDrawCallback.bind(this);
	        this.hideSelector = this.hideSelector.bind(this);
	        this.selectBuild = this.selectBuild.bind(this);
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'StringVersion',
	            autoWidth: true,
	            columns: [
	                {
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<input type='radio' name='selectedVersion' id='spnRadioButton" + rowData.StringVersion + "' value='" + rowData.StringVersion + "' />");
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "StringVersion",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnStringVersion" + rowData.StringVersion + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "StringContent",
	                    render: function (data, type, rowData) {
	                        var manifest = JSON.parse(rowData.StringContent);
	                        var file = manifest.Files[0];
	                        var md5 = "";
	                        var sha1 = "";
	                        var sha256 = "";
	                        if (file.Hashes.hasOwnProperty("MD5")) {
	                            md5 = file.Hashes['MD5'];
	                        }
	                        if (file.Hashes.hasOwnProperty("SHA1")) {
	                            sha1 = file.Hashes['SHA1'];
	                        }
	                        if (file.Hashes.hasOwnProperty("SHA256")) {
	                            sha256 = file.Hashes['SHA256'];
	                        }
	                        return "<table id='tblStringContent" + rowData.StringVersion + "' class='buildVersion-table'>\n                                <tr><td>MD5: </td><td>" + md5 + "</td></tr>\n                                <tr><td>SHA1: </td><td>" + sha1 + "</td></tr>\n                                <tr><td>SHA256: </td><td>" + sha256 + "</td></tr>\n                                </table>";
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "Created",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCreated" + rowData.StringVersion + "'>" + DateUtils_1.DateUtils.toDefaultWithTime(data) + "</span>");
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "Description",
	                    render: function (data, type, rowData) {
	                        var description = Utils_1.Utils.isNullOrUndefined(data) ? "" : data;
	                        return "<span id='spnDescription" + rowData.StringVersion + "'>" + description + "</span>";
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "IsEnabled",
	                    render: function (data, type, rowData) {
	                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                        var css = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "IsValid",
	                    render: function (data, type, rowData) {
	                        var css = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + StringUtils_1.StringUtils.capitalizeFirstLetter(data.toString()) + "</span>";
	                    }
	                }
	            ],
	            callbacks: {
	                preDrawCallback: this.preDrawCallback
	            }
	        };
	    }
	    BuildSelectorPage.prototype.init = function () {
	        var btnHideBuildSelector = Utils_1.Utils.getJQueryById("btnHideBuildSelector");
	        btnHideBuildSelector.on("click", this.hideSelector);
	        var btnSelectVersion = Utils_1.Utils.getJQueryById("btnSelectVersion");
	        btnSelectVersion.on("click", this.selectBuild);
	        this._table = new Datatable_1.Datatable(buildSelectorTableId, this._tableOptions);
	    };
	    BuildSelectorPage.prototype.preDrawCallback = function (datatable) {
	        datatable.columns(1).search(selectedName);
	        return true;
	    };
	    BuildSelectorPage.prototype.hideSelector = function () {
	        $('#buildSelector').attr("hidden", "hidden");
	    };
	    BuildSelectorPage.prototype.selectBuild = function () {
	        var urlPost = this._options.urlPost;
	        var buildConfigurationTable = Utils_1.Utils.getJQueryById(tableId).DataTable();
	        var ids = $("input[name='selectedBuild']:checked").map(function () {
	            return $(this).val();
	        });
	        var idsToChange = ids.get();
	        if (!idsToChange || idsToChange.length === 0) {
	            this.hideSelector();
	            return;
	        }
	        var selectedVersion = $("input[name='selectedVersion']:checked").map(function () {
	            return $(this).val();
	        });
	        var versionToSet = selectedVersion.get();
	        if (!versionToSet || versionToSet.length === 0) {
	            this.hideSelector();
	            return;
	        }
	        $.ajax({
	            url: urlPost,
	            type: "POST",
	            dataType: 'html',
	            data: { selectedGame: selectedName, ids: idsToChange, version: versionToSet[0] },
	            success: function (data) {
	                buildConfigurationTable.draw();
	            }
	        });
	        this.hideSelector();
	    };
	    return BuildSelectorPage;
	}(PageBase_1.PageBase));
	exports.BuildSelectorPage = BuildSelectorPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ResultPage_1 = __webpack_require__(116);
	exports.ResultPage = ResultPage_1.ResultPage;
	var SettingsPage_1 = __webpack_require__(117);
	exports.SettingsPage = SettingsPage_1.SettingsPage;


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var _ = __webpack_require__(7);
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var MultiSelect_1 = __webpack_require__(52);
	var Utils_1 = __webpack_require__(5);
	var StringUtils_1 = __webpack_require__(3);
	var tableDom = "<'row'<'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var tableId = 'tableConfigurationImportResult';
	var FILTER_DELIM = '-delim-';
	var COLUMNS_INDEX = {
	    CustomerCode: 0,
	    CurrencyCode: 1,
	    GameCode: 2,
	    Result: 3
	};
	var ResultPage = (function (_super) {
	    __extends(ResultPage, _super);
	    function ResultPage(options) {
	        _super.call(this, options);
	        this._detailRowsIds = [];
	        this.createdRow = this.createdRow.bind(this);
	        this.renderDetailRow = this.renderDetailRow.bind(this);
	        this.preDrawCallback = this.preDrawCallback.bind(this);
	        this.formSubmit = this.formSubmit.bind(this);
	        this.cancelSearch = this.cancelSearch.bind(this);
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: false,
	            pageLength: -1,
	            fixedHeader: {
	                header: true,
	                headerOffset: 50
	            },
	            order: [3, "asc"],
	            columns: [
	                {
	                    data: "CustomerCode"
	                },
	                {
	                    data: "CurrencyCode"
	                },
	                {
	                    data: "GameCode"
	                },
	                {
	                    data: "Result"
	                }
	            ],
	            rowDetail: {
	                hasDetail: true,
	                render: this.renderDetailRow
	            },
	            callbacks: {
	                preDrawCallback: this.preDrawCallback,
	                createdRow: this.createdRow
	            }
	        };
	    }
	    ResultPage.prototype.init = function () {
	        this._form = Utils_1.Utils.getJQueryById("formConfigurationImportResult");
	        this._btnCancelSearch = Utils_1.Utils.getJQueryById('btnCancelSearch');
	        this._filterCustomers = new MultiSelect_1.MultiSelectApi("filterCustomers");
	        this._filterCurrencies = new MultiSelect_1.MultiSelectApi("filterCurrencies");
	        this._filterGames = new MultiSelect_1.MultiSelectApi("filterGames");
	        this._filterResults = new MultiSelect_1.MultiSelectApi("filterResults");
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	        this._form.on('submit', this.formSubmit);
	        this._btnCancelSearch.on('click', this.cancelSearch);
	    };
	    ResultPage.prototype.formSubmit = function (e) {
	        e.preventDefault();
	        this._table.draw();
	        return false;
	    };
	    ResultPage.prototype.cancelSearch = function (e) {
	        this._filterCustomers.selectAll();
	        this._filterCurrencies.selectAll();
	        this._filterGames.selectAll();
	        this._filterResults.selectAll();
	    };
	    ResultPage.prototype.preDrawCallback = function (datatable) {
	        var filterCustomer = this._filterCustomers.isAllSelected() ? '' : this._filterCustomers.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.CustomerCode).search(filterCustomer);
	        var filterCurrency = this._filterCurrencies.isAllSelected() ? '' : this._filterCurrencies.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.CurrencyCode).search(filterCurrency);
	        var filterGame = this._filterGames.isAllSelected() ? '' : this._filterGames.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.GameCode).search(filterGame);
	        var filterResult = this._filterResults.isAllSelected() ? '' : this._filterResults.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.Result).search(filterResult);
	    };
	    ResultPage.prototype.createdRow = function (row, data, dataIndex) {
	        $('td', row).addClass('cursor-pointer');
	        if (data["Result"] === "Failed") {
	            $(row).addClass('error-log-row');
	        }
	    };
	    ResultPage.prototype.renderDetailRow = function (data) {
	        var result = '';
	        if (!StringUtils_1.StringUtils.isNullOrEmpty(data.Error)) {
	            result = "<div class='note note-danger'>\n                    <h5>Exception</h5>\n                    <p class=\"errorLogContextData\">" + _.escape(data.Error) + "</p>\n                    <p>&nbsp;</p>\n                    </div>";
	        }
	        else {
	            result = "<div class='note'>\n                    <p class=\"jsonContextData\">" + _.escape(JSON.stringify(JSON.parse(data.Configuration))) + "</p>\n                    <p>&nbsp;</p>\n                    </div>";
	        }
	        return result;
	    };
	    return ResultPage;
	}(PageBase_1.PageBase));
	exports.ResultPage = ResultPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var _ = __webpack_require__(7);
	var PageBase_1 = __webpack_require__(67);
	var TreeView_1 = __webpack_require__(59);
	var Modal_1 = __webpack_require__(60);
	var FileUtils_1 = __webpack_require__(9);
	var UriHelper_1 = __webpack_require__(8);
	var SettingsPage = (function (_super) {
	    __extends(SettingsPage, _super);
	    function SettingsPage(options) {
	        _super.call(this, options);
	        this.handleCustomerTreeInit = this.handleCustomerTreeInit.bind(this);
	        this.handleCustomerTreeRenderNode = this.handleCustomerTreeRenderNode.bind(this);
	        this.handleCustomerTreeGetIcon = this.handleCustomerTreeGetIcon.bind(this);
	        this.handleCustomerTreeAcceptSelection = this.handleCustomerTreeAcceptSelection.bind(this);
	        this.handleCustomerTreeSelectAll = this.handleCustomerTreeSelectAll.bind(this);
	        this.handleGamesTreeRenderNode = this.handleGamesTreeRenderNode.bind(this);
	        this.handleGamesTreeGetIcon = this.handleGamesTreeGetIcon.bind(this);
	        this.handleGamesTreeSelectAll = this.handleGamesTreeSelectAll.bind(this);
	        this.handleGameListInfoClick = this.handleGameListInfoClick.bind(this);
	        this._urlGameList = this._options.urlGameList;
	    }
	    SettingsPage.prototype.init = function () {
	        this._isInitLoad = true;
	        this._elemSelectAllCustomerTree = $('#chSelectAllCustomerTree');
	        this._elemSelectAllCustomerTree.on('change', this.handleCustomerTreeSelectAll);
	        this._elemSelectAllGamesTree = $('#chSelectAllGames');
	        this._elemSelectAllGamesTree.on('change', this.handleGamesTreeSelectAll);
	        this._gameListModal = new Modal_1.ModalApi('gameListModal');
	        this._treeCustomers = TreeView_1.TreeView.get('treeCustomers');
	        this._treeCustomers.onInit = this.handleCustomerTreeInit;
	        this._treeCustomers.onRenderNode = this.handleCustomerTreeRenderNode;
	        this._treeCustomers.onAcceptSelection = this.handleCustomerTreeAcceptSelection;
	        this._treeCustomers.options.icon = this.handleCustomerTreeGetIcon;
	        this._treeCustomers.initialize();
	        this._treeGames = TreeView_1.TreeView.get('treeGames');
	        this._treeGames.onRenderNode = this.handleGamesTreeRenderNode;
	        this._treeGames.options.icon = this.handleGamesTreeGetIcon;
	        this._treeGames.initialize();
	        this._isInitLoad = false;
	    };
	    SettingsPage.prototype.handleCustomerTreeInit = function (event, data) {
	        this._treeCustomers.collapseAll();
	    };
	    SettingsPage.prototype.handleCustomerTreeRenderNode = function (event, data) {
	        var node = data.node.fancyNode;
	        var metadata = node.data.metadata;
	        var isCurrency = metadata.type === 'Currency';
	        if (isCurrency) {
	            var unselectable = node.unselectable;
	            var style = 'color: cadetblue; padding-left: 5px; cursor: pointer;';
	            var node_span = $(node.span);
	            if (this._isInitLoad) {
	                var info_span = $("<span class=\"glyphicon glyphicon-info-sign\" data-key='" + node.key + "' style='" + style + "' title='Show game list info...'></span>");
	                info_span.on('click', this.handleGameListInfoClick);
	                info_span.appendTo(node_span);
	            }
	        }
	        if (metadata.status === 'Closed') {
	            TreeView_1.TreeView.updateNodeStrikeThrough(node, true);
	            return;
	        }
	        if (metadata.isDefined === false && metadata.status !== 'Closed') {
	            TreeView_1.TreeView.updateNodeDisabled(node, true);
	            return;
	        }
	    };
	    SettingsPage.prototype.handleCustomerTreeAcceptSelection = function (node) {
	        return node.fancyNode.data.metadata.type === 'Currency';
	    };
	    SettingsPage.prototype.handleCustomerTreeGetIcon = function (event, data) {
	        if (event.type === 'icon') {
	            var type = data.node.data.metadata.type;
	            var status = data.node.data.metadata.status;
	            var isDisabled = status === 'Disabled';
	            if (type === 'Customer') {
	                return 'fa fa-folder-open';
	            }
	            else if (type === 'Operation') {
	                return 'fa fa-barcode';
	            }
	            else if (type === 'Currency') {
	                return 'fa ' + (isDisabled ? 'fa-exclamation' : 'fa-file-o');
	            }
	        }
	        return undefined;
	    };
	    SettingsPage.prototype.handleCustomerTreeSelectAll = function () {
	        var selectAll = this._elemSelectAllCustomerTree.is(':checked');
	        this._treeCustomers.visit(function (node) {
	            var isCurrency = node.data.metadata.type === 'Currency';
	            if (isCurrency) {
	                node.setSelected(selectAll);
	            }
	        });
	    };
	    SettingsPage.prototype.handleGamesTreeRenderNode = function (event, data) {
	        var node = data.node.fancyNode;
	        var metadata = node.data.metadata;
	        if (metadata.isDefined === false) {
	            TreeView_1.TreeView.updateNodeDisabled(node, true);
	            return;
	        }
	    };
	    SettingsPage.prototype.handleGameListInfoClick = function (e) {
	        var nodeKey = $(e.target).attr('data-key');
	        this.showGameListModal(nodeKey);
	    };
	    SettingsPage.prototype.handleGamesTreeGetIcon = function (event, data) {
	        if (event.type === 'icon') {
	            return 'fa fa-gamepad';
	        }
	        return undefined;
	    };
	    SettingsPage.prototype.handleGamesTreeSelectAll = function () {
	        var selectAll = this._elemSelectAllGamesTree.is(':checked');
	        this._treeGames.selectAll(selectAll);
	    };
	    SettingsPage.prototype.showGameListModal = function (nodeKey) {
	        var self = this;
	        var keyValues = nodeKey.split('-');
	        var urlData = {
	            customerCode: keyValues[0],
	            currencyCode: keyValues[1]
	        };
	        var url = UriHelper_1.UriHelper.setQueryString(this._urlGameList, urlData);
	        function updateModalBody(entries) {
	            var currencyNode = self._treeCustomers.getNodeByKey(nodeKey);
	            var operationNode = currencyNode.parent;
	            var customerNode = operationNode.parent;
	            var info = {
	                customerCode: customerNode.title + " (" + urlData.customerCode + ")",
	                currencyCode: currencyNode.title + " (" + urlData.currencyCode + ")"
	            };
	            var html = FreeRoundGameList.render(info, entries);
	            self._gameListModal.updateBody(html);
	            self._gameListModal.show();
	        }
	        this._gameListModal.hide();
	        FileUtils_1.FileUtils.jsonPost(url)
	            .then(function (json) {
	            if (json) {
	                updateModalBody(json);
	            }
	        })
	            .catch(function (err) {
	            alert('Failed to get data');
	            console.error(err);
	        });
	    };
	    return SettingsPage;
	}(PageBase_1.PageBase));
	exports.SettingsPage = SettingsPage;
	var FreeRoundGameList = (function () {
	    function FreeRoundGameList() {
	    }
	    FreeRoundGameList.render = function (info, entries) {
	        var hasEntries = entries && _.isArray(entries) && entries.length > 0;
	        var infoHtml = FreeRoundGameList.renderInfo(info);
	        var content = $('<div/>', { style: 'height: 300px; overflow-y: auto; overflow-x: hidden;' });
	        if (hasEntries) {
	            FreeRoundGameList.renderListHeader(content);
	            _.each(entries, function (entry) {
	                FreeRoundGameList.renderListRow(content, entry);
	            });
	        }
	        else {
	            content.append('<b>Game list is empty.</b>');
	        }
	        return infoHtml + content.prop('outerHTML');
	    };
	    FreeRoundGameList.renderInfo = function (info) {
	        return $('<div/>').append($("<div class=\"row\">\n                    <div class=\"col-md-2\"><b>Customer:</b></div><div class=\"col-md-10\">" + info.customerCode + "</div>\n               </div>\n                <div class=\"row\">\n                    <div class=\"col-md-2\"><b>Currency:</b></div><div class=\"col-md-10\">" + info.currencyCode + "</div>\n               </div>\n                <p></p>")).html();
	    };
	    FreeRoundGameList.renderListHeader = function (parent) {
	        parent.append($("<div class=\"row\" style=\"background-color: silver; padding: 2px; font-weight: bold;\">\n                    <div class=\"col-md-4\">Game name</div>\n                    <div class=\"col-md-4\">Game code</div>\n               </div>"));
	    };
	    FreeRoundGameList.renderListRow = function (parent, entry) {
	        parent.append($("<div class=\"row\" style=\"padding: 2px;\">\n                    <div class=\"col-md-4\">" + entry.GameName + "</div>\n                    <div class=\"col-md-4\">" + entry.GameCode + "</div>\n               </div>"));
	    };
	    return FreeRoundGameList;
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var DetailPage_1 = __webpack_require__(119);
	exports.DetailPage = DetailPage_1.DetailPage;


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var _ = __webpack_require__(7);
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var StringUtils_1 = __webpack_require__(3);
	var tableId = 'tableRequestLog';
	var tableDom = "<'row'<'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var DetailPage = (function (_super) {
	    __extends(DetailPage, _super);
	    function DetailPage(options) {
	        _super.call(this, options);
	        this.createdRow = this.createdRow.bind(this);
	        this.renderDetailRow = this.renderDetailRow.bind(this);
	        this.renderContextData = this.renderContextData.bind(this);
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            columns: [
	                {
	                    data: 'Id',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnId" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Created',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCreated" + rowData.Id + "'>" + (data || '') + "</span>");
	                    },
	                },
	                {
	                    data: 'Duration',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnDuration" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Action',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnAction" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Result',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnResult" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Source',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnSource" + rowData.Id + "'>" + data + "</span>");
	                    }
	                }
	            ],
	            callbacks: {
	                createdRow: this.createdRow
	            },
	            rowDetail: {
	                hasDetail: true,
	                render: this.renderDetailRow
	            }
	        };
	    }
	    DetailPage.prototype.init = function () {
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	    };
	    DetailPage.prototype.createdRow = function (row, data, dataIndex) {
	        $('td', row).addClass('cursor-pointer');
	        if (data["Result"] === 'Error') {
	            $(row).addClass('error-log-row');
	        }
	        if (data["Result"] === 'Warning') {
	            $(row).addClass('warning-log-row');
	        }
	    };
	    DetailPage.prototype.renderDetailRow = function (data) {
	        var css = 'info';
	        if (data.Result === 'Warning') {
	            css = 'warning';
	        }
	        if (data.Result === 'Error') {
	            css = 'danger';
	        }
	        var result = "<div class='note note-" + css + "'>";
	        if (!StringUtils_1.StringUtils.isNullOrEmpty(data.ContextData)) {
	            result += "<h5>Context</h5>\n                    <p>" + this.renderContextData(data.ContextData) + "</p>\n                    <p>&nbsp;</p>";
	        }
	        if (!StringUtils_1.StringUtils.isNullOrEmpty(data.ExceptionData)) {
	            result += "<h5>Exception</h5>\n                    <p class=\"errorLogContextData\">" + _.escape(data.ExceptionData) + "</p>\n                    <p>&nbsp;</p>";
	        }
	        if (!StringUtils_1.StringUtils.isNullOrEmpty(data.RequestData)) {
	            result += "<h5>Request</h5>\n                    <p class=\"errorLogContextData\">" + _.escape(data.RequestData) + "</p>\n                    <p>&nbsp;</p>";
	        }
	        if (!StringUtils_1.StringUtils.isNullOrEmpty(data.ResponseData)) {
	            result += "<h5>Response</h5>\n                    <p class=\"errorLogContextData\">" + _.escape(data.ResponseData) + "</p>\n                    <p>&nbsp;</p>";
	        }
	        result += '</div>';
	        return result;
	    };
	    DetailPage.prototype.renderContextData = function (contextData) {
	        var json = null;
	        try {
	            json = JSON.parse(contextData);
	        }
	        catch (e) {
	            json = null;
	        }
	        var result = '';
	        if (json === null || !_.isArray(json)) {
	            result = contextData;
	        }
	        else {
	            result = '<table class="errorLogContextData table-bordered table-hover">';
	            _.each(json, function (item) {
	                for (var key in item) {
	                    result += "<tr><td>" + key + "</td><td>" + StringUtils_1.StringUtils.escapeHtml(item[key]) + "</td></tr>";
	                }
	            });
	            result += '</table>';
	        }
	        return result;
	    };
	    return DetailPage;
	}(PageBase_1.PageBase));
	exports.DetailPage = DetailPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var OfCustomerPage_1 = __webpack_require__(121);
	exports.OfCustomerPage = OfCustomerPage_1.OfCustomerPage;
	var DetailPage_1 = __webpack_require__(122);
	exports.DetailPage = DetailPage_1.DetailPage;


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var tableId = 'tableUsers';
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'f><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var OfCustomerPage = (function (_super) {
	    __extends(OfCustomerPage, _super);
	    function OfCustomerPage(options) {
	        _super.call(this, options);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            columns: [
	                {
	                    data: "UserName",
	                    className: "bold",
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkUsername" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: "IsEnabled",
	                    render: function (data, type, rowData) {
	                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                        var css = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                    }
	                },
	                {
	                    data: '',
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkDetail" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + options.localizer.DetailsLink + "</a>");
	                    }
	                }
	            ]
	        };
	    }
	    OfCustomerPage.prototype.init = function () {
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	    };
	    return OfCustomerPage;
	}(PageBase_1.PageBase));
	exports.OfCustomerPage = OfCustomerPage;


/***/ },
/* 122 */
69,
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var IndexPage_1 = __webpack_require__(124);
	exports.IndexPage = IndexPage_1.IndexPage;
	exports.BasketPage = IndexPage_1.BasketPage;
	exports.BuildSelectorPage = IndexPage_1.BuildSelectorPage;
	var SummaryPage_1 = __webpack_require__(125);
	exports.SummaryPage = SummaryPage_1.SummaryPage;


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var MultiSelect_1 = __webpack_require__(52);
	var Utils_1 = __webpack_require__(5);
	var DateUtils_1 = __webpack_require__(48);
	var StringUtils_1 = __webpack_require__(3);
	var tableId = 'tableGameBuildConfigurations';
	var basketTableId = 'tableBasket';
	var buildSelectorTableId = 'tableBuildSelector';
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var hashTypes = ["MD5", "SHA1", "SHA256"];
	var COLUMN_INDEX = {
	    GameCode: 1,
	    Operation: 2,
	    GameStatus: 3
	};
	var selectedType;
	var FILTER_DELIM = '-delim-';
	var selectedName;
	var IndexPage = (function (_super) {
	    __extends(IndexPage, _super);
	    function IndexPage(options) {
	        var _this = this;
	        _super.call(this, options);
	        selectedType = options.defaultHashButton;
	        this.showMd5 = this.showMd5.bind(this);
	        this.showSha1 = this.showSha1.bind(this);
	        this.showSha256 = this.showSha256.bind(this);
	        this.drawCallback = this.drawCallback.bind(this);
	        this.addToBasket = this.addToBasket.bind(this);
	        this.formSubmit = this.formSubmit.bind(this);
	        this.cancelSearch = this.cancelSearch.bind(this);
	        this.preDrawCallback = this.preDrawCallback.bind(this);
	        this.detectSelectedGame = this.detectSelectedGame.bind(this);
	        this.showBuildSelector = this.showBuildSelector.bind(this);
	        this.checkBoxAll = this.checkBoxAll.bind(this);
	        this.displayHash = this.displayHash.bind(this);
	        window['detectSelectedGame'] = this.detectSelectedGame;
	        window['setBuildsSelectAllCheckbox'] = this.setBuildsSelectAllCheckbox;
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            order: [1, "asc"],
	            autoWidth: true,
	            pageLength: 100,
	            lengthMenu: [[50, 100, 200, 500, 1000], [50, 100, 200, 500, 1000]],
	            columns: [
	                {
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<input id='chckbx" + rowData.Id + "' name='selectedBuild' value='" + rowData.Id + "' type='checkbox' onchange=detectSelectedGame() onClick=\"setBuildsSelectAllCheckbox()\" />");
	                    }
	                },
	                {
	                    sortable: true,
	                    data: "GameCode",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnGameCode" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "CustomerOperationCode",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCustomerOperationCode" + rowData.Id + "'>" + rowData.CustomerCode + " | " + data + "</span>");
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "GameStatus",
	                    render: function (data, type, rowData) {
	                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                        var css = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnGameStatus" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "ModuleVersion",
	                    render: function (data, type, rowData) {
	                        return ("<span class='buildVersion-format' id='spnModuleVersion" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        var md5 = "";
	                        var sha1 = "";
	                        var sha256 = "";
	                        if (rowData.Hashes.hasOwnProperty("MD5")) {
	                            md5 = rowData.Hashes['MD5'];
	                        }
	                        if (rowData.Hashes.hasOwnProperty("SHA1")) {
	                            sha1 = rowData.Hashes['SHA1'];
	                        }
	                        if (rowData.Hashes.hasOwnProperty("SHA256")) {
	                            sha256 = rowData.Hashes['SHA256'];
	                        }
	                        return "<span id='spnModuleVersionMd5Hash' name=\"md5hash\" class=\"hash-format\" title=\"" + md5 + "\">" + _this.shortHash(md5) + "</span>\n                          <span id='spnModuleVersionSha1Hash' name=\"sha1hash\" class=\"hash-format\" title=\"" + sha1 + "\">" + _this.shortHash(sha1) + "</span>\n                          <span id='spnModuleVersionSha256Hash' name=\"sha256hash\" class=\"hash-format\" title=\"" + sha256 + "\">" + _this.shortHash(sha256) + "</span>";
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "SelectedModuleVersion",
	                    render: function (data, type, rowData) {
	                        return ("<span class='buildVersion-format' id='spnSelectedModuleVersion" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        var md5 = "";
	                        var sha1 = "";
	                        var sha256 = "";
	                        if (rowData.SelectedHashes.hasOwnProperty("MD5")) {
	                            md5 = rowData.SelectedHashes['MD5'];
	                        }
	                        if (rowData.SelectedHashes.hasOwnProperty("SHA1")) {
	                            sha1 = rowData.SelectedHashes['SHA1'];
	                        }
	                        if (rowData.SelectedHashes.hasOwnProperty("SHA256")) {
	                            sha256 = rowData.SelectedHashes['SHA256'];
	                        }
	                        return "<span id='spnSelectedModuleVersionMd5Hash' name=\"md5hash\" class=\"hash-format\" title=\"" + md5 + "\">" + _this.shortHash(md5) + "</span>\n                          <span id='spnSelectedModuleVersionSha1Hash' name=\"sha1hash\" class=\"hash-format\" title=\"" + sha1 + "\">" + _this.shortHash(sha1) + "</span>\n                          <span id='spnSelectedModuleVersionSha256Hash' name=\"sha256hash\" class=\"hash-format\" title=\"" + sha256 + "\">" + _this.shortHash(sha256) + "</span>";
	                    }
	                },
	                {
	                    orderable: false,
	                    data: 'filterButtons',
	                    defaultContent: '',
	                    searchable: false,
	                    sortable: false
	                }
	            ],
	            callbacks: {
	                drawCallback: this.drawCallback,
	                preDrawCallback: this.preDrawCallback
	            }
	        };
	    }
	    IndexPage.prototype.init = function () {
	        this._form = Utils_1.Utils.getJQueryById("formGameBuilConfigurations");
	        this._btnCancelSearch = Utils_1.Utils.getJQueryById("btnCancelSearch");
	        this._filterGame = new MultiSelect_1.MultiSelectApi('filterGame');
	        this._filterOperation = new MultiSelect_1.MultiSelectApi('filterOperation');
	        this._filterGameStatus = new MultiSelect_1.MultiSelectApi('filterGameStatus');
	        this._btnShowMd5 = Utils_1.Utils.getJQueryById("MD5button");
	        this._btnShowMd5.on("click", this.showMd5);
	        this._btnShowSha1 = Utils_1.Utils.getJQueryById("SHA1button");
	        this._btnShowSha1.on("click", this.showSha1);
	        this._btnShowSha256 = Utils_1.Utils.getJQueryById("SHA256button");
	        this._btnShowSha256.on("click", this.showSha256);
	        this._btnAddToBasketMulti = Utils_1.Utils.getJQueryById("btnAddToBasket");
	        this._btnAddToBasketMulti.attr("disabled", 1);
	        this._btnAddToBasketMulti.on("click", this.addToBasket);
	        this._btnSelectBuild = Utils_1.Utils.getJQueryById("btnSelectBuild");
	        this._btnSelectBuild.attr("disabled", 1);
	        this._btnSelectBuild.on("click", this.showBuildSelector);
	        this._chckAllBuilds = Utils_1.Utils.getJQueryById("buildSelectAll");
	        this._chckAllBuilds.on("change", this.checkBoxAll);
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	        this._form.on('submit', this.formSubmit);
	        this._btnCancelSearch.on('click', this.cancelSearch);
	    };
	    IndexPage.prototype.setBuildsSelectAllCheckbox = function () {
	        var checkboxes = $("input[name='selectedBuild']");
	        var buildSelectAll = Utils_1.Utils.getJQueryById("buildSelectAll")[0];
	        if (Utils_1.Utils.isNullOrUndefined(buildSelectAll))
	            return;
	        var allCheckboxesChecked = false;
	        for (var i = 0; i < checkboxes.length; i++) {
	            allCheckboxesChecked = checkboxes[i].checked;
	            if (!allCheckboxesChecked)
	                break;
	        }
	        buildSelectAll.checked = allCheckboxesChecked;
	    };
	    IndexPage.prototype.checkBoxAll = function () {
	        var checkboxes = $("input[name='selectedBuild']");
	        for (var i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = this._chckAllBuilds[0].checked;
	        }
	        this.detectSelectedGame();
	    };
	    IndexPage.prototype.deselectAll = function () {
	        var checkboxes = $("input[name='selectedBuild']");
	        for (var i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = false;
	        }
	        this.detectSelectedGame();
	    };
	    IndexPage.prototype.cancelSearch = function (e) {
	        this._filterGame.selectAll();
	        this._filterOperation.selectAll();
	        this._filterGameStatus.selectAll();
	    };
	    IndexPage.prototype.formSubmit = function (e) {
	        e.preventDefault();
	        this._table.draw();
	        return false;
	    };
	    IndexPage.prototype.showMd5 = function () {
	        selectedType = "MD5";
	        this.displayHash();
	    };
	    IndexPage.prototype.showSha1 = function () {
	        selectedType = "SHA1";
	        this.displayHash();
	    };
	    IndexPage.prototype.showSha256 = function () {
	        selectedType = "SHA256";
	        this.displayHash();
	    };
	    IndexPage.prototype.displayHash = function () {
	        hashTypes.forEach(function (type) {
	            $("span[name='" + type.toLowerCase() + "hash']").toggle(selectedType === type);
	            $("#" + type + "button").toggleClass("green", selectedType === type);
	        });
	    };
	    IndexPage.prototype.shortHash = function (hash) {
	        if (hash.length > 0) {
	            return hash.substring(0, 4) + "..." + hash.substring(hash.length - 4);
	        }
	        return "";
	    };
	    IndexPage.prototype.drawCallback = function (datatable) {
	        this.showHideSelectAllCheckboxes();
	        this.displayHash();
	    };
	    IndexPage.prototype.preDrawCallback = function (datatable) {
	        this._chckAllBuilds[0].checked = false;
	        this.showHideSelectAllCheckboxes();
	        var filterGame = this._filterGame.isAllSelected() ? '' : this._filterGame.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMN_INDEX.GameCode).search(filterGame);
	        var filterCustomerOperation = this._filterOperation.isAllSelected() ? '' : this._filterOperation.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMN_INDEX.Operation).search(filterCustomerOperation);
	        var filterGameStatus = this._filterGameStatus.isAllSelected() ? '' : this._filterGameStatus.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMN_INDEX.GameStatus).search(filterGameStatus);
	        return true;
	    };
	    IndexPage.prototype.addToBasket = function (e) {
	        e.preventDefault();
	        var urlPost = this._options.urlPost;
	        var table = this._table;
	        var basketTable = Utils_1.Utils.getJQueryById(basketTableId).DataTable();
	        var ids = $("input[name='selectedBuild']:checked").map(function () {
	            return $(this).val();
	        });
	        var idsToAdd = ids.get();
	        if (!idsToAdd || idsToAdd.length === 0) {
	            return;
	        }
	        $.ajax({
	            url: urlPost,
	            type: "POST",
	            dataType: 'html',
	            data: { ids: idsToAdd },
	            success: function (data) {
	                table.draw();
	                basketTable.draw();
	            }
	        });
	        this.deselectAll();
	    };
	    IndexPage.prototype.detectSelectedGame = function () {
	        var ids = $("input[name='selectedBuild']:checked").map(function () {
	            var val = $(this).val();
	            return val.substring(0, val.indexOf("-"));
	        });
	        var idsArray = ids.toArray();
	        var unique = idsArray.filter(function (value, index, array) { return array.indexOf(value) === index; });
	        if (idsArray.length > 0) {
	            this._btnAddToBasketMulti.removeAttr("disabled");
	        }
	        else {
	            this._btnAddToBasketMulti.attr("disabled", 1);
	        }
	        if (unique.length === 1) {
	            this._btnSelectBuild.removeAttr("disabled");
	            selectedName = unique.join();
	        }
	        else {
	            this._btnSelectBuild.attr("disabled", 1);
	            selectedName = "";
	        }
	    };
	    IndexPage.prototype.showBuildSelector = function () {
	        var buildSelectorTable = Utils_1.Utils.getJQueryById(buildSelectorTableId).DataTable();
	        buildSelectorTable.draw();
	        $('#buildSelector').removeAttr("hidden");
	    };
	    IndexPage.prototype.showHideSelectAllCheckbox = function (selectAllButton, checkboxesIdentifier) {
	        var selectAllCheckbox = Utils_1.Utils.getJQueryById(selectAllButton)[0];
	        if (Utils_1.Utils.isNullOrUndefined(selectAllCheckbox))
	            return;
	        var checkboxes = $(checkboxesIdentifier);
	        if (checkboxes.length === 0) {
	            selectAllCheckbox.hidden = true;
	        }
	        else {
	            selectAllCheckbox.hidden = false;
	        }
	    };
	    IndexPage.prototype.showHideSelectAllCheckboxes = function () {
	        this.showHideSelectAllCheckbox("buildSelectAll", "input[name='selectedBuild']");
	    };
	    return IndexPage;
	}(PageBase_1.PageBase));
	exports.IndexPage = IndexPage;
	var BasketPage = (function (_super) {
	    __extends(BasketPage, _super);
	    function BasketPage(options) {
	        var _this = this;
	        _super.call(this, options);
	        this.showHash = this.showHash.bind(this);
	        this.drawCallback = this.drawCallback.bind(this);
	        this.removeFromBasket = this.removeFromBasket.bind(this);
	        this.clearBasket = this.clearBasket.bind(this);
	        this.formSubmit = this.formSubmit.bind(this);
	        this.cancelSearch = this.cancelSearch.bind(this);
	        this.preDrawCallback = this.preDrawCallback.bind(this);
	        this.checkBoxAll = this.checkBoxAll.bind(this);
	        window['setBasketSelectAllCheckbox'] = this.setBasketSelectAllCheckbox;
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            order: [1, "asc"],
	            autoWidth: true,
	            pageLength: 100,
	            lengthMenu: [[50, 100, 200, 500, 1000], [50, 100, 200, 500, 1000]],
	            columns: [
	                {
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<input id='chckbxBasket" + rowData.Id + "' name='selectedBasketRow' value='" + rowData.Id + "' type='checkbox' onClick=\"setBasketSelectAllCheckbox()\" />");
	                    }
	                },
	                {
	                    sortable: true,
	                    data: "GameCode",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnBasketGameCode" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "CustomerOperationCode",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnBasketCustomerOperationCode" + rowData.Id + "'>" + rowData.CustomerCode + " | " + data + "</span>");
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "GameStatus",
	                    render: function (data, type, rowData) {
	                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                        var css = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnBasketGameStatus" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "SelectedModuleVersion",
	                    render: function (data, type, rowData) {
	                        return ("<span class='buildVersion-format' id='spnBasketSelectedModuleVersion" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        var md5 = "";
	                        var sha1 = "";
	                        var sha256 = "";
	                        if (rowData.SelectedHashes.hasOwnProperty("MD5")) {
	                            md5 = rowData.SelectedHashes['MD5'];
	                        }
	                        if (rowData.SelectedHashes.hasOwnProperty("SHA1")) {
	                            sha1 = rowData.SelectedHashes['SHA1'];
	                        }
	                        if (rowData.SelectedHashes.hasOwnProperty("SHA256")) {
	                            sha256 = rowData.SelectedHashes['SHA256'];
	                        }
	                        return "<span id='spnBasketSelectedModuleVersionMd5Hash' name=\"md5hash\" class=\"hash-format\" title=\"" + md5 + "\">" + _this.shortHash(md5) + "</span>\n                          <span id='spnBasketSelectedModuleVersionSha1Hash' name=\"sha1hash\" class=\"hash-format\" title=\"" + sha1 + "\">" + _this.shortHash(sha1) + "</span>\n                          <span id='spnBasketSelectedModuleVersionSha256Hash' name=\"sha256hash\" class=\"hash-format\" title=\"" + sha256 + "\">" + _this.shortHash(sha256) + "</span>";
	                    }
	                },
	                {
	                    orderable: false,
	                    data: 'filterButtons',
	                    defaultContent: '',
	                    searchable: false,
	                    sortable: false
	                }
	            ],
	            callbacks: {
	                drawCallback: this.drawCallback,
	                preDrawCallback: this.preDrawCallback
	            }
	        };
	    }
	    BasketPage.prototype.init = function () {
	        var btnRemoveFromBasketMulti = Utils_1.Utils.getJQueryById("btnRemoveFromBasket");
	        btnRemoveFromBasketMulti.on("click", this.removeFromBasket);
	        var btnClearBasket = Utils_1.Utils.getJQueryById("btnClearAll");
	        btnClearBasket.on("click", this.clearBasket);
	        this._form = Utils_1.Utils.getJQueryById("formBasket");
	        this._btnCancelSearch = Utils_1.Utils.getJQueryById("btnBasketCancelSearch");
	        this._filterGame = new MultiSelect_1.MultiSelectApi('filterBasketGame');
	        this._filterOperation = new MultiSelect_1.MultiSelectApi('filterBasketOperation');
	        this._filterGameStatus = new MultiSelect_1.MultiSelectApi('filterBasketGameStatus');
	        this._chckAllBasket = Utils_1.Utils.getJQueryById("basketSelectAll");
	        this._chckAllBasket.on("change", this.checkBoxAll);
	        this._table = new Datatable_1.Datatable(basketTableId, this._tableOptions);
	        this._form.on('submit', this.formSubmit);
	        this._btnCancelSearch.on('click', this.cancelSearch);
	    };
	    BasketPage.prototype.setBasketSelectAllCheckbox = function () {
	        var checkboxes = $("input[name='selectedBasketRow']");
	        var basketSelectAll = Utils_1.Utils.getJQueryById("basketSelectAll")[0];
	        if (Utils_1.Utils.isNullOrUndefined(basketSelectAll))
	            return;
	        var allCheckboxesChecked = false;
	        for (var i = 0; i < checkboxes.length; i++) {
	            allCheckboxesChecked = checkboxes[i].checked;
	            if (!allCheckboxesChecked)
	                break;
	        }
	        basketSelectAll.checked = allCheckboxesChecked;
	    };
	    BasketPage.prototype.checkBoxAll = function () {
	        var checkboxes = $("input[name='selectedBasketRow']");
	        for (var i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = this._chckAllBasket[0].checked;
	        }
	    };
	    BasketPage.prototype.showHideSelectAllCheckbox = function (selectAllButton, checkboxesIdentifier) {
	        var selectAllCheckbox = Utils_1.Utils.getJQueryById(selectAllButton)[0];
	        if (Utils_1.Utils.isNullOrUndefined(selectAllCheckbox))
	            return;
	        var checkboxes = $(checkboxesIdentifier);
	        if (checkboxes.length === 0) {
	            selectAllCheckbox.hidden = true;
	        }
	        else {
	            selectAllCheckbox.hidden = false;
	        }
	    };
	    BasketPage.prototype.showHideSelectAllCheckboxes = function () {
	        this.showHideSelectAllCheckbox("basketSelectAll", "input[name='selectedBasketRow']");
	    };
	    BasketPage.prototype.shortHash = function (hash) {
	        if (hash.length > 0) {
	            return hash.substring(0, 4) + "..." + hash.substring(hash.length - 4);
	        }
	        return "";
	    };
	    BasketPage.prototype.showHash = function () {
	        hashTypes.forEach(function (type) {
	            $("span[name='" + type.toLowerCase() + "hash']").toggle(selectedType === type);
	        });
	    };
	    BasketPage.prototype.drawCallback = function (datatable) {
	        this.showHideSelectAllCheckboxes();
	        this.showHash();
	    };
	    BasketPage.prototype.removeFromBasket = function (e) {
	        e.preventDefault();
	        var urlPost = this._options.urlRemove;
	        var table = this._table;
	        var buildConfigurationTable = Utils_1.Utils.getJQueryById(tableId).DataTable();
	        var ids = $("input[name='selectedBasketRow']:checked").map(function () {
	            return $(this).val();
	        });
	        var idsToRemove = ids.get();
	        if (!idsToRemove || idsToRemove.length === 0) {
	            return;
	        }
	        $.ajax({
	            url: urlPost,
	            type: "POST",
	            dataType: 'html',
	            data: { ids: idsToRemove },
	            success: function (data) {
	                table.draw();
	                buildConfigurationTable.draw();
	            }
	        });
	    };
	    BasketPage.prototype.clearBasket = function (e) {
	        e.preventDefault();
	        var urlPost = this._options.urlClear;
	        var table = this._table;
	        var buildConfigurationTable = Utils_1.Utils.getJQueryById(tableId).DataTable();
	        $.ajax({
	            url: urlPost,
	            type: "POST",
	            dataType: 'html',
	            success: function (data) {
	                table.draw();
	                buildConfigurationTable.draw();
	            }
	        });
	    };
	    BasketPage.prototype.preDrawCallback = function (datatable) {
	        this._chckAllBasket[0].checked = false;
	        this.showHideSelectAllCheckboxes();
	        var filterGame = this._filterGame.isAllSelected() ? '' : this._filterGame.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMN_INDEX.GameCode).search(filterGame);
	        var filterCustomerOperation = this._filterOperation.isAllSelected() ? '' : this._filterOperation.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMN_INDEX.Operation).search(filterCustomerOperation);
	        var filterGameStatus = this._filterGameStatus.isAllSelected() ? '' : this._filterGameStatus.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMN_INDEX.GameStatus).search(filterGameStatus);
	        return true;
	    };
	    BasketPage.prototype.cancelSearch = function (e) {
	        this._filterGame.selectAll();
	        this._filterOperation.selectAll();
	        this._filterGameStatus.selectAll();
	    };
	    BasketPage.prototype.formSubmit = function (e) {
	        e.preventDefault();
	        this._table.draw();
	        return false;
	    };
	    return BasketPage;
	}(PageBase_1.PageBase));
	exports.BasketPage = BasketPage;
	var BuildSelectorPage = (function (_super) {
	    __extends(BuildSelectorPage, _super);
	    function BuildSelectorPage(options) {
	        _super.call(this, options);
	        this.preDrawCallback = this.preDrawCallback.bind(this);
	        this.hideSelector = this.hideSelector.bind(this);
	        this.selectBuild = this.selectBuild.bind(this);
	        window['enableSelectButton'] = this.enableSelectButton;
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'StringVersion',
	            autoWidth: true,
	            columns: [
	                {
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<input type='radio' name='selectedVersion' id='spnRadioButton" + rowData.StringVersion + "' value='" + rowData.StringVersion + "' onChange=enableSelectButton() />");
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "StringVersion",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnStringVersion" + rowData.StringVersion + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "Hashes",
	                    render: function (data, type, rowData) {
	                        var md5 = "";
	                        var sha1 = "";
	                        var sha256 = "";
	                        if (data.hasOwnProperty("MD5")) {
	                            md5 = data['MD5'];
	                        }
	                        if (data.hasOwnProperty("SHA1")) {
	                            sha1 = data['SHA1'];
	                        }
	                        if (data.hasOwnProperty("SHA256")) {
	                            sha256 = data['SHA256'];
	                        }
	                        return "<table id='tblStringContent" + rowData.StringVersion + "' class='buildVersion-table'>\n                                <tr><td>MD5: </td><td>" + md5 + "</td></tr>\n                                <tr><td>SHA1: </td><td>" + sha1 + "</td></tr>\n                                <tr><td>SHA256: </td><td>" + sha256 + "</td></tr>\n                                </table>";
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "Created",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCreated" + rowData.StringVersion + "'>" + DateUtils_1.DateUtils.toDefaultWithTime(data) + "</span>");
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "Description",
	                    render: function (data, type, rowData) {
	                        var description = Utils_1.Utils.isNullOrUndefined(data) ? "" : data;
	                        return "<span id='spnDescription" + rowData.StringVersion + "'>" + description + "</span>";
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "IsEnabled",
	                    render: function (data, type, rowData) {
	                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                        var css = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "IsValid",
	                    render: function (data, type, rowData) {
	                        var css = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + StringUtils_1.StringUtils.capitalizeFirstLetter(data.toString()) + "</span>";
	                    }
	                }
	            ],
	            callbacks: {
	                preDrawCallback: this.preDrawCallback
	            }
	        };
	    }
	    BuildSelectorPage.prototype.init = function () {
	        var btnHideBuildSelector = Utils_1.Utils.getJQueryById("btnHideBuildSelector");
	        btnHideBuildSelector.on("click", this.hideSelector);
	        var btnSelectVersion = Utils_1.Utils.getJQueryById("btnSelectVersion");
	        btnSelectVersion.on("click", this.selectBuild);
	        btnSelectVersion.attr("disabled", "disabled");
	        this._btnSelectBuild = Utils_1.Utils.getJQueryById("btnSelectBuild");
	        this._btnAddToBasketMulti = Utils_1.Utils.getJQueryById("btnAddToBasket");
	        this._table = new Datatable_1.Datatable(buildSelectorTableId, this._tableOptions);
	    };
	    BuildSelectorPage.prototype.preDrawCallback = function (datatable) {
	        datatable.columns(1).search(selectedName);
	        return true;
	    };
	    BuildSelectorPage.prototype.hideSelector = function () {
	        this.disableSelectButton();
	        $('#buildSelector').attr("hidden", "hidden");
	    };
	    BuildSelectorPage.prototype.enableSelectButton = function () {
	        var selectButton = Utils_1.Utils.getJQueryById("btnSelectVersion");
	        selectButton.removeAttr("disabled");
	    };
	    BuildSelectorPage.prototype.disableSelectButton = function () {
	        var selectButton = Utils_1.Utils.getJQueryById("btnSelectVersion");
	        selectButton.attr("disabled", "disabled");
	    };
	    BuildSelectorPage.prototype.selectBuild = function () {
	        var urlPost = this._options.urlPost;
	        var buildConfigurationTable = Utils_1.Utils.getJQueryById(tableId).DataTable();
	        var basketTable = Utils_1.Utils.getJQueryById(basketTableId).DataTable();
	        var ids = $("input[name='selectedBuild']:checked").map(function () {
	            return $(this).val();
	        });
	        var idsToChange = ids.get();
	        if (!idsToChange || idsToChange.length === 0) {
	            this.hideSelector();
	            return;
	        }
	        var selectedVersion = $("input[name='selectedVersion']:checked").map(function () {
	            return $(this).val();
	        });
	        var versionToSet = selectedVersion.get();
	        if (!versionToSet || versionToSet.length === 0) {
	            this.hideSelector();
	            return;
	        }
	        $.ajax({
	            url: urlPost,
	            type: "POST",
	            dataType: 'html',
	            data: { selectedGame: selectedName, ids: idsToChange, version: versionToSet[0] },
	            success: function (data) {
	                buildConfigurationTable.draw();
	                basketTable.draw();
	            }
	        });
	        this.hideSelector();
	        this.deselectAll();
	    };
	    BuildSelectorPage.prototype.deselectAll = function () {
	        var checkboxes = $("input[name='selectedBuild']");
	        for (var i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = false;
	        }
	        this.detectSelectedGame();
	    };
	    BuildSelectorPage.prototype.detectSelectedGame = function () {
	        var ids = $("input[name='selectedBuild']:checked").map(function () {
	            var val = $(this).val();
	            return val.substring(0, val.indexOf("-"));
	        });
	        var idsArray = ids.toArray();
	        var unique = idsArray.filter(function (value, index, array) { return array.indexOf(value) === index; });
	        if (idsArray.length > 0) {
	            this._btnAddToBasketMulti.removeAttr("disabled");
	        }
	        else {
	            this._btnAddToBasketMulti.attr("disabled", 1);
	        }
	        if (unique.length === 1) {
	            this._btnSelectBuild.removeAttr("disabled");
	            selectedName = unique.join();
	        }
	        else {
	            this._btnSelectBuild.attr("disabled", 1);
	            selectedName = "";
	        }
	    };
	    return BuildSelectorPage;
	}(PageBase_1.PageBase));
	exports.BuildSelectorPage = BuildSelectorPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var MultiSelect_1 = __webpack_require__(52);
	var Utils_1 = __webpack_require__(5);
	var tableId = 'tableGameBuildConfigurationSummary';
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var FILTER_DELIM = '-delim-';
	var COLUMN_INDEX = {
	    GameCode: 0,
	    Operation: 1,
	    Currency: 4,
	    GameVariant: 7
	};
	var SummaryPage = (function (_super) {
	    __extends(SummaryPage, _super);
	    function SummaryPage(options) {
	        var _this = this;
	        _super.call(this, options);
	        this._hashTypes = ["MD5", "SHA1", "SHA256"];
	        this._selectedType = options.defaultHashButton;
	        this._summaryFilter = "variant";
	        this.drawCallback = this.drawCallback.bind(this);
	        this.showMd5 = this.showMd5.bind(this);
	        this.showSha1 = this.showSha1.bind(this);
	        this.showSha256 = this.showSha256.bind(this);
	        this.formSubmit = this.formSubmit.bind(this);
	        this.cancelSearch = this.cancelSearch.bind(this);
	        this.preDrawCallback = this.preDrawCallback.bind(this);
	        this.filterChangedVariants = this.filterChangedVariants.bind(this);
	        this.filterDisabledConfigurations = this.filterDisabledConfigurations.bind(this);
	        this.filterAllConfigurations = this.filterAllConfigurations.bind(this);
	        this.displayHash = this.displayHash.bind(this);
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'GameCode',
	            ordering: false,
	            autoWidth: true,
	            pageLength: 100,
	            lengthMenu: [[50, 100, 200, 500, 1000], [50, 100, 200, 500, 1000]],
	            columns: [
	                {
	                    sortable: false,
	                    data: "GameCode",
	                    render: function (data, type, rowData) {
	                        var color = rowData.GameVariant !== rowData.NewGameVariant
	                            ? "font-red"
	                            : "";
	                        return "<span id='spnGameCode" + rowData.Id + "' class='" + color + "'>" + data + "</span>";
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "CustomerOperationCode",
	                    render: function (data, type, rowData) {
	                        var color = rowData.GameVariant !== rowData.NewGameVariant
	                            ? "font-red"
	                            : "";
	                        return "<span id='spnCustomerOperationCode" + rowData.Id + "' class='" + color + "'>" + rowData.CustomerCode + " | " + data + "</span>";
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "GameStatus",
	                    render: function (data, type, rowData) {
	                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                        var css = data === true ? 'status-enabled' : 'status-disabled';
	                        return "<span id='spnGameStatus" + rowData.Id + "' class='" + css + "'>" + text + "</span>";
	                    }
	                },
	                {
	                    sortable: false,
	                    width: "10%",
	                    data: "SelectedModuleVersion",
	                    render: function (data, type, rowData) {
	                        return ("<span class='buildVersion-format' id='spnSelectedModuleVersion" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    sortable: false,
	                    width: "5%",
	                    render: function (data, type, rowData) {
	                        var md5 = "";
	                        var sha1 = "";
	                        var sha256 = "";
	                        if (rowData.Hashes.hasOwnProperty("MD5")) {
	                            md5 = rowData.Hashes['MD5'];
	                        }
	                        if (rowData.Hashes.hasOwnProperty("SHA1")) {
	                            sha1 = rowData.Hashes['SHA1'];
	                        }
	                        if (rowData.Hashes.hasOwnProperty("SHA256")) {
	                            sha256 = rowData.Hashes['SHA256'];
	                        }
	                        return "<span id='spnSelectedModuleVersion$Md5Hash' name=\"md5hash\" class=\"hash-format\" title=\"" + md5 + "\">" + _this.shortHash(md5) + "</span>\n                          <span id='spnSelectedModuleVersion$Sha1Hash' name=\"sha1hash\" class=\"hash-format\" title=\"" + sha1 + "\">" + _this.shortHash(sha1) + "</span>\n                          <span id='spnSelectedModuleVersion$Sha256Hash' name=\"sha256hash\" class=\"hash-format\" title=\"" + sha256 + "\">" + _this.shortHash(sha256) + "</span>";
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "CurrencyCode",
	                    render: function (data, type, rowData) {
	                        var color = rowData.GameVariant !== rowData.NewGameVariant
	                            ? "font-red"
	                            : "";
	                        return "<span id='spnCurrency" + rowData.Id + "' class='" + color + "'>" + data + "</span>";
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "GameConfigurationStatus",
	                    render: function (data, type, rowData) {
	                        var css = "";
	                        if (data === "Enabled") {
	                            css = 'status-enabled';
	                        }
	                        if (data === "Disabled") {
	                            css = 'status-disabled';
	                        }
	                        return "<span id='spnConfigurationStatus" + rowData.Id + "' class='" + css + "'>" + data + "</span>";
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "GameVariant",
	                    render: function (data, type, rowData) {
	                        var color = rowData.GameVariant !== rowData.NewGameVariant
	                            ? "font-red"
	                            : "";
	                        return "<span id='spnGameVariant" + rowData.Id + "' class='" + color + "'>" + data + "</span>";
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "NewGameVariant",
	                    render: function (data, type, rowData) {
	                        var color = rowData.GameVariant !== rowData.NewGameVariant
	                            ? "font-red"
	                            : "";
	                        return "<span id='spnNewGameVariant" + rowData.Id + "' class='" + color + "'>" + data + "</span>";
	                    }
	                }
	            ],
	            callbacks: {
	                drawCallback: this.drawCallback,
	                preDrawCallback: this.preDrawCallback
	            }
	        };
	    }
	    SummaryPage.prototype.init = function () {
	        this._form = Utils_1.Utils.getJQueryById("formGameBuilConfigurationSummary");
	        this._btnCancelSearch = Utils_1.Utils.getJQueryById("btnCancelSearch");
	        this._btnShowMd5 = Utils_1.Utils.getJQueryById("MD5button");
	        this._btnShowMd5.on("click", this.showMd5);
	        this._btnShowSha1 = Utils_1.Utils.getJQueryById("SHA1button");
	        this._btnShowSha1.on("click", this.showSha1);
	        this._btnShowSha256 = Utils_1.Utils.getJQueryById("SHA256button");
	        this._btnShowSha256.on("click", this.showSha256);
	        this._filterGame = new MultiSelect_1.MultiSelectApi('filterGame');
	        this._filterOperation = new MultiSelect_1.MultiSelectApi('filterOperation');
	        this._filterCurrency = new MultiSelect_1.MultiSelectApi('filterCurrency');
	        this._filterVariants = Utils_1.Utils.getJQueryById("filterVariantsChanged");
	        this._filterVariants.on("click", this.filterChangedVariants);
	        this._filterDisabled = Utils_1.Utils.getJQueryById("filterDisabledConfigurations");
	        this._filterDisabled.on("click", this.filterDisabledConfigurations);
	        this._filterTotal = Utils_1.Utils.getJQueryById("filterTotal");
	        this._filterTotal.on("click", this.filterAllConfigurations);
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	        this._form.on('submit', this.formSubmit);
	        this._btnCancelSearch.on('click', this.cancelSearch);
	    };
	    SummaryPage.prototype.cancelSearch = function (e) {
	        this._filterGame.selectAll();
	        this._filterOperation.selectAll();
	        this._filterCurrency.selectAll();
	        this._summaryFilter = "variant";
	    };
	    SummaryPage.prototype.formSubmit = function (e) {
	        e.preventDefault();
	        this._table.draw();
	        return false;
	    };
	    SummaryPage.prototype.filterChangedVariants = function () {
	        this._summaryFilter = "variant";
	        this._table.draw();
	    };
	    SummaryPage.prototype.filterDisabledConfigurations = function () {
	        this._summaryFilter = "disabled";
	        this._table.draw();
	    };
	    SummaryPage.prototype.filterAllConfigurations = function () {
	        this._summaryFilter = "total";
	        this._table.draw();
	    };
	    SummaryPage.prototype.showMd5 = function () {
	        this._selectedType = "MD5";
	        this.displayHash();
	    };
	    SummaryPage.prototype.showSha1 = function () {
	        this._selectedType = "SHA1";
	        this.displayHash();
	    };
	    SummaryPage.prototype.showSha256 = function () {
	        this._selectedType = "SHA256";
	        this.displayHash();
	    };
	    SummaryPage.prototype.displayHash = function () {
	        var _this = this;
	        this._hashTypes.forEach(function (type) {
	            $("span[name='" + type.toLowerCase() + "hash']").toggle(_this._selectedType === type);
	            $("#" + type + "button").toggleClass("green", _this._selectedType === type);
	        });
	    };
	    SummaryPage.prototype.drawCallback = function (datatable) {
	        this.displayHash();
	        if (this._summaryFilter === "variant") {
	            $("#lblTotalConfigurations").removeClass("bg-info");
	            $("#lblDisabledConfigurations").removeClass("bg-info");
	            $("#lblVariantsChanged").addClass("bg-info");
	        }
	        if (this._summaryFilter === "disabled") {
	            $("#lblTotalConfigurations").removeClass("bg-info");
	            $("#lblDisabledConfigurations").addClass("bg-info");
	            $("#lblVariantsChanged").removeClass("bg-info");
	        }
	        if (this._summaryFilter === "total") {
	            $("#lblTotalConfigurations").addClass("bg-info");
	            $("#lblDisabledConfigurations").removeClass("bg-info");
	            $("#lblVariantsChanged").removeClass("bg-info");
	        }
	    };
	    SummaryPage.prototype.preDrawCallback = function (datatable) {
	        var filterGame = this._filterGame.isAllSelected() ? '' : this._filterGame.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMN_INDEX.GameCode).search(filterGame);
	        var filterCustomerOperation = this._filterOperation.isAllSelected() ? '' : this._filterOperation.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMN_INDEX.Operation).search(filterCustomerOperation);
	        var filterCurrency = this._filterCurrency.isAllSelected() ? '' : this._filterCurrency.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMN_INDEX.Currency).search(filterCurrency);
	        datatable.columns(COLUMN_INDEX.GameVariant).search(this._summaryFilter);
	        return true;
	    };
	    SummaryPage.prototype.shortHash = function (hash) {
	        if (hash.length > 0) {
	            return hash.substring(0, 4) + "..." + hash.substring(hash.length - 4);
	        }
	        return "";
	    };
	    return SummaryPage;
	}(PageBase_1.PageBase));
	exports.SummaryPage = SummaryPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var DashBoardPage_1 = __webpack_require__(127);
	exports.DashBoardPage = DashBoardPage_1.DashBoardPage;
	var PendingHandpayWins_1 = __webpack_require__(128);
	exports.PendingHandpayWins = PendingHandpayWins_1.PendingHandpayWins;
	var Wins_1 = __webpack_require__(129);
	exports.Wins = Wins_1.Wins;
	var Win_1 = __webpack_require__(130);
	exports.Win = Win_1.Win;
	var Snapshot_1 = __webpack_require__(131);
	exports.Snapshot = Snapshot_1.Snapshot;
	var GameConfigurationPage_1 = __webpack_require__(132);
	exports.GameConfigurationPage = GameConfigurationPage_1.GameConfigurationPage;
	var ConfigurationPage_1 = __webpack_require__(133);
	exports.ConfigurationPage = ConfigurationPage_1.ConfigurationPage;
	var ConfigurationDetailPage_1 = __webpack_require__(134);
	exports.ConfigurationDetailPage = ConfigurationDetailPage_1.ConfigurationDetailPage;
	var AssignedCustomerOperationsPage_1 = __webpack_require__(135);
	exports.AssignedCustomerOperationsPage = AssignedCustomerOperationsPage_1.AssignedCustomerOperationsPage;
	var AvailableCustomerOperationsPage_1 = __webpack_require__(136);
	exports.AvailableCustomerOperationsPage = AvailableCustomerOperationsPage_1.AvailableCustomerOperationsPage;
	var IndexPage_1 = __webpack_require__(137);
	exports.IndexPage = IndexPage_1.IndexPage;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var MultiSelect_1 = __webpack_require__(52);
	var Utils_1 = __webpack_require__(5);
	var DateUtils_1 = __webpack_require__(48);
	var tableId = 'tableProgressiveBonuses';
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var COLUMN_INDEX = {
	    BonusName: 1,
	    Status: 3,
	};
	var FILTER_DELIM = '-delim-';
	var DashBoardPage = (function (_super) {
	    __extends(DashBoardPage, _super);
	    function DashBoardPage(options) {
	        _super.call(this, options);
	        this.formSubmit = this.formSubmit.bind(this);
	        this.cancelSearch = this.cancelSearch.bind(this);
	        this.preDrawCallback = this.preDrawCallback.bind(this);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            pageLength: 100,
	            lengthMenu: [[100, 200, 300, -1], [100, 200, 300, "All"]],
	            columns: [
	                {
	                    data: 'Id',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnId" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Name',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnBonusName" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "Created",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCreated" + rowData.Id + "'>" + DateUtils_1.DateUtils.toDefaultWithTime(data) + "</span>");
	                    }
	                },
	                {
	                    data: "Status",
	                    render: function (data, type, rowData) {
	                        return "<span id='spnStatus" + rowData.Id + "'>" + data + "</span>";
	                    }
	                },
	                {
	                    data: 'Currencies',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCurrencies" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: '',
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkDetail" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + options.localizer.DetailsLink + "</a>");
	                    }
	                }
	            ],
	            callbacks: {
	                preDrawCallback: this.preDrawCallback
	            }
	        };
	    }
	    DashBoardPage.prototype.init = function () {
	        this._form = Utils_1.Utils.getJQueryById("formProgressiveBonuses");
	        this._btnCancelSearch = Utils_1.Utils.getJQueryById("btnCancelSearch");
	        this._filterBonus = new MultiSelect_1.MultiSelectApi('filterBonus');
	        this._filterStatus = new MultiSelect_1.MultiSelectApi('filterStatus');
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	        this._form.on('submit', this.formSubmit);
	        this._btnCancelSearch.on('click', this.cancelSearch);
	    };
	    DashBoardPage.prototype.preDrawCallback = function (datatable) {
	        var filterBonus = this._filterBonus.isAllSelected() ? '' : this._filterBonus.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMN_INDEX.BonusName).search(filterBonus);
	        var filterStatus = this._filterStatus.isAllSelected() ? '' : this._filterStatus.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMN_INDEX.Status).search(filterStatus);
	        return true;
	    };
	    DashBoardPage.prototype.cancelSearch = function (e) {
	        this._filterBonus.selectAll();
	        this._filterStatus.selectAll();
	    };
	    DashBoardPage.prototype.formSubmit = function (e) {
	        e.preventDefault();
	        this._table.draw();
	        return false;
	    };
	    return DashBoardPage;
	}(PageBase_1.PageBase));
	exports.DashBoardPage = DashBoardPage;


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var MultiSelect_1 = __webpack_require__(52);
	var DateTimePicker_1 = __webpack_require__(57);
	var Utils_1 = __webpack_require__(5);
	var StatusMessageHelper_1 = __webpack_require__(50);
	var DateUtils_1 = __webpack_require__(48);
	var tableId = 'tableBonusWins';
	var formId = 'formBonusWins';
	var btnCancelSearchId = 'btnCancelSearch';
	var FILTER_DELIM = '-delim-';
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-12't>r>" + "<'row'<''i><''p>>";
	var COLUMNS_INDEX = {
	    TicketId: 1,
	    Bonus: 2,
	    Player: 3,
	    Customer: 4,
	    CustomerOperation: 5,
	    PlayerWinAmount: 6,
	    MainWinAmount: 7,
	    Level: 8,
	    Created: 9,
	    Started: 10,
	    Finished: 11
	};
	var PendingHandpayWins = (function (_super) {
	    __extends(PendingHandpayWins, _super);
	    function PendingHandpayWins(options) {
	        _super.call(this, options);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        var getCustomerDetailUrl = function (rowData) { return (options.urlCustomerDetail + "/" + rowData.CustomerId); };
	        var getPlayerDetailUrl = function (rowData) { return (options.urlPlayerDetail + "/" + rowData.PlayerId); };
	        var getBonusDetailUrl = function (rowData) { return (options.urlBonusDetail + "/" + rowData.BonusId); };
	        var getOperationDetailUrl = function (rowData) { return (options.urlCustomerOperationDetail + "/" + rowData.CustomerOperationId); };
	        this.formSubmit = this.formSubmit.bind(this);
	        this.cancelSearch = this.cancelSearch.bind(this);
	        this.preDrawCallback = this.preDrawCallback.bind(this);
	        this.checkBoxAll = this.checkBoxAll.bind(this);
	        this.confirmWins = this.confirmWins.bind(this);
	        window['setWinsSelectAllCheckbox'] = this.setWinsSelectAllCheckbox;
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            scrollX: false,
	            fixedHeader: false,
	            columns: [
	                {
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<input id='chckbx" + rowData.Id + "' name='selectedWin' value='" + rowData.Id + "' type='checkbox' onClick=\"setWinsSelectAllCheckbox()\" />");
	                    }
	                },
	                {
	                    data: "Id",
	                    className: "bold",
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkDetail" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: 'BonusName',
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkBonusDetail" + rowData.Id + "' href='" + getBonusDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: 'PlayerRemoteId',
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkPlayerDetail" + rowData.Id + "' href='" + getPlayerDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: 'CustomerName',
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkCustomerDetail" + rowData.Id + "' href='" + getCustomerDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: 'CustomerOperationName',
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkCustomerOperationDetail" + rowData.Id + "' href='" + getOperationDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: 'PlayerWinAmount',
	                    render: function (data, type, rowData) {
	                        return ("<span id='PlayerWinAmount" + rowData.Id + "'>" + data + " " + rowData.PlayerCurrency + "</span>");
	                    }
	                },
	                {
	                    data: 'MainWinAmount',
	                    render: function (data, type, rowData) {
	                        return ("<span id='MainWinAmount" + rowData.Id + "'>" + data + " " + rowData.MainCurrency + "</span>");
	                    }
	                },
	                { data: 'LevelCode' },
	                {
	                    data: 'Created',
	                    render: function (data, type, rowData) {
	                        return ("<span id='Created" + rowData.Id + "'>" + DateUtils_1.DateUtils.toDefaultWithTime(data) + "</span>");
	                    } },
	                {
	                    data: 'Started',
	                    render: function (data, type, rowData) {
	                        return ("<span id='Started" + rowData.Id + "'>" + DateUtils_1.DateUtils.toDefaultWithTime(data) + "</span>");
	                    } },
	                {
	                    data: 'Finished',
	                    render: function (data, type, rowData) {
	                        return ("<span id='Finished" + rowData.Id + "'>" + DateUtils_1.DateUtils.toDefaultWithTime(data) + "</span>");
	                    } },
	                {
	                    orderable: false,
	                    data: 'filterButtons',
	                    defaultContent: '',
	                    searchable: false,
	                    sortable: false
	                }
	            ],
	            order: [[COLUMNS_INDEX.TicketId, "desc"]],
	            callbacks: {
	                preDrawCallback: this.preDrawCallback
	            }
	        };
	    }
	    PendingHandpayWins.prototype.init = function () {
	        this._form = Utils_1.Utils.getJQueryById(formId);
	        this._btnCancelSearch = Utils_1.Utils.getJQueryById(btnCancelSearchId);
	        this._filterTicketId = Utils_1.Utils.getJQueryById('filterGameRoundId');
	        this._filterPlayer = Utils_1.Utils.getJQueryById('filterPlayer');
	        this._filterBonus = new MultiSelect_1.MultiSelectApi('filterBonus');
	        this._filterCustomer = new MultiSelect_1.MultiSelectApi('filterCustomer');
	        this._filterCustomerOperation = new MultiSelect_1.MultiSelectApi('filterCustomerOperation');
	        this._filterCreatedFrom = new DateTimePicker_1.DateTimePickerApi('filterCreatedFrom');
	        this._filterCreatedTo = new DateTimePicker_1.DateTimePickerApi('filterCreatedTo');
	        this._chckAllWins = Utils_1.Utils.getJQueryById("winSelectAll");
	        this._chckAllWins.on("change", this.checkBoxAll);
	        this._btnConfirm = Utils_1.Utils.getJQueryById("btnConfirm");
	        this._btnConfirm.on("click", this.confirmWins);
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	        this._form.on('submit', this.formSubmit);
	        this._btnCancelSearch.on('click', this.cancelSearch);
	    };
	    PendingHandpayWins.prototype.cancelSearch = function (e) {
	        this._filterBonus.selectAll();
	        this._filterCustomer.selectAll();
	        this._filterCustomerOperation.selectAll();
	        this._filterTicketId.val('');
	        this._filterPlayer.val('');
	        this._filterCreatedFrom.clearDates();
	        this._filterCreatedTo.clearDates();
	    };
	    PendingHandpayWins.prototype.formSubmit = function (e) {
	        e.preventDefault();
	        this._table.draw();
	        return false;
	    };
	    PendingHandpayWins.prototype.preDrawCallback = function (datatable) {
	        var filterTicketId = this._filterTicketId.val();
	        datatable.columns(COLUMNS_INDEX.TicketId).search(filterTicketId);
	        var filterPlayer = this._filterPlayer.val();
	        datatable.columns(COLUMNS_INDEX.Player).search(filterPlayer);
	        var filterBonus = this._filterBonus.isAllSelected() ? '' : this._filterBonus.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.Bonus).search(filterBonus);
	        var filterCustomer = this._filterCustomer.isAllSelected() ? '' : this._filterCustomer.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.Customer).search(filterCustomer);
	        var filterCustomerOperation = this._filterCustomerOperation.isAllSelected() ? '' : this._filterCustomerOperation.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.CustomerOperation).search(filterCustomerOperation);
	        var filterCreatedFrom = this._filterCreatedFrom.getUnixTimestamp();
	        var filterCreatedTo = this._filterCreatedTo.getUTCDate();
	        var filterCreated = filterCreatedFrom + FILTER_DELIM + filterCreatedTo;
	        datatable.columns(COLUMNS_INDEX.Created).search(filterCreated);
	    };
	    PendingHandpayWins.prototype.checkBoxAll = function () {
	        var checkboxes = $("input[name='selectedWin']");
	        for (var i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = this._chckAllWins[0].checked;
	        }
	    };
	    PendingHandpayWins.prototype.setWinsSelectAllCheckbox = function () {
	        var checkboxes = $("input[name='selectedWin']");
	        var winSelectAll = Utils_1.Utils.getJQueryById("winSelectAll")[0];
	        if (Utils_1.Utils.isNullOrUndefined(winSelectAll))
	            return;
	        var allCheckboxesChecked = false;
	        for (var i = 0; i < checkboxes.length; i++) {
	            allCheckboxesChecked = checkboxes[i].checked;
	            if (!allCheckboxesChecked)
	                break;
	        }
	        winSelectAll.checked = allCheckboxesChecked;
	    };
	    PendingHandpayWins.prototype.confirmWins = function (e) {
	        e.preventDefault();
	        var urlPost = this._options.urlPost;
	        var table = this._table;
	        var ids = $("input[name='selectedWin']:checked").map(function () {
	            return $(this).val();
	        });
	        var idsToConfirm = ids.get();
	        if (!idsToConfirm || idsToConfirm.length === 0) {
	            return;
	        }
	        var statusMessage = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	        $.ajax({
	            url: urlPost,
	            type: "POST",
	            dataType: 'html',
	            data: { ids: idsToConfirm },
	            success: function (data) {
	                table.draw();
	                statusMessage.html(data);
	                StatusMessageHelper_1.StatusMessageHelper.initValidator();
	                StatusMessageHelper_1.StatusMessageHelper.initSatusMessage();
	            }
	        });
	    };
	    return PendingHandpayWins;
	}(PageBase_1.PageBase));
	exports.PendingHandpayWins = PendingHandpayWins;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var MultiSelect_1 = __webpack_require__(52);
	var DateTimePicker_1 = __webpack_require__(57);
	var Utils_1 = __webpack_require__(5);
	var DateUtils_1 = __webpack_require__(48);
	var tableId = 'tableBonusWins';
	var formId = 'formBonusWins';
	var btnCancelSearchId = 'btnCancelSearch';
	var FILTER_DELIM = '-delim-';
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-12't>r>" + "<'row'<''i><''p>>";
	var COLUMNS_INDEX = {
	    TicketId: 0,
	    Status: 1,
	    Handpay: 2,
	    Bonus: 3,
	    Player: 4,
	    Customer: 5,
	    CustomerOperation: 6,
	    PlayerWinAmount: 7,
	    MainWinAmount: 8,
	    Level: 9,
	    Created: 10,
	    Started: 11,
	    Finished: 12,
	    Canceled: 13,
	    Result: 14
	};
	var Wins = (function (_super) {
	    __extends(Wins, _super);
	    function Wins(options) {
	        _super.call(this, options);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        var getCustomerDetailUrl = function (rowData) { return (options.urlCustomerDetail + "/" + rowData.CustomerId); };
	        var getPlayerDetailUrl = function (rowData) { return (options.urlPlayerDetail + "/" + rowData.PlayerId); };
	        var getBonusDetailUrl = function (rowData) { return (options.urlBonusDetail + "/" + rowData.BonusId); };
	        var getCustomerOperationDetailUrl = function (rowData) { return (options.urlCustomerOperationDetail + "/" + rowData.CustomerOperationId); };
	        this.formSubmit = this.formSubmit.bind(this);
	        this.cancelSearch = this.cancelSearch.bind(this);
	        this.preDrawCallback = this.preDrawCallback.bind(this);
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            scrollX: false,
	            fixedHeader: false,
	            columns: [
	                {
	                    data: "Id",
	                    className: "bold",
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkDetail" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                { data: 'Status' },
	                { data: 'Handpay' },
	                {
	                    data: 'BonusName',
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkBonusDetail" + rowData.Id + "' href='" + getBonusDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: 'PlayerRemoteId',
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkPlayerDetail" + rowData.Id + "' href='" + getPlayerDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: 'CustomerName',
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkCustomerDetail" + rowData.Id + "' href='" + getCustomerDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: 'CustomerOperationName',
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkCustomerDetail" + rowData.Id + "' href='" + getCustomerOperationDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: 'PlayerWinAmount',
	                    render: function (data, type, rowData) {
	                        return ("<span id='PlayerWinAmount" + rowData.Id + "'>" + (Utils_1.Utils.isNullOrUndefined(data) ? "" : data + " " + rowData.PlayerCurrency) + "</span>");
	                    }
	                },
	                {
	                    data: 'MainWinAmount',
	                    render: function (data, type, rowData) {
	                        return ("<span id='MainWinAmount" + rowData.Id + "'>" + (Utils_1.Utils.isNullOrUndefined(data) ? "" : data + " " + rowData.MainCurrency) + "</span>");
	                    }
	                },
	                {
	                    data: 'LevelCode',
	                    render: function (data, type, rowData) {
	                        return ("<span id='LevelCode" + rowData.Id + "'>" + (Utils_1.Utils.isNullOrUndefined(data) ? "" : data) + "</span>");
	                    } },
	                {
	                    data: 'Created',
	                    render: function (data, type, rowData) {
	                        return ("<span id='Created" + rowData.Id + "'>" + DateUtils_1.DateUtils.toDefaultWithTime(data) + "</span>");
	                    } },
	                {
	                    data: 'Started',
	                    render: function (data, type, rowData) {
	                        return ("<span id='Started" + rowData.Id + "'>" + DateUtils_1.DateUtils.toDefaultWithTime(data) + "</span>");
	                    } },
	                {
	                    data: 'Finished',
	                    render: function (data, type, rowData) {
	                        return ("<span id='Finished" + rowData.Id + "'>" + DateUtils_1.DateUtils.toDefaultWithTime(data) + "</span>");
	                    }
	                },
	                {
	                    data: 'Canceled',
	                    render: function (data, type, rowData) {
	                        return ("<span id='PaidCanceled" + rowData.Id + "'>" + (Utils_1.Utils.isNullOrUndefined(data) ? DateUtils_1.DateUtils.toDefaultWithTime(rowData.Paid) : DateUtils_1.DateUtils.toDefaultWithTime(data)) + "</span>");
	                    }
	                },
	                {
	                    data: 'Result',
	                    render: function (data, type, rowData) {
	                        return ("<span id='Result" + rowData.Id + "'>" + (Utils_1.Utils.isNullOrUndefined(data) ? "" : data) + "</span>");
	                    } },
	                {
	                    orderable: false,
	                    data: 'filterButtons',
	                    defaultContent: '',
	                    searchable: false,
	                    sortable: false
	                }
	            ],
	            order: [[COLUMNS_INDEX.TicketId, "desc"]],
	            callbacks: {
	                preDrawCallback: this.preDrawCallback
	            }
	        };
	    }
	    Wins.prototype.init = function () {
	        this._form = Utils_1.Utils.getJQueryById(formId);
	        this._btnCancelSearch = Utils_1.Utils.getJQueryById(btnCancelSearchId);
	        this._filterTicketId = Utils_1.Utils.getJQueryById('filterGameRoundId');
	        this._filterBonus = new MultiSelect_1.MultiSelectApi('filterBonus');
	        this._filterCustomer = new MultiSelect_1.MultiSelectApi('filterCustomer');
	        this._filterCustomerOperation = new MultiSelect_1.MultiSelectApi('filterCustomerOperation');
	        this._filterStatus = new MultiSelect_1.MultiSelectApi('filterStatus');
	        this._filterHandpay = new MultiSelect_1.MultiSelectApi('filterHandpay');
	        this._filterPlayer = Utils_1.Utils.getJQueryById('filterPlayer');
	        this._filterLevel = new MultiSelect_1.MultiSelectApi('filterLevel');
	        this._filterResult = new MultiSelect_1.MultiSelectApi('filterResult');
	        this._filterStartedFrom = new DateTimePicker_1.DateTimePickerApi('filterStartedFrom');
	        this._filterStartedTo = new DateTimePicker_1.DateTimePickerApi('filterStartedTo');
	        this._filterFinishedFrom = new DateTimePicker_1.DateTimePickerApi('filterFinishedFrom');
	        this._filterFinishedTo = new DateTimePicker_1.DateTimePickerApi('filterFinishedTo');
	        this._filterCreatedFrom = new DateTimePicker_1.DateTimePickerApi('filterCreatedFrom');
	        this._filterCreatedTo = new DateTimePicker_1.DateTimePickerApi('filterCreatedTo');
	        this._filterPaidCanceledFrom = new DateTimePicker_1.DateTimePickerApi('filterPaidCanceledFrom');
	        this._filterPaidCanceledTo = new DateTimePicker_1.DateTimePickerApi('filterPaidCanceledTo');
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	        this._form.on('submit', this.formSubmit);
	        this._btnCancelSearch.on('click', this.cancelSearch);
	    };
	    Wins.prototype.cancelSearch = function (e) {
	        this._filterBonus.selectAll();
	        this._filterCustomer.selectAll();
	        this._filterCustomerOperation.selectAll();
	        this._filterTicketId.val('');
	        this._filterStatus.selectAll();
	        this._filterHandpay.selectAll();
	        this._filterPlayer.val('');
	        this._filterLevel.selectAll();
	        this._filterStartedFrom.clearDates();
	        this._filterStartedTo.clearDates();
	        this._filterFinishedFrom.clearDates();
	        this._filterFinishedTo.clearDates();
	        this._filterCreatedFrom.clearDates();
	        this._filterCreatedTo.clearDates();
	        this._filterPaidCanceledFrom.clearDates();
	        this._filterPaidCanceledTo.clearDates();
	    };
	    Wins.prototype.formSubmit = function (e) {
	        e.preventDefault();
	        this._table.draw();
	        return false;
	    };
	    Wins.prototype.preDrawCallback = function (datatable) {
	        var filterTicketId = this._filterTicketId.val();
	        datatable.columns(COLUMNS_INDEX.TicketId).search(filterTicketId);
	        var filterBonus = this._filterBonus.isAllSelected() ? '' : this._filterBonus.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.Bonus).search(filterBonus);
	        var filterCustomer = this._filterCustomer.isAllSelected() ? '' : this._filterCustomer.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.Customer).search(filterCustomer);
	        var filterCustomerOperation = this._filterCustomerOperation.isAllSelected() ? '' : this._filterCustomerOperation.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.CustomerOperation).search(filterCustomerOperation);
	        var filterStatus = this._filterStatus.isAllSelected() ? '' : this._filterStatus.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.Status).search(filterStatus);
	        var filterHandpay = this._filterHandpay.isAllSelected() ? '' : this._filterHandpay.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.Handpay).search(filterHandpay);
	        var filterPlayer = this._filterPlayer.val();
	        datatable.columns(COLUMNS_INDEX.Player).search(filterPlayer);
	        var filterLevel = this._filterLevel.isAllSelected() ? '' : this._filterLevel.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.Level).search(filterLevel);
	        var filterResult = this._filterResult.isAllSelected() ? '' : this._filterResult.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.Result).search(filterResult);
	        var filterStartedFrom = this._filterStartedFrom.getUnixTimestamp();
	        var filterStartedTo = this._filterStartedTo.getUTCDate();
	        var filterStarted = filterStartedFrom + FILTER_DELIM + filterStartedTo;
	        datatable.columns(COLUMNS_INDEX.Started).search(filterStarted);
	        var filterFinishedFrom = this._filterFinishedFrom.getUnixTimestamp();
	        var filterFinishedTo = this._filterFinishedTo.getUTCDate();
	        var filterFinished = filterFinishedFrom + FILTER_DELIM + filterFinishedTo;
	        datatable.columns(COLUMNS_INDEX.Finished).search(filterFinished);
	        var filterCreatedFrom = this._filterCreatedFrom.getUnixTimestamp();
	        var filterCreatedTo = this._filterCreatedTo.getUTCDate();
	        var filterCreated = filterCreatedFrom + FILTER_DELIM + filterCreatedTo;
	        datatable.columns(COLUMNS_INDEX.Created).search(filterCreated);
	        var filterPaidCanceledFrom = this._filterPaidCanceledFrom.getUnixTimestamp();
	        var filterPaidCanceledTo = this._filterPaidCanceledTo.getUTCDate();
	        var filterPaidCanceled = filterPaidCanceledFrom + FILTER_DELIM + filterPaidCanceledTo;
	        datatable.columns(COLUMNS_INDEX.Canceled).search(filterPaidCanceled);
	    };
	    return Wins;
	}(PageBase_1.PageBase));
	exports.Wins = Wins;


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var DateUtils_1 = __webpack_require__(48);
	var tableId = 'tableGameTransactions';
	var tableDom = "<'row'<'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var Win = (function (_super) {
	    __extends(Win, _super);
	    function Win(options) {
	        _super.call(this, options);
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            columns: [
	                {
	                    data: 'Type',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnType" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Id',
	                    className: "bold",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnName" + rowData.Id + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: 'ExternalParentId',
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnExternalParentId" + rowData.Id + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: 'ReversedBy',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnReversedBy" + rowData.Id + "'>" + (data || '') + "</span>");
	                    },
	                },
	                {
	                    data: 'RealAmount',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnRealAmount" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'BonusAmount',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnBonusAmount" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Status',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnStatus" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Forced',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnForced" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Created',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCreated" + rowData.Id + "'>" + DateUtils_1.DateUtils.toDefaultWithTime(data) + "</span>");
	                    }
	                },
	                {
	                    data: 'Completed',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCompleted" + rowData.Id + "'>" + DateUtils_1.DateUtils.toDefaultWithTime(data) + "</span>");
	                    }
	                },
	                {
	                    data: 'RemoteId',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnRemoteId" + rowData.Id + "'>" + (data || '') + "</span>");
	                    }
	                },
	                {
	                    data: 'RealBalance',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnRealBalance" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'BonusBalance',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnBonusBalance" + rowData.Id + "'>" + data + "</span>");
	                    }
	                }
	            ],
	            order: [[1, "asc"]]
	        };
	    }
	    Win.prototype.init = function () {
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	    };
	    return Win;
	}(PageBase_1.PageBase));
	exports.Win = Win;


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var tableId = 'tableSnapshot';
	var tableDom = "<'row'<'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var Snapshot = (function (_super) {
	    __extends(Snapshot, _super);
	    function Snapshot(options) {
	        _super.call(this, options);
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Name',
	            autoWidth: true,
	            columns: [
	                {
	                    data: 'Name',
	                    sortable: false,
	                    width: "30%",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnSnapshotName" + rowData.Name + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'MainCurrencyBeforeWinValue',
	                    sortable: false,
	                    width: "17%",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnMainCurrencyBeforeWinValue" + rowData.Name + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'MainCurrencyAfterWinValue',
	                    sortable: false,
	                    width: "17%",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnMainCurrencyAfterWinValue" + rowData.Name + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'PlayerCurrencyBeforeWinValue',
	                    sortable: false,
	                    width: "18%",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnPlayerCurrencyBeforeWinValue" + rowData.Name + "'>" + data + "</span>");
	                    },
	                },
	                {
	                    data: 'PlayerCurrencyAfterWinValue',
	                    sortable: false,
	                    width: "18%",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnPlayerCurrencyAfterWinValue" + rowData.Name + "'>" + data + "</span>");
	                    }
	                }
	            ]
	        };
	    }
	    Snapshot.prototype.init = function () {
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	    };
	    return Snapshot;
	}(PageBase_1.PageBase));
	exports.Snapshot = Snapshot;


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var Utils_1 = __webpack_require__(5);
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var GameConfigurationPage = (function (_super) {
	    __extends(GameConfigurationPage, _super);
	    function GameConfigurationPage(options) {
	        _super.call(this, options);
	        this._tableId = "tableGameConfigurations";
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Game',
	            autoWidth: true,
	            columns: [
	                {
	                    data: 'Game',
	                    className: "bold"
	                },
	                {
	                    data: "CustomerOperation",
	                    sortable: false
	                },
	                {
	                    data: "Currencies",
	                    sortable: false
	                },
	            ]
	        };
	    }
	    GameConfigurationPage.prototype.init = function () {
	        if (Utils_1.Utils.isNullOrUndefined(this._tableOptions))
	            return;
	        this._table = new Datatable_1.Datatable(this._tableId, this._tableOptions);
	    };
	    return GameConfigurationPage;
	}(PageBase_1.PageBase));
	exports.GameConfigurationPage = GameConfigurationPage;


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var Utils_1 = __webpack_require__(5);
	var DateUtils_1 = __webpack_require__(48);
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var ConfigurationPage = (function (_super) {
	    __extends(ConfigurationPage, _super);
	    function ConfigurationPage(options) {
	        _super.call(this, options);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        this._tableId = "tableConfigurations";
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Version',
	            autoWidth: true,
	            pageLength: 100,
	            lengthMenu: [[20, 100, 200, -1], [20, 100, 200, "All"]],
	            columns: [
	                {
	                    data: 'Activated',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnActivated" + rowData.Id + "'>" + DateUtils_1.DateUtils.toDefaultWithTimeExt(data, false) + "</span>");
	                    },
	                },
	                {
	                    data: "Version"
	                },
	                {
	                    data: "Status"
	                },
	                {
	                    data: '',
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkDetail" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + options.localizer.DetailsLink + "</a>");
	                    }
	                }
	            ],
	            order: [[1, "desc"]],
	        };
	    }
	    ConfigurationPage.prototype.init = function () {
	        if (Utils_1.Utils.isNullOrUndefined(this._tableOptions))
	            return;
	        this._table = new Datatable_1.Datatable(this._tableId, this._tableOptions);
	        var exportBounsButton = document.getElementById("btnUpdateExportBounsAction");
	        if (exportBounsButton != null) {
	            exportBounsButton.onclick = function () {
	                var errorExportBounsButton = document.getElementById("spnExportBounsValidation");
	                if (errorExportBounsButton != null) {
	                    errorExportBounsButton.hidden = true;
	                }
	            };
	        }
	    };
	    return ConfigurationPage;
	}(PageBase_1.PageBase));
	exports.ConfigurationPage = ConfigurationPage;


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var StatusMessage_1 = __webpack_require__(61);
	var Utils_1 = __webpack_require__(5);
	var StatusMessageHelper_1 = __webpack_require__(50);
	var ConfigurationDetailPage = (function (_super) {
	    __extends(ConfigurationDetailPage, _super);
	    function ConfigurationDetailPage(options) {
	        _super.call(this, options);
	        this.setConfiguration = this.setConfiguration.bind(this);
	        this.openDialog = this.openDialog.bind(this);
	        this.calculateContribution = this.calculateContribution.bind(this);
	    }
	    ConfigurationDetailPage.prototype.init = function () {
	        var _this = this;
	        this.fileInput = document.getElementById("fileInput");
	        this.importButton = document.getElementById("btnImportFile");
	        if (this.importButton != null) {
	            this.importButton.onclick = function () { return _this.setConfiguration(); };
	            this.fileInput.onchange = function () { return _this.setImportFileButtonDisabledProp(); };
	            this.setImportFileButtonDisabledProp();
	        }
	        this.submitButton = document.getElementById("btnSubmit");
	        if (this.submitButton != null) {
	            this.submitButton.onclick = function () { return _this.calculateContribution(); };
	        }
	        this.closeDialogButton = document.getElementById("btnHideConfirmation");
	        this.closeDialogButton.onclick = function () { return _this.closeDialog(); };
	        this.configurationForm = document.getElementById("frmBonusConfiguration");
	    };
	    ConfigurationDetailPage.prototype.setConfiguration = function () {
	        var importButton = this.importButton;
	        importButton.disabled = true;
	        var data = new FormData();
	        data.append('file', this.fileInput.files[0]);
	        data.append('name', this._options.bonusName);
	        $.ajax({
	            url: this._options.processUrl,
	            type: "POST",
	            processData: false,
	            contentType: false,
	            data: data,
	            success: function (data) {
	                window.editor.set(data.configuration);
	                Utils_1.Utils.getJQueryById("BonusConfigurationJson").val(window.editor.getText());
	                document.getElementById("btnSubmit").style.display = null;
	            },
	            complete: function (data) {
	                var statusMessageWrapper = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	                var statusMessageData = JSON.parse(data.responseJSON.statusMessages);
	                var statusMessage = new StatusMessage_1.StatusMessage(statusMessageData);
	                statusMessageWrapper.html(statusMessage.getHTMLmessage());
	                StatusMessageHelper_1.StatusMessageHelper.initValidator();
	                StatusMessageHelper_1.StatusMessageHelper.initSatusMessage();
	            },
	            error: function (jqXHR, textStatus, errorThrown) {
	                importButton.disabled = false;
	                if (jqXHR.status === 404) {
	                    window.location.replace(window.location.href);
	                }
	            }
	        });
	    };
	    ConfigurationDetailPage.prototype.openDialog = function () {
	        document.getElementById("configurationConfirmation").hidden = false;
	    };
	    ConfigurationDetailPage.prototype.closeDialog = function () {
	        document.getElementById("configurationConfirmation").hidden = true;
	    };
	    ConfigurationDetailPage.prototype.calculateContribution = function () {
	        var jsonString = Utils_1.Utils.getJQueryById("#BonusConfigurationJson").val();
	        var json = JSON.parse(jsonString);
	        var totalContribution = 0;
	        totalContribution += json['bonusData']['baseBufferContribution'];
	        var levels = json['levelsData']['levelConfigurations'];
	        for (var i = 0; i < levels.length; i++) {
	            totalContribution += levels[i]['hiddenContribution'];
	            totalContribution += levels[i]['visibleContribution'];
	        }
	        Utils_1.Utils.getJQueryById("#spnContributionValue").text(totalContribution.toFixed(4).replace(/\.?0+$/, ""));
	        if (totalContribution > 10) {
	            document.getElementById("spnContributionTooHigh").style.display = null;
	            document.getElementById("spnContributionWarning").style.display = "none";
	            document.getElementById("btnConfirm").style.display = "none";
	            this.openDialog();
	        }
	        else if (totalContribution >= 2) {
	            document.getElementById("spnContributionTooHigh").style.display = "none";
	            document.getElementById("spnContributionWarning").style.display = null;
	            document.getElementById("btnConfirm").style.display = null;
	            this.openDialog();
	        }
	        else {
	            this.configurationForm.submit();
	        }
	    };
	    ConfigurationDetailPage.prototype.setImportFileButtonDisabledProp = function () {
	        this.importButton.disabled = this.fileInput.files.length == 0;
	    };
	    return ConfigurationDetailPage;
	}(PageBase_1.PageBase));
	exports.ConfigurationDetailPage = ConfigurationDetailPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var Utils_1 = __webpack_require__(5);
	var DateUtils_1 = __webpack_require__(48);
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var AssignedCustomerOperationsPage = (function (_super) {
	    __extends(AssignedCustomerOperationsPage, _super);
	    function AssignedCustomerOperationsPage(options) {
	        _super.call(this, options);
	        var getCustomerDetailUrl = function (rowData) { return (options.urlCustomerDetail + "/" + rowData.CustomerId); };
	        var getOperationDetailUrl = function (rowData) { return (options.urlCustomerOperationDetail + "/" + rowData.CustomerOperationId); };
	        this._tableId = "tableAssignedCustomerOperations";
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'CustomerOperationId',
	            autoWidth: true,
	            pageLength: 100,
	            lengthMenu: [[20, 100, 200, -1], [20, 100, 200, "All"]],
	            columns: [
	                {
	                    orderable: false,
	                    searchable: false,
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        if (rowData.RelationStatus == 'Removed') {
	                            return ("");
	                        }
	                        else {
	                            return ("<input id='chckbx" + rowData.Id + "' name='selectedCustomerOperations' value='" + rowData.CustomerOperationId + "' type='checkbox' />");
	                        }
	                    }
	                },
	                {
	                    data: 'CustomerName',
	                    render: function (data, type, rowData) {
	                        return ("<a href='" + getCustomerDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: "CustomerCode",
	                },
	                {
	                    data: "CustomerOperationName",
	                    render: function (data, type, rowData) {
	                        return ("<a href='" + getOperationDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: "CustomerOperationCode",
	                },
	                {
	                    data: "AssignedDate",
	                    render: function (data, type, rowData) {
	                        return ("<span>" + DateUtils_1.DateUtils.toDefaultWithTime(data) + "</span>");
	                    }
	                },
	                {
	                    data: "RemovedDate",
	                    render: function (data, type, rowData) {
	                        return ("<span>" + DateUtils_1.DateUtils.toDefaultWithTime(data) + "</span>");
	                    }
	                },
	                {
	                    data: "RelationStatus"
	                },
	            ]
	        };
	    }
	    AssignedCustomerOperationsPage.prototype.removeSelected = function (that) {
	        var ids = $("input[name='selectedCustomerOperations']:checked").map(function () {
	            return $(this).val();
	        });
	        var idsToAdd = ids.get();
	        if (!idsToAdd || idsToAdd.length === 0) {
	            return;
	        }
	        $.ajax({
	            url: this._options.urlRemoveSelected,
	            type: "POST",
	            data: { bonusId: this._options.bonusId, customerOperationIds: idsToAdd },
	            success: function () {
	                that._table.draw();
	            }
	        });
	    };
	    AssignedCustomerOperationsPage.prototype.openDialog = function () {
	        document.getElementById("areYouSureConfirmation").hidden = false;
	    };
	    AssignedCustomerOperationsPage.prototype.closeDialog = function () {
	        document.getElementById("areYouSureConfirmation").hidden = true;
	    };
	    AssignedCustomerOperationsPage.prototype.init = function () {
	        var _this = this;
	        if (Utils_1.Utils.isNullOrUndefined(this._tableOptions))
	            return;
	        this._table = new Datatable_1.Datatable(this._tableId, this._tableOptions);
	        this._btnRemoveSelected = Utils_1.Utils.getJQueryById("lnkRemoveSelected");
	        var confirmButton = document.getElementById("btnConfirm");
	        var closeButton = document.getElementById("btnHideConfirmation");
	        var that = this;
	        this._btnRemoveSelected.on("click", function (e) {
	            var ids = $("input[name='selectedCustomerOperations']:checked").map(function () {
	                return $(this).val();
	            });
	            var idsToAdd = ids.get();
	            if (!idsToAdd || idsToAdd.length === 0) {
	                return;
	            }
	            _this.openDialog();
	        });
	        confirmButton.onclick = function () {
	            _this.removeSelected(that);
	            _this.closeDialog();
	        };
	        closeButton.onclick = function () { return _this.closeDialog(); };
	    };
	    return AssignedCustomerOperationsPage;
	}(PageBase_1.PageBase));
	exports.AssignedCustomerOperationsPage = AssignedCustomerOperationsPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var MultiSelect_1 = __webpack_require__(52);
	var Utils_1 = __webpack_require__(5);
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var FILTER_DELIM = '-delim-';
	var COLUMNS_INDEX = {
	    Customer: 0,
	    CustomerCode: 1,
	    OperationName: 2,
	    OperationCode: 3,
	    OperationStatus: 4
	};
	var AvailableCustomerOperationsPage = (function (_super) {
	    __extends(AvailableCustomerOperationsPage, _super);
	    function AvailableCustomerOperationsPage(options) {
	        _super.call(this, options);
	        var getCustomerDetailUrl = function (rowData) { return (options.urlCustomerDetail + "/" + rowData.CustomerId); };
	        var getOperationDetailUrl = function (rowData) { return (options.urlCustomerOperationDetail + "/" + rowData.OperationId); };
	        var getAssignOperationUrl = function (rowData) { return (options.urlAssignOperation + "&customerOperationId=" + rowData.OperationId); };
	        this.formSubmit = this.formSubmit.bind(this);
	        this.cancelSearch = this.cancelSearch.bind(this);
	        this.preDrawCallback = this.preDrawCallback.bind(this);
	        this._tableId = "tableAvailableCustomerOperations";
	        this._formId = "formAvailableCustomerOperations";
	        this._btnCancelSearchId = "btnCancelSearch";
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'OperationId',
	            autoWidth: true,
	            columns: [
	                {
	                    data: 'CustomerName',
	                    render: function (data, type, rowData) {
	                        return ("<a href='" + getCustomerDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: "CustomerCode",
	                },
	                {
	                    data: "OperationName",
	                    render: function (data, type, rowData) {
	                        return ("<a href='" + getOperationDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: "OperationCode",
	                },
	                {
	                    data: "OperationStatus",
	                },
	                {
	                    orderable: false,
	                    searchable: false,
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<a class=\"assignOperationLink\" data-operationId=\"" + rowData.OperationId + "\" data-operationName=\"" + rowData.OperationName + "\" data-customerId=\"" + rowData.CustomerId + "\" data-customerName=\"" + rowData.CustomerName + "\" href=" + getAssignOperationUrl(rowData) + ">Assign</a>");
	                    }
	                },
	            ],
	            callbacks: {
	                preDrawCallback: this.preDrawCallback
	            }
	        };
	    }
	    AvailableCustomerOperationsPage.prototype.init = function () {
	        var _this = this;
	        this._form = Utils_1.Utils.getJQueryById(this._formId);
	        this._btnCancelSearch = Utils_1.Utils.getJQueryById(this._btnCancelSearchId);
	        this._filterCustomerCode = Utils_1.Utils.getJQueryById('filterCustomerCode');
	        this._filterOperationName = Utils_1.Utils.getJQueryById('filterOperationName');
	        this._filterOperationCode = Utils_1.Utils.getJQueryById('filterOperationCode');
	        this._filterCustomer = new MultiSelect_1.MultiSelectApi('filterCustomer');
	        this._table = new Datatable_1.Datatable(this._tableId, this._tableOptions);
	        this._form.on('submit', this.formSubmit);
	        this._btnCancelSearch.on('click', this.cancelSearch);
	        var that = this;
	        var confirmButton = document.getElementById("btnConfirm");
	        var closeButton = document.getElementById("btnHideConfirmation");
	        var assignOperationLink;
	        $(document).on('click', '.assignOperationLink', function (e) {
	            var operationNameAndId = e.target.attributes['data-operationName'].value + ' (' + e.target.attributes['data-operationId'].value + ')';
	            var customerNameAndId = e.target.attributes['data-customerName'].value + ' (' + e.target.attributes['data-customerId'].value + ')';
	            $("#operation-name-confirmation").text(operationNameAndId);
	            $("#customer-name-confirmation").text(customerNameAndId);
	            assignOperationLink = e.target.attributes['href'].value;
	            that.assignOperation(e);
	        });
	        confirmButton.onclick = function () {
	            window.location.href = assignOperationLink;
	        };
	        closeButton.onclick = function () { return _this.closeDialog(); };
	    };
	    AvailableCustomerOperationsPage.prototype.assignOperation = function (e) {
	        e.preventDefault();
	        this.openDialog();
	    };
	    AvailableCustomerOperationsPage.prototype.openDialog = function () {
	        document.getElementById("areYouSureConfirmation").hidden = false;
	    };
	    AvailableCustomerOperationsPage.prototype.closeDialog = function () {
	        document.getElementById("areYouSureConfirmation").hidden = true;
	    };
	    AvailableCustomerOperationsPage.prototype.cancelSearch = function (e) {
	        this._filterCustomerCode.val('');
	        this._filterOperationName.val('');
	        this._filterOperationCode.val('');
	        this._filterCustomer.selectAll();
	    };
	    AvailableCustomerOperationsPage.prototype.formSubmit = function (e) {
	        e.preventDefault();
	        this._table.draw();
	        return false;
	    };
	    AvailableCustomerOperationsPage.prototype.preDrawCallback = function (datatable) {
	        var filterCustomerCode = this._filterCustomerCode.val();
	        datatable.columns(COLUMNS_INDEX.CustomerCode).search(filterCustomerCode);
	        var filterOperationName = this._filterOperationName.val();
	        datatable.columns(COLUMNS_INDEX.OperationName).search(filterOperationName);
	        var filterOperationCode = this._filterOperationCode.val();
	        datatable.columns(COLUMNS_INDEX.OperationCode).search(filterOperationCode);
	        var filterCustomer = this._filterCustomer.isAllSelected() ? '' : this._filterCustomer.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.Customer).search(filterCustomer);
	    };
	    return AvailableCustomerOperationsPage;
	}(PageBase_1.PageBase));
	exports.AvailableCustomerOperationsPage = AvailableCustomerOperationsPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var MultiSelect_1 = __webpack_require__(52);
	var DateTimePicker_1 = __webpack_require__(57);
	var Utils_1 = __webpack_require__(5);
	var StatusMessageHelper_1 = __webpack_require__(50);
	var StatusMessage_1 = __webpack_require__(61);
	var DateUtils_1 = __webpack_require__(48);
	var FILTER_DELIM = '-delim-';
	var checkboxName = 'selectedTicketId';
	var batchSize = 100;
	var ProgressiveBonusBrowseRequest = (function () {
	    function ProgressiveBonusBrowseRequest() {
	    }
	    return ProgressiveBonusBrowseRequest;
	}());
	var IndexPage = (function () {
	    function IndexPage(options) {
	        this.run = this.run.bind(this);
	        this.loadMore = this.loadMore.bind(this);
	        this.resetFilter = this.resetFilter.bind(this);
	        this.getCountResult = this.getCountResult.bind(this);
	        this.showLoadMoreButton = this.showLoadMoreButton.bind(this);
	        this.hideLoadMoreButton = this.hideLoadMoreButton.bind(this);
	        this.enableRunButton = this.enableRunButton.bind(this);
	        this.checkBoxAll = this.checkBoxAll.bind(this);
	        this._options = options;
	        this._filterTicketId = Utils_1.Utils.getJQueryById("filterTicketId");
	        this._filterPlayer = Utils_1.Utils.getJQueryById("filterPlayer");
	        this._filterStatus = new MultiSelect_1.MultiSelectApi("filterStatus");
	        this._filterHandPay = new MultiSelect_1.MultiSelectApi("filterHandpay");
	        this._filterBonus = new MultiSelect_1.MultiSelectApi("filterBonus");
	        this._filterCustomer = new MultiSelect_1.MultiSelectApi("filterCustomer");
	        this._filterCustomerOperation = new MultiSelect_1.MultiSelectApi("filterCustomerOperation");
	        this._filterLevelWon = new MultiSelect_1.MultiSelectApi("filterLevel");
	        this._filterResult = new MultiSelect_1.MultiSelectApi("filterResult");
	        this._filterStartedFrom = new DateTimePicker_1.DateTimePickerApi("filterStartedFrom");
	        this._filterStartedTo = new DateTimePicker_1.DateTimePickerApi("filterStartedTo");
	        this._filterFinishedFrom = new DateTimePicker_1.DateTimePickerApi("filterFinishedFrom");
	        this._filterFinishedTo = new DateTimePicker_1.DateTimePickerApi("filterFinishedTo");
	        this._filterCreatedFrom = new DateTimePicker_1.DateTimePickerApi("filterCreatedFrom");
	        this._filterCreatedTo = new DateTimePicker_1.DateTimePickerApi("filterCreatedTo");
	        this._filterPaidCanceledFrom = new DateTimePicker_1.DateTimePickerApi("filterPaidCanceledFrom");
	        this._filterPaidCanceledTo = new DateTimePicker_1.DateTimePickerApi("filterPaidCanceledTo");
	        this._source = Utils_1.Utils.getJQueryById("source");
	        this._runButton = Utils_1.Utils.getJQueryById("btnRunQuery");
	        this._runButton.on("click", this.run);
	        this._loadMoreButton = Utils_1.Utils.getJQueryById("btnLoadMore");
	        this._loadMoreButton.on("click", this.loadMore);
	        this._resetFilterButton = Utils_1.Utils.getJQueryById("btnResetFilter");
	        this._resetFilterButton.on("click", this.resetFilter);
	        this._btnCountResult = Utils_1.Utils.getJQueryById("btnCountResult");
	        this._btnCountResult.on("click", this.getCountResult);
	        this._totalEntries = Utils_1.Utils.getJQueryById("totalEntries");
	        this._checkAll = Utils_1.Utils.getJQueryById("selectAll");
	        this._checkAll.on("change", this.checkBoxAll);
	        this._processing = Utils_1.Utils.getJQueryById("processing");
	    }
	    IndexPage.prototype.sendRequest = function (request) {
	        var urlList = this._options.urlList;
	        var urlDetail = this._options.urlDetail;
	        var urlBonusDetail = this._options.urlBonusDetail;
	        var urlPlayerDetail = this._options.urlPlayerDetail;
	        var urlCustomerDetail = this._options.urlCustomerDetail;
	        var urlCustomerOperationDetail = this._options.urlCustomerOperationDetail;
	        var table = this.getTableBody();
	        var getDetailUrl = this.getDetailUrl;
	        var showLoadMore = this.showLoadMoreButton;
	        var hideLoadMore = this.hideLoadMoreButton;
	        var enableRunButton = this.enableRunButton;
	        var processing = this._processing;
	        var displayMessage = this.displayMessage;
	        processing.show();
	        $.ajax({
	            url: urlList,
	            type: "POST",
	            dataType: 'html',
	            data: { request: request }
	        }).done(function (data) {
	            var items = JSON.parse(data);
	            if (items.length < batchSize + 1) {
	                hideLoadMore();
	            }
	            else {
	                request.LastTicketId = items[batchSize].Id;
	                request.LastFinished = items[batchSize].FinishedTicks;
	                showLoadMore();
	            }
	            $.each(items, function (index, item) {
	                if (index < batchSize) {
	                    var row = table.insertRow(-1);
	                    row.insertCell(0).innerHTML = "<a href='" + getDetailUrl(urlDetail, item.Id) + "'>" + item.Id + "</a>";
	                    row.insertCell(1).innerHTML = "" + item.Status;
	                    row.insertCell(2).innerHTML = "" + item.Handpay;
	                    row.insertCell(3).innerHTML = "<a href='" + getDetailUrl(urlBonusDetail, item.BonusId) + "'>" + item.BonusName + "</a>";
	                    row.insertCell(4).innerHTML = "<a href='" + getDetailUrl(urlPlayerDetail, item.PlayerId) + "'>" + item.PlayerRemoteId + "</a>";
	                    row.insertCell(5).innerHTML = "<a href='" + getDetailUrl(urlCustomerDetail, item.CustomerId) + "'>" + item.CustomerName + "</a>";
	                    row.insertCell(6).innerHTML = "<a href='" + getDetailUrl(urlCustomerOperationDetail, item.CustomerOperationId) + "'>" + item.CustomerOperationName + "</a>";
	                    row.insertCell(7).innerHTML = Utils_1.Utils.isNullOrUndefined(item.PlayerWinAmount) ? '' : item.PlayerWinAmount + " " + item.PlayerCurrency;
	                    row.insertCell(8).innerHTML = Utils_1.Utils.isNullOrUndefined(item.MainWinAmount) ? '' : item.MainWinAmount + " " + item.MainCurrency;
	                    row.insertCell(9).innerHTML = Utils_1.Utils.isNullOrUndefined(item.LevelCode) ? '' : "" + item.LevelCode;
	                    row.insertCell(10).innerHTML = "" + DateUtils_1.DateUtils.toDefaultWithTime(item.Created);
	                    row.insertCell(11).innerHTML = "" + DateUtils_1.DateUtils.toDefaultWithTime(item.Started);
	                    row.insertCell(12).innerHTML = "" + DateUtils_1.DateUtils.toDefaultWithTime(item.Finished);
	                    row.insertCell(13).innerHTML = Utils_1.Utils.isNullOrUndefined(item.Canceled) ? "" + DateUtils_1.DateUtils.toDefaultWithTime(item.Paid) : "" + DateUtils_1.DateUtils.toDefaultWithTime(item.Canceled);
	                    row.insertCell(14).innerHTML = Utils_1.Utils.isNullOrUndefined(item.Result) ? '' : "" + item.Result;
	                }
	            });
	            processing.hide();
	            enableRunButton();
	        }).fail(function (jqXHR, textStatus, errorThrown) {
	            processing.hide();
	            enableRunButton();
	            displayMessage(jqXHR);
	        });
	    };
	    IndexPage.prototype.getTableBody = function () {
	        return document.getElementById("tableGameRounds").getElementsByTagName("tbody")[0];
	    };
	    IndexPage.prototype.getDetailUrl = function (detailUrl, data) {
	        return detailUrl + "/" + data;
	    };
	    IndexPage.prototype.displayMessage = function (jqXHR) {
	        var statusMessageWrapper = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	        var statusMessageData = {
	            code: "500",
	            autoClose: false,
	            class: "danger",
	            message: "Unexpected error",
	            type: StatusMessage_1.StatusMessageType.Error
	        };
	        var statusMessage = new StatusMessage_1.StatusMessage(statusMessageData);
	        statusMessageWrapper.html(statusMessage.getHTMLmessage());
	        StatusMessageHelper_1.StatusMessageHelper.initValidator();
	        StatusMessageHelper_1.StatusMessageHelper.initSatusMessage();
	    };
	    IndexPage.prototype.run = function () {
	        this.disableRunButton();
	        var totalEntries = this._totalEntries[0];
	        totalEntries.innerText = "##";
	        this._currentRequest = this.getBrowseRequest();
	        var table = this.getTableBody();
	        table.innerHTML = "";
	        this.sendRequest(this._currentRequest);
	    };
	    IndexPage.prototype.loadMore = function () {
	        this.sendRequest(this._currentRequest);
	    };
	    IndexPage.prototype.showLoadMoreButton = function () {
	        this._loadMoreButton.removeClass("display-none");
	    };
	    IndexPage.prototype.hideLoadMoreButton = function () {
	        this._loadMoreButton.addClass("display-none");
	    };
	    IndexPage.prototype.disableRunButton = function () {
	        this._runButton.attr("disabled", 1);
	    };
	    IndexPage.prototype.enableRunButton = function () {
	        this._runButton.removeAttr("disabled");
	    };
	    IndexPage.prototype.checkBoxAll = function () {
	        var checkboxes = $("input[name='" + checkboxName + "']");
	        for (var i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = this._checkAll[0].checked;
	        }
	    };
	    IndexPage.prototype.getCountResult = function () {
	        var request = Utils_1.Utils.isNullOrUndefined(this._currentRequest) ? this.getBrowseRequest() : this._currentRequest;
	        var urlCount = this._options.urlCount;
	        var totalEntries = this._totalEntries[0];
	        var processing = this._processing;
	        var displayMessage = this.displayMessage;
	        processing.show();
	        $.ajax({
	            url: urlCount,
	            type: "POST",
	            dataType: 'html',
	            data: { request: request },
	            success: function (data) {
	                totalEntries.innerText = data;
	                processing.hide();
	            },
	            error: function (jqXHR, textStatus, errorThrown) {
	                processing.hide();
	                displayMessage(jqXHR);
	            }
	        });
	    };
	    IndexPage.prototype.getBrowseRequest = function () {
	        var request = new ProgressiveBonusBrowseRequest();
	        request.TicketId = this._filterTicketId.val();
	        request.Status = this._filterStatus.isAllSelected() ? '' : this._filterStatus.getSelectionValues(FILTER_DELIM);
	        request.Handpay = this._filterHandPay.isAllSelected() ? '' : this._filterHandPay.getSelectionValues(FILTER_DELIM);
	        request.Bonus = this._filterBonus.isAllSelected() ? '' : this._filterBonus.getSelectionValues(FILTER_DELIM);
	        request.Player = this._filterPlayer.val();
	        request.Customer = this._filterCustomer.isAllSelected() ? '' : this._filterCustomer.getSelectionValues(FILTER_DELIM);
	        request.CustomerOperation = this._filterCustomerOperation.isAllSelected() ? '' : this._filterCustomerOperation.getSelectionValues(FILTER_DELIM);
	        request.LevelWon = this._filterLevelWon.isAllSelected() ? '' : this._filterLevelWon.getSelectionValues(FILTER_DELIM);
	        request.CreatedFrom = this._filterCreatedFrom.getUnixTimestamp();
	        request.CreatedTo = this._filterCreatedTo.getUnixTimestamp();
	        request.StartedFrom = this._filterStartedFrom.getUnixTimestamp();
	        request.StartedTo = this._filterStartedTo.getUnixTimestamp();
	        request.FinishedFrom = this._filterFinishedFrom.getUnixTimestamp();
	        request.FinishedTo = this._filterFinishedTo.getUnixTimestamp();
	        request.PaidCanceledFrom = this._filterPaidCanceledFrom.getUnixTimestamp();
	        request.PaidCanceledTo = this._filterPaidCanceledTo.getUnixTimestamp();
	        request.Result = this._filterResult.isAllSelected() ? '' : this._filterResult.getSelectionValues(FILTER_DELIM);
	        request.Source = this._source.val();
	        request.BatchSize = batchSize + 1;
	        return request;
	    };
	    IndexPage.prototype.resetFilter = function () {
	        this._filterTicketId.val('');
	        this._filterPlayer.val('');
	        this._filterStatus.selectAll();
	        this._filterHandPay.selectAll();
	        this._filterBonus.selectAll();
	        this._filterCustomer.selectAll();
	        this._filterCustomerOperation.selectAll();
	        this._filterLevelWon.selectAll();
	        this._filterResult.selectAll();
	        this._source.val('Live');
	        this._filterStartedFrom.clearDates();
	        this._filterStartedTo.clearDates();
	        this._filterFinishedFrom.clearDates();
	        this._filterFinishedTo.clearDates();
	        this._filterCreatedFrom.clearDates();
	        this._filterCreatedTo.clearDates();
	        this._filterPaidCanceledFrom.clearDates();
	        this._filterPaidCanceledTo.clearDates();
	    };
	    return IndexPage;
	}());
	exports.IndexPage = IndexPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var IndexPage_1 = __webpack_require__(139);
	exports.IndexPage = IndexPage_1.IndexPage;
	var ApprovalPage_1 = __webpack_require__(141);
	exports.ApprovalPage = ApprovalPage_1.ApprovalPage;


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var MultiSelect_1 = __webpack_require__(52);
	var Utils_1 = __webpack_require__(5);
	var RoundTypeEnum_1 = __webpack_require__(140);
	var Widgets_1 = __webpack_require__(51);
	var tableId = 'tableReviews';
	var formId = 'formReviews';
	var btnCancelSearchId = 'btnCancelSearch';
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var COLUMNS_INDEX = {
	    RoundId: 0,
	    Customer: 1,
	    TotalWin: 2,
	    Source: 3,
	    Created: 4,
	    Approved: 5,
	    ApprovedBy: 6,
	    ApprovedDate: 7
	};
	var FILTER_DELIM = '-delim-';
	var IndexPage = (function (_super) {
	    __extends(IndexPage, _super);
	    function IndexPage(options) {
	        _super.call(this, options);
	        var getGameRoundDetailUrl = function (roundId) { return (options.urlGameRoundDetail + "/" + roundId); };
	        var getProgressiveBonusWinDetailUrl = function (roundId) { return (options.urlProgressiveBonusWinDetail + "/" + roundId); };
	        var getFreeRoundOfferDetailUrl = function (roundId) { return (options.urlFreeRoundOfferDetail + "/" + roundId); };
	        var getCustomerDetailUrl = function (customerId) { return (options.urlCustomerDetail + "/" + customerId); };
	        var getRoundDetailUrl = function (rowData) {
	            var resultUrl = null;
	            switch (RoundTypeEnum_1.getRoundTypeValue(rowData.RoundType)) {
	                case RoundTypeEnum_1.RoundType.GameRound:
	                    resultUrl = getGameRoundDetailUrl(rowData.RoundId);
	                    break;
	                case RoundTypeEnum_1.RoundType.ProgressiveBonus:
	                    resultUrl = getProgressiveBonusWinDetailUrl(rowData.RoundId);
	                    break;
	                case RoundTypeEnum_1.RoundType.FreeRoundOffer:
	                    resultUrl = getFreeRoundOfferDetailUrl(rowData.RoundId);
	                    break;
	            }
	            return resultUrl;
	        };
	        this.preDrawCallback = this.preDrawCallback.bind(this);
	        this.formSubmit = this.formSubmit.bind(this);
	        this.cancelSearch = this.cancelSearch.bind(this);
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            pageLength: 100,
	            lengthMenu: [[20, 50, 100, 200], [20, 50, 100, 200]],
	            columns: [
	                {
	                    data: 'RoundId',
	                    className: "bold",
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkGameRound" + rowData.Id + "' href='" + getRoundDetailUrl(rowData) + "' target='_blank'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: "CustomerName",
	                    className: "bold",
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkCustomer" + rowData.Id + "' href='" + getCustomerDetailUrl(rowData.CustomerId) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: 'TotalWin'
	                },
	                {
	                    data: 'Source'
	                },
	                {
	                    data: 'Created',
	                },
	                {
	                    data: 'Approved',
	                    defaultContent: ''
	                },
	                {
	                    data: 'ApprovedBy',
	                    defaultContent: ''
	                },
	                {
	                    data: 'ApprovedDate',
	                    defaultContent: ''
	                },
	                {
	                    orderable: false,
	                    data: 'filterButtons',
	                    defaultContent: '',
	                    searchable: false,
	                    sortable: false
	                }
	            ],
	            order: [[COLUMNS_INDEX.Created, "asc"]],
	            callbacks: {
	                preDrawCallback: this.preDrawCallback
	            }
	        };
	    }
	    IndexPage.prototype.init = function () {
	        this._form = Utils_1.Utils.getJQueryById(formId);
	        this._btnCancelSearch = Utils_1.Utils.getJQueryById(btnCancelSearchId);
	        this._filterId = Utils_1.Utils.getJQueryById('filterId');
	        this._filterRoundId = Utils_1.Utils.getJQueryById('filterRoundId');
	        this._filterCustomer = new MultiSelect_1.MultiSelectApi('filterCustomer');
	        this._filterSource = new MultiSelect_1.MultiSelectApi('filterSource');
	        this._filterApproved = new MultiSelect_1.MultiSelectApi('filterApproved');
	        this._filterCreatedFrom = new Widgets_1.DateTimePickerApi("filterCreatedFrom");
	        this._filterCreatedTo = new Widgets_1.DateTimePickerApi("filterCreatedTo");
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	        this._form.on('submit', this.formSubmit);
	        this._btnCancelSearch.on('click', this.cancelSearch);
	    };
	    IndexPage.prototype.formSubmit = function (e) {
	        e.preventDefault();
	        this._table.draw();
	        return false;
	    };
	    IndexPage.prototype.cancelSearch = function (e) {
	        this._filterCustomer.selectAll();
	        this._filterApproved.selectAll();
	        this._filterSource.selectAll();
	        this._filterId.val('');
	        this._filterRoundId.val('');
	        this._filterCreatedFrom.clearDates();
	        this._filterCreatedTo.clearDates();
	    };
	    IndexPage.prototype.preDrawCallback = function (datatable) {
	        var filterCustomer = this._filterCustomer.isAllSelected() ? '' : this._filterCustomer.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.Customer).search(filterCustomer);
	        var filterSource = this._filterSource.isAllSelected() ? '' : this._filterSource.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.Source).search(filterSource);
	        var filterApproved = this._filterApproved.isAllSelected() ? '' : this._filterApproved.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.Approved).search(filterApproved);
	        var filterRoundId = this._filterRoundId.val();
	        datatable.columns(COLUMNS_INDEX.RoundId).search(filterRoundId);
	        var filterCreatedFrom = this._filterCreatedFrom.getUnixTimestamp();
	        var filterCreatedTo = this._filterCreatedTo.getUTCDate();
	        var filterCreated = filterCreatedFrom + FILTER_DELIM + filterCreatedTo;
	        datatable.columns(COLUMNS_INDEX.Created).search(filterCreated);
	    };
	    return IndexPage;
	}(PageBase_1.PageBase));
	exports.IndexPage = IndexPage;


/***/ },
/* 140 */
/***/ function(module, exports) {

	"use strict";
	(function (RoundType) {
	    RoundType[RoundType["GameRound"] = 0] = "GameRound";
	    RoundType[RoundType["ProgressiveBonus"] = 1] = "ProgressiveBonus";
	    RoundType[RoundType["FreeRoundOffer"] = 2] = "FreeRoundOffer";
	})(exports.RoundType || (exports.RoundType = {}));
	var RoundType = exports.RoundType;
	function getRoundTypeValue(stringValue) {
	    var returnValue;
	    if (stringValue === "GameRound") {
	        returnValue = RoundType.GameRound;
	    }
	    else if (stringValue === "ProgressiveBonusWin") {
	        returnValue = RoundType.ProgressiveBonus;
	    }
	    else if (stringValue === "FreeRoundOffer") {
	        returnValue = RoundType.FreeRoundOffer;
	    }
	    return returnValue;
	}
	exports.getRoundTypeValue = getRoundTypeValue;


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var DateUtils_1 = __webpack_require__(48);
	var tableId = 'tableGameTransactions';
	var tableDom = "<'row'<'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var ApprovalPage = (function (_super) {
	    __extends(ApprovalPage, _super);
	    function ApprovalPage(options) {
	        _super.call(this, options);
	        this.openDialog = this.openDialog.bind(this);
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            columns: [
	                {
	                    data: 'Type',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnType" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Id',
	                    className: "bold",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnName" + rowData.Id + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: 'ExternalParentId',
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnExternalParentId" + rowData.Id + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: 'ReversedBy',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnReversedBy" + rowData.Id + "'>" + (data || '') + "</span>");
	                    },
	                },
	                {
	                    data: 'RealAmount',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnRealAmount" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'BonusAmount',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnBonusAmount" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Status',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnStatus" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Forced',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnForced" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'Created',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCreated" + rowData.Id + "'>" + DateUtils_1.DateUtils.toDefaultWithTime(data) + "</span>");
	                    }
	                },
	                {
	                    data: 'Completed',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCompleted" + rowData.Id + "'>" + DateUtils_1.DateUtils.toDefaultWithTime(data) + "</span>");
	                    }
	                },
	                {
	                    data: 'RemoteId',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnRemoteId" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'RealBalance',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnRealBalance" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: 'BonusBalance',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnBonusBalance" + rowData.Id + "'>" + data + "</span>");
	                    }
	                }
	            ],
	            order: [[1, "asc"]]
	        };
	    }
	    ApprovalPage.prototype.openDialog = function () {
	        document.getElementById("areYouSureConfirmation").hidden = false;
	    };
	    ApprovalPage.prototype.closeDialog = function () {
	        document.getElementById("areYouSureConfirmation").hidden = true;
	    };
	    ApprovalPage.prototype.init = function () {
	        var _this = this;
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	        var submitButton = document.getElementById("lnkReview");
	        if (submitButton != null) {
	            submitButton.onclick = function (e) {
	                e.preventDefault();
	                var confirmButton = document.getElementById("btnConfirm");
	                confirmButton.onclick = function () {
	                    window.location.href = submitButton.href;
	                };
	                var closeButton = document.getElementById("btnHideConfirmation");
	                closeButton.onclick = function () { return _this.closeDialog(); };
	                _this.openDialog();
	            };
	        }
	    };
	    return ApprovalPage;
	}(PageBase_1.PageBase));
	exports.ApprovalPage = ApprovalPage;


/***/ },
/* 142 */
[173, 143, 144],
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var tableId = 'tableJurisdictions';
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'f><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var IndexPage = (function (_super) {
	    __extends(IndexPage, _super);
	    function IndexPage(options) {
	        _super.call(this, options);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            pageLength: 100,
	            lengthMenu: [[100, 200, 300, -1], [100, 200, 300, "All"]],
	            columns: [
	                {
	                    data: 'Name',
	                    className: "bold",
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkName" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: "Code",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCode" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "IsEnabled",
	                    render: function (data, type, rowData) {
	                        var isEnabled = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
	                        return "<span id='spnState" + rowData.Id + "'>" + isEnabled + "</span>";
	                    }
	                },
	                {
	                    data: '',
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkDetail" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>" + options.localizer.DetailsLink + "</a>");
	                    }
	                }
	            ]
	        };
	    }
	    IndexPage.prototype.init = function () {
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	    };
	    return IndexPage;
	}(PageBase_1.PageBase));
	exports.IndexPage = IndexPage;


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var tableId = "tableOperations";
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var DetailPage = (function (_super) {
	    __extends(DetailPage, _super);
	    function DetailPage(options) {
	        _super.call(this, options);
	        var getOperationDetailUrl = function (rowData) { return (options.urlOperationDetail + "/" + rowData.OperationId); };
	        var getCustomerDetailUrl = function (rowData) { return (options.urlCustomerDetail + "/" + rowData.CustomerId); };
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            ordering: false,
	            columns: [
	                {
	                    data: "CustomerName",
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkCustomerName" + rowData.CustomerId + "' href='" + getCustomerDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: "CustomerStatus",
	                    render: function (data, type, rowData) {
	                        var css = "status-" + data.toLowerCase();
	                        return "<span id='spnState" + rowData.OperationId + "' class='" + css + "'>" + data + "</span>";
	                    }
	                },
	                {
	                    data: 'OperationName',
	                    className: "bold",
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkName" + rowData.OperationId + "' href='" + getOperationDetailUrl(rowData) + "'>" + data + "</a>");
	                    }
	                },
	                {
	                    data: "OperationStatus",
	                    render: function (data, type, rowData) {
	                        var css = "status-" + data.toLowerCase();
	                        return "<span id='spnState" + rowData.OperationId + "' class='" + css + "'>" + data + "</span>";
	                    }
	                },
	                {
	                    data: '',
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkDetail" + rowData.OperationId + "' href='" + getOperationDetailUrl(rowData) + "'>" + options.localizer.DetailsLink + "</a>");
	                    }
	                }
	            ]
	        };
	    }
	    DetailPage.prototype.init = function () {
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	    };
	    return DetailPage;
	}(PageBase_1.PageBase));
	exports.DetailPage = DetailPage;


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {"use strict";
	var ConfigurationKeys_1 = __webpack_require__(146);
	exports.ConfigurationKeys = ConfigurationKeys_1.ConfigurationKeys;
	var SelectedConfigurationKeys_1 = __webpack_require__(147);
	exports.SelectedConfigurationKeys = SelectedConfigurationKeys_1.SelectedConfigurationKeys;
	(function ($) {
	    if (location.pathname != "/Configuration" || !location.hash)
	        return;
	    $(document).ready(function () {
	        var top = document.documentElement.scrollTop;
	        var el = $(location.hash);
	        var fieldName = location.hash.replace('configurationItem_', '');
	        var initColor = $(fieldName).css('border-color');
	        $(fieldName)[0].onfocus = function (e) { $(fieldName).css('border-color', initColor); };
	        window.setTimeout(function () {
	            document.documentElement.scrollTop = top - el.outerHeight(true);
	            $(fieldName).css('border-color', 'red');
	        }, 10);
	    });
	})(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var Utils_1 = __webpack_require__(5);
	var tableId = 'tableConfigurationKeys';
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'f><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var ConfigurationKeys = (function (_super) {
	    __extends(ConfigurationKeys, _super);
	    function ConfigurationKeys(options) {
	        _super.call(this, options);
	        this.addToExport = this.addToExport.bind(this);
	        this.cleanExport = this.cleanExport.bind(this);
	        this.checkBoxAll = this.checkBoxAll.bind(this);
	        window['setSelectAllCheckbox'] = this.setSelectAllCheckbox;
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Code',
	            order: [1, "asc"],
	            autoWidth: true,
	            columns: [
	                {
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<input id='chckbx" + rowData.Code + "' name='selectedKey' value='" + rowData.Code + "' type='checkbox' onClick=\"setSelectAllCheckbox()\" />");
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "Code"
	                },
	                {
	                    sortable: false,
	                    data: "DisplayName"
	                }
	            ]
	        };
	    }
	    ConfigurationKeys.prototype.init = function () {
	        this._btnAddToExport = Utils_1.Utils.getJQueryById("btnAddToExport");
	        this._btnAddToExport.on("click", this.addToExport);
	        this._btnCleanExport = Utils_1.Utils.getJQueryById("btnClearExport");
	        this._btnCleanExport.on("click", this.cleanExport);
	        this._checkAll = Utils_1.Utils.getJQueryById("keysSelectAll");
	        this._checkAll.on("change", this.checkBoxAll);
	        this._otherCheckAll = Utils_1.Utils.getJQueryById("selectedKeysSelectAll");
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	    };
	    ConfigurationKeys.prototype.addToExport = function (e) {
	        e.preventDefault();
	        var urlPost = this._options.urlPost;
	        var table = this._table;
	        var selectedTable = Utils_1.Utils.getJQueryById("tableSelectedConfigurationKeys").DataTable();
	        var codes = $("input[name='selectedKey']:checked").map(function () {
	            return $(this).val();
	        });
	        var codesToAdd = codes.get();
	        if (!codesToAdd || codesToAdd.length === 0) {
	            return;
	        }
	        var checkAll = this._checkAll;
	        var otherCheckAll = this._otherCheckAll;
	        $.ajax({
	            url: urlPost,
	            type: "POST",
	            dataType: 'html',
	            data: { codes: codesToAdd },
	            success: function (data) {
	                checkAll.prop("checked", false);
	                otherCheckAll.prop("checked", false);
	                table.draw();
	                selectedTable.draw();
	            }
	        });
	    };
	    ConfigurationKeys.prototype.cleanExport = function (e) {
	        e.preventDefault();
	        var urlClean = this._options.urlClean;
	        var table = this._table;
	        var selectedTable = Utils_1.Utils.getJQueryById("tableSelectedConfigurationKeys").DataTable();
	        $.ajax({
	            url: urlClean,
	            type: "POST",
	            dataType: 'html',
	            data: {},
	            success: function (data) {
	                table.draw();
	                selectedTable.draw();
	            }
	        });
	    };
	    ConfigurationKeys.prototype.checkBoxAll = function () {
	        var checkboxes = $("input[name='selectedKey']");
	        for (var i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = this._checkAll[0].checked;
	        }
	    };
	    ConfigurationKeys.prototype.setSelectAllCheckbox = function () {
	        var checkboxes = $("input[name='selectedKey']");
	        var buildSelectAll = Utils_1.Utils.getJQueryById("keysSelectAll")[0];
	        if (Utils_1.Utils.isNullOrUndefined(buildSelectAll))
	            return;
	        var allCheckboxesChecked = false;
	        for (var i = 0; i < checkboxes.length; i++) {
	            allCheckboxesChecked = checkboxes[i].checked;
	            if (!allCheckboxesChecked)
	                break;
	        }
	        buildSelectAll.checked = allCheckboxesChecked;
	    };
	    return ConfigurationKeys;
	}(PageBase_1.PageBase));
	exports.ConfigurationKeys = ConfigurationKeys;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var Utils_1 = __webpack_require__(5);
	var tableId = 'tableSelectedConfigurationKeys';
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var SelectedConfigurationKeys = (function (_super) {
	    __extends(SelectedConfigurationKeys, _super);
	    function SelectedConfigurationKeys(options) {
	        _super.call(this, options);
	        this.removeFromExport = this.removeFromExport.bind(this);
	        this.checkBoxAll = this.checkBoxAll.bind(this);
	        window['setSelectAllCheckbox'] = this.setSelectAllCheckbox;
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Code',
	            order: [1, "asc"],
	            autoWidth: true,
	            columns: [
	                {
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<input id='chckbx" + rowData.Code + "' name='keyToRemove' value='" + rowData.Code + "' type='checkbox' onClick=\"setSelectAllCheckbox()\" />");
	                    }
	                },
	                {
	                    sortable: false,
	                    data: "Code"
	                },
	                {
	                    sortable: false,
	                    data: "DisplayName"
	                }
	            ]
	        };
	    }
	    SelectedConfigurationKeys.prototype.init = function () {
	        this._btnRemoveFromExport = Utils_1.Utils.getJQueryById("btnRemoveFromExport");
	        this._btnRemoveFromExport.on("click", this.removeFromExport);
	        this._checkAll = Utils_1.Utils.getJQueryById("selectedKeysSelectAll");
	        this._checkAll.on("change", this.checkBoxAll);
	        this._otherCheckAll = Utils_1.Utils.getJQueryById("keysSelectAll");
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	    };
	    SelectedConfigurationKeys.prototype.removeFromExport = function (e) {
	        e.preventDefault();
	        var urlPost = this._options.urlPost;
	        var table = this._table;
	        var keysTable = Utils_1.Utils.getJQueryById("tableConfigurationKeys").DataTable();
	        var codes = $("input[name='keyToRemove']:checked").map(function () {
	            return $(this).val();
	        });
	        var codesToAdd = codes.get();
	        if (!codesToAdd || codesToAdd.length === 0) {
	            return;
	        }
	        var checkAll = this._checkAll;
	        var otherCheckAll = this._otherCheckAll;
	        $.ajax({
	            url: urlPost,
	            type: "POST",
	            dataType: 'html',
	            data: { codes: codesToAdd },
	            success: function (data) {
	                checkAll.prop("checked", false);
	                otherCheckAll.prop("checked", false);
	                table.draw();
	                keysTable.draw();
	            }
	        });
	    };
	    SelectedConfigurationKeys.prototype.checkBoxAll = function () {
	        var checkboxes = $("input[name='keyToRemove']");
	        for (var i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = this._checkAll[0].checked;
	        }
	    };
	    SelectedConfigurationKeys.prototype.setSelectAllCheckbox = function () {
	        var checkboxes = $("input[name='keyToRemove']");
	        var buildSelectAll = Utils_1.Utils.getJQueryById("selectedKeysSelectAll")[0];
	        if (Utils_1.Utils.isNullOrUndefined(buildSelectAll))
	            return;
	        var allCheckboxesChecked = false;
	        for (var i = 0; i < checkboxes.length; i++) {
	            allCheckboxesChecked = checkboxes[i].checked;
	            if (!allCheckboxesChecked)
	                break;
	        }
	        buildSelectAll.checked = allCheckboxesChecked;
	    };
	    return SelectedConfigurationKeys;
	}(PageBase_1.PageBase));
	exports.SelectedConfigurationKeys = SelectedConfigurationKeys;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 148 */
[172, 149],
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Utils_1 = __webpack_require__(5);
	var StatusMessageHelper_1 = __webpack_require__(50);
	var IndexPage = (function (_super) {
	    __extends(IndexPage, _super);
	    function IndexPage(options) {
	        _super.call(this, options);
	        this.generateLink = this.generateLink.bind(this);
	        this.copyToClipboard = this.copyToClipboard.bind(this);
	    }
	    IndexPage.prototype.init = function () {
	        this._btnGenerate = Utils_1.Utils.getJQueryById("btnGenerate");
	        this._btnGenerate.on("click", this.generateLink);
	        this._btnCopy = Utils_1.Utils.getJQueryById("btnCopy");
	        this._btnCopy.on("click", this.copyToClipboard);
	    };
	    IndexPage.prototype.generateLink = function () {
	        var gameCode = $('#gameCode').val();
	        if (Utils_1.Utils.isNullOrUndefined(gameCode) || gameCode === "") {
	            return;
	        }
	        var url = this._options.urlGeneratePresentationLink;
	        var statusMessage = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	        $.ajax({
	            url: url,
	            type: "GET",
	            data: { 'gameCode': gameCode },
	            success: function (data) {
	                if (Utils_1.Utils.isNullOrUndefined(data.generatedLink)) {
	                    statusMessage.html(data);
	                    StatusMessageHelper_1.StatusMessageHelper.initValidator();
	                    StatusMessageHelper_1.StatusMessageHelper.initSatusMessage();
	                }
	                else {
	                    $('#generatedLink').text(data.generatedLink);
	                    document.getElementById("linkValidity").innerText = data.validTo + " UTC";
	                }
	            },
	        });
	    };
	    IndexPage.prototype.copyToClipboard = function () {
	        var textToCopy = $('#generatedLink');
	        textToCopy.select();
	        document.execCommand("copy");
	    };
	    return IndexPage;
	}(PageBase_1.PageBase));
	exports.IndexPage = IndexPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 150 */
[172, 151],
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Utils_1 = __webpack_require__(5);
	var Datatable_1 = __webpack_require__(54);
	var tableId = 'tableUnusedValues';
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'f><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var IndexPage = (function (_super) {
	    __extends(IndexPage, _super);
	    function IndexPage(options) {
	        _super.call(this, options);
	        this.checkBoxAll = this.checkBoxAll.bind(this);
	        this.removeSelected = this.removeSelected.bind(this);
	        window['setSelectAllCheckbox'] = this.setSelectAllCheckbox;
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            columns: [
	                {
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<input id='chckbx" + rowData.Id + "' name='selectedRow' value='" + rowData.Id + "' type='checkbox' onClick=\"setSelectAllCheckbox()\" />");
	                    }
	                },
	                {
	                    sortable: false,
	                    data: 'Id',
	                },
	                {
	                    sortable: false,
	                    data: "Key"
	                },
	                {
	                    sortable: false,
	                    data: "Level"
	                },
	                {
	                    sortable: false,
	                    data: "EntityId",
	                    defaultContent: ''
	                }
	            ]
	        };
	    }
	    IndexPage.prototype.init = function () {
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	        this._checkAll = Utils_1.Utils.getJQueryById("selectAll");
	        this._checkAll.on("change", this.checkBoxAll);
	        var btnRemove = Utils_1.Utils.getJQueryById("lnkRemoveSelected");
	        btnRemove.on("click", this.removeSelected);
	    };
	    IndexPage.prototype.removeSelected = function (e) {
	        e.preventDefault();
	        var urlPost = this._options.urlPost;
	        var ids = $("input[name='selectedRow']:checked").map(function () {
	            return $(this).val();
	        });
	        $.ajax({
	            url: urlPost,
	            type: "POST",
	            dataType: 'json',
	            data: { ids: ids.get() },
	            success: function (data) {
	                window.location.href = data;
	            }
	        });
	    };
	    IndexPage.prototype.checkBoxAll = function () {
	        var checkboxes = $("input[name='selectedRow']");
	        for (var i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = this._checkAll[0].checked;
	        }
	    };
	    IndexPage.prototype.setSelectAllCheckbox = function () {
	        var checkboxes = $("input[name='selectedRow']");
	        var buildSelectAll = Utils_1.Utils.getJQueryById("selectAll")[0];
	        if (Utils_1.Utils.isNullOrUndefined(buildSelectAll))
	            return;
	        var allCheckboxesChecked = false;
	        for (var i = 0; i < checkboxes.length; i++) {
	            allCheckboxesChecked = checkboxes[i].checked;
	            if (!allCheckboxesChecked)
	                break;
	        }
	        buildSelectAll.checked = allCheckboxesChecked;
	    };
	    return IndexPage;
	}(PageBase_1.PageBase));
	exports.IndexPage = IndexPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var IndexPage_1 = __webpack_require__(153);
	exports.IndexPage = IndexPage_1.IndexPage;
	var SetValidityPage_1 = __webpack_require__(154);
	exports.SetValidityPage = SetValidityPage_1.SetValidityPage;
	var SetStatusPage_1 = __webpack_require__(155);
	exports.SetStatusPage = SetStatusPage_1.SetStatusPage;
	var RemoveValidityPage_1 = __webpack_require__(156);
	exports.RemoveValidityPage = RemoveValidityPage_1.RemoveValidityPage;


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Utils_1 = __webpack_require__(5);
	var Datatable_1 = __webpack_require__(54);
	var MultiSelect_1 = __webpack_require__(52);
	var DateTimePicker_1 = __webpack_require__(57);
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var FILTER_DELIM = '-delim-';
	var COLUMNS_INDEX = {
	    Id: 0,
	    GameName: 2,
	    GameVariant: 3,
	    Rtp: 4,
	    Currency: 5,
	    Customer: 6,
	    Operation: 7,
	    Jurisdiction: 8,
	    Status: 9,
	    ValidFrom: 10,
	    ValidTo: 11
	};
	var IndexPage = (function (_super) {
	    __extends(IndexPage, _super);
	    function IndexPage(options) {
	        _super.call(this, options);
	        var getDetailUrl = function (rowData) { return (options.urlDetail + "/" + rowData.Id); };
	        this.preDrawCallback = this.preDrawCallback.bind(this);
	        this.formSubmit = this.formSubmit.bind(this);
	        this.cancelSearch = this.cancelSearch.bind(this);
	        this.removeValidFrom = this.removeValidFrom.bind(this);
	        this.removeValidTo = this.removeValidTo.bind(this);
	        this.showSetValidity = this.showSetValidity.bind(this);
	        this.checkBoxAll = this.checkBoxAll.bind(this);
	        this.showSetStatusEnable = this.showSetStatusEnable.bind(this);
	        this.showSetStatusDisable = this.showSetStatusDisable.bind(this);
	        window['setSelectAllCheckbox'] = this.setSelectAllCheckbox;
	        this._tableId = "tableGameConfigurations";
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'Id',
	            autoWidth: true,
	            pageLength: 20,
	            lengthMenu: [[10, 20, 100, 500], [10, 20, 100, 500]],
	            columns: [
	                {
	                    data: 'Id',
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<input id='chckbx" + rowData.Id + "' name='selectedConfig' value='" + rowData.Id + "' type='checkbox' onClick=\"setSelectAllCheckbox()\" />");
	                    }
	                },
	                {
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<a id='lnkDetail" + rowData.Id + "' href='" + getDetailUrl(rowData) + "'>Detail</a>");
	                    }
	                },
	                {
	                    data: 'GameName',
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCode" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "GameVariant",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnVariant" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "Rtp",
	                    sortable: false,
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnRtp" + rowData.Id + "'>" + data + "</span>");
	                    },
	                    defaultContent: ''
	                },
	                {
	                    data: "CurrencyCode",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCurrency" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "CustomerName",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnCustomer" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "OperationName",
	                    render: function (data, type, rowData) {
	                        return ("<span id='spnOperation" + rowData.Id + "'>" + data + "</span>");
	                    }
	                },
	                {
	                    data: "JurisdictionName",
	                    render: function (data, type, rowData) {
	                        if (Utils_1.Utils.isNullOrUndefined(data)) {
	                            return "";
	                        }
	                        return "<span id='spnJurisdiction" + rowData.Id + "'>" + data + "</span>";
	                    }
	                },
	                {
	                    data: "DisplayStatus",
	                    render: function (data, type, rowData) {
	                        var css = "status-" + data.toLowerCase();
	                        return "<span id='spnState" + rowData.Id + "' class='" + css + "'>" + data + "</span>";
	                    }
	                },
	                {
	                    data: "ValidFrom",
	                    defaultContent: ''
	                },
	                {
	                    data: "ValidTo",
	                    defaultContent: ''
	                }
	            ],
	            order: [[COLUMNS_INDEX.GameName, "asc"]],
	            callbacks: {
	                preDrawCallback: this.preDrawCallback
	            }
	        };
	    }
	    IndexPage.prototype.init = function () {
	        this._form = Utils_1.Utils.getJQueryById("formGameConfigurations");
	        this._btnCancelSearch = Utils_1.Utils.getJQueryById('btnCancelSearch');
	        this._filterGame = new MultiSelect_1.MultiSelectApi('filterGame');
	        this._filterCurrency = new MultiSelect_1.MultiSelectApi('filterCurrency');
	        this._filterCustomer = new MultiSelect_1.MultiSelectApi('filterCustomer');
	        this._filterOperation = new MultiSelect_1.MultiSelectApi('filterOperation');
	        this._filterJurisdiction = new MultiSelect_1.MultiSelectApi('filterJurisdiction');
	        this._filterStatus = new MultiSelect_1.MultiSelectApi('filterStatus');
	        this._filterValidFromFrom = new DateTimePicker_1.DateTimePickerApi("filterValidFromFrom");
	        this._filterValidFromTo = new DateTimePicker_1.DateTimePickerApi("filterValidFromTo");
	        this._filterValidToFrom = new DateTimePicker_1.DateTimePickerApi("filterValidToFrom");
	        this._filterValidToTo = new DateTimePicker_1.DateTimePickerApi("filterValidToTo");
	        var btnEnableMulti = Utils_1.Utils.getJQueryById("btnEnableMulti");
	        btnEnableMulti.on("click", this.showSetStatusEnable);
	        var btnDisableMulti = Utils_1.Utils.getJQueryById("btnDisableMulti");
	        btnDisableMulti.on("click", this.showSetStatusDisable);
	        var btnRemoveValidFrom = Utils_1.Utils.getJQueryById("btnRemoveValidFrom");
	        btnRemoveValidFrom.on("click", this.removeValidFrom);
	        var btnRemoveValidTo = Utils_1.Utils.getJQueryById("btnRemoveValidTo");
	        btnRemoveValidTo.on("click", this.removeValidTo);
	        var btnSetValidity = Utils_1.Utils.getJQueryById("btnSetValidity");
	        btnSetValidity.on("click", this.showSetValidity);
	        this._chckSelectAll = Utils_1.Utils.getJQueryById("selectAll");
	        this._chckSelectAll.on("change", this.checkBoxAll);
	        if (Utils_1.Utils.isNullOrUndefined(this._tableOptions))
	            return;
	        this._table = new Datatable_1.Datatable(this._tableId, this._tableOptions);
	        this._form.on('submit', this.formSubmit);
	        this._btnCancelSearch.on('click', this.cancelSearch);
	    };
	    IndexPage.prototype.setSelectAllCheckbox = function () {
	        var checkboxes = $("input[name='selectedConfig']");
	        var selectAll = Utils_1.Utils.getJQueryById("selectAll")[0];
	        if (Utils_1.Utils.isNullOrUndefined(selectAll))
	            return;
	        var allCheckboxesChecked = false;
	        for (var i = 0; i < checkboxes.length; i++) {
	            allCheckboxesChecked = checkboxes[i].checked;
	            if (!allCheckboxesChecked)
	                break;
	        }
	        selectAll.checked = allCheckboxesChecked;
	    };
	    IndexPage.prototype.checkBoxAll = function () {
	        var checkboxes = $("input[name='selectedConfig']");
	        for (var i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = this._chckSelectAll[0].checked;
	        }
	    };
	    IndexPage.prototype.deselectAll = function () {
	        var checkboxes = $("input[name='selectedConfig']");
	        for (var i = 0; i < checkboxes.length; i++) {
	            checkboxes[i].checked = false;
	        }
	    };
	    IndexPage.prototype.showSetStatusEnable = function () {
	        this.showSetStatus(true);
	    };
	    IndexPage.prototype.showSetStatusDisable = function () {
	        this.showSetStatus(false);
	    };
	    IndexPage.prototype.showSetValidity = function () {
	        $('#validitySettings').removeAttr("hidden");
	    };
	    IndexPage.prototype.showSetStatus = function (status) {
	        $('#statusSettings').removeAttr("hidden");
	        $('#edStatus').prop("checked", status);
	    };
	    IndexPage.prototype.removeValidFrom = function () {
	        this.removeValidity("from");
	    };
	    IndexPage.prototype.removeValidTo = function () {
	        this.removeValidity("to");
	    };
	    IndexPage.prototype.removeValidity = function (type) {
	        $('#removeValiditySettings').removeAttr("hidden");
	        $('#edValidityType').val(type);
	    };
	    IndexPage.prototype.formSubmit = function (e) {
	        e.preventDefault();
	        this._table.draw();
	        return false;
	    };
	    IndexPage.prototype.cancelSearch = function (e) {
	        this._filterCurrency.selectAll();
	        this._filterGame.selectAll();
	        this._filterCustomer.selectAll();
	        this._filterOperation.selectAll();
	        this._filterJurisdiction.selectAll();
	        this._filterStatus.selectAll();
	        this._filterValidFromFrom.clearDates();
	        this._filterValidFromTo.clearDates();
	        this._filterValidToFrom.clearDates();
	        this._filterValidToTo.clearDates();
	    };
	    IndexPage.prototype.preDrawCallback = function (datatable) {
	        var filterGame = this._filterGame.isAllSelected() ? '' : this._filterGame.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.GameName).search(filterGame);
	        var filterCurrency = this._filterCurrency.isAllSelected() ? '' : this._filterCurrency.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.Currency).search(filterCurrency);
	        var filterCustomer = this._filterCustomer.isAllSelected() ? '' : this._filterCustomer.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.Customer).search(filterCustomer);
	        var filterOperation = this._filterOperation.isAllSelected() ? '' : this._filterOperation.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.Operation).search(filterOperation);
	        var filterJurisdiction = this._filterJurisdiction.isAllSelected() ? '' : this._filterJurisdiction.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.Jurisdiction).search(filterJurisdiction);
	        var filterStatus = this._filterStatus.isAllSelected() ? '' : this._filterStatus.getSelectionValues(FILTER_DELIM);
	        datatable.columns(COLUMNS_INDEX.Status).search(filterStatus);
	        var filterValidFromFrom = this._filterValidFromFrom.getUnixTimestamp();
	        var filterValidFromTo = this._filterValidFromTo.getUTCDate();
	        var filterValidFrom = filterValidFromFrom + FILTER_DELIM + filterValidFromTo;
	        datatable.columns(COLUMNS_INDEX.ValidFrom).search(filterValidFrom);
	        var filterValidToFrom = this._filterValidToFrom.getUnixTimestamp();
	        var filterValidToTo = this._filterValidToTo.getUTCDate();
	        var filterValidTo = filterValidToFrom + FILTER_DELIM + filterValidToTo;
	        datatable.columns(COLUMNS_INDEX.ValidTo).search(filterValidTo);
	    };
	    return IndexPage;
	}(PageBase_1.PageBase));
	exports.IndexPage = IndexPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Utils_1 = __webpack_require__(5);
	var DateTimePicker_1 = __webpack_require__(57);
	var StatusMessageHelper_1 = __webpack_require__(50);
	var SetValidityRequest = (function () {
	    function SetValidityRequest() {
	    }
	    return SetValidityRequest;
	}());
	var SetValidityPage = (function (_super) {
	    __extends(SetValidityPage, _super);
	    function SetValidityPage(options) {
	        _super.call(this, options);
	        this.hideSetValidity = this.hideSetValidity.bind(this);
	        this.setValidity = this.setValidity.bind(this);
	    }
	    SetValidityPage.prototype.init = function () {
	        this._validFromCheckbox = document.getElementById("validFromCheckBox");
	        this._validToCheckbox = document.getElementById("validToCheckBox");
	        this._validFrom = new DateTimePicker_1.DateTimePickerApi("validFromValue");
	        this._validTo = new DateTimePicker_1.DateTimePickerApi("validToValue");
	        this._passwordInput = document.getElementById("edPasswordValidity");
	        this._reasonInput = document.getElementById("edEditValidityReason");
	        var btnCancel = Utils_1.Utils.getJQueryById("btnHideSetValidity");
	        btnCancel.on("click", this.hideSetValidity);
	        var btnSubmitValidity = Utils_1.Utils.getJQueryById("btnSubmitValidity");
	        btnSubmitValidity.on("click", this.setValidity);
	    };
	    SetValidityPage.prototype.hideSetValidity = function () {
	        $('#validitySettings').attr("hidden", "hidden");
	    };
	    SetValidityPage.prototype.setValidity = function (e) {
	        e.preventDefault();
	        var urlPost = this._options.urlPost;
	        var that = this;
	        var ids = $("input[name='selectedConfig']:checked").map(function () {
	            return $(this).val();
	        });
	        var statusMessage = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	        var checkAll = $("#selectAll");
	        var table = Utils_1.Utils.getJQueryById('tableGameConfigurations').DataTable();
	        var request = new SetValidityRequest();
	        request.SetValidFrom = this._validFromCheckbox.checked;
	        request.SetValidTo = this._validToCheckbox.checked;
	        request.ValidFrom = this._validFrom.getUnixTimestamp();
	        request.ValidTo = this._validTo.getUnixTimestamp();
	        request.Password = this._passwordInput.value;
	        request.Reason = this._reasonInput.value;
	        request.Ids = ids.get();
	        $.ajax({
	            url: urlPost,
	            type: "POST",
	            dataType: 'html',
	            data: { request: request },
	            success: function (data) {
	                checkAll.prop('checked', false);
	                that.hideSetValidity();
	                statusMessage.html(data);
	                StatusMessageHelper_1.StatusMessageHelper.initValidator();
	                StatusMessageHelper_1.StatusMessageHelper.initSatusMessage();
	                table.draw();
	            }
	        });
	    };
	    return SetValidityPage;
	}(PageBase_1.PageBase));
	exports.SetValidityPage = SetValidityPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Utils_1 = __webpack_require__(5);
	var StatusMessageHelper_1 = __webpack_require__(50);
	var SetStatusRequest = (function () {
	    function SetStatusRequest() {
	    }
	    return SetStatusRequest;
	}());
	var SetStatusPage = (function (_super) {
	    __extends(SetStatusPage, _super);
	    function SetStatusPage(options) {
	        _super.call(this, options);
	        this.hideSetStatus = this.hideSetStatus.bind(this);
	        this.changeConfigurationStatusMulti = this.changeConfigurationStatusMulti.bind(this);
	    }
	    SetStatusPage.prototype.init = function () {
	        var btnCancel = Utils_1.Utils.getJQueryById("btnHideSetStatus");
	        btnCancel.on("click", this.hideSetStatus);
	        var btnSubmit = Utils_1.Utils.getJQueryById("btnSubmitStatus");
	        btnSubmit.on("click", this.changeConfigurationStatusMulti);
	        this._passwordInput = document.getElementById("edPasswordState");
	        this._reasonInput = document.getElementById("edEditStateReason");
	    };
	    SetStatusPage.prototype.hideSetStatus = function () {
	        $('#statusSettings').attr("hidden", "hidden");
	    };
	    SetStatusPage.prototype.changeConfigurationStatusMulti = function (e) {
	        e.preventDefault();
	        var checkAll = $("#selectAll");
	        var urlPost = this._options.urlPost;
	        var that = this;
	        var table = Utils_1.Utils.getJQueryById('tableGameConfigurations').DataTable();
	        var statusMessage = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	        var ids = $("input[name='selectedConfig']:checked").map(function () {
	            return $(this).val();
	        });
	        var status = $('#edStatus').is(':checked');
	        var request = new SetStatusRequest();
	        request.Password = this._passwordInput.value;
	        request.Reason = this._reasonInput.value;
	        request.Status = status;
	        request.ConfigIds = ids.get();
	        $.ajax({
	            url: urlPost,
	            type: "POST",
	            dataType: 'html',
	            data: { request: request },
	            success: function (data) {
	                checkAll.prop('checked', false);
	                that.hideSetStatus();
	                statusMessage.html(data);
	                StatusMessageHelper_1.StatusMessageHelper.initValidator();
	                StatusMessageHelper_1.StatusMessageHelper.initSatusMessage();
	                table.draw();
	            }
	        });
	    };
	    return SetStatusPage;
	}(PageBase_1.PageBase));
	exports.SetStatusPage = SetStatusPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Utils_1 = __webpack_require__(5);
	var StatusMessageHelper_1 = __webpack_require__(50);
	var RemoveValidityRequest = (function () {
	    function RemoveValidityRequest() {
	    }
	    return RemoveValidityRequest;
	}());
	var RemoveValidityPage = (function (_super) {
	    __extends(RemoveValidityPage, _super);
	    function RemoveValidityPage(options) {
	        _super.call(this, options);
	        this.hideRemoveValidity = this.hideRemoveValidity.bind(this);
	        this.removeValidityMulti = this.removeValidityMulti.bind(this);
	    }
	    RemoveValidityPage.prototype.init = function () {
	        var btnCancel = Utils_1.Utils.getJQueryById("btnHideRemoveValidity");
	        btnCancel.on("click", this.hideRemoveValidity);
	        var btnSubmit = Utils_1.Utils.getJQueryById("btnSubmitRemoveValidity");
	        btnSubmit.on("click", this.removeValidityMulti);
	        this._passwordInput = document.getElementById("edPasswordRemoveValidity");
	        this._reasonInput = document.getElementById("edRemoveValidityReason");
	    };
	    RemoveValidityPage.prototype.hideRemoveValidity = function () {
	        $('#removeValiditySettings').attr("hidden", "hidden");
	    };
	    RemoveValidityPage.prototype.removeValidityMulti = function (e) {
	        e.preventDefault();
	        var checkAll = $("#selectAll");
	        var urlPost = this._options.urlPost;
	        var that = this;
	        var table = Utils_1.Utils.getJQueryById('tableGameConfigurations').DataTable();
	        var statusMessage = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	        var ids = $("input[name='selectedConfig']:checked").map(function () {
	            return $(this).val();
	        });
	        var type = $('#edValidityType').val();
	        var request = new RemoveValidityRequest();
	        request.Password = this._passwordInput.value;
	        request.Reason = this._reasonInput.value;
	        request.Type = type;
	        request.ConfigIds = ids.get();
	        $.ajax({
	            url: urlPost,
	            type: "POST",
	            dataType: 'html',
	            data: { request: request },
	            success: function (data) {
	                checkAll.prop('checked', false);
	                that.hideRemoveValidity();
	                statusMessage.html(data);
	                StatusMessageHelper_1.StatusMessageHelper.initValidator();
	                StatusMessageHelper_1.StatusMessageHelper.initSatusMessage();
	                table.draw();
	            }
	        });
	    };
	    return RemoveValidityPage;
	}(PageBase_1.PageBase));
	exports.RemoveValidityPage = RemoveValidityPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 157 */
[172, 158],
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PageBase_1 = __webpack_require__(67);
	var Datatable_1 = __webpack_require__(54);
	var MultiSelect_1 = __webpack_require__(52);
	var Utils_1 = __webpack_require__(5);
	var StatusMessageHelper_1 = __webpack_require__(50);
	var FILTER_DELIM = '-delim-';
	var tableId = 'tableGameBuildConfigurations';
	var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
	var IndexPage = (function (_super) {
	    __extends(IndexPage, _super);
	    function IndexPage(options) {
	        _super.call(this, options);
	        this.preDrawCallback = this.preDrawCallback.bind(this);
	        this.formSubmit = this.formSubmit.bind(this);
	        this.cancelSearch = this.cancelSearch.bind(this);
	        this.clientVersionChanged = this.clientVersionChanged.bind(this);
	        window['clientVersionChanged'] = this.clientVersionChanged;
	        this._tableOptions = {
	            url: this._options.urlList,
	            dom: tableDom,
	            rowId: 'GameId',
	            columns: [
	                {
	                    sortable: false,
	                    data: 'Customer'
	                },
	                {
	                    sortable: false,
	                    data: 'CustomerOperation'
	                },
	                {
	                    sortable: false,
	                    data: 'GameName'
	                },
	                {
	                    sortable: false,
	                    data: 'GameClientVersionNumber',
	                    render: function (data, type, rowData) {
	                        var value = Utils_1.Utils.isNullOrUndefined(rowData.GameClientVersionNumber) ? "" : rowData.GameClientVersionNumber;
	                        return ("<input id='gameVersion" + rowData.GameId + "' name='gameVersion' value='" + value + "' />\n                        <input class='btn' id='btnUpdateVersion" + rowData.GameId + "' value='Save' type='button' onclick='clientVersionChanged(" + rowData.GameId + ", " + rowData.CustomerOperationId + ")' />");
	                    }
	                },
	                {
	                    sortable: false,
	                    data: 'Modified',
	                    render: function (data, type, rowData) {
	                        return Utils_1.Utils.isNullOrUndefined(data) ? 'Not modified' : data;
	                    }
	                }
	            ],
	            callbacks: {
	                preDrawCallback: this.preDrawCallback
	            }
	        };
	    }
	    IndexPage.prototype.init = function () {
	        this._form = Utils_1.Utils.getJQueryById("formGameClientVersions");
	        this._btnCancelSearch = Utils_1.Utils.getJQueryById("btnCancelSearch");
	        this._filterGame = new MultiSelect_1.MultiSelectApi('filterGame');
	        this._filterCustomer = new MultiSelect_1.MultiSelectApi('filterCustomer');
	        this._filterCustomerOperation = new MultiSelect_1.MultiSelectApi('filterCustomerOperation');
	        this._table = new Datatable_1.Datatable(tableId, this._tableOptions);
	        this._form.on('submit', this.formSubmit);
	        this._btnCancelSearch.on('click', this.cancelSearch);
	    };
	    IndexPage.prototype.formSubmit = function (e) {
	        e.preventDefault();
	        this._table.draw();
	        return false;
	    };
	    IndexPage.prototype.preDrawCallback = function (datatable) {
	        var filterCustomer = this._filterCustomer.isAllSelected() ? '' : this._filterCustomer.getSelectionValues(FILTER_DELIM);
	        datatable.columns(0).search(filterCustomer);
	        var filterCustomerOperation = this._filterCustomerOperation.isAllSelected() ? '' : this._filterCustomerOperation.getSelectionValues(FILTER_DELIM);
	        datatable.columns(1).search(filterCustomerOperation);
	        var filterGame = this._filterGame.isAllSelected() ? '' : this._filterGame.getSelectionValues(FILTER_DELIM);
	        datatable.columns(2).search(filterGame);
	        return true;
	    };
	    IndexPage.prototype.cancelSearch = function (e) {
	        this._filterGame.selectAll();
	    };
	    IndexPage.prototype.clientVersionChanged = function (gameId, operationId) {
	        var gameVersion = document.getElementById("gameVersion" + gameId).value;
	        var urlUpdate = this._options.urlUpdate;
	        var table = this._table;
	        var statusMessage = Utils_1.Utils.getJQueryById("statusMessageWrapper");
	        $.ajax({
	            url: urlUpdate,
	            type: "POST",
	            data: {
	                customerOperationId: operationId,
	                gameId: gameId,
	                version: gameVersion
	            },
	            success: function (data) {
	                statusMessage.html(data);
	                StatusMessageHelper_1.StatusMessageHelper.initValidator();
	                StatusMessageHelper_1.StatusMessageHelper.initSatusMessage();
	                table.draw(false);
	            }
	        });
	    };
	    return IndexPage;
	}(PageBase_1.PageBase));
	exports.IndexPage = IndexPage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Component_1 = __webpack_require__(160);
	exports.QuickSearchPanelComponent = Component_1.QuickSearchPanelComponent;
	var Component_2 = __webpack_require__(161);
	exports.ProgressPanelComponent = Component_2.ProgressPanelComponent;
	var Component_3 = __webpack_require__(162);
	exports.ConfigurationPanelComponent = Component_3.ConfigurationPanelComponent;


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ComponentBase_1 = __webpack_require__(68);
	var Typeahead_1 = __webpack_require__(56);
	var FileUtils_1 = __webpack_require__(9);
	var QuickSearchPanelComponent = (function (_super) {
	    __extends(QuickSearchPanelComponent, _super);
	    function QuickSearchPanelComponent(options) {
	        _super.call(this, options);
	        this.afterSelect = this.afterSelect.bind(this);
	        this.getSource = this.getSource.bind(this);
	        this._typeaheadOptions = {
	            source: this.getSource,
	            afterSelect: this.afterSelect,
	            delay: 500,
	            minLength: 2,
	            items: 'all',
	            fitToElement: true,
	            overflowHeight: '200px'
	        };
	    }
	    QuickSearchPanelComponent.prototype.afterSelect = function (item) {
	        if (item) {
	            var uri = URI(this._options.urlSelection + '/' + item.id.toString());
	            location.href = uri.toString();
	        }
	    };
	    QuickSearchPanelComponent.prototype.getSource = function (query, callback) {
	        var uri = URI(this._options.urlList);
	        uri.setQuery('query', query);
	        FileUtils_1.FileUtils.readLocalJsonFile(uri.toString(), false)
	            .then(function (json) {
	            callback(json);
	        });
	    };
	    QuickSearchPanelComponent.prototype.init = function () {
	        this._typeahead = new Typeahead_1.Typeahead(this._options.editElementId, this._typeaheadOptions);
	    };
	    return QuickSearchPanelComponent;
	}(ComponentBase_1.ComponentBase));
	exports.QuickSearchPanelComponent = QuickSearchPanelComponent;


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ComponentBase_1 = __webpack_require__(68);
	var Utils_1 = __webpack_require__(5);
	var FileUtils_1 = __webpack_require__(9);
	var StringUtils_1 = __webpack_require__(3);
	var ProgressPanelComponent = (function (_super) {
	    __extends(ProgressPanelComponent, _super);
	    function ProgressPanelComponent(options) {
	        _super.call(this, options);
	        this._currentInfo = null;
	        this._urlGetStatus = URI(this._options.urlProgressStatus).toString();
	        this._urlStopProcess = StringUtils_1.StringUtils.isNullOrEmpty(this._options.urlStopProcess) ? null : URI(this._options.urlStopProcess).toString();
	        this._urlHideProcessInfo = StringUtils_1.StringUtils.isNullOrEmpty(this._options.urlHideProcessInfo) ? null : URI(this._options.urlHideProcessInfo).toString();
	    }
	    ProgressPanelComponent.prototype.init = function () {
	        var panelId = "progressPanel-" + this._options.idPostfix;
	        var containerId = panelId + "-container";
	        var progressId = panelId + "-progress";
	        var statusId = panelId + "-status";
	        var statusSucceededId = panelId + "-succeeded";
	        var statusFailedId = panelId + "-failed";
	        var statusRemainingId = panelId + "-remaining";
	        var statusStartedId = panelId + "-started";
	        var statusFinishedId = panelId + "-finished";
	        var buttonStopId = panelId + "-btnStop";
	        var buttonHideId = panelId + "-btnHide";
	        var errorTextId = panelId + "-errorText";
	        var taskLabelId = panelId + "-taskId";
	        this._container = Utils_1.Utils.getJQueryById(containerId);
	        this._progress = Utils_1.Utils.getJQueryById(progressId);
	        this._status = Utils_1.Utils.getJQueryById(statusId);
	        this._statusSucceeded = Utils_1.Utils.getJQueryById(statusSucceededId);
	        this._statusFailed = Utils_1.Utils.getJQueryById(statusFailedId);
	        this._statusRemaining = Utils_1.Utils.getJQueryById(statusRemainingId);
	        this._statusStarted = Utils_1.Utils.getJQueryById(statusStartedId);
	        this._statusFinished = Utils_1.Utils.getJQueryById(statusFinishedId);
	        this._buttonStop = Utils_1.Utils.getJQueryById(buttonStopId);
	        this._buttonHide = Utils_1.Utils.getJQueryById(buttonHideId);
	        this._errorText = Utils_1.Utils.getJQueryById(errorTextId);
	        this._taskLabel = Utils_1.Utils.getJQueryById(taskLabelId);
	        this.refreshProgressStatus = this.refreshProgressStatus.bind(this);
	        setTimeout(this.refreshProgressStatus, 100);
	        if (!StringUtils_1.StringUtils.isNullOrEmpty(this._urlStopProcess)) {
	            this.stopProcess = this.stopProcess.bind(this);
	            this._buttonStop.on('click', this.stopProcess);
	        }
	        if (!StringUtils_1.StringUtils.isNullOrEmpty(this._urlHideProcessInfo)) {
	            this.hideProcessInfo = this.hideProcessInfo.bind(this);
	            this._buttonHide.on('click', this.hideProcessInfo);
	        }
	        if (!Utils_1.Utils.isNullOrUndefined(this._options.initialStatusInfo)) {
	            this.update(this._options.initialStatusInfo);
	        }
	        this._container.show();
	    };
	    ProgressPanelComponent.prototype.stopProcess = function () {
	        var self = this;
	        if (this.isRunning) {
	            FileUtils_1.FileUtils.jsonPost(this._urlStopProcess)
	                .then(function (json) {
	                if (json) {
	                    self.update(json);
	                }
	            });
	        }
	        return false;
	    };
	    ProgressPanelComponent.prototype.hideProcessInfo = function () {
	        location.href = this._urlHideProcessInfo;
	        return false;
	    };
	    ProgressPanelComponent.prototype.refreshProgressStatus = function () {
	        var self = this;
	        var uri = URI(this._options.urlProgressStatus);
	        FileUtils_1.FileUtils.readLocalJsonFile(uri.toString(), false)
	            .then(function (json) {
	            if (json) {
	                self.update(json);
	            }
	        });
	    };
	    Object.defineProperty(ProgressPanelComponent.prototype, "isRunning", {
	        get: function () {
	            return !Utils_1.Utils.isNullOrUndefined(this._currentInfo) &&
	                this._currentInfo.status !== 'Completed' &&
	                this._currentInfo.status !== 'Cancelled' &&
	                this._currentInfo.status !== 'NoData';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ProgressPanelComponent.prototype.update = function (info) {
	        this._currentInfo = info;
	        this._status.text(this._options.localizer['Status' + info.status]);
	        if (!Utils_1.Utils.isNullOrUndefined(info)) {
	            if (info.status === 'Completed') {
	                if (info.failed === 0) {
	                    this._status.addClass('text-success');
	                }
	                else {
	                    this._status.addClass('text-danger');
	                }
	            }
	            else if (info.status === 'Cancelled') {
	                this._status.addClass('text-danger');
	            }
	        }
	        this._statusSucceeded.text(info.succeeded);
	        this._statusFailed.text(info.failed);
	        this._statusRemaining.text(info.remaining);
	        this._statusStarted.text(info.started);
	        this._statusFinished.text(info.finished);
	        this._taskLabel.text(info.taskId);
	        var progress = info.progress + '%';
	        this._progress.css('width', progress);
	        this._progress.text(progress);
	        var hasErrorText = !StringUtils_1.StringUtils.isNullOrEmpty(info.errorText);
	        Utils_1.Utils.toggleShow(this._errorText, hasErrorText);
	        this._errorText.text(info.errorText || '');
	        if (this.isRunning) {
	            setTimeout(this.refreshProgressStatus, 1000);
	        }
	        if (this._buttonStop.length === 1) {
	            var hide = !Utils_1.Utils.isNullOrUndefined(info) &&
	                info.status === 'Completed' ||
	                info.status === 'Cancelled' ||
	                info.status === 'NoData';
	            Utils_1.Utils.toggleShow(this._buttonStop, !hide);
	        }
	        if (this._buttonHide.length === 1) {
	            var hide = Utils_1.Utils.isNullOrUndefined(info) ||
	                info.status === 'Queued' ||
	                info.status === 'Running';
	            Utils_1.Utils.toggleShow(this._buttonHide, !hide);
	        }
	    };
	    return ProgressPanelComponent;
	}(ComponentBase_1.ComponentBase));
	exports.ProgressPanelComponent = ProgressPanelComponent;


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ComponentBase_1 = __webpack_require__(68);
	var StringUtils_1 = __webpack_require__(3);
	var ConfigurationCategory_1 = __webpack_require__(163);
	var ConfigurationItem_1 = __webpack_require__(164);
	var ConfigurationPanelComponent = (function (_super) {
	    __extends(ConfigurationPanelComponent, _super);
	    function ConfigurationPanelComponent(options) {
	        _super.call(this, options);
	        this._searchInputId = options.searchInputId;
	        this._filterSelectId = options.filterSelectId;
	        this._configurationFormId = options.configurationFormId;
	        this.onFilterChange = this.onFilterChange.bind(this);
	        this.onSubmit = this.onSubmit.bind(this);
	        this.hideAllCategories = this.hideAllCategories.bind(this);
	        this.showAllCategories = this.showAllCategories.bind(this);
	        this.mapAllItems();
	        this.mapAllCategories();
	    }
	    ConfigurationPanelComponent.prototype.mapAllItems = function () {
	        this._configurationItems = new Array();
	        var items = $("dt.configurationItem");
	        for (var i = 0; i < items.length; i++) {
	            var item = items[i];
	            var configuration = new ConfigurationItem_1.ConfigurationItem(item);
	            this._configurationItems.push(configuration);
	        }
	    };
	    ConfigurationPanelComponent.prototype.mapAllCategories = function () {
	        this._configurationCategories = new Array();
	        var categories = $(".collapsible");
	        for (var i = 0; i < categories.length; i++) {
	            var category = categories[i];
	            var configurationCategory = new ConfigurationCategory_1.ConfigurationCategory(category);
	            this._configurationCategories.push(configurationCategory);
	        }
	    };
	    ConfigurationPanelComponent.prototype.itemIsVisible = function (item) {
	        var filter = this._selectedFilter.val();
	        var searchValue = this._searchInput.val().trim();
	        if (StringUtils_1.StringUtils.equals(filter, "unfilled") && !StringUtils_1.StringUtils.isNullOrEmpty(item.getValue())) {
	            return false;
	        }
	        if (StringUtils_1.StringUtils.equals(filter, "required") && !item.isRequired) {
	            return false;
	        }
	        if (StringUtils_1.StringUtils.equals(filter, "validationError") && item.isValid()) {
	            return false;
	        }
	        if (StringUtils_1.StringUtils.equals(filter, "leaf") && !item.isLeaf) {
	            return false;
	        }
	        if (StringUtils_1.StringUtils.equals(filter, "edited") && !item.isSet()) {
	            return false;
	        }
	        if (StringUtils_1.StringUtils.equals(filter, "filled") && !item.isSet() && !item.jurisdictionOverride) {
	            return false;
	        }
	        if (item.name.toLowerCase().search(searchValue.toLowerCase()) === -1 && item.code.toLowerCase().search(searchValue.toLowerCase()) === -1) {
	            return false;
	        }
	        return true;
	    };
	    ConfigurationPanelComponent.prototype.onFilterChange = function () {
	        sessionStorage.setItem("searchInput", this._searchInput.val());
	        this.showAllCategories();
	        for (var i = 0; i < this._configurationItems.length; i++) {
	            var item = this._configurationItems[i];
	            if (this.itemIsVisible(item)) {
	                item.show();
	            }
	            else {
	                item.hide();
	            }
	        }
	    };
	    ConfigurationPanelComponent.prototype.onSubmit = function (e) {
	        for (var i = 0; i < this._configurationItems.length; i++) {
	            this._configurationItems[i].validateField();
	            if (!this._configurationItems[i].isValid()) {
	                e.preventDefault();
	                this._selectedFilter[0].value = "validationError";
	                this._searchInput.val('');
	                this.onFilterChange();
	                return;
	            }
	        }
	    };
	    ConfigurationPanelComponent.prototype.showAllCategories = function () {
	        for (var i = 0; i < this._configurationCategories.length; i++) {
	            this._configurationCategories[i].show();
	        }
	    };
	    ConfigurationPanelComponent.prototype.hideAllCategories = function () {
	        for (var i = 0; i < this._configurationCategories.length; i++) {
	            this._configurationCategories[i].hide();
	        }
	    };
	    ConfigurationPanelComponent.prototype.onFileChange = function () {
	        var fileInput = $("#configuration-file");
	        if (fileInput.val()) {
	            $("#fileForm").submit();
	        }
	    };
	    ConfigurationPanelComponent.prototype.uploadClick = function () {
	        $("#configuration-file").trigger('click');
	    };
	    ConfigurationPanelComponent.prototype.init = function () {
	        this._searchInput = $("#" + this._searchInputId);
	        this._searchInput.on("keyup", this.onFilterChange);
	        this._searchInput.val(sessionStorage.getItem("searchInput"));
	        this._selectedFilter = $("#" + this._filterSelectId);
	        this._selectedFilter.on("change", this.onFilterChange);
	        this.onFilterChange();
	        $("#" + this._configurationFormId).on("submit", this.onSubmit);
	        $(".expand-icon").on("click", this.showAllCategories);
	        $(".collapse-icon").on("click", this.hideAllCategories);
	        $("#btnUpload").on("click", this.uploadClick);
	        var configurationFile = $("#configuration-file");
	        if (configurationFile) {
	            configurationFile.on("change", this.onFileChange);
	        }
	    };
	    return ConfigurationPanelComponent;
	}(ComponentBase_1.ComponentBase));
	exports.ConfigurationPanelComponent = ConfigurationPanelComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery, $) {"use strict";
	var ConfigurationCategory = (function () {
	    function ConfigurationCategory(htmlItem) {
	        this.onShow = this.onShow.bind(this);
	        this.onHide = this.onHide.bind(this);
	        this._categoryElement = jQuery(htmlItem);
	        this._arrow = $("#" + htmlItem.id + "_arrow");
	        this._categoryElement.on("show.bs.collapse", this.onShow);
	        this._categoryElement.on("hide.bs.collapse", this.onHide);
	    }
	    ConfigurationCategory.prototype.show = function () {
	        this._categoryElement["collapse"]("show");
	    };
	    ConfigurationCategory.prototype.hide = function () {
	        this._categoryElement["collapse"]("hide");
	    };
	    ConfigurationCategory.prototype.onShow = function () {
	        this._arrow.addClass("fa-caret-down");
	        this._arrow.removeClass("fa-caret-right");
	    };
	    ConfigurationCategory.prototype.onHide = function () {
	        this._arrow.removeClass("fa-caret-down");
	        this._arrow.addClass("fa-caret-right");
	    };
	    return ConfigurationCategory;
	}());
	exports.ConfigurationCategory = ConfigurationCategory;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(1)))

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Utils_1 = __webpack_require__(5);
	var StringUtils_1 = __webpack_require__(3);
	var ValidatorManager_1 = __webpack_require__(165);
	var ConfigurationItem = (function () {
	    function ConfigurationItem(htmlItem) {
	        this.validationMessages = new Array();
	        this.validateFieldThrottled = this.validateFieldThrottled.bind(this);
	        this.validateField = this.validateField.bind(this);
	        this.revealPassword = this.revealPassword.bind(this);
	        this.hidePassword = this.hidePassword.bind(this);
	        this.setSelectInputStyle = this.setSelectInputStyle.bind(this);
	        this.dtItem = htmlItem;
	        this.isHidden = htmlItem.classList.contains("hidden");
	        this.name = htmlItem.children[0].innerText;
	        this.code = htmlItem.nextElementSibling.getElementsByClassName("configurationSearchItemCode")[0].innerText;
	        this.isRequired = htmlItem.getElementsByClassName("required").length > 0;
	        this.valueItem = htmlItem.nextElementSibling.getElementsByClassName("configurationItemValue")[0];
	        this.parentValue = htmlItem.dataset["parentvalue"];
	        this.isLeaf = StringUtils_1.StringUtils.equals(htmlItem.dataset["leaf"], "True");
	        this.lockItem = htmlItem.nextElementSibling.getElementsByClassName("isLockedValue")[0];
	        this.editItem = htmlItem.nextElementSibling.getElementsByClassName("isSetValue")[0];
	        this.isSetInput = htmlItem.nextElementSibling.getElementsByClassName("configuration-isset-input")[0];
	        this.isLockedInput = htmlItem.nextElementSibling.getElementsByClassName("configuration-islocked-input")[0];
	        this.isEditable = StringUtils_1.StringUtils.equals(htmlItem.dataset["iseditable"], "True");
	        this.lockEdited = StringUtils_1.StringUtils.equals(htmlItem.dataset["lockedited"], "True");
	        this.cannotBeEmpty = StringUtils_1.StringUtils.equals(htmlItem.dataset["cannotbeempty"], "True");
	        this.isText = StringUtils_1.StringUtils.equals(htmlItem.dataset["istext"], "True");
	        this.validations = htmlItem.nextElementSibling.getElementsByClassName("configurationItemValidation")[0];
	        var jurisdictionElement = htmlItem.nextElementSibling.getElementsByClassName("jurisdiction-locked-item")[0];
	        this.jurisdictionOverride = !Utils_1.Utils.isNullOrUndefined(jurisdictionElement);
	        this.validatorManager = new ValidatorManager_1.ValidatorManager(htmlItem);
	        this.processItemTypeValue();
	        this.processEditableEditItem();
	        this.setValidationListeners();
	        this.validateField();
	    }
	    ConfigurationItem.prototype.processItemTypeValue = function () {
	        if (StringUtils_1.StringUtils.equals(this.valueItem.type, "password")) {
	            this.revealedPassword = this.valueItem.nextElementSibling;
	            this.revealButton = this.valueItem.parentElement.getElementsByTagName("i")[0];
	            this.revealButton.addEventListener("mousedown", this.revealPassword);
	            this.revealButton.addEventListener("mouseup", this.hidePassword);
	            this.revealButton.addEventListener("mouseleave", this.hidePassword);
	        }
	        else if (StringUtils_1.StringUtils.equals(this.valueItem.type, "select-one")) {
	            this.valueItem.addEventListener("change", this.setSelectInputStyle);
	            this.setSelectInputStyle();
	        }
	    };
	    ConfigurationItem.prototype.processEditableEditItem = function () {
	        var _this = this;
	        if (!Utils_1.Utils.isNullOrUndefined(this.editItem) && this.isEditable) {
	            this.valueItem.addEventListener("input", function () { return _this.onInputChange(); });
	            this.editItem.addEventListener("change", function () { return _this.onIsSetChange(); });
	            if (this.editItem.checked) {
	                this.valueItem.placeholder = "";
	            }
	            if (!this.isText && this.isSetInput) {
	                this.isSetInput.style.display = "none";
	            }
	            if (this.lockEdited && this.isLockedInput) {
	                this.isLockedInput.style.display = "none";
	            }
	        }
	    };
	    ConfigurationItem.prototype.setSelectInputStyle = function () {
	        if (StringUtils_1.StringUtils.isNullOrEmpty(this.getValue())) {
	            this.valueItem.classList.add("configurationItemValueDefault");
	        }
	        else {
	            this.valueItem.classList.remove("configurationItemValueDefault");
	        }
	    };
	    ConfigurationItem.prototype.revealPassword = function () {
	        var value = this.getValue();
	        if (value === "......" || value === "") {
	            this.revealedPassword.value = this.revealedPassword.dataset[value === "" ? "revealedParentValue" : "revealedValue"];
	            this.revealedPassword.type = "text";
	            this.valueItem.type = "hidden";
	        }
	        else {
	            this.valueItem.type = "text";
	        }
	    };
	    ConfigurationItem.prototype.hidePassword = function () {
	        this.revealedPassword.type = "hidden";
	        this.valueItem.type = "password";
	    };
	    ConfigurationItem.prototype.setValidationListeners = function () {
	        this.valueItem.addEventListener("input", this.validateFieldThrottled);
	        if (!Utils_1.Utils.isNullOrUndefined(this.lockItem)) {
	            this.lockItem.addEventListener("input", this.validateFieldThrottled);
	        }
	    };
	    ConfigurationItem.prototype.validateFieldThrottled = function () {
	        if (this.timerId) {
	            return;
	        }
	        var func = this.validateField;
	        this.timerId = setTimeout(function () {
	            func();
	        }, 250);
	    };
	    ConfigurationItem.prototype.validateField = function () {
	        this.validationMessages = [];
	        var value = this.getValue();
	        var isValueEmpty = StringUtils_1.StringUtils.isNullOrEmpty(value);
	        this.validations.innerHTML = "";
	        var isSet = Utils_1.Utils.isNullOrUndefined(this.editItem) ? false : this.editItem.checked;
	        if (this.isRequired && isValueEmpty && (StringUtils_1.StringUtils.isNullOrEmpty(this.parentValue) || isSet)) {
	            this.validationMessages.push("This field is required");
	        }
	        if (isValueEmpty && this.isLocked() && (!this.isText || (this.isText && !this.editItem.checked))) {
	            this.validationMessages.push("Only explicit value can be locked");
	        }
	        if (isValueEmpty && !this.isRequired && isSet && this.cannotBeEmpty) {
	            this.validationMessages.push("This field cannot be set to an empty value");
	        }
	        this.validatorManager.validate(value, this.validationMessages);
	        for (var i = 0; i < this.validationMessages.length; i++) {
	            var validationMessage = this.validationMessages[i];
	            var validationMessageItem = document.createElement("li");
	            validationMessageItem.innerText = validationMessage;
	            this.validations.appendChild(validationMessageItem);
	        }
	        this.timerId = undefined;
	    };
	    ConfigurationItem.prototype.lockEditedItem = function () {
	        if (!Utils_1.Utils.isNullOrUndefined(this.lockItem) && this.lockEdited) {
	            if (this.editItem.checked) {
	                this.lockItem.checked = true;
	            }
	            else {
	                this.lockItem.checked = false;
	            }
	        }
	    };
	    ConfigurationItem.prototype.onInputChange = function () {
	        if (Utils_1.Utils.isNullOrUndefined(this.editItem)) {
	            return false;
	        }
	        if (this.valueItem.value == '') {
	            this.valueItem.placeholder = this.parentValue;
	            this.editItem.checked = false;
	        }
	        else {
	            this.editItem.checked = true;
	        }
	        this.lockEditedItem();
	    };
	    ConfigurationItem.prototype.onIsSetChange = function () {
	        if (Utils_1.Utils.isNullOrUndefined(this.valueItem)) {
	            return false;
	        }
	        if (this.editItem.checked) {
	            this.valueItem.placeholder = "";
	        }
	        else {
	            this.valueItem.placeholder = this.parentValue;
	        }
	        this.valueItem.value = "";
	        this.lockEditedItem();
	        this.validateField();
	    };
	    ConfigurationItem.prototype.isSet = function () {
	        return !Utils_1.Utils.isNullOrUndefined(this.editItem) && this.editItem.checked;
	    };
	    ConfigurationItem.prototype.hide = function () {
	        this.isHidden = true;
	        this.dtItem.classList.add("hidden");
	    };
	    ConfigurationItem.prototype.show = function () {
	        this.isHidden = false;
	        this.dtItem.classList.remove("hidden");
	    };
	    ConfigurationItem.prototype.getValue = function () {
	        if (this.valueItem.tagName === "LABEL") {
	            return this.valueItem.innerText;
	        }
	        return this.valueItem.value;
	    };
	    ConfigurationItem.prototype.isLocked = function () {
	        if (Utils_1.Utils.isNullOrUndefined(this.lockItem)) {
	            return false;
	        }
	        return this.lockItem.checked;
	    };
	    ConfigurationItem.prototype.isValid = function () {
	        return this.validationMessages.length === 0;
	    };
	    return ConfigurationItem;
	}());
	exports.ConfigurationItem = ConfigurationItem;


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Utils_1 = __webpack_require__(5);
	var TimespanValidator_1 = __webpack_require__(166);
	var EmailValidator_1 = __webpack_require__(168);
	var UrlValidator_1 = __webpack_require__(169);
	var RangeValidator_1 = __webpack_require__(170);
	var MaxLengthValidator_1 = __webpack_require__(171);
	var StringUtils_1 = __webpack_require__(3);
	var ValidatorManager = (function () {
	    function ValidatorManager(htmlItem) {
	        this.validators = new Array();
	        if (!Utils_1.Utils.isNullOrUndefined(htmlItem.dataset["validatorTimespan"])) {
	            this.validators.push(new TimespanValidator_1.TimespanValidator(htmlItem.dataset["validatorTimespanMessage"], htmlItem.dataset["validatorTimespan"]));
	        }
	        if (!Utils_1.Utils.isNullOrUndefined(htmlItem.dataset["validatorEmail"])) {
	            this.validators.push(new EmailValidator_1.EmailValidator(htmlItem.dataset["validatorEmailMessage"], htmlItem.dataset["validatorEmail"]));
	        }
	        if (!Utils_1.Utils.isNullOrUndefined(htmlItem.dataset["validatorUrl"])) {
	            this.validators.push(new UrlValidator_1.UrlValidator(htmlItem.dataset["validatorUrlMessage"], htmlItem.dataset["validatorUrl"]));
	        }
	        if (!Utils_1.Utils.isNullOrUndefined(htmlItem.dataset["validatorRange"])) {
	            this.validators.push(new RangeValidator_1.RangeValidator(htmlItem.dataset["validatorRangeMessage"], htmlItem.dataset["validatorRange"]));
	        }
	        if (!Utils_1.Utils.isNullOrUndefined(htmlItem.dataset["validatorMaxlength"])) {
	            this.validators.push(new MaxLengthValidator_1.MaxLengthValidator(htmlItem.dataset["validatorMaxlengthMessage"], htmlItem.dataset["validatorMaxlength"]));
	        }
	    }
	    ValidatorManager.prototype.validate = function (value, messages) {
	        if (StringUtils_1.StringUtils.isNullOrEmpty(value)) {
	            return;
	        }
	        for (var i = 0; i < this.validators.length; i++) {
	            var validator = this.validators[i];
	            validator.validate(value, messages);
	        }
	    };
	    return ValidatorManager;
	}());
	exports.ValidatorManager = ValidatorManager;


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ValidatorBase_1 = __webpack_require__(167);
	var StringUtils_1 = __webpack_require__(3);
	var TimespanValidator = (function (_super) {
	    __extends(TimespanValidator, _super);
	    function TimespanValidator(message, data) {
	        _super.call(this, message, data);
	    }
	    TimespanValidator.prototype.validate = function (value, messages) {
	        if (!/^((?:-?0*\d+\.)?(?:0*)(?:2[0-3]|1[0-9]|[0-9]))(?::0*([0-5]?[0-9]))?(?::0*((?:[0-5]?[0-9])(?:\.\d{0,7})?))?$/.test(value)) {
	            var msg = StringUtils_1.StringUtils.isNullOrEmpty(this._message) ? "Value is not a valid time span. Valid formats are: d / d.hh:mm / d.hh:mm:ss / hh:mm" : this._message;
	            messages.push(msg);
	        }
	    };
	    return TimespanValidator;
	}(ValidatorBase_1.ValidatorBase));
	exports.TimespanValidator = TimespanValidator;


/***/ },
/* 167 */
/***/ function(module, exports) {

	"use strict";
	var ValidatorBase = (function () {
	    function ValidatorBase(message, data) {
	        this._message = message;
	        this._data = data;
	    }
	    return ValidatorBase;
	}());
	exports.ValidatorBase = ValidatorBase;


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ValidatorBase_1 = __webpack_require__(167);
	var StringUtils_1 = __webpack_require__(3);
	var EmailValidator = (function (_super) {
	    __extends(EmailValidator, _super);
	    function EmailValidator(message, data) {
	        _super.call(this, message, data);
	    }
	    EmailValidator.prototype.validate = function (value, messages) {
	        var regex = /(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
	        if (!regex.test(value)) {
	            var msg = StringUtils_1.StringUtils.isNullOrEmpty(this._message) ? "Value is not a valid email address." : this._message;
	            messages.push(msg);
	        }
	    };
	    return EmailValidator;
	}(ValidatorBase_1.ValidatorBase));
	exports.EmailValidator = EmailValidator;


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ValidatorBase_1 = __webpack_require__(167);
	var StringUtils_1 = __webpack_require__(3);
	var UrlValidator = (function (_super) {
	    __extends(UrlValidator, _super);
	    function UrlValidator(message, data) {
	        _super.call(this, message, data);
	    }
	    UrlValidator.prototype.validate = function (value, messages) {
	        var regex = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
	        if (!regex.test(value)) {
	            var msg = StringUtils_1.StringUtils.isNullOrEmpty(this._message) ? "Value is not a valid URL." : this._message;
	            messages.push(msg);
	        }
	    };
	    return UrlValidator;
	}(ValidatorBase_1.ValidatorBase));
	exports.UrlValidator = UrlValidator;


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ValidatorBase_1 = __webpack_require__(167);
	var StringUtils_1 = __webpack_require__(3);
	var RangeValidator = (function (_super) {
	    __extends(RangeValidator, _super);
	    function RangeValidator(message, data) {
	        _super.call(this, message, data);
	    }
	    RangeValidator.prototype.validate = function (value, messages) {
	        var intValue = parseInt(value);
	        var from = parseInt(this._data.split('-')[0]);
	        var to = parseInt(this._data.split('-')[1]);
	        if (intValue < from || intValue > to) {
	            var msg = StringUtils_1.StringUtils.isNullOrEmpty(this._message) ? "Value must be in range " + from + "-" + to + "." : this._message;
	            messages.push(msg);
	        }
	    };
	    return RangeValidator;
	}(ValidatorBase_1.ValidatorBase));
	exports.RangeValidator = RangeValidator;


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ValidatorBase_1 = __webpack_require__(167);
	var MaxLengthValidator = (function (_super) {
	    __extends(MaxLengthValidator, _super);
	    function MaxLengthValidator(message, data) {
	        _super.call(this, message, data);
	    }
	    MaxLengthValidator.prototype.validate = function (value, messages) {
	        var maxLength = parseInt(this._data);
	        if (value.length > maxLength) {
	            messages.push("The maximum length should be " + maxLength + " characters.");
	        }
	    };
	    return MaxLengthValidator;
	}(ValidatorBase_1.ValidatorBase));
	exports.MaxLengthValidator = MaxLengthValidator;


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	var IndexPage_1 = __webpack_require__(__webpack_module_template_argument_0__);
	exports.IndexPage = IndexPage_1.IndexPage;


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	var IndexPage_1 = __webpack_require__(__webpack_module_template_argument_0__);
	exports.IndexPage = IndexPage_1.IndexPage;
	var DetailPage_1 = __webpack_require__(__webpack_module_template_argument_1__);
	exports.DetailPage = DetailPage_1.DetailPage;


/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** ./wwwroot/js/backoffice.min.js
 **/